webpackJsonp([0,2],{

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadingScreen_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a7854e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadingScreen_vue__ = __webpack_require__(326);
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadingScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49a7854e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadingScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sport_sportHeader_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sport_marketHeader_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_components_loadingScreen__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__home_gameHeader_vue__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sport_allBet_allBetHeader__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__sport_allBet_allBet2__ = __webpack_require__(334);



















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    sportHeader: __WEBPACK_IMPORTED_MODULE_9__sport_sportHeader_vue__["a" /* default */],
    loadingScreen: __WEBPACK_IMPORTED_MODULE_11__vue_components_loadingScreen__["a" /* default */],
    marketHeader: __WEBPACK_IMPORTED_MODULE_10__sport_marketHeader_vue__["a" /* default */],
    gameHeader: __WEBPACK_IMPORTED_MODULE_12__home_gameHeader_vue__["a" /* default */],
    allBetHeader: __WEBPACK_IMPORTED_MODULE_13__sport_allBet_allBetHeader__["a" /* default */],
    allBet2: __WEBPACK_IMPORTED_MODULE_15__sport_allBet_allBet2__["a" /* default */]
  },
  data: function data() {
    return {
      showPasscodeCreation: false,
      pch: window.pch,
      pcTyp: '1',
      token: window.token,
      isP: true,
      selectedSkinTheme: null,
      window: {
        width: 0,
        height: 0
      },
      userAccount: window.account.acccode,
      orientation: window.outerWidth < window.outerHeight || window.orientation != undefined && window.orientation === 0 || window.matchMedia("(orientation: portrait)").matches ? 0 : 90,
      showPromoDetail: false,
      gameBanner: window._gameBanner,
      sel_edition: '3',
      langId: window._langid
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['int_marketToggle', 'loadingScreen', 'arr_selectedTemplate', 'userdetail', 'passcode', 'account', 'noShowAgainList', 'arr_leagues', 'isParlay', 'isSpecial', 'bettingSelection', 'bettingMessage', 'arr_lang', 'minSize', 'isMobile', 'skinTheme', 'showFloating', 'isShowBtModal', 'isShowFilter', 'showFavEvents', 'allowLanscape', 'arr_sportAll', 'notSupportParlay', '_theme']), {
    selectedTemplate: function selectedTemplate() {
      return this.$store.getters.arr_selectedTemplate;
    }
  }),
  methods: {
    actionPasscodeReminder: function actionPasscodeReminder(data) {
      this.showPasscodeCreation = data;
    },
    getSelectedLeagueOdds: function getSelectedLeagueOdds() {
      this.$store.commit('S_ODD', false);
      this.$store.commit('SHOW_CALENDAR', false);
      this.$store.commit('SELECTED_LEAGUES', this.arr_leagues);

      var templateId = this.$store.getters.int_marketToggle == '3' ? 2 : 3;
      var subTemplateId = this.$store.getters.int_marketToggle == '3' ? 1 : this.$store.getters.arr_selectedTemplate.subTemplateId;

      this.$store.dispatch('changeTemplate', {
        templateId: templateId,
        marketKey: this.$store.getters.int_selectedMarket,
        plytype: 1,
        bettypeid: this.$store.getters.arr_selectedTemplate.bettypeid,
        sportId: this.$store.getters.arr_selectedTemplate.sportId,
        subTemplateId: subTemplateId
      });
    },
    handleResize: function handleResize() {

      this.orientation = window.outerWidth < window.outerHeight || window.orientation != undefined && window.orientation === 0 || window.matchMedia("(orientation: portrait)").matches ? 0 : 90;
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      if (window.innerWidth < this.minSize) {
        this.$store.commit('IS_MOBILE', true);
      } else {
        this.$store.commit('IS_MOBILE', false);
      }
    },
    clickEdition: function clickEdition(edition) {
      this.sel_edition = edition;
    },
    selectEdition: function selectEdition() {
      var _this = this;

      var Vue = this;
      var bettypeid = null;
      var plytype = 1;
      var subTemplateId = 1;
      Vue.$store.commit("GAMEBANNER_SELECTED", false);
      $(".scroller").scrollTop(0);
      Vue.$store.commit('IS_HIDE_LEAGUE', false);
      var container = $(".sub-m-menu");
      var container2 = $(".sub-background");
      if (container || container2) {
        container.hide();
        container2.hide();
      }
      if (Vue.sel_edition == '3') {
        var sprtId = 'N1';
        var market = 1;
        Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sprtId);
        this.$store.dispatch('getEventList', {
          market: market,
          token: token.arr_2,
          callback: function (res) {
            var today = !_.isUndefined(_this.$store.getters.arr_sportCountMarket.today) ? _this.$store.getters.arr_sportCountMarket.today[1] : 0;
            var live = !_.isUndefined(_this.$store.getters.arr_sportCountMarket.live) ? _this.$store.getters.arr_sportCountMarket.live[1] : 0;

            var tdRbevent = today + live;
            if (tdRbevent > 0) {
              _this.$store.commit('CURRENT_TAB', 1);
              _this.$store.commit('SHOW_CALENDAR', false);
              _this.$store.commit('MARKETTOGGLE', market);
              if (account.previewFlag == undefined || account.previewFlag && market != '1') {
                var btemplateId = 1;
              } else if (account.previewFlag && market == '1') {
                var btemplateId = 3;
                _this.$store.commit('SEL_MATCH', true);
              }
              if (sprtId != '' && sprtId != 'G98' && !_this.isGameBannerSelected) {
                if (_this.$store.getters.arr_sportList != null && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this.$store.getters.arr_sportList).length > 0) {
                  var current1stSport = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(res.totalMatch)[0];
                  if (market == 1) {
                    if (_this.$store.getters.arr_sportCountMarket.live && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this.$store.getters.arr_sportCountMarket.live).length > 0) {
                      var rbSport = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(_this.$store.getters.arr_sportCountMarket.live)[0];
                      if (rbSport <= current1stSport) {
                        current1stSport = rbSport;
                      }
                    }
                  }

                  var getSport = _.filter(_this.$store.getters.titleSport, function (x) {
                    return _.indexOf(x.sid, current1stSport) !== -1;
                  });

                  bettypeid = sprtId.split('');
                  if (bettypeid.length >= 3) {
                    bettypeid = bettypeid[1] + "" + bettypeid[2];
                  } else {
                    bettypeid = bettypeid[1];
                  }
                }
              }

              _this.$store.dispatch('changeTemplate', {
                templateId: btemplateId,

                marketKey: market,
                plytype: plytype,
                bettypeid: bettypeid,
                sportId: sprtId,
                subTemplateId: subTemplateId
              });

              __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);

              _this.$nextTick(function () {
                _this.$store.commit('SELECTED_MARKET', market);
                __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('sportTemplate', sprtId);
                $('.chkbox_league').prop('checked', false);
              });
            }
          }.bind(this)
        });

        $.ajax({
          url: _baseUrl + '/account-def-settings',
          type: 'get',
          data: {
            action: 'updateAccountSportSetting',
            edition: 3,
            startedtab: 1,
            sport_id: 1
          }
        }).done(function (response) {});
        Vue.$store.commit('EDITIONSTAND', Vue.sel_edition);
      }

      Vue.$store.commit('SHOW_FLOATING', false);
      $(".scroll").scrollTop(0);
      Vue.$store.commit('VIRTUAL_DATA_LIST', []);
      Vue.$store.commit('LOADGAMEHEADER', false);

      Vue.$store.commit('EVENTLIST', []);
      Vue.$store.commit('TODAYRBEVENTLIST', []);
      Vue.$store.commit('SWIPE_MODE', 1);
      $('.odd-t-i-wrapper').removeClass('status2');
      $('.standard-odd-l-w').removeClass('status2');
      Vue.$store.commit('SORTEDEVENTLIST', []);
      Vue.$store.commit('COOKIE_LEAGUE', {
        remove: true
      });
      __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('refreshSportTable');
    },
    getAllSportCount: function getAllSportCount(comid) {
      var Vue = this;

      Vue.$store.dispatch('getSportCount');
      Vue.$store.dispatch('getSportCountByMarket');

      setInterval(function () {
        Vue.$store.dispatch('getSportCount');
        Vue.$store.dispatch('getSportCountByMarket');
      }, 60000);
    },
    randomSleep: function randomSleep() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.sleep(500);

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    sleep: function sleep(ms) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                  return setTimeout(resolve, ms);
                }));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    if (__WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get('UID') && JSON.parse(__WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get('UID')).usrn) {
      var usrn = JSON.parse(__WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get('UID')).usrn;
      if (usrn == '-1' || !JSON.parse(__WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get('UID')).nsid) {
        this.isP = true;
      } else {
        this.isP = false;
      }
    }
    __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$on('enableLoading', function (params) {
      _this4.$store.commit('REFRESHSCREEN', params);
    });
    if (!this.account.previewFlag) {
      this.$store.commit('SET_ACC_CHIP_SETTING');
    }
    var sprt = 'N1';

    this.$store.commit('DEFAULT_SPORT', sprt);
    this.$store.commit('SELECTED_TEMPLATE', {
      templateId: 1,
      sportId: sprt
    });

    if (__WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get(window.compcode + '_xrmd')) {
      this.$store.commit('NO_SHOW_AGAIN_LIST', JSON.parse(__WEBPACK_IMPORTED_MODULE_7_vue_cookie___default.a.get(window.compcode + '_xrmd')));
      this.$store.commit('SHOW_PASSCODE_REMINDER', false);
    }

    if (!this.account.isApi && this.pch && this.pch != '' && this.account.showReminder != false) {
      this.showPasscodeCreation = true;
      this.pcTyp = '2';
    } else if ((this.userdetail.usrn !== this.account.usrn || this.userdetail && (this.userdetail.usrn === '-1' || typeof this.userdetail.nsid === 'undefined') && this.passcode.showReminder) && this.passcode.noShowAgainList.indexOf(this.account.acccode) == -1 && this.account.showReminder != false && !this.account.isApi) {
      this.showPasscodeCreation = true;
    }
    if (localStorage.getItem('bts')) {
      var bts = JSON.parse(localStorage.getItem('bts'));
      var selectedTemplate = this.arr_selectedTemplate;

      this.$store.commit('SELECTED_TEMPLATE', {
        templateId: bts.data != '' && bts.data.length > 0 ? bts.tempId : selectedTemplate.templateId,
        subTemplateId: bts.data != '' && bts.data.length > 0 ? bts.selection : 1
      });

      if (bts.data != '' && bts.data.length > 0) {
        this.$store.commit('IS_PARLAY', bts.isParlay);
        this.$store.commit('IS_OTR', bts.isOtr);
        this.$store.commit('IS_COMBOBET', bts.isCombo);

        this.$store.dispatch('getLatestInfo', {
          token: token.arr_2
        });
      }
    }
    if (this.$store.getters._sortHot) {
      this.$store.commit('SORT_HOT', this.$store.getters._sortHot);
    }
    if (this.$store.getters._editionStand) {
      this.$store.commit('EDITIONSTAND', this.$store.getters._editionStand);
    }
    if (this.$store.getters._betterOdds) {
      this.$store.commit('BETTER_ODDS', this.$store.getters._betterOdds);
    }
    if (this.$store.getters._filterLeague) {
      this.$store.commit('FILTER_LEAGUE', this.$store.getters._filterLeague);
    }
    if (this.$store.getters._theme) {
      this.$store.commit('SKIN_THEME', this.$store.getters._theme);
      if (this.$store.getters._theme == 2) {
        document.documentElement.classList.toggle('theme02');
      }
    }

    if (localStorage.getItem('simDisp')) {
      this.$store.commit('SIM_DISP', JSON.parse(localStorage.getItem('simDisp')));
    }

    this.$store.commit('DATE_LIST', window.completedDateList);

    var date = new __WEBPACK_IMPORTED_MODULE_14_moment___default.a().utcOffset(this.$store.getters.selected_timezone).format("YYYY-MM-DD");
    this.$store.commit('PARLAYDATELIST', window.earlyDateList);
    this.$store.commit('SELECTEDDATE', date);
  },
  mounted: function mounted() {
    var Vue = this;
    $('.gridContainer').css('overflow-y', 'auto');

    $(document).ready(function () {
      $("#loading-root-ele").hide();
      var lastScrollTop = 0;
      $('.scroll, #sportTable, #simpleSportTable').scroll(function () {
        var st = $(this).scrollTop();
        if ($(window).scrollTop() >= $('.scroll').offset().top + $('.scroll').outerHeight() - window.innerHeight) {
          $(".loading-more-container").show();
        } else {
          $(".loading-more-container").hide();
        }
        Vue.randomSleep();
        setTimeout(function () {
          var simpleClass = 'simple';
          if (Vue.gameBanner) {
            simpleClass = 'simple1';
          }
          var checDV = $(".sub-menu-date-w").hasClass(simpleClass);
          var checDV2 = $(".container-menu-w").hasClass("scrolling-down");
          var checDV3 = $(".container-menu-w").hasClass("scrolling-down");
          if (st > lastScrollTop) {
            if (!checDV) {
              $(".sub-menu-date-w").addClass(simpleClass);
              $(".sport-m-container").addClass(simpleClass);
              $(".list-scroll-to-topr").show();
            }
            if (checDV2) {
              $(".container-menu-w").removeClass("scrolling-down");
            }
            if (!checDV3) {
              $(".container-menu-w").addClass("scrolling-up");
            }
          } else {
            if (checDV) {
              $(".list-scroll-to-topr").hide();
              $(".sub-menu-date-w").removeClass(simpleClass);
              $(".sport-m-container").removeClass(simpleClass);
            }
            if (!checDV2) {
              $(".container-menu-w").removeClass("scrolling-up");
              $(".container-menu-w").addClass("scrolling-down");
            }
          }
          lastScrollTop = st;
        }, 100);
      });
    });

    if (window.hideLeagues && this.$store.getters.isHideLeague && this.$store.getters.isHideLeague.length == 0 && this.$store.getters.titleSport && this.$store.getters.titleSport.length > 0) {
      var _vue = this;
      var sprts = {};
      sprts.sport = 1;
      sprts.status = true;
      _.forEach(this.$store.getters.titleSport, function (val, key) {
        if (val.sid && val.sid.length > 0) {
          sprts.sport = val.sid[0];
          _vue.$store.commit('IS_HIDE_LEAGUE', sprts);
        }
      });
    }
    var playframe_original_style;
    var playframe_original_scare;
    var playframe_original_or;
    var vue = this;
    window.addEventListener("message", function (ev) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(ev.data) !== "object") return;
      if (!ev.data.type) return;
      if (ev.data.type !== "full_screen_click") return;
      var playframe_message = ev.data.message;
      var playframe = document.getElementById("bdIframe");

      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(playframe_message).length > 0) {
        var playframe_fullscreen_style = "";
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(playframe_message).forEach(function (val, idx) {
          var style_name = val;
          playframe_fullscreen_style += style_name + ': ' + playframe_message[val] + ';';
        });
        playframe_original_style = playframe.getAttribute("style");
        playframe.setAttribute("style", playframe_fullscreen_style);
        playframe_original_scare = $('#overview').css('transform');
        playframe_original_or = vue.orientation;
        if (playframe_original_scare != 'none') {
          if (playframe_original_or == 0) {
            Vue.$store.commit('TV_FULL_SCREEN', '1');
            $('.title-events-mobile-wrap').addClass('fulltv');
          } else {
            Vue.$store.commit('TV_FULL_SCREEN', '2');
          }
        }
        $('#overview').addClass('fulltv');
      } else {
        Vue.$store.commit('TV_FULL_SCREEN', '0');
        if (playframe_original_style != null) {
          playframe.setAttribute("style", playframe_original_style);
        } else {
          playframe.removeAttribute("style");
        }
        $('#overview').removeClass('fulltv');
        $('.title-events-mobile-wrap').removeClass('fulltv');
      }
    });
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__marketHeader_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contentSport_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_components_loadingScreen__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__home_gameBanner__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__oddsTable_odds1x2__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__ = __webpack_require__(91);

















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_11__vue_mixins_favourite__["a" /* default */]],
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['arr_selectedTemplate', 'arr_selectedLeague', 'sortTypes', 'sportTableLang', 'arr_earlyParlayDateList', 'int_selectedParlayDate', 'selectedSort', 'int_marketToggle', 'bettingSelection', 'bettingFormToggle', 'arr_lang', 'bettingMessage', 'arr_sportList', 'arr_selectedLeagues', 'showCalendarBox', 'selectedMatches', 'isParlay', 'isSpecial', 'isCorrectScore', 'arr_leagueList', 'totalPage', 'subLoading', 'account', 'fullLoading', 'selectedState', 'sportSelected', 'isOtr', 'showFavEvents', 'skinTheme', 'showFloating', 'isShowBtModal', 'isShowFilter', 'showHelp', 'emptyBetAmt', 'combMaxInfo', 'isComboBet', 'haveEmptyCombo', 'notSupportParlay', 'isresult_schedule', 'dateList', 'selected_date', 'schedule', 'matchSchdTab', 'arr_selectedLeagueList', 'sortedEvents', 'tvIconFlag', 'selected_timezone', 'selectedSport', 'hotMatchList', 'selected_country', 'selected_league', 'showOdds']), {
        currentSport: function currentSport() {
            return this.$store.getters.sportBettypeList[this.arr_selectedTemplate.sportId];
        },
        selectedPage: {
            get: function get() {
                return this.$store.getters.selectedPage;
            },
            set: function set(value) {

                this.reloadingPer = '0%';
                this.reloading = true;
                __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
                this.$store.commit('SELECTED_PAGE', value);
                this.reloadTable(token.arr_13 + '|' + value);
            }
        },
        completedDateList: function completedDateList() {
            return this.dateList && this.dateList.length ? this.dateList.slice(0, 7) : this.dateList;
        },
        firstEvent: function firstEvent() {
            var events = this.$store.getters.sortedEvents;
            return events && events.length ? events[0] : null;
        },
        getSelectedTz: function getSelectedTz() {
            var _this = this;

            var filtered = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.timezonelist).filter(function (tz) {
                return tz.value == _this.selected_timezone;
            });
            return filtered.length > 0 ? filtered[0].caption : this.arr_lang.home['HOME.TIMEZONE'];
        }
    }),
    components: {
        marketHeader: __WEBPACK_IMPORTED_MODULE_6__marketHeader_vue__["a" /* default */],
        contentSport: __WEBPACK_IMPORTED_MODULE_7__contentSport_vue__["a" /* default */],
        loadingScreen: __WEBPACK_IMPORTED_MODULE_8__vue_components_loadingScreen__["a" /* default */],
        gameBanner: __WEBPACK_IMPORTED_MODULE_9__home_gameBanner__["a" /* default */],

        odds1x2: __WEBPACK_IMPORTED_MODULE_10__oddsTable_odds1x2__["a" /* default */]
    },
    data: function data() {
        return {
            timerSeconds: 90,
            timerId: null,
            selectedSortType: "",
            selectedDate: "",
            token: window.token,
            cookies_lang: window._cookie,
            gameBannerImage: window._gameBannerImage,
            heightPX: window.innerHeight,
            popularLeagues: window.popularLeagues,
            countryMatches: window.countryMatches,
            timezonelist: window._timezonelist,
            collapsedBoxes: [],
            scheduleTab: 'completed',
            isTimeZoneOpen: false,
            ftPlyType: '1',
            setHandicapPlyType: '3',
            onex2BetType: '4',
            ronex2BetType: '11',
            mlBetType: '12',
            rmlBetType: '13',
            selected_panel: '',
            innerWidth: window.innerWidth
        };
    },

    methods: {
        getWeekdays: function getWeekdays(dt) {
            if (this.cookies_lang == 'en_US') {
                return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dt).format('ddd');
            } else {
                return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dt).format('dddd');
            }
        },
        getMonth: function getMonth(dt) {
            if (this.cookies_lang == 'en_US') {
                return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dt).format('MMM');
            } else {
                return __WEBPACK_IMPORTED_MODULE_5_moment___default()(dt).format('MMMM');
            }
        },
        changeEarlyParlayDate: function changeEarlyParlayDate(datekey) {
            this.$store.commit('SELECTED_PAYLAY_DATE', datekey);
            this.$store.dispatch('getLaugueList', {
                token: token.arr_6
            });
        },
        startTimer: function startTimer() {
            var _this2 = this;

            if (this.int_marketToggle == 3) {
                this.timerSeconds = 10;
            }
            if (this.timerId == null) {
                this.timerId = setInterval(function () {
                    if (!_this2.bettingFormToggle) {
                        if (!_this2.bettingMessage) {
                            if (_this2.timerSeconds - 1 < 0) {
                                _this2.reloadTable(token.arr_1);
                            } else {
                                _this2.timerSeconds -= 1;
                            }
                        }
                    }
                }, 1000);
            }
        },
        refreshTimer: function refreshTimer() {
            this.clearTimer();
            this.timerSeconds = 90;
            if (this.int_marketToggle == 3) {
                this.timerSeconds = 10;
            }
            this.startTimer();
        },
        clearTimer: function clearTimer() {
            clearInterval(this.timerId);
            this.timerId = null;
        },
        reloadTable: function reloadTable() {
            var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.$store.dispatch('getSportOdds', {
                loading: 0,
                token: token_val
            });
            this.refreshTimer();
        },
        changeSubTemplate: function changeSubTemplate(subTemplateId) {
            var sportId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if ((this.$store.getters.int_marketToggle == '1' || this.$store.getters.int_marketToggle == '2') && subTemplateId == 2 || this.$store.getters.int_marketToggle == '2' && subTemplateId == 1) {
                this.$store.commit('SELECTED_PAYLAY_DATE', 99);
                if (this.$store.getters.int_marketToggle == '1' && subTemplateId == 2) {
                    this.$store.commit('SELECTED_PAYLAY_DATE', 0);
                }
                this.selectedDate = this.int_selectedParlayDate;
            }

            if (account.previewFlag == undefined || account.previewFlag && this.$store.getters.int_marketToggle != '1') {
                var btemplateId = 2;
            } else if (account.previewFlag && this.$store.getters.int_marketToggle == '1') {
                var btemplateId = 3;
                this.$store.commit('SEL_MATCH', true);
            }

            this.$store.dispatch('changeTemplate', {
                templateId: btemplateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 1,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: sportId != null ? sportId : this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId
            });
            if (subTemplateId == '3') {
                this.$store.dispatch('getOutrightLeague', {
                    token: token.arr_2
                });
            } else {
                if (this.$store.getters.int_marketToggle == '3') {
                    this.$store.dispatch('getLiveSportOdds', {
                        enableLoading: true,
                        token: token.arr_2
                    });
                } else {
                    if (this.$store.getters.isSpecial) {
                        this.$store.dispatch('getSpecialEventOdds', {
                            enableLoading: true,
                            token: token.arr_2
                        });
                    } else {
                        if (this.isOtr) {
                            this.$store.dispatch('getOutrightLeague', { token: token.arr_1 });
                        } else {
                            if (this.$store.getters.arr_selectedTemplate.marketKey == 1) {
                                this.$store.dispatch('getTodayRBSportOdds', {
                                    loading: 1,
                                    token: token.arr_2,
                                    state: this.$store.getters.selectedState ? this.$store.getters.selectedState : ''
                                });
                            } else {
                                this.$store.dispatch('getSportOdds', {
                                    loading: 1,
                                    token: token.arr_2,
                                    state: this.$store.getters.selectedState ? this.$store.getters.selectedState : ''
                                });
                            }
                        }
                    }
                }
            }
            this.refreshTimer();
        },
        changeSpecialTemplate: function changeSpecialTemplate(market) {
            var _this3 = this;

            var sprtId = 'N1';
            var plytype = 1;
            var subTemplateId = 1;

            var bettypeid = sprtId.split('');
            if (bettypeid.length >= 3) {
                bettypeid = bettypeid[1] + "" + bettypeid[2];
            } else {
                bettypeid = bettypeid[1];
            }
            this.$store.commit('SUBLOAD', true);

            this.$store.commit('ARR_LEAGUES', []);
            this.$store.commit('SELECTED_LEAGUES', []);
            this.$store.commit('SEL_MATCH', false);
            this.$store.commit('SELECTED_LEAGUE', []);
            this.$store.commit('SORTEDEVENTLIST', []);

            this.$store.commit('S_ODD', true);

            this.$store.dispatch('getEventList', {
                market: market,
                token: token.arr_2,
                callback: function (res) {
                    _this3.$store.commit('MARKETTOGGLE', market);
                    _this3.$store.dispatch('changeTemplate', {
                        templateId: 2,
                        marketKey: market,
                        plytype: plytype,
                        bettypeid: bettypeid,
                        sportId: sprtId,
                        subTemplateId: subTemplateId
                    });
                    _this3.$store.commit('SELECTED_MARKET', market);

                    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('sportTemplate', sprtId);
                    $('.chkbox_league').prop('checked', false);
                }.bind(this)
            });
        },
        sortLeague: function sortLeague(event) {
            var token_val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var sortId = this.selectedSort == '1' ? '2' : '1';
            this.$store.commit('SELECTED_SORT', sortId);
            this.reloadTable(token_val);
        },
        sportTemplate: function sportTemplate(sportId) {
            var vue = this;

            this.$store.commit('SELECTED_TEMPLATE', {
                sportId: sportId,
                marketKey: vue.int_marketToggle,
                subTemplateId: vue.$store.getters.arr_selectedTemplate.subTemplateId
            });

            this.$store.commit('SELECTED_SPORT', sportId);
            var bettypeid = sportId.split('');
            if (bettypeid.length >= 3) {
                bettypeid = bettypeid[1] + "" + bettypeid[2];
            } else {
                bettypeid = bettypeid[1];
            }
            __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('enableLoading', true);
            this.changeSubTemplate(vue.$store.getters.arr_selectedTemplate.subTemplateId, sportId);
            this.$store.commit('SELECTED_MARKET', this.int_marketToggle);
        },
        goBack: function goBack() {
            if (this.$store.getters.isSpecial) {
                if (this.$store.getters.arr_selectedTemplate.templateId == 6) {
                    this.changeSpecialTemplate(this.$store.getters.int_marketToggle);
                } else {
                    this.changeSpecialTemplate(1);
                }
            } else {
                this.$store.commit('ARR_LEAGUES', []);
                this.$store.commit('SEL_MATCH', false);
                this.$store.commit('SORTEDEVENTLIST', []);
                if (this.$store.getters.arr_selectedTemplate.templateId == 17) {
                    this.changeTemplate(1);
                } else if (this.$store.getters.arr_breadcumb.length > 0) {
                    if (this.$store.getters.arr_selectedTemplate.templateId == 3) {
                        this.$store.commit('SELECTED_LEAGUE', []);
                        this.$store.commit('SELECTED_LEAGUES', []);
                        this.$store.commit('SELECTED_STATE', '');
                        if (this.isParlay) {
                            this.$store.dispatch('changeTemplate', {
                                templateId: 21,
                                marketKey: this.$store.getters.int_marketToggle,
                                plytype: 1,
                                bettypeid: this.arr_selectedTemplate.bettypeid,
                                sportId: this.arr_selectedTemplate.sportId,
                                subTemplateId: 2
                            });
                        } else {
                            this.$store.dispatch('changeTemplate', {
                                templateId: 2,
                                marketKey: this.$store.getters.int_marketToggle,
                                plytype: 1,
                                bettypeid: this.arr_selectedTemplate.bettypeid,
                                sportId: this.arr_selectedTemplate.sportId,
                                subTemplateId: 1
                            });
                        }
                    } else {
                        this.$store.dispatch('redirectReturn');
                    }
                } else if (this.$store.getters.arr_selectedTemplate.subTemplateId != 4) {
                    this.$store.commit('SELECTED_LEAGUE', []);
                } else if (this.$store.getters.arr_selectedTemplate.templateId != 6) {
                    this.$store.commit('SELECTED_LEAGUES', []);
                } else {
                    window.history.go(-1);
                }
            }
        },
        showCalendar: function showCalendar() {
            if (this.$store.getters.showCalendarBox) {
                this.$store.commit('SHOW_CALENDAR', false);
            } else {
                this.$store.commit('SHOW_CALENDAR', true);
            }
        },
        getMainMarket: function getMainMarket(subTemplateId) {
            var token_val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            this.$store.commit('IS_CORRECTSCORE', false);
            var templateId = this.$store.getters.int_marketToggle == '3' ? 2 : 3;

            if (this.$store.getters.int_marketToggle == '3') {
                this.$store.commit('SELECTED_LEAGUES', []);
            }

            if (this.selectedState != null && this.selectedState != '') {
                this.$store.commit('SELECTED_LEAGUE', []);
            }

            var plytype = 1;

            if (this.isParlay) {
                plytype = 5;
                subTemplateId = '2';
            }

            this.$store.dispatch('changeTemplate', {
                templateId: templateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: plytype,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId
            });
        },
        getCorrectScore: function getCorrectScore(subTemplateId) {
            var token_val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var market = this.$store.getters.isParlay ? 1 : this.$store.getters.int_marketToggle;
            this.$store.commit('MARKETTOGGLE', market);
            this.$store.commit('IS_CORRECTSCORE', true);

            var templateId = this.$store.getters.int_marketToggle == '3' ? 2 : 3;
            if (this.$store.getters.isSpecial) {
                templateId = 2;
            }
            this.$store.dispatch('changeTemplate', {
                templateId: templateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 2,
                bettypeid: 7,
                sportId: this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId
            });

            this.$store.commit('SUBLOAD', true);
            if (this.$store.getters.isSpecial) {
                this.$store.dispatch('getSpecialCorrectScore', {
                    loading: 1,
                    token: token_val
                });
            } else {
                this.$store.dispatch('getSportCorrectScore', {
                    loading: 1,
                    token: token_val,
                    state: this.selectedState ? this.selectedState : ''
                });
            }
        },
        getLiveLeague: function getLiveLeague() {
            var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.$store.dispatch('changeTemplate', {
                templateId: 2,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 1,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: this.arr_selectedTemplate.sportId,
                subTemplateId: 5
            });
            this.$store.dispatch('getLaugueList', {
                enableLoading: true,
                token: token.arr_2
            });
            this.refreshTimer();
        },
        toggleActive: function toggleActive() {
            this.sortActive = false;
            this.showTypeActive = false;
            this.oddsTypeActive = false;
            this.marketActive = false;
        },
        checkSportList: function checkSportList(sport) {
            var STORE = this;
            var sportId = [];
            if (sport == 'N1') {
                sportId = ['1'];
            } else if (sport == 'G1') {
                sportId = ['2', '13'];
            } else if (sport == 'N3') {
                sportId = ['3'];
            } else if (sport == 'N21') {
                sportId = ['21'];
            } else if (sport == 'N12') {
                sportId = ['12'];
            } else if (sport == 'N24') {
                sportId = ['24'];
            } else if (sport == 'N23') {
                sportId = ['23'];
            } else if (sport == 'N15') {
                sportId = ['15'];
            } else if (sport == 'G2') {
                sportId = ['7', '14', '19', '20'];
            } else if (sport == 'G98') {
                sportId = ['1', '2', '3', '7', '12', '13', '14', '15', '19', '20', '21', '23', '24'];
            }

            var d = _.keys(this.arr_sportList);
            _.each(sportId, function (val) {
                if (_.indexOf(d, val) !== -1) {
                    STORE.$set(STORE.$store.getters.arr_selectedTemplate, 'sportId', sport);
                    STORE.$store.commit('SPORT_SELECTED', true);
                } else {
                    STORE.$store.commit('SPORT_SELECTED', false);
                }
            });
        },
        getAllSportCount: function getAllSportCount(comid) {
            var Vue = this;

            Vue.$store.dispatch('getSportCount');
            Vue.$store.dispatch('getSportCountByMarket');

            setInterval(function () {
                Vue.$store.dispatch('getSportCount');
                Vue.$store.dispatch('getSportCountByMarket');
            }, 60000);
        },
        changeMarket: function changeMarket(val, dt) {
            if (dt == undefined) {
                var date = new __WEBPACK_IMPORTED_MODULE_5_moment___default.a().utcOffset(this.$store.getters.selected_timezone).format("YYYY-MM-DD");
                dt = date;
            }
            $(".scroll").scrollTop(0);

            this.$store.commit('SORTEDEVENTLIST', []);
            this.$store.commit('MATCH_SCHEDULE_TAB', val);
            this.$store.commit('SCHEDULE', val);
            if (this.$store.getters.selected_country) {
                this.$store.commit('PLAYTYPE', 3);
            }


            if (val == 3) {
                this.$store.commit('SELECTEDDATE', dt);
            } else {
                this.$store.commit('SELECTEDDATE', dt);
            }
            this.$store.dispatch('getSportOdds', {
                loading: 1,
                token: token.arr_2
            });
        },
        changeDate: function changeDate(val, dt) {
            if (this.$store.getters.selected_league == null) {
                this.$store.commit('PLAYTYPE', 1);
            }
            if (this.scheduleTab == 'completed') {
                val = 3;
            } else if (this.scheduleTab == 'upcoming') {
                val = 1;
            }
            this.changeMarket(val, dt);
        },
        checkHotLeg: function checkHotLeg(lge, selected) {
            if (lge.lgeid == selected) {
                return 'current';
            }
        },
        filterLeague: function filterLeague(lge) {
            var isHot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            $(".scroll").scrollTop(0);
            var plytyp = 2;
            var sport = lge.sptid;
            var lgeid = lge.lgeid;
            var getSport = _.filter(this.$store.getters.titleSport, function (x) {
                return _.indexOf(x.sid, sport.toString()) !== -1;
            });
            if (getSport && getSport.length > 0) {
                sport = getSport[0].id;
            }
            if (lgeid == this.selected_league) {
                lgeid = null;
                plytyp = 1;
            }
            if (isHot) {
                __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('changeMatches');
            }
            this.$store.commit('SELECTEDCOUNTRY', null);
            this.$store.commit('SELECTED_SPORT', sport);
            this.$store.commit('SELECTEDLEAGUE', lgeid);
            this.$store.commit('SELECTED_TEMPLATE', { templateId: 1 });
            this.$store.commit('PLAYTYPE', plytyp);
            this.changeMarket(this.$store.getters.schedule, this.$store.getters.selected_date);
        },
        toggleCollapse: function toggleCollapse(index) {
            if (window.innerWidth < 769) {
                this.collapsedBoxes = [];
                return;
            }
            var idx = this.collapsedBoxes.indexOf(index);
            if (idx > -1) {
                this.collapsedBoxes.splice(idx, 1);
            } else {
                this.collapsedBoxes.push(index);
            }
        },
        toggleScheduleTab: function toggleScheduleTab(tab) {
            this.scheduleTab = tab;
        },
        toggleTimezone: function toggleTimezone() {
            this.isTimeZoneOpen = !this.isTimeZoneOpen;
        },
        changeTimezone: function changeTimezone(val) {
            $('.selected-timezone').text(val.caption);
            this.$store.commit('SELECTEDTIMEZONE', val.value);
            this.reloadTable();
        },
        oddsSwitch: function oddsSwitch() {
            this.$store.commit('SHOW_ODDS_TOGGLE', !this.showOdds);
            this.$ajax({
                url: _baseUrl + '/account-def-settings',
                type: 'get',
                data: {
                    action: 'previewSetting',
                    showOdds: this.showOdds ? 1 : 0
                }
            }).done(function (response) {});
        },
        getAllBet: function getAllBet(event) {
            var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            if (event && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(event).length) {
                if (channel == 1 && (event.rb != 1 || event.ch == 0)) {
                    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('getAllBet', event, 0);
                } else {
                    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('getAllBet', event, channel);
                }
            }
        },
        getPlaytype: function getPlaytype() {
            if (this.arr_selectedTemplate['sportId'] == 'N3' || this.arr_selectedTemplate['sportId'] == 'N21' || this.arr_selectedTemplate['sportId'] == 'N12') {
                return this.setHandicapPlyType;
            } else {
                return this.ftPlyType;
            }
        },
        getBettype: function getBettype(spid, rb) {
            if (spid == 1) {
                if (rb == 1) {
                    return this.ronex2BetType;
                } else {
                    return this.onex2BetType;
                }
            } else {
                if (rb == 1) {
                    return this.rmlBetType;
                } else {
                    return this.mlBetType;
                }
            }
        },
        selectCountry: function selectCountry(cid) {
            var plytyp = 3;
            if (cid == this.selected_country) {
                cid = null;
                plytyp = 1;
            }
            $(".scroll").scrollTop(0);

            this.$store.commit('SELECTEDLEAGUE', null);
            this.$store.commit('SELECTEDCOUNTRY', cid);
            this.$store.commit('SELECTED_TEMPLATE', { templateId: 1 });
            this.$store.commit('PLAYTYPE', plytyp);
            __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('changeMatches');
            this.changeMarket(this.$store.getters.schedule, this.$store.getters.selected_date);
        },
        handleDateChange: function handleDateChange(event) {
            if (this.$store.getters.selected_league == null) {
                this.$store.commit('PLAYTYPE', 1);
            }
            this.changeMarket(this.$store.getters.schedule, event.target.value);
        },
        panelClick: function panelClick() {
            var panel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.selected_panel = panel;
        },
        handleResize: function handleResize() {
            this.innerWidth = window.innerWidth;
            if (window.innerWidth < 769) {
                this.collapsedBoxes = [];
            } else {
                this.panelClick();
            }
        }
    },
    beforeMount: function beforeMount() {
        if (!this.isParlay) {
            this.$store.commit('SELECTED_PAYLAY_DATE', 99);
        }
        if (this.int_marketToggle == '1' && this.arr_selectedTemplate.subTemplateId == 2) {
            this.$store.commit('SELECTED_PAYLAY_DATE', 0);
        }

        this.selectedDate = this.int_selectedParlayDate;
        this.selectedSortType = this.selectedSort;

        this.startTimer();
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('resetTimer', function () {
            this.refreshTimer();
        }.bind(this));
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('refreshSportHeaderSelection', function () {
            this.selectedDate = this.int_selectedParlayDate;
        }.bind(this));
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('sportTemplate');
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('sportTemplate', function (sportId) {
            this.sportTemplate(sportId);
        }.bind(this));
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('sportOutrightTemplate');
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('sportOutrightTemplate', function (sportId) {
            this.sportTemplate(sportId);
        }.bind(this));
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('sportAllTemplate', function (sportId) {
            this.sportAllTemplate(sportId);
        }.bind(this));

        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('changeMarketTab');
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('changeMarketTab', function (val, dt) {
            this.changeMarket(val, dt);
        }.bind(this));
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('filterLeague');
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('filterLeague', function (val) {
            this.filterLeague(val);
        }.bind(this));
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('changeMarketTab');
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('refreshSportHeaderDate');
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('resetTimer');
        __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('sportAllTemplate');
        if (this.$store.getters.isresult_schedule) {
            __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('sportTemplate');
        }
        this.clearTimer();
    },
    mounted: function mounted() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    },
    beforeUnmount: function beforeUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketHeader_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b0d4f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketHeader_vue__ = __webpack_require__(296);
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_marketHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b0d4f9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_marketHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_accountMenu_vue__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_gameHeader_vue__ = __webpack_require__(181);




var _computed$watch$compo;







/* harmony default export */ __webpack_exports__["a"] = (_computed$watch$compo = {
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['account', 'arr_sportList', 'sportBettypeList', 'int_marketToggle', 'arr_selectedTemplate', 'tvIconFlag', 'isParlay', 'isSpecial', 'isVip', 'isCorrectScore', 'openBetCount', 'parlaySportList', 'fullLoading', 'sportSelected', 'skinTheme', 'arr_sportCountMarket', 'isOtr', 'isResult', 'showFavEvents', 'arr_earlyEventCountByDate', 'currentTab', 'titleSport', 'isGameBannerSelected', 'gameBannerSportId', 'isresult_schedule', 'arr_lang', 'selectedSport', 'selected_league', 'selected_country', 'playtype']), {
    market: function market() {
      return this.$store.getters.market;
    },
    selectedMarket: function selectedMarket() {
      return this.$store.getters.int_selectedMarket;
    },
    decimals: function decimals() {
      return this.account.showDecimals ? 2 : 0;
    }
  }),
  watch: {
    searchText: function searchText(newVal) {
      this.$store.dispatch('sortEvents');
    }
  },
  components: {
    EventBus: __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */],
    accMenu: __WEBPACK_IMPORTED_MODULE_5__home_accountMenu_vue__["a" /* default */],
    gameHeader: __WEBPACK_IMPORTED_MODULE_6__home_gameHeader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      cookies_lang: window._cookie,
      lang: window.lang,
      odds: window.odds,
      eventId: null,
      currentTemplate: window._currentTemplate,
      customTemplate: window._customTemplate,
      companycode: window.compcode,
      timestamp: "",
      isSelectedMarketId: [2, 3, 4, 5, 6],
      showSpecialEvent: false,
      fromSpecialEvent: false,
      showVipEvent: false,
      gameBannerImage: window._gameBannerImage,
      lobby: window.lobby,
      lobbyUrl: window.lobbyUrl,
      isVIP: window._isVIP,
      isShowMenu: false,
      moreDetails: false,
      langId: window._langid,
      revertLang: window._langid == 10 ? '-revert' : '',
      isSettingsOpen: false,
      isLangOpen: false,
      langSelect: lang_select,
      popularLeagues: window.popularLeagues,
      searchText: '',
      selectedPopular: false
    };
  },
  created: function created() {
    setInterval(this.getNow, 1000);
  },

  methods: {
    loadGoogleTranslateScript: function loadGoogleTranslateScript() {
      if (document.getElementById("google-translate-script")) return;
      var script = document.createElement("script");
      script.id = "google-translate-script";
      script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      document.body.appendChild(script);

      window.googleTranslateElementInit = function () {
        new window.google.translate.TranslateElement({
          pageLanguage: "en",
          autoDisplay: false
        }, "google_translate_container");
      };
    },
    setGoogTransCookie: function setGoogTransCookie(val) {
      try {
        document.cookie = 'googtrans=' + val + '; path=/; max-age=31536000';
        document.cookie = 'googtrans=' + val + '; path=/; domain=.' + location.hostname + '; max-age=31536000';
      } catch (e) {}
    },
    clearGoogTransCookie: function clearGoogTransCookie() {
      new window.google.translate.TranslateElement({
        pageLanguage: "en",
        autoDisplay: false
      }, "google_translate_container");
      var expires = "Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = 'googtrans=; expires=' + expires + '; path=/';
      document.cookie = 'googtrans=; expires=' + expires + '; path=/; domain=.' + location.hostname;
      document.cookie = 'googtrans=; expires=' + expires + '; path=/; domain=.' + location.hostname.replace("www.", "");
    },
    getCurrentLangFromCookie: function getCurrentLangFromCookie() {
      var match = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
      if (!match) return "en";
      var val = decodeURIComponent(match[1]);
      var parts = val.split("/");
      return parts.length >= 3 ? parts[2] : "en";
    },
    showContact: function showContact() {
      var langsPost = 1;
      if (this.langId == 2) {
        langsPost = 3;
      } else if (this.langId == 2) {
        langsPost = 3;
      } else if (this.langId == 3) {
        langsPost = 4;
      } else if (this.langId == 5) {
        langsPost = 2;
      }

      window.open('https://sigma23.3swolf.com/views/page.php?pg=1&acc=' + this.account.acccode + '&lang=' + langsPost);
    },

    getNow: function getNow() {
      Date.prototype.addHours = function (h) {
        this.setHours(this.getHours() + h);
        return this;
      };

      var today = new Date().addHours(-12);

      var hours = today.getHours();

      hours = hours < 10 ? '0' + hours : hours;

      var minutes = today.getMinutes();
      minutes = minutes < 10 ? '0' + minutes : minutes;

      var seconds = today.getSeconds();
      seconds = seconds < 10 ? '0' + seconds : seconds;

      var time = hours + ":" + minutes + ":" + seconds;
      this.timestamp = time;
    },
    hideMenuAll: function hideMenuAll(event) {
      if (event.target.id == "menu-inner") return;
      if ($(event.target).closest('#menu-inner').length) return;
      this.moreDetails = false;
    },
    convertCCL: function convertCCL(ccl) {
      return Math.floor(ccl);
    },
    getSportCCL: function getSportCCL() {
      if (!this.account.previewFlag) {
        this.$store.dispatch('getSportCCL', {
          token: token.arr_5
        });
      }
    },
    changeTemplate: function changeTemplate(templateId) {
      var subTemplateId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$store.dispatch('changeTemplate', {
        templateId: templateId,
        marketKey: this.$store.getters.int_marketToggle,
        bettypeid: this.$store.getters.arr_selectedTemplate.bettypeid,
        sportId: this.$store.getters.arr_selectedTemplate.sportId,
        subTemplateId: subTemplateId
      });
      this.showMenu = false;
    },
    toTemplate: function toTemplate(ItemplateId, IsubTemplateId) {
      var _this = this;

      if (account.previewFlag) {}

      if (ItemplateId == 21) {
        this.$store.commit('IS_RESULT_SCHEDULE', false);
        this.$store.commit('CURRENT_TAB', 4);
      } else if (ItemplateId == 19) {
        this.$store.commit('IS_PARLAY', false);
        this.$store.commit('IS_RESULT_SCHEDULE', true);
        this.$store.commit('CURRENT_TAB', 5);
      } else if (ItemplateId == 20) {
        this.$store.commit('IS_PARLAY', false);
        this.$store.commit('IS_RESULT_SCHEDULE', true);
        this.$store.commit('CURRENT_TAB', 7);
      }

      if ([15, 14].indexOf(ItemplateId) >= 0) {
        this.$store.commit('SELECTED_WAGER_SPORT', 99);
      }

      if (ItemplateId == 14) {
        this.$store.dispatch('getOpenBet', {
          wgrTyp: 'openBet',
          perPage: 10,
          token: token.arr_2
        });
      }
      this.$nextTick(function () {
        _this.$store.dispatch('changeTemplate', {
          templateId: ItemplateId,
          subTemplateId: IsubTemplateId,
          sportId: _this.$store.getters.arr_selectedTemplate.sportId,
          plytype: 1
        });
      });
    },
    showMarket: function showMarket(market, backButton) {
      var _this2 = this;

      var container = $(".sub-m-menu");
      var container2 = $(".sub-background");
      if (container || container2) {
        container.hide();
        container2.hide();
      }
      this.$store.commit('SHOW_FLOATING', false);
      var sprtId = 'N1';
      if (market != 3 && this.$store.getters.arr_selectedTemplate.sportId == 'G98') {
        sprtId = 'N1';
      } else {
        sprtId = this.$store.getters.arr_selectedTemplate.sportId ? this.$store.getters.arr_selectedTemplate.sportId : 'N1';
      }

      if (this.isGameBannerSelected) {
        sprtId = this.gameBannerSportId;
      }
      var bettypeid = null;
      var plytype = 1;
      var subTemplateId = 1;
      var marketCap = null;

      if (this.fromSpecialEvent) {
        this.fromSpecialEvent = false;
      }

      if (market == 1) {
        marketCap = 'today';
      } else if (market == 2) {
        marketCap = 'early';
      } else if (market == 3) {
        marketCap = 'live';
      } else if (market == 7) {
        marketCap = 'schedule';
      }

      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('marketChange', market);
      if (account.previewFlag || account.previewFlag == undefined && market == '3') {
        this.$store.commit('S_ODD', true);
      } else {
        this.$store.commit('S_ODD', false);
      }
      this.$store.commit('ARR_LEAGUES', []);
      this.$store.commit('SELECTED_LEAGUES', []);
      this.$store.commit('SEL_MATCH', false);
      this.$store.commit('SELECTED_LEAGUE', []);
      this.$store.commit('SORTEDEVENTLIST', []);
      this.$store.commit('SPORT_SELECTED', false);
      this.$store.dispatch('getEventList', {
        market: market,
        token: token.arr_2,
        callback: function (res) {
          _this2.$store.commit('MARKETTOGGLE', market);
          if (account.previewFlag == undefined || account.previewFlag && market != '1') {
            var btemplateId = 1;
          } else if (account.previewFlag && market == '1') {
            var btemplateId = 3;
            _this2.$store.commit('SEL_MATCH', true);
          }

          if (sprtId != '' && sprtId != 'G98' && !_this2.isGameBannerSelected) {
            if (_this2.$store.getters.arr_sportList != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.$store.getters.arr_sportList).length > 0) {
              var current1stSport = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(res.totalMatch)[0];
              if (market == 1) {
                if (_this2.$store.getters.arr_sportCountMarket.live && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.$store.getters.arr_sportCountMarket.live).length > 0) {
                  var rbSport = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.$store.getters.arr_sportCountMarket.live)[0];
                  if (rbSport <= current1stSport) {
                    current1stSport = rbSport;
                  }
                }
              }

              var getSport = _.filter(_this2.$store.getters.titleSport, function (x) {
                return _.indexOf(x.sid, current1stSport) !== -1;
              });

              if (_this2.$store.getters.market_button_toggle && sprtId != 'G3') {
                var currSport = _.filter(_this2.$store.getters.titleSport, function (x) {
                  return x.id == sprtId;
                });
                var currSportId = currSport[0].sid[0];
                if (_this2.$store.getters.arr_sportList[currSportId] == null) {
                  sprtId = getSport && getSport.length > 0 ? getSport[0].id : 'N1';
                }
              }

              bettypeid = sprtId.split('');
              if (bettypeid.length >= 3) {
                bettypeid = bettypeid[1] + "" + bettypeid[2];
              } else {
                bettypeid = bettypeid[1];
              }
            }
          }

          if (!backButton) {
            _this2.$store.dispatch('changeTemplate', {
              templateId: btemplateId,

              marketKey: market,
              plytype: plytype,
              bettypeid: bettypeid,
              sportId: sprtId,
              subTemplateId: subTemplateId
            });
          }

          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);

          if (_this2.moreDetails) {
            _this2.moreDetails = false;
          }
          _this2.$nextTick(function () {
            _this2.$store.commit('SELECTED_MARKET', market);
            __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('marketChange', market);
            _this2.$store.commit('MARKETTOGGLE', market);
            __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('sportTemplate', sprtId);
            $('.chkbox_league').prop('checked', false);
          });
        }.bind(this)
      });
    },
    checkMarket: function checkMarket(market) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var buttonClick = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (account.previewFlag) {
        if (value == '1') {
          alert(lang.info7);
          return false;
        }
      }
      this.$store.commit('SELECT_ALL_LEAGUE', true);
      this.$store.commit('FILTER_SELECT_ALL', true);
      this.$store.commit('MARKET_BUTTON_TOGGLE', buttonClick);
      var container = $(".sub-m-menu");
      var container2 = $(".sub-background");
      if (container || container2) {
        container.hide();
        container2.hide();
      }
      this.$store.commit('SHOW_FLOATING', false);

      this.$store.commit('IS_CORRECTSCORE', false);
      this.$store.commit('SELECTED_STATE', '');
      if (this.$store.getters.showCalendarBox) {
        this.$store.commit('SHOW_CALENDAR', false);
      }
      this.$store.commit('IS_OTR', false);
      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('enableLoading', true);

      this.$store.commit('SWIPE_MODE', 1);
      $('.odd-t-i-wrapper').removeClass('status2');
      $('.standard-odd-l-w').removeClass('status2');
      this.$store.commit('VIRTUAL_DATA_LIST', []);


      this.$store.commit('COOKIE_LEAGUE', {
        remove: true
      });

      if (value != null) {
        if (value == '1') {
          if (account.previewFlag) {
            alert(lang.info7);
            return false;
          }
          this.$store.commit('IS_PARLAY', true);
          this.$store.commit('IS_SPECIAL', false);
          this.$store.commit('IS_COMBOBET', false);
          this.$store.commit('SHOW_CALENDAR', true);
          this.$store.commit('IS_RESULT_SCHEDULE', true);
          this.$store.commit('CURRENT_TAB', 4);
          this.$store.commit('MARKETTOGGLE', market);

          this.showParlayMarket(market);
        } else if (value == '2') {
          this.$store.commit("GAMEBANNER_SELECTED", false);
          this.$store.commit('IS_PARLAY', false);
          this.$store.commit('IS_SPECIAL', false);
          this.$store.commit('IS_VIP', false);
          this.$store.commit('MARKETTOGGLE', market);
          this.$store.commit('IS_COMBOBET', false);
          this.$store.commit('BETTING_SELECTION', []);
          this.$store.commit('IS_RESULT_SCHEDULE', false);
          this.$store.commit('CURRENT_TAB', 3);
          this.showOutright(market);
        } else if (value == '99') {
          this.$store.commit('IS_VIP', true);
          this.$store.commit('IS_PARLAY', false);
          this.$store.commit('IS_SPECIAL', false);
          this.$store.commit('IS_COMBOBET', false);
          this.$store.commit('S_ODD', true);
          this.$store.commit('IS_RESULT_SCHEDULE', false);
          this.changeSpecialTemplate(market);
        } else {
          this.fromSpecialEvent = true;
          this.$store.commit('IS_PARLAY', false);
          this.$store.commit('IS_SPECIAL', true);
          this.$store.commit('IS_VIP', false);
          this.$store.commit('S_ODD', true);
          this.$store.commit('IS_COMBOBET', false);
          this.$store.commit('IS_RESULT_SCHEDULE', false);
          this.changeSpecialTemplate(market);
        }
      } else {
        if (this.isParlay && this.$store.getters.bettingSelection && this.$store.getters.bettingSelection.length > 0) {
          this.$store.commit('IS_PARLAY', true);
        } else {
          this.$store.commit('IS_PARLAY', false);
        }
        this.$store.commit('IS_SPECIAL', false);
        this.$store.commit('IS_VIP', false);
        this.$store.commit('MARKETTOGGLE', market);
        if (market == 1) {
          this.$store.commit('CURRENT_TAB', 1);
        } else if (market == 2) {
          this.$store.commit('TODAYRBEVENTLIST', []);
          this.$store.commit('SORTEDTODAYRBEVENTLIST', []);
          this.$store.commit('CURRENT_TAB', 2);
          this.$store.commit('SHOW_CALENDAR', true);
        }
        this.showMarket(market);
      }
      this.startTimer();
    },
    modifySportId: function modifySportId() {
      if (this.arr_sportList.propertyIsEnumerable(1)) {
        return 'N1';
      } else if (this.arr_sportList.propertyIsEnumerable(2) || this.arr_sportList.propertyIsEnumerable(13)) {
        return 'G1';
      } else if (this.arr_sportList.propertyIsEnumerable(3)) {
        return 'N3';
      } else if (this.arr_sportList.propertyIsEnumerable(21)) {
        return 'N21';
      } else if (this.arr_sportList.propertyIsEnumerable(12)) {
        return 'N12';
      } else if (this.arr_sportList.propertyIsEnumerable(24)) {
        return 'N24';
      } else if (this.arr_sportList.propertyIsEnumerable(23)) {
        return 'N23';
      } else if (this.arr_sportList.propertyIsEnumerable(15)) {
        return 'N15';
      } else if (this.arr_sportList.propertyIsEnumerable(7) || this.arr_sportList.propertyIsEnumerable(14) || this.arr_sportList.propertyIsEnumerable(19) || this.arr_sportList.propertyIsEnumerable(20)) {
        return 'G2';
      }
    },
    modifyParlaySportId: function modifyParlaySportId() {
      if (this.parlaySportList.propertyIsEnumerable(1)) {
        return 'N1';
      } else if (this.parlaySportList.propertyIsEnumerable(2) || this.parlaySportList.propertyIsEnumerable(13)) {
        return 'G1';
      } else if (this.parlaySportList.propertyIsEnumerable(3)) {
        return 'N3';
      } else if (this.parlaySportList.propertyIsEnumerable(21)) {
        return 'N21';
      } else if (this.parlaySportList.propertyIsEnumerable(12)) {
        return 'N12';
      } else if (this.parlaySportList.propertyIsEnumerable(24)) {
        return 'N24';
      } else if (this.parlaySportList.propertyIsEnumerable(23)) {
        return 'N23';
      } else if (this.parlaySportList.propertyIsEnumerable(15)) {
        return 'N15';
      } else if (this.parlaySportList.propertyIsEnumerable(7) || this.parlaySportList.propertyIsEnumerable(14) || this.parlaySportList.propertyIsEnumerable(19) || this.parlaySportList.propertyIsEnumerable(20)) {
        return 'G2';
      }
    },
    showMenu: function showMenu() {
      this.moreDetails = false;
      $('#accountMenu').addClass('on');
    },
    checkMarketId: function checkMarketId(id) {
      return this.isSelectedMarketId.indexOf(id) !== -1;
    },
    changeParlayTemplate: function changeParlayTemplate(market) {

      this.$store.commit('IS_PARLAY', true);
      this.$store.commit('MARKETTOGGLE', market);

      var sprtId = 'N1';
      var bettypeid = null;
      var plytype = 1;
      var subTemplateId = 2;

      if (this.parlaySportList != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.parlaySportList).length > 0) {
        sprtId = this.modifyParlaySportId();
        bettypeid = sprtId.split('');
        if (bettypeid.length >= 3) {
          bettypeid = bettypeid[1] + "" + bettypeid[2];
        } else {
          bettypeid = bettypeid[1];
        }
      }

      this.$store.commit('FULL_LOAD', true);
      this.$store.commit('ARR_LEAGUES', []);
      this.$store.commit('SELECTED_LEAGUES', []);
      this.$store.commit('SEL_MATCH', false);
      this.$store.commit('SELECTED_LEAGUE', []);
      this.$store.commit('SPORT_SELECTED', false);
      if (this.fullLoading) {
        if (this.parlaySportList != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.parlaySportList).length > 0) {
          var sSport = _.keys(this.parlaySportList)[0].toString();
          if (this.arr_selectedTemplate.sportId != null) {
            this.checkSportList(this.arr_selectedTemplate.sportId);
          }
          if (!this.sportSelected) {
            if (sSport == 1) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'N1');
            } else if (sSport == 2 || sSport == 13) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'G1');
            } else if (sSport == 3) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'N3');
            } else if (sSport == 21) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'N21');
            } else if (sSport == 12) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'N12');
            } else if (sSport == 24) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'N24');
            } else if (sSport == 23) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'N23');
            } else if (sSport == 15) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'N15');
            } else if (sSport == 7 || sSport == 14 || sSport == 19 || sSport == 20) {
              this.$set(this.arr_selectedTemplate, 'sportId', 'G2');
            }
          }
        }
      }
      sprtId = this.arr_selectedTemplate.sportId;

      this.$store.dispatch('changeTemplate', {
        templateId: 21,
        marketKey: market,
        plytype: plytype,
        bettypeid: bettypeid,
        sportId: sprtId,
        subTemplateId: subTemplateId
      });
      this.$store.commit('FULL_LOAD', false);
      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('parlaySportTemplate', sprtId);
    },
    showParlayMarket: function showParlayMarket(market, backButton) {
      var _this3 = this;

      this.$store.commit('IS_PARLAY', true);
      var sprtId = 'N1';

      var bettypeid = null;
      var plytype = 1;
      var subTemplateId = 2;

      if (this.parlaySportList != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.parlaySportList).length > 0) {
        sprtId = this.modifyParlaySportId();
        bettypeid = sprtId.split('');
        if (bettypeid.length >= 3) {
          bettypeid = bettypeid[1] + "" + bettypeid[2];
        } else {
          bettypeid = bettypeid[1];
        }
      }

      if (!backButton) {
        this.$store.dispatch('changeTemplate', {
          templateId: 21,
          marketKey: market,
          plytype: plytype,
          bettypeid: bettypeid,
          sportId: sprtId,
          subTemplateId: subTemplateId
        });
      }

      if (account.previewFlag || account.previewFlag == undefined && market == '3') {} else {
        this.$store.commit('S_ODD', false);
      }
      this.$store.commit('ARR_LEAGUES', []);
      this.$store.commit('SELECTED_LEAGUES', []);
      this.$store.commit('SEL_MATCH', false);
      this.$store.commit('SELECTED_LEAGUE', []);
      this.$store.commit('SORTEDEVENTLIST', []);
      this.$store.commit('SPORT_SELECTED', false);
      this.$store.dispatch('getEventList', {
        market: 0,
        token: token.arr_2,
        callback: function (res) {
          _this3.$store.commit('MARKETTOGGLE', market);
          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);

          if (_this3.moreDetails) {
            _this3.moreDetails = false;
          }
          _this3.$store.commit('SELECTED_MARKET', market);
          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('marketChange', market);
          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('parlaySportTemplate', sprtId);
          $('.chkbox_league').prop('checked', false);
        }.bind(this)
      });
    },
    changeSpecialTemplate: function changeSpecialTemplate(market) {
      var _this4 = this;

      var sprtId = 'N1';
      var plytype = 1;
      var subTemplateId = 1;

      var bettypeid = sprtId.split('');
      if (bettypeid.length >= 3) {
        bettypeid = bettypeid[1] + "" + bettypeid[2];
      } else {
        bettypeid = bettypeid[1];
      }

      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('marketChange', market);
      this.$store.commit('ARR_LEAGUES', []);
      this.$store.commit('SELECTED_LEAGUES', []);
      this.$store.commit('SEL_MATCH', false);
      this.$store.commit('SELECTED_LEAGUE', []);
      this.$store.commit('SORTEDEVENTLIST', []);
      this.$store.commit('FULL_LOAD', true);
      this.$store.dispatch('getEventList', {
        market: market,
        token: token.arr_2,
        callback: function (res) {
          _this4.$store.commit('MARKETTOGGLE', market);
          _this4.$store.dispatch('changeTemplate', {
            templateId: 2,
            marketKey: market,
            plytype: plytype,
            bettypeid: bettypeid,
            sportId: sprtId,
            subTemplateId: subTemplateId
          });
          _this4.$store.commit('SELECTED_MARKET', market);
          _this4.$store.commit('FULL_LOAD', false);
          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('sportTemplate', sprtId);
          $('.chkbox_league').prop('checked', false);
        }.bind(this)
      });
    },
    startTimer: function startTimer() {
      var _this5 = this;

      if (this.int_marketToggle == 3) {
        this.timerSeconds = 10;
      }
      if (this.timerId == null) {
        this.timerId = setInterval(function () {
          if (!_this5.bettingFormToggle) {
            if (!_this5.bettingMessage) {
              if (_this5.timerSeconds - 1 < 0) {
                _this5.reloadTable(token.arr_1);
                _this5.refreshTimer();
              } else {
                _this5.timerSeconds -= 1;
              }
            }
          }
        }, 1000);
      }
    },
    refreshTimer: function refreshTimer() {
      this.clearTimer();
      this.timerSeconds = 60;
      if (this.int_marketToggle == 3) {
        this.timerSeconds = 10;
      }
      this.startTimer();
    },
    clearTimer: function clearTimer() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    reloadTable: function reloadTable() {
      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.refreshTimer();
    },
    checkSportList: function checkSportList(sport) {
      var STORE = this;
      var sportId = [];
      if (sport == 'N1') {
        sportId = ['1'];
      } else if (sport == 'G1') {
        sportId = ['2', '13'];
      } else if (sport == 'N3') {
        sportId = ['3'];
      } else if (sport == 'N21') {
        sportId = ['21'];
      } else if (sport == 'N12') {
        sportId = ['12'];
      } else if (sport == 'N24') {
        sportId = ['24'];
      } else if (sport == 'N23') {
        sportId = ['23'];
      } else if (sport == 'N15') {
        sportId = ['15'];
      } else if (sport == 'G2') {
        sportId = ['7', '14', '19', '20'];
      }

      if (this.isParlay) {
        var s = _.keys(this.parlaySportList);
        _.each(sportId, function (val) {
          if (_.indexOf(s, val) !== -1) {
            STORE.$set(STORE.$store.getters.arr_selectedTemplate, 'sportId', sport);
            STORE.$store.commit('SPORT_SELECTED', true);
          }
        });
      } else {
        var d = _.keys(this.$store.getters.arr_sportList);
        _.each(sportId, function (val) {
          if (_.indexOf(d, val) !== -1) {
            STORE.$set(STORE.$store.getters.arr_selectedTemplate, 'sportId', sport);
            STORE.$store.commit('SPORT_SELECTED', true);
          }
        });
      }
    },
    showLobby: function showLobby() {
      if (this.lobby != '' && this.lobbyUrl != '') {
        if (this.lobby != null && this.lobbyUrl != null) {
          return true;
        }
      }
      return false;
    },
    backToLobby: function backToLobby() {
      if (window.self !== window.top) {
        window.top.location.href = this.lobbyUrl;
      } else {
        window.location.href = this.lobbyUrl;
      }
    },
    showAccMenu: function showAccMenu() {
      var container = $(".sub-m-menu");
      var container2 = $(".sub-background");
      if (container || container2) {
        container.hide();
        container2.hide();
      }
      this.$store.commit('SHOW_FLOATING', false);
      $('.c-set-menu').show();
      this.isShowMenu = true;
    },
    modifySportCount: function modifySportCount(market) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var Vue = this;
      var sptCount = Vue.arr_sportCountMarket;
      var count = [];
      var earlyCount = Vue.arr_earlyEventCountByDate;

      if (market == 1) {
        $.each(sptCount['live'], function (sport, val) {
          count.push(val);
        });
        $.each(sptCount['today'], function (sport, val) {
          count.push(val);
        });
      } else if (market == 2) {
        if (value == 2) {
          $.each(sptCount['otr'], function (sport, val) {
            count.push(val);
          });
        } else {
          $.each(sptCount['early'], function (sport, val) {
            count.push(val);
          });
        }
      } else if (market == 3) {
        $.each(sptCount['live'], function (sport, val) {
          count.push(val);
        });
      }
      return _.sum(count);
    },
    showMoreDetails: function showMoreDetails(val) {
      this.$store.commit('IS_HIDE_LEAGUE', false);
      this.$store.commit('EDITIONSTAND', 3);
      var container = $(".sub-m-menu");
      var container2 = $(".sub-background");
      if (container || container2) {
        container.hide();
        container2.hide();
      }
      this.$store.commit('SHOW_FLOATING', false);
      this.$store.commit('FILTERLEAGUELIST', []);
      this.$store.commit('SC_CS_HIDE', {});
      this.$store.commit('SET_SUBMENU_STATUS', {});

      $(".scroller").scrollTop(0);
      console.log(this.$store.getters.int_marketToggle);
      if (val == 1) {
        this.checkMarket(this.$store.getters.market.inPlayMarket.key);
      } else if (val == 2) {
        this.checkMarket(this.$store.getters.market.tdyMarket.key);
      } else if (val == 3) {
        this.checkMarket(this.$store.getters.market.earlyMarket.key);
      } else if (val == 4 && !this.isOtr) {
        this.checkMarket(this.$store.getters.market.earlyMarket.key, 2);
      } else if (val == 5 && !this.isParlay) {
        this.checkMarket(this.$store.getters.market.earlyMarket.key, 1);
      } else if (val == 6 && this.$store.getters.arr_selectedTemplate.templateId != 19) {
        this.toTemplate(19, 1);
      } else if (val == 7 && (this.isOtr || this.isParlay || this.$store.getters.int_marketToggle != 1)) {
        this.toTemplate(20, 1);
      } else {
        if (this.moreDetails) {
          this.moreDetails = false;
        } else {
          this.moreDetails = true;
        }
      }
    },
    showOutright: function showOutright(market, backButton) {
      var _this6 = this;

      this.$store.commit('IS_OTR', true);

      var sprtId = 'N1';
      var bettypeid = null;
      var plytype = 1;
      var subTemplateId = 3;
      var marketCap = 'otr';

      if (this.fromSpecialEvent) {
        this.fromSpecialEvent = false;
      }


      if (this.$store.getters.arr_sportList != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.$store.getters.arr_sportList).length > 0) {
        sprtId = this.modifySportId();
        bettypeid = sprtId.split('');
        if (bettypeid.length >= 3) {
          bettypeid = bettypeid[1] + "" + bettypeid[2];
        } else {
          bettypeid = bettypeid[1];
        }
      }

      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('marketChange', market);
      if (account.previewFlag || account.previewFlag == undefined && market == '3') {}
      if (this.$store.getters.editionStand == 3) {
        this.$store.commit('EDITIONSTAND', 1);
      }
      this.$store.commit('ARR_LEAGUES', []);
      this.$store.commit('SELECTED_LEAGUES', []);
      this.$store.commit('SEL_MATCH', false);
      this.$store.commit('SELECTED_LEAGUE', []);
      this.$store.commit('SORTEDEVENTLIST', []);
      this.$store.commit('SPORT_SELECTED', false);
      this.$store.dispatch('getEventOutright', {
        market: market,
        token: token.arr_2,
        callback: function (res) {
          _this6.$store.commit('MARKETTOGGLE', market);
          if (account.previewFlag == undefined || account.previewFlag && market != '1') {
            var btemplateId = 5;
          } else if (account.previewFlag && market == '1') {
            var btemplateId = 3;
            _this6.$store.commit('SEL_MATCH', true);
          }
          if (_this6.$store.getters.arr_sportCountMarket != null && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this6.$store.getters.arr_sportCountMarket).length > 0) {
            var sSport = _this6.$store.getters.arr_sportCountMarket[marketCap] ? _.keys(_this6.$store.getters.arr_sportCountMarket[marketCap])[0].toString() : 1;
            if (_this6.arr_selectedTemplate.sportId != null) {}

            if (!_this6.sportSelected) {
              if (sSport == 1) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N1');
              } else if (sSport == 2) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N2');
              } else if (sSport == 13) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N13');
              } else if (sSport == 3) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N3');
              } else if (sSport == 21) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N21');
              } else if (sSport == 12) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N12');
              } else if (sSport == 24) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N24');
              } else if (sSport == 23) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N23');
              } else if (sSport == 15) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N15');
              } else if (sSport == 7) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N7');
              } else if (sSport == 14) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N14');
              } else if (sSport == 19) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N19');
              } else if (sSport == 20) {
                _this6.$set(_this6.$store.getters.arr_selectedTemplate, 'sportId', 'N20');
              }
            }
          }

          sprtId = _this6.$store.getters.arr_selectedTemplate.sportId == undefined ? sprtId : _this6.$store.getters.arr_selectedTemplate.sportId;

          if (!backButton) {
            _this6.$store.dispatch('changeTemplate', {
              templateId: btemplateId,

              marketKey: market,
              plytype: plytype,
              bettypeid: bettypeid,
              sportId: sprtId,
              subTemplateId: subTemplateId
            });
          }

          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);

          if (_this6.moreDetails) {
            _this6.moreDetails = false;
          }

          _this6.$store.commit('SELECTED_MARKET', market);
          __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('sportOutrightTemplate', sprtId);
          $('.chkbox_league').prop('checked', false);
        }.bind(this)
      });
    },
    toggleSettingsMenu: function toggleSettingsMenu() {
      this.isSettingsOpen = !this.isSettingsOpen;
      this.isLangOpen = false;
    },
    toggleLangMenu: function toggleLangMenu() {
      this.isLangOpen = !this.isLangOpen;
      this.isSettingsOpen = false;
    },
    changeSkin: function changeSkin(theme) {
      this.isSettingsOpen = false;
      if (theme != this.$store.getters._theme) {
        this.$store.commit('SKIN_THEME', theme);
        if (this.account.previewFlag) {
          this.$ajax({
            url: _baseUrl + '/account-def-settings',
            type: 'get',
            data: {
              action: 'previewSetting',
              theme: this.$store.getters._theme
            }
          }).done(function (response) {});
        }
      }
      if (theme == 2) {
        document.documentElement.classList.add('theme02');
      } else {
        document.documentElement.classList.remove('theme02');
      }
    },
    changeLanguage: function changeLanguage(selectedLangauge) {
      this.isLangOpen = false;
      if (selectedLangauge == 5) {
        this.setGoogTransCookie('/auto/th');
      } else {
        this.setGoogTransCookie('/auto/en');
        this.clearGoogTransCookie();
      }
      this.$ajax({
        url: '',
        type: 'get',
        data: {
          language: selectedLangauge,
          token: token.arr_3,
          action: 'changeLanguage'
        }
      }).then(function (response) {
        var url = window.location.href;

        if (url.indexOf('langs') != -1) {
          var url_temp = url.split("langs");
          var new_url = url_temp[0].slice(-1) == '&' ? url_temp[0].slice(0, -1) : url_temp[0];

          if (url_temp[1].indexOf('&') != -1) {
            var url_rest = url_temp[1].split(/&(.*)/);
            window.location.href = new_url + (new_url.slice(-1) == '?' ? '' : '&') + url_rest[1];
          } else {
            window.location.href = new_url;
          }
        } else {
          window.location.reload();
        }
      });
    },
    changeSport: function changeSport(sportId) {
      this.selectedPopular = false;
      this.$store.commit('SELECTEDLEAGUE', null);
      this.$store.commit('PLAYTYPE', 1);
      if (this.$store.getters.selected_country) {
        this.$store.commit('PLAYTYPE', 1);
      }
      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('CHANGE_SPORT', sportId);
    },
    filterLeague: function filterLeague(lge) {
      this.selectedPopular = true;
      __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('filterLeague', lge);
    },
    handleClickOutside: function handleClickOutside(event) {
      var settings = this.$el.querySelector('.settings-toggle');
      var lang = this.$el.querySelector('.lang-toggle');

      if (!settings.contains(event.target) && !lang.contains(event.target)) {
        this.isSettingsOpen = false;
        this.isLangOpen = false;
      }
    },
    refresh: function refresh() {
      window.location.reload();
    },
    getNameByLang: function getNameByLang(arr) {
      return this.cookies_lang == 'zh_CN' ? arr.name_2 : this.cookies_lang == 'zh_TW' ? arr.name_3 : arr.name_1;
    }
  },
  beforeMount: function beforeMount() {
    var _this7 = this;

    var accCookie = this.$store.getters.accSetting;
    this.selectedOdd = accCookie.oddsType;
    if (!this.account.previewFlag) {
      this.$store.dispatch('getSportCCL', {
        token: token.arr_7
      });
    }
    if (window._gameBanner) {
      this.showSpecialEvent = true;
    }
    if (localStorage.getItem('bts')) {
      var bts = JSON.parse(localStorage.getItem('bts'));

      if (bts.data != '' && bts.data.length > 0) {
        if (bts.isComboBet) {
          this.checkMarket(this.int_marketToggle);
        } else if (bts.isParlay) {
          this.checkMarket(this.market.earlyMarket.key, 1);
        } else if (bts.isOtr) {
          this.checkMarket(this.market.earlyMarket.key, 2);
        }
      }
    }
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('euroChangeMarket', function (market) {
      _this7.checkMarket(market);
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('changeMarket', function (val) {
      console.log('changeMarket: ' + val);
      _this7.showMoreDetails(val);
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('changeMatches', function () {
      this.selectedPopular = false;
    }.bind(this));
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('euroChangeMarket');
    this.loadGoogleTranslateScript();
    this.refreshTimer();

    document.addEventListener('click', this.handleClickOutside);
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed$watch$compo, 'created', function created() {
  var _this8 = this;

  __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$on('getMatchDetail', function (market) {
    if (_this8.$store.getters.market_button_toggle) {
      _this8.$store.commit('MARKET_BUTTON_TOGGLE', false);
    } else {
      if (_this8.isParlay) {
        if (_this8.$store.getters.currentTab != '4') {
          if (_this8.$store.getters.currentTab == '1') {
            _this8.checkMarket(_this8.$store.getters.market.tdyMarket.key);
          } else {
            _this8.checkMarket(_this8.$store.getters.market.earlyMarket.key);
          }
        } else {
          _this8.checkMarket(market, 1);
        }
      } else if (_this8.isOtr) {
        _this8.checkMarket(market, 2);
      } else {
        if (!_this8.$store.getters.isresult_schedule) {
          _this8.checkMarket(market);
        }
      }
    }
    __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$off('getMatchDetail');
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_computed$watch$compo, 'beforeDestroy', function beforeDestroy() {
  document.removeEventListener('click', this.handleClickOutside);
}), _computed$watch$compo);

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);







/* harmony default export */ __webpack_exports__["a"] = ({
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['account', 'timeZone', 'oddsFormatDec', 'betSlipAny', 'editionStand', 'previous_edition', 'skinTheme', 'sortHot', 'isOtr', 'betterOdds', 'isParlay']), {
		market: function market() {
			return this.$store.getters.market;
		},
		decimals: function decimals() {
			return this.account.showDecimals ? 2 : 0;
		}
	}),
	components: {},
	props: {
		isShowMenu: Boolean
	},
	data: function data() {
		return {
			lang: window.lang,
			cookies_lang: window._cookie,
			odds: window.odds,
			selectedOdd: null,
			selectedTimeZone: null,
			selectedEdition: null,
			selectedMarket: null,
			selectedSkinTheme: null,
			selectedBetterOdds: null,
			eventId: null,
			annCount: 0,
			token: window.token,
			isP: true,
			isShowBalance: 'true',
			lobby: window.lobby,
			lobbyUrl: window.lobbyUrl,
			langSelect: lang_select,
			timerSeconds: 60,
			timerSec: 60
		};
	},

	methods: {
		showOdds: function showOdds() {
			if (!$('#selec_oddstype').hasClass("on")) {
				$('#selec_oddstype').addClass('on');
			} else {
				$('#selec_oddstype').removeClass('on');
			}

			if ($('#selec_language').hasClass("on")) {
				$('#selec_language').removeClass('on');
			}
		},
		changeOdd: function changeOdd(selectedOdd) {
			this.selectedOdd = selectedOdd;
			this.$store.commit('SELECTED_ODD', this.selectedOdd);
			if (this.$store.getters.latestInfo != null) {
				this.$store.dispatch('getLatestInfo', { token: token.arr_4 });
			}

			if (!this.account.previewFlag) {
				this.$ajax({
					url: _baseUrl + '/account-def-settings',
					type: 'get',
					data: {
						action: 'updateAccountSportSetting',
						odd: this.selectedOdd
					}
				}).done(function (response) {});
			}
			this.showOddsType();
			if (this.isOtr) {
				__WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('refreshSportOutrightTable');
			} else {
				__WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('BottomNavRefresh');
			}
		},
		changeEdition: function changeEdition(selectedEdition) {
			this.selectedEdition = selectedEdition;
			this.$store.commit('EDITIONSTAND', this.selectedEdition);
			if (this.selectedEdition != 3) {
				this.$store.commit('PREVIOUS_EDITION', this.selectedEdition);
			}
			this.showEdition();
			__WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('resetTimer');
			if (this.isParlay && this.$store.getters.arr_selectedTemplate.templateId == 21) {
				__WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('parlaySportTemplate', 'N1');
			} else {
				__WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('sportTemplate', 'N1');
			}


			$('.sport-m-container').removeClass('shadow-down simple1').addClass('shadow-up');
			$('.sub-menu-date-w').removeClass('simple1');
			$('.container-menu-w').removeClass('scrolling-up').addClass('scrolling-down');
		},
		changeTimeZone: function changeTimeZone(selectedTimeZone) {
			this.selectedTimeZone = selectedTimeZone;
			this.$store.commit('TIME_ZONE', this.selectedTimeZone);
			this.showTimeZone();

			__WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('BottomNavRefresh');
		},
		showTimeZone: function showTimeZone() {
			var active = $('.timeZone-wrap').hasClass("active");
			if (active) {
				$('.timeZone-wrap').removeClass("active");
			} else {
				$('.timeZone-wrap').addClass("active");
			}
		},
		showLanguage: function showLanguage() {
			var active = $('.lang-wrap').hasClass("active");
			if (active) {
				$('.lang-wrap').removeClass("active");
			} else {
				$('.lang-wrap').addClass("active");
				$('.ed-wrap').removeClass("active");
				$('.oddstype-wrap').removeClass("active");
				$('.acc_setting').removeClass("active");
			}
		},
		showAccSetting: function showAccSetting() {
			var active = $('.acc_setting').hasClass("active");
			if (!this.account.previewFlag) {
				if (active) {
					$('.acc_setting').removeClass("active");
				} else {
					$('.acc_setting').addClass("active");
					$('.lang-wrap').removeClass("active");
					$('.ed-wrap').removeClass("active");
					$('.oddstype-wrap').removeClass("active");
				}
			} else {

				$("#successChip_msg").show();
				setTimeout('$("#successChip_msg").hide()', 1500);
			}
		},
		showOddsType: function showOddsType() {
			var active = $('.oddstype-wrap').hasClass("active");
			if (active) {
				$('.oddstype-wrap').removeClass("active");
			} else {
				$('.oddstype-wrap').addClass("active");
				$('.acc_setting').removeClass("active");
				$('.lang-wrap').removeClass("active");
				$('.ed-wrap').removeClass("active");
			}
		},
		showEdition: function showEdition() {
			var active = $('.ed-wrap').hasClass("active");
			if (active) {
				$('.ed-wrap').removeClass("active");
			} else {
				$('.ed-wrap').addClass("active");
				$('.oddstype-wrap').removeClass("active");
				$('.lang-wrap').removeClass("active");
			}
		},
		changeLanguage: function changeLanguage(selectedLangauge) {
			this.loading = true;
			$('.loading').show();
			this.$ajax({
				url: '',
				type: 'get',
				data: {
					language: selectedLangauge,
					token: token.arr_3,
					action: 'changeLanguage'
				}
			}).then(function (response) {
				var url = window.location.href;

				if (url.indexOf('langs') != -1) {
					var url_temp = url.split("langs");
					var new_url = url_temp[0].slice(-1) == '&' ? url_temp[0].slice(0, -1) : url_temp[0];

					if (url_temp[1].indexOf('&') != -1) {
						var url_rest = url_temp[1].split(/&(.*)/);
						window.location.href = new_url + (new_url.slice(-1) == '?' ? '' : '&') + url_rest[1];
					} else {
						window.location.href = new_url;
					}
				} else {
					window.location.reload();
				}
			});
			this.showLanguage();
		},
		showLogout: function showLogout() {
			if (this.account.isApi && !this.account.showDemo) {
				return false;
			}
			return true;
		},
		logout: function logout() {
			this.$store.dispatch('logoutAccount');
		},
		showSwitchOldSite: function showSwitchOldSite() {
			if (this.account.hgOldSite) {
				return true;
			}
			return false;
		},
		switchOldSite: function switchOldSite() {
			window.location.href = '../whg/home';
		},
		closeMenu: function closeMenu() {
			$('#accountMenu').removeClass('on');
		},
		showBalance: function showBalance() {
			if ($('#acc_show_eye').hasClass('off')) {
				$('#acc_show_eye').removeClass('off');
				this.isShowBalance = 'false';
			} else {
				$('#acc_show_eye').addClass('off');
				this.isShowBalance = 'true';
			}
		},
		toTemplate: function toTemplate(ItemplateId, IsubTemplateId) {
			if (ItemplateId == 16) {
				if (account.previewFlag) {
					$("#successChip_msg").show();
					setTimeout('$("#successChip_msg").hide()', 1500);
					return false;
				}
			}
			$('.loading').show();
			this.closeMenu();
			if (this.account.previewFlag && ItemplateId != 10 && ItemplateId != 11 && ItemplateId != 12 && ItemplateId != 13) {
				return false;
			}
			if (ItemplateId == 14) {
				this.$store.dispatch('getOpenBet', {
					wgrTyp: 'openBet'
				});
			}
			this.$store.dispatch('changeTemplate', {
				templateId: ItemplateId,
				subTemplateId: IsubTemplateId

			});
		},
		showLobby: function showLobby() {
			if (this.lobby != '' && this.lobbyUrl != '') {
				if (this.lobby != null && this.lobbyUrl != null) {
					return true;
				}
			}
			return false;
		},
		backToLobby: function backToLobby() {
			if (window.self !== window.top) {
				window.top.location.href = this.lobbyUrl;
			} else {
				window.location.href = this.lobbyUrl;
			}
		},
		hideMenu: function hideMenu() {
			this.$emit('updateShowMenu', false);
			$('.c-set-menu').hide();
		},
		hideMenuAll: function hideMenuAll(event) {
			if (event.target.id == "menu-inner") return;
			if ($(event.target).closest('#menu-inner').length) return;
			this.$emit('updateShowMenu', false);
			$('.c-set-menu').hide();
		},
		refreshCcl: function refreshCcl() {
			$('.balance-wrap').find('.refesh').addClass('rotate');
			if (!this.account.previewFlag) {
				this.$store.dispatch('getSportCCL', {
					token: token.arr_5
				});
			}
		},
		optionTrigger: function optionTrigger(option) {
			if (option == 'sort') {
				var sortId = this.$store.getters.sortHot == '1' ? '2' : '1';
				this.$store.commit('SORT_HOT', sortId);
			} else if (option == 'odd') {
				if (this.$store.getters.oddsFormatDec == '1') {
					this.$store.commit('ODDSFORMATDEC', 0);
				} else {
					this.$store.commit('ODDSFORMATDEC', 1);
				}
			} else if (option == 'bet') {
				var account = this.$store.getters.account;

				if (this.$store.getters.betterOdds == '1') {
					this.$store.commit('BETTER_ODDS', 0);
					account.autoAccBetterOdd = 1;
				} else {
					this.$store.commit('BETTER_ODDS', 1);
					account.autoAccBetterOdd = 2;
				}

				this.$store.commit('ACCOUNT', account);
			} else if (option == 'edition') {
				if (this.selectedEdition == '1') {
					this.selectedEdition = 0;
					this.$store.commit('EDITIONSTAND', this.selectedEdition);
				} else {
					this.selectedEdition = 1;
					this.$store.commit('EDITIONSTAND', this.selectedEdition);
				}
			}

			__WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('BottomNavRefresh');
		},
		changeSkin: function changeSkin(theme) {
			if (this.$store.getters.skinTheme == 2) {
				this.$store.commit('SKIN_THEME', 1);
			} else {
				this.$store.commit('SKIN_THEME', 2);
			}

			if (!this.account.previewFlag) {
				this.$ajax({
					url: _baseUrl + '/account-def-settings',
					type: 'get',
					data: {
						action: 'updateAccountSportSetting',
						theme: this.$store.getters.skinTheme
					}
				}).done(function (response) {});
			}
			document.documentElement.classList.toggle('theme02');
		},
		startTimer: function startTimer() {
			var _this = this;

			this.clearTimer();
			this.timerSeconds = 60;
			if (this.timerIdccl == null) {
				this.timerIdccl = setInterval(function () {
					if (_this.timerSeconds - 1 < 0) {
						_this.$store.dispatch('getSportCCL', {
							token: token.arr_7
						});
						_this.timerSeconds = _this.timerSec;
					} else {
						_this.timerSeconds -= 1;
					}
				}, 1000);
			}
		},
		clearTimer: function clearTimer() {
			clearInterval(this.timerIdccl);
			this.timerIdccl = null;
		}
	},
	beforeMount: function beforeMount() {
		if (!this.account.previewFlag) {
			this.startTimer();
		}

		var accCookie = this.$store.getters.accSetting;
		this.selectedOdd = accCookie.oddsType;
		this.selectedTheme = this.$store.getters.skinTheme;
		this.selectedEdition = this.$store.getters.editionStand;
		this.selectedBetterOdds = this.$store.getters.betterOdds;
		this.selectedTimeZone = this.$store.getters.timeZone.default;
		if (__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UID') && JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UID')).usrn) {
			var usrn = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UID')).usrn;
			if (usrn == '-1' || !JSON.parse(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a.get('UID')).nsid) {
				this.isP = true;
			} else {
				this.isP = false;
			}
		}
	},

	mounted: function mounted() {},
	updated: function updated() {
		this.selectedEdition = this.$store.getters.editionStand;
	}
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gameHeader_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3b3b3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gameHeader_vue__ = __webpack_require__(295);
function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gameHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea3b3b3c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gameHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        EventBus: __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['int_marketToggle', 'arr_selectedTemplate', 'arr_sportList', 'arr_lang', 'arr_sportAll', 'arr_sportCountMarket', 'showCalendarBox', 'arr_earlyParlayDateList', 'sportTableLang', 'int_selectedParlayDate', 'arr_earlyEventCountByDate', 'loadGameHeader', 'titleSport', 'parlaySportList', 'isOtr', 'sportBettypeList', 'editionStand', 'previous_edition', 'isParlay'])),
    data: function data() {
        return {
            cookies_lang: window._cookie,
            promotionRulesShow: window.promotionRulesShow,
            popularLeagues: window.popularLeagues
        };
    },

    methods: {
        changeSport: function changeSport(sportId) {
            this.$store.commit('SELECTED_SPORT', sportId);

            this.$store.commit('SELECTED_TEMPLATE', { templateId: 1 });
            __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('changeMarketTab', 1, this.$store.getters.selected_date);
        },
        changeSportEdition: function changeSportEdition(sportId, edition) {
            var Vue = this;
            this.$store.commit("GAMEBANNER_SELECTED", false);
            $(".scroller").scrollTop(0);
            this.$store.commit('IS_HIDE_LEAGUE', false);
            var container = $(".sub-m-menu");
            var container2 = $(".sub-background");
            if (container || container2) {
                container.hide();
                container2.hide();
            }

            this.$store.commit('SHOW_FLOATING', false);
            $(".scroll").scrollTop(0);
            this.$store.commit('VIRTUAL_DATA_LIST', []);
            this.$store.commit('LOADGAMEHEADER', false);

            this.$store.commit('EVENTLIST', []);
            this.$store.commit('TODAYRBEVENTLIST', []);
            this.$store.commit('SWIPE_MODE', 1);
            $('.odd-t-i-wrapper').removeClass('status2');
            $('.standard-odd-l-w').removeClass('status2');
            this.$store.commit('SORTEDEVENTLIST', []);
            this.$store.commit('SET_SUBMENU_STATUS', {});
            this.$store.commit('COOKIE_LEAGUE', {
                remove: true
            });
            this.$store.commit('EDITIONSTAND', edition);
            if (this.arr_selectedTemplate.templateId == 21) {
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('parlaySportTemplate', sportId);
            } else {
                __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('sportTemplate', sportId);
            }
        },
        modifySportCount: function modifySportCount(sprtId, market) {

            var Vue = this;
            var count = [];
            var sid = [];

            var sportList = Vue.arr_sportCountMarket;
            var earlyCount = this.$store.getters.arr_earlyEventCountByDate;

            if (sprtId == 'N1' || sprtId == 'ALL') {
                sid.push('1');
            }
            if (sprtId == 'N2' || sprtId == 'ALL') {
                sid.push('2');
            }
            if (sprtId == 'N13' || sprtId == 'ALL') {
                sid.push('13');
            }
            if (sprtId == 'N3' || sprtId == 'ALL') {
                sid.push('3');
            }
            if (sprtId == 'N21' || sprtId == 'ALL') {
                sid.push('21');
            }
            if (sprtId == 'N12' || sprtId == 'ALL') {
                sid.push('12');
            }
            if (sprtId == 'N24' || sprtId == 'ALL') {
                sid.push('24');
            }
            if (sprtId == 'N23' || sprtId == 'ALL') {
                sid.push('23');
            }
            if (sprtId == 'N15' || sprtId == 'ALL') {
                sid.push('15');
            }
            if (sprtId == 'N7' || sprtId == 'ALL') {
                sid.push('7');
            }
            if (sprtId == 'N14' || sprtId == 'ALL') {
                sid.push('14');
            }
            if (sprtId == 'N19' || sprtId == 'ALL') {
                sid.push('19');
            }
            if (sprtId == 'N20' || sprtId == 'ALL') {
                sid.push('20');
            }
            if (market == 1) {
                $.each(sportList['live'], function (sport, val) {
                    if (_.indexOf(sid, sport) !== -1) {
                        count.push(val);
                    }
                });
                $.each(sportList['today'], function (sport, val) {
                    if (_.indexOf(sid, sport) !== -1) {
                        count.push(val);
                    }
                });
            } else if (market == 2) {
                if (this.$store.getters.arr_selectedTemplate.subTemplateId == '3') {
                    $.each(sportList['otr'], function (sport, val) {
                        if (_.indexOf(sid, sport) !== -1) {
                            count.push(val);
                        }
                    });
                } else {
                    $.each(sportList['early'], function (sport, val) {
                        if (_.indexOf(sid, sport) !== -1) {
                            count.push(val);
                        }
                    });
                }
            } else if (market == 3) {
                $.each(sportList['live'], function (sport, val) {
                    if (_.indexOf(sid, sport) !== -1) {
                        count.push(val);
                    }
                });
            }

            return _.sum(count);
        },
        checkSportCount: function checkSportCount(sprtId) {
            return true;

            var Vue = this;

            var sptCount = Vue.arr_sportCountMarket;
            var market = Vue.arr_selectedTemplate.int_marketToggle;
            var earlyCount = this.$store.getters.arr_earlyEventCountByDate;
            var spt = [];
            var havCount = false;

            _.forEach(this.titleSport, function (tsVal, tsKey) {
                if (tsVal.id == sprtId) {
                    spt = tsVal.sid;
                }
            });

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sptCount).length > 0) {
                _.forEach(spt, function (sptid) {
                    if (market == 1) {
                        if (sptCount['live'] && sptCount['live'][sptid]) {
                            havCount = true;
                            return true;
                        }
                        if (sptCount['today'] && sptCount['today'][sptid]) {
                            havCount = true;
                            return true;
                        }
                        if (!sptCount['today'] && !sptCount['live'] && sptid == 1) {
                            havCount = true;
                            return true;
                        }
                    } else if (market == 2) {
                        if (Vue.$store.getters.arr_selectedTemplate.subTemplateId == '3') {
                            if (sptCount['otr'] && sptCount['otr'][sptid]) {
                                havCount = true;
                                return true;
                            }
                        } else {
                            if (sptCount['early'] && sptCount['early'][sptid]) {
                                havCount = true;
                                return true;
                            }
                            if (Vue.$store.getters.arr_selectedTemplate.templateId == 21) {
                                if (sptCount['today'] && sptCount['today'][sptid]) {
                                    havCount = true;
                                    return true;
                                }
                            }
                        }
                        if (!sptCount['today'] && !sptCount['early'] && sptid == 1) {
                            havCount = true;
                            return true;
                        }
                    } else if (market == 3) {
                        if (sptCount['live'] && sptCount['live'][sptid]) {
                            havCount = true;
                            return true;
                        }
                        if (!sptCount['live'] && sptid == 1) {
                            havCount = true;
                            return true;
                        }
                    }
                });
            }

            if (havCount) {
                if (this.loadGameHeader) {
                    this.checkDefaultMatches();
                }

                return true;
            } else {
                return false;
            }
        },
        checkDefaultMatches: function checkDefaultMatches() {
            var Vue = this;

            var sptCount = Vue.arr_sportCountMarket;
            var market = Vue.arr_selectedTemplate.int_marketToggle;
            var spt = [];
            var sptidSelect = "";
            if (window.sprtid != '') {
                var index = this.$store.getters.sportList.findIndex(function (item) {
                    return item.sprtId === 'N' + window.sprtid;
                });
                if (index !== -1) {
                    sptidSelect = 'N' + window.sprtid;
                }
            }
            var getSport = _.filter(this.$store.getters.titleSport, function (x) {
                if (!_.isUndefined(account.default['def_sprt']) && account.default['def_sprt'] != null) {
                    if (x.sid.toString() == account.default['def_sprt'].toString()) {
                        sptidSelect = x.id;
                    }
                }
            });
            var havCount = false;
            _.forEach(this.titleSport, function (tsVal, tsKey) {
                spt.push(tsVal.sid);
            });

            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(sptCount).length > 0) {
                _.forEach(spt, function (sptid) {
                    if (market == 1) {
                        if (sptCount['live'] && sptCount['live'][sptid]) {
                            havCount = true;
                        }
                        if (sptCount['today'] && sptCount['today'][sptid]) {
                            havCount = true;
                        }
                    } else if (market == 2) {
                        if (Vue.$store.getters.arr_selectedTemplate.subTemplateId == '3') {
                            if (sptCount['otr'] && sptCount['otr'][sptid]) {
                                havCount = true;
                            }
                        } else {
                            if (sptCount['early'] && sptCount['early'][sptid]) {
                                havCount = true;
                            }
                            if (Vue.$store.getters.arr_selectedTemplate.templateId == 21) {
                                if (sptCount['today'] && sptCount['today'][sptid]) {
                                    havCount = true;
                                }
                            }
                        }
                    } else if (market == 3) {
                        if (sptCount['live'] && sptCount['live'][sptid]) {
                            havCount = true;
                        }
                        if (!sptCount['live'] && sptid == 1) {
                            havCount = true;
                        }
                    }
                    var sprtid_str = "N" + sptid;
                    if (havCount == false && sptidSelect == sprtid_str) {
                        sptidSelect = "";
                    }
                    if (havCount == true && sptidSelect == "") {
                        sptidSelect = sprtid_str;
                    }
                });
            }

            if (sptidSelect != '') {
                if (this.loadGameHeader) {
                    if (Vue.$store.getters.arr_selectedTemplate.templateId == 21) {
                        if (Vue.$store.getters.arr_selectedTemplate.sportId != sptidSelect) {
                            Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sptidSelect);
                            Vue.changeSport(sptidSelect);
                        }
                    } else {
                        if (Vue.$store.getters.arr_selectedTemplate.sportId != sptidSelect) {
                            Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sptidSelect);
                            Vue.changeSport(sptidSelect);
                        }
                    }
                }
            }
        },
        changeEarlyParlayDate: function changeEarlyParlayDate(datekey) {
            $(".scroller").scrollTop(0);
            this.$store.commit('SELECT_ALL_LEAGUE', true);
            this.$store.commit('FILTER_SELECT_ALL', true);
            this.$store.commit('TODAYRBEVENTLIST', []);
            this.$store.commit('SORTEDEVENTLIST', []);
            this.$store.commit('SORTEDTODAYRBEVENTLIST', []);
            this.$store.commit('SELECTED_PAYLAY_DATE', datekey);
            if (this.editionStand == '3') {
                this.$store.commit('SC_CS_HIDE', {});
            } else {
                this.$store.commit('SET_SUBMENU_STATUS', {});
            }
            if (this.isParlay && window.allowRbParlay && (datekey == 99 || datekey == 0)) {
                this.$store.dispatch('getTodayRBSportOdds', {
                    loading: 0,
                    token: token.arr_6
                });
            } else {
                this.$store.dispatch('getSportOdds', {
                    loading: 0,
                    token: token.arr_6
                });
            }
        },
        totalCountByDate: function totalCountByDate(date) {
            var currectSport = this.$store.getters.arr_selectedTemplate.sportId;
            var sportId = '';
            var sid = [];
            var totalCount = 0;
            var allDateCount = this.$store.getters.arr_earlyEventCountByDate;

            if (currectSport == 'N1') {
                sid.push('1');
            } else if (currectSport == 'N2') {
                sid.push('2');
            } else if (currectSport == 'N13') {
                sid.push('13');
            } else if (currectSport == 'N3') {
                sid.push('3');
            } else if (currectSport == 'N21') {
                sid.push('21');
            } else if (currectSport == 'N12') {
                sid.push('12');
            } else if (currectSport == 'N24') {
                sid.push('24');
            } else if (currectSport == 'N23') {
                sid.push('23');
            } else if (currectSport == 'N15') {
                sid.push('15');
            } else if (currectSport == 'N7') {
                sid.push('7');
            } else if (currectSport == 'N14') {
                sid.push('14');
            } else if (currectSport == 'N19') {
                sid.push('19');
            } else if (currectSport == 'N20') {
                sid.push('20');
            } else if (currectSport == 'N23') {
                sid.push('23');
            }

            _.forEach(sid, function (sval) {
                totalCount = allDateCount[sval] && allDateCount[sval][date] ? allDateCount[sval][date] : 0;
            });

            return totalCount;
        },
        getEarlyCountByDate: function getEarlyCountByDate() {
            this.$store.dispatch('getEarlyEventCountByDate');
        },
        showPromoDetails: function showPromoDetails() {
            __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('SHOW_PROMO_DETAILS', true);
        },
        filterLeague: function filterLeague(lge) {
            __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('filterLeague', lge);
        }
    },
    mounted: function mounted() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('CHANGE_SPORT');
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('CHANGE_SPORT', function (sportId) {
            _this.changeSport(sportId);
        }.bind(this));
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('getSimpleSoccer', function (sportid, edition) {
            _this.changeSportEdition(sportid, edition);
        }.bind(this));
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('changeEarlyParlayDate', function (dt) {
            console.log('changeEarlyParlayDate: ' + dt);
            _this.changeEarlyParlayDate(dt);
        }.bind(this));
    }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_backToTop__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_scrollEnd__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_components_refreshScreen__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__simpleSoccerTable__ = __webpack_require__(305);











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isOddsSwitch: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['arr_selectedTemplate', 'skinTheme', 'editionStand', 'loadingScreen', 'sortedEvents', 'arr_lang', 'refreshScreen', 'titleSport', 'int_marketToggle', 'isOtr', 'matchSchdTab', 'selected_date'])),
  components: {
    backToTop: __WEBPACK_IMPORTED_MODULE_3__core_backToTop__["a" /* default */],
    refreshScreen: __WEBPACK_IMPORTED_MODULE_6__vue_components_refreshScreen__["a" /* default */],
    simpleSoccerTable: __WEBPACK_IMPORTED_MODULE_7__simpleSoccerTable__["a" /* default */],
    scrollEnd: __WEBPACK_IMPORTED_MODULE_4__core_scrollEnd__["a" /* default */]
  },
  data: function data() {
    return {
      heightPX: window.innerHeight - 155,
      gameBanner: window._gameBanner
    };
  },

  methods: {
    changeMarket: function changeMarket(val) {
      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$emit('changeMarketTab', val, this.selected_date);
    }
  },
  beforeMount: function beforeMount() {}
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backToTop_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df1a1fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backToTop_vue__ = __webpack_require__(299);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df1a1fc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportTableLang', 'skinTheme'])),
  methods: {
    backToTop: function backToTop() {
      $(".scroll").animate({ scrollTop: 0 }, 100);
      $("#sportTable>div").animate({ scrollTop: 0 }, 100);
      $(".vue-recycle-scroller").animate({ scrollTop: 0 }, 100);
      $("#expandSportTable>div").animate({ scrollTop: 0 }, 100);
    },
    showhideTop: function showhideTop() {
      var pos = $(window).scrollTop();
      if (pos == 0) {
        $('.list-scroll-to-top').css({ 'display': 'none' });
      } else {
        $('.list-scroll-to-top').css({ 'display': 'block' });
      }
    }
  }, beforeMount: function beforeMount() {
    $(window).scroll(function (res) {
      this.showhideTop();
    }.bind(this));
  }

});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scrollEnd_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bf095a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scrollEnd_vue__ = __webpack_require__(301);
function injectStyle (ssrContext) {
  __webpack_require__(300)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scrollEnd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bf095a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scrollEnd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sportTableLang'])),
  methods: {}
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        loading: false,
        edition: null,
        stemplate: null,
        showFavEvents: null
    },
    data: function data() {
        return {
            marginPX: 1,

            heightPX: 530
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['account'])),
    methods: {},
    mounted: function mounted() {
        this.marginPX = 1;
        if (this.stemplate.int_marketToggle == "2") {
            if (this.edition == 3) {
                this.marginPX = 1.35;
            } else {
                this.marginPX = 1.3;
            }
        }
    }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_common_common__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_odd1x2__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_backToTop__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_scrollEnd__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_virtual_scroller_dist_vue_virtual_scroller_css__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_virtual_scroller_dist_vue_virtual_scroller_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_virtual_scroller_dist_vue_virtual_scroller_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_virtual_scroller__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__oddsTable_odds1x2__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vue_mixins_favourite__ = __webpack_require__(91);






















var pageSize = 20;
var LOAD_THRESHOLD_PX = 400;
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isOddsSwitch: {
      type: Boolean,
      default: false
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__vue_mixins_favourite__["a" /* default */]],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['arr_eventList', 'sortedEvents', 'leagueList', 'int_marketToggle', 'sportTableLang', 'sportAllBetLang', 'arr_selectedTemplate', 'currentBettingSelectionTemplate', 'sportBettypeList', 'market', 'arr_lang', 'bettingSelection', 'tvIconFlag', 'arr_earlyParlayDateList', 'selectedMatches', 'isParlay', 'int_selectedParlayDate', 'selectedState', 'editionStand', 'simDisp', 'skinTheme', 'favouriteEvents', 'titleSport', 'loadingScreen', 'hideLegHeader', 'sortedTodayRBEvents', 'arr_sportCountMarket', 'refreshScreen', 'virtualDataList', 'showEnd', 'showNoScrollEnd', 'isHideLeague', 'showLegCapt', 'swipe', 'isCollapseMatch', 'timeZone', 'isGameBannerSelected', 'lableHeader', 'plytyp']), {
    computehdpBetType: function computehdpBetType() {
      if (this.int_marketToggle == 3) {
        return '8';
      } else {
        return '1';
      }
    },
    currentSport: function currentSport() {
      var sprtId = this.arr_selectedTemplate.sportId;
      return this.sportBettypeList[sprtId]['sprtTitleLang'];
    },

    computeouBetType: function computeouBetType() {
      if (this.int_marketToggle == 3) {
        return '9';
      } else {
        return '2';
      }
    },
    isCollapseMatch: function isCollapseMatch() {
      return this.$store.getters.isCollapseMatch;
    }
  }),
  components: {
    backToTop: __WEBPACK_IMPORTED_MODULE_7__core_backToTop__["a" /* default */],
    scrollEnd: __WEBPACK_IMPORTED_MODULE_8__core_scrollEnd__["a" /* default */],
    DynamicScroller: __WEBPACK_IMPORTED_MODULE_10_vue_virtual_scroller__["a" /* DynamicScroller */],
    DynamicScrollerItem: __WEBPACK_IMPORTED_MODULE_10_vue_virtual_scroller__["b" /* DynamicScrollerItem */],

    RecycleScroller: __WEBPACK_IMPORTED_MODULE_10_vue_virtual_scroller__["c" /* RecycleScroller */],
    odds1x2: __WEBPACK_IMPORTED_MODULE_11__oddsTable_odds1x2__["a" /* default */]
  },
  data: function data() {
    return {
      cookies_lang: window._cookie,
      lang: window.lang,
      heightPX: window.innerHeight - 155,

      teamA: 'oddsa',
      teamB: 'oddsb',
      teamHome: 'h',
      teamAway: 'a',
      teamDraw: 'd',
      ftPlyType: '1',
      firstHtPlyType: '2',
      pointHdpPlyType: '4',
      iotPlyType: '5',
      setHandicapPlyType: '3',
      gameHdpPlyType: '6',
      firstSetPlyType: '7',
      secondSetPlyType: '8',
      thirdSetPlyType: '9',
      fourthSetPlyType: '10',
      fifthSetPlyType: '11',
      sixthSetPlyType: '12',
      oeBetType: '3',
      onex2BetType: '4',
      rhdpBetType: '8',
      rouBetType: '9',
      roeBetType: '10',
      ronex2BetType: '11',
      mlBetType: '12',
      rmlBetType: '13',
      style: {
        "style1": "right",
        "style2": "none"
      },
      allBetToggle: true,
      showDetails: false,
      htPlyType: '2',
      showHdp: false,
      showOu: false,
      showft: false,
      showht: false,
      selectedPty: '',
      curEveId: '',
      isOpenSubMenu: {},
      isRB: false,
      data: null,

      items: [],
      isLoading: true,
      startIndex: 0,
      isScrollUp: false,

      showCollapse: false,
      myTimeout: '',

      gameBanner: window._gameBanner,
      updateScroll: true,
      loadingImg: true,
      selectedTtlArr: [],

      selectedKey: ''
    };
  },

  methods: {
    getData: function getData() {
      var vue = this;

      var testloop = [];
      for (var i = 0; i < this.sortedEvents.length; i++) {
        if (this.sortedEvents[i]) {
          testloop.push(this.sortedEvents[i]);
        }
      }
      testloop.map(function (item, index) {
        item.id = index;
        return item;
      });

      this.items = testloop;
      this.isLoading = false;
    },
    getBettype: function getBettype(spid, rb) {
      if (spid == 1) {
        if (rb == 1) {
          return this.ronex2BetType;
        } else {
          return this.onex2BetType;
        }
      } else {
        if (rb == 1) {
          return this.rmlBetType;
        } else {
          return this.mlBetType;
        }
      }
    },
    showHide: function showHide(lid, sport) {
      var vue = this;
      var matche = {};
      matche.sport = sport;
      if (this.isHideLeague[sport] == undefined) {
        this.isHideLeague[sport] = false;
      }
      if (lid == -1) {
        var sprts = {};
        sprts.sport = sport;
        sprts.status = false;
        if (this.isHideLeague[sport] == false) {
          sprts.status = true;
        }
        matche.lid = -1;
        this.$store.commit('IS_HIDE_LEAGUE', sprts);
        this.$store.commit('IS_COLLAPSE_MATCH', matche);
      } else {
        matche.lid = lid;
        this.$store.commit('IS_COLLAPSE_MATCH', matche);
      }
      this.$store.dispatch('sortEvents');
    },
    checkLeague: function checkLeague(lid, sport) {
      if (this.isHideLeague[sport] == undefined) {
        this.isHideLeague[sport] = false;
      }
      if (this.isCollapseMatch[sport] == undefined) {
        this.isCollapseMatch[sport] = [];
      }
      if (this.isHideLeague[sport] == false && this.isCollapseMatch[sport].indexOf(lid) >= 0) {
        return true;
      } else if (this.isHideLeague[sport] == true && this.isCollapseMatch[sport].indexOf(lid) < 0) {
        return true;
      }
      return false;
    },
    playtypeSelection_1: function playtypeSelection_1(sptId) {
      if (this.arr_selectedTemplate['sportId'] == 'N3' || this.arr_selectedTemplate['sportId'] == 'N21' || this.arr_selectedTemplate['sportId'] == 'N12') {
        return this.setHandicapPlyType;
      } else {
        return this.ftPlyType;
      }
    },
    matchDateCheck: function matchDateCheck(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss");
    },
    getDate: function getDate(dt) {
      dt = this.matchDateCheck(dt);
      if (this.cookies_lang == 'zh_TW' || this.cookies_lang == 'zh_CN') {
        return new __WEBPACK_IMPORTED_MODULE_4_moment___default.a(dt).format("MM / DD");
      }
      return new __WEBPACK_IMPORTED_MODULE_4_moment___default.a(dt).format("DD / MM");
    },
    getTime: function getTime(dt) {
      dt = this.matchDateCheck(dt);
      return new __WEBPACK_IMPORTED_MODULE_4_moment___default.a(dt).format("HH:mm");
    },
    initComponent: function initComponent() {
      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('changeMarketTab', 1, this.$store.getters.selected_date);

      __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('resetTimer');
    },
    reloadSSCSportTable: function reloadSSCSportTable() {
      if (this.$store.getters.arr_selectedTemplate.marketKey == 1) {
        this.$store.dispatch('getTodayRBSportOdds', {
          loading: 1,
          token: token.arr_2,
          isGameBanner: 0,
          state: this.$store.getters.selectedState ? this.$store.getters.selectedState : ''
        });
      } else {
        this.$store.dispatch('getSportOdds', {
          loading: 1,
          token: token.arr_2,
          isGameBanner: 0,
          state: this.$store.getters.selectedState ? this.$store.getters.selectedState : ''
        });
      }

      var VUE = this;
      _.forEach(VUE.isOpenSubMenu, function (title, tkey) {
        if (VUE.isOpenSubMenu[tkey]) {}
      });
    },
    getAllBet: function getAllBet(event) {
      var channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (channel == 1 && event.rb != 1) {
        return;
      }
      this.$store.commit('SELECTED_TEMPLATE', { templateId: 6 });
      this.$store.commit('IS_RESULT_SCHEDULE', true);
      this.$store.commit('ALLBETEVENT', null);
      this.$store.commit('FULL_LOAD', true);
      this.$store.dispatch('getSportAllBet', {
        startTv: channel,
        event: event,
        token: token.arr_8
      });
    },
    backToTop: function backToTop() {
      var vue = this;
      $("html, body").animate({ scrollTop: 0 }, 1);
      $(".vue-recycle-scroller").animate({ scrollTop: 0 }, 100);
    },
    showHide_result: function showHide_result(lid) {
      if (lid == 0) {
        if (!$("#llge" + lid).hasClass("hidelg")) {
          $("#llge" + lid).addClass("hidelg");
          $('#spt' + this.$store.getters.resultSport).addClass('collapsed');
          $(".league match-indent").addClass("hidelg");
          $(".match-odds-container").hide();
          $(".league-title-text .league-collapse-dir").show();
          $(".llgeAll").hide();
        } else {
          $("#llge" + lid).removeClass("hidelg");
          $('#spt' + this.$store.getters.resultSport).removeClass('collapsed');
          $(".league match-indent").removeClass("hidelg");
          $(".match-odds-container").show();
          $(".league-title-text .league-collapse-dir").hide();
          $(".llgeAll").show();
        }
      } else {
        if (!$("#llge" + lid).hasClass("hidelg")) {
          $("#llge" + lid).addClass("hidelg");
          $(".llge" + lid).hide();
          $("#imgllge" + lid).show();
        } else {
          $("#llge" + lid).removeClass("hidelg");
          $(".llge" + lid).show();
          $("#imgllge" + lid).hide();
        }
      }
    },
    eventDate: function eventDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('MM/DD');
    },
    eventTime: function eventTime(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format('HH:mm');
    },
    sportTemplateResult: function sportTemplateResult(sptId) {
      this.$store.commit('RESULT_SPORT', sptId);
      this.getSportResult();
    },
    sportTemplateResultDate: function sportTemplateResultDate(dt) {
      this.$store.commit('RESULT_DATE', dt);
      this.getSportResult();
    },
    getSportResult: function getSportResult() {
      var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.$store.commit('LEAGUE_LIST', []);
      this.$store.commit('SORTEDEVENTLIST', []);
      this.$store.commit('SORTEDTODAYRBEVENTLIST', []);

      this.$store.dispatch('getSportOdds', {
        loading: 1,
        isResult: true,
        token: token.arr_2
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (account.previewFlag && this.int_marketToggle == '1' && this.arr_selectedTemplate.subTemplateId == 1) {
      this.$store.commit('SELECTED_PAYLAY_DATE', 0);
    }

    this.initComponent();
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('refreshSSCSportTable', function () {
      _this.reloadSSCSportTable();
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('reloadSimpleSoccerComputed');
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('reloadSimpleSoccerComputed', function () {
      _this.getData();
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('updateScroll', function (val) {
      _this.updateScroll = val;
      var vue = _this;
      setTimeout(function () {
        if (!vue.updateScroll) {
          vue.updateScroll = true;
        }
      }, 5000);
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('sportTemplateResult');
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('sportTemplateResult', function (sportId) {
      this.sportTemplateResult(sportId);
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('sportTemplateResultDate');
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('sportTemplateResultDate', function (dt) {
      this.sportTemplateResultDate(dt);
    }.bind(this));

    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('getAllBet');
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$on('getAllBet', function (event, channel) {
      this.getAllBet(event, channel);
    }.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('refreshSSCSportTable');
    __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$off('updateScroll');
    this.$store.commit('SC_CS_HIDE', {});
    this.$store.commit('IS_HIDE_LEAGUE', false);
    this.$store.commit('IS_COLLAPSE_MATCH', -1);
    $('.scroller').off('scroll');
  },
  mounted: function mounted() {
    this.getData();
    $(".list-scroll-to-top").hide();
    this.backToTop();
    this.isLoading = false;
    this.$store.commit('IS_HIDE_LEAGUE', false);
    this.$store.commit('IS_COLLAPSE_MATCH', -1);
  },
  created: function created() {},
  beforeUpdate: function beforeUpdate() {}
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateHightlightOdds; });
var updateHightlightOdds = function updateHightlightOdds(bettingSelection) {
    $('.odds_box_up').removeClass('odds_box_up');
    $('.subaccountform_up').removeClass('subaccountform_up');
    $('.more_td_up').removeClass('more_td_up');
    $('.accordion_content_2_up').removeClass('accordion_content_2_up');
    $('.oddsdetails_up').removeClass('oddsdetails_up');
    $('.btn_lebet_odd').removeClass('on');
    $('.btn_obt_odd').removeClass('on');
    $('.odd-column-item').removeClass('odd-column-item2');
    $('.ol-li-item').removeClass('active-item');
    $('.play-box-sty').removeClass('details-bg5');
    $('.play-box-sty').removeClass('white_text');
    $('.fz_16').removeClass('size-color-wit');
    $('.fz_16').addClass('size-color');
    $('.odds').removeClass('white_text');
    $('.play-box-style').removeClass('details-bg5');
    $('.play-box-style').removeClass('white_text');
    $('.play-box-style').removeClass('first-rad');
    $('.play-box').removeClass('active-play');
    $('.play-box').removeClass('border-top');
    $('.fz_14').removeClass('white_text');
    $('.odd-title').removeClass('white_text');
    $('.fz_16').removeClass('white_text');
    $('.odd-column').removeClass('details-bg5');
    $('.play-box').removeClass('details-bg5');
    $('.play-box' + ' .item-fat').removeClass('white_text');

    _.forEach(bettingSelection, function (value, key) {
        if (value.uniqueId && value.uniqueId != "") {
            if ($('.oddsdetails.' + value.uniqueId).length > 0) {
                $('.oddsdetails.' + value.uniqueId).addClass('oddsdetails_up');
            } else if ($('.odds_box.' + value.uniqueId).length > 0) {
                $('.odds_box.' + value.uniqueId).addClass('odds_box_up');
            } else if ($('.subaccountform.' + value.uniqueId).length > 0) {
                $('.subaccountform.' + value.uniqueId).addClass('subaccountform_up');
            } else if ($('.more_td.' + value.uniqueId).length > 0) {
                $('.more_td.' + value.uniqueId).addClass('more_td_up');
            } else if ($('.accordion_content_2.' + value.uniqueId).length > 0) {
                $('.accordion_content_2.' + value.uniqueId).addClass('accordion_content_2_up');
            } else if ($('.btn_lebet_odd.' + value.uniqueId).length > 0) {
                $('.btn_lebet_odd.' + value.uniqueId).addClass('on');

                if ($('.btn_obt_odd.' + value.uniqueId).length > 0) {
                    $('.btn_obt_odd.' + value.uniqueId).addClass('on');
                }
            } else if ($('.odd-column-item.' + value.uniqueId).length > 0) {
                $('.odd-column-item.' + value.uniqueId).addClass('odd-column-item2');
            } else if ($('.odd-column.' + value.uniqueId).length > 0) {
                $('.odd-column.' + value.uniqueId).addClass('details-bg5');
                $('.fz_14.' + value.uniqueId).addClass('white_text');
                $('.odds.' + value.uniqueId).addClass('white_text');
            } else if ($('.play-box-sty.' + value.uniqueId).length > 0) {
                $('.play-box-sty.' + value.uniqueId).addClass('details-bg5');
                $('.play-box-sty.' + value.uniqueId).addClass('white_text');
                $('.fz_16.' + value.uniqueId).addClass('size-color-wit');
                $('.fz_16.' + value.uniqueId).removeClass('size-color');
                $('.odds.' + value.uniqueId).addClass('white_text');
            } else if ($('.play-box-style.' + value.uniqueId).length > 0) {
                $('.play-box-style.' + value.uniqueId).addClass('details-bg5');
                $('.play-box-style.' + value.uniqueId).addClass('white_text');
                $('.play-box-style.' + value.uniqueId).addClass('first-rad');
                $('.fz_14.' + value.uniqueId).addClass('white_text');
                $('.fz_16.' + value.uniqueId).addClass('white_text');
                $('.odds.' + value.uniqueId).addClass('white_text');
                $('.odd-title.' + value.uniqueId).addClass('white_text');
            } else if ($('.ol-li-item.' + value.uniqueId).length > 0) {
                $('.ol-li-item.' + value.uniqueId).addClass('active-item');
            } else if ($('.play-box.' + value.uniqueId).length > 0) {
                $('.play-box.' + value.uniqueId).addClass('active-play');
                $('.play-box.' + value.uniqueId).addClass('border-top');
                $('.odds.' + value.uniqueId).addClass('white_text');
                if (value.bettype == '25') {
                    $('.play-box.' + value.uniqueId).addClass('details-bg5');
                    $('.play-box.' + value.uniqueId + ' .item-fat').addClass('white_text');
                }
            }
        }
    });
};



/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateSpecialRBTimer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




var validateSpecialRBTimer = function validateSpecialRBTimer(event, timerHour, timerMin) {
    if (event.lgeflag == '1' && event.rbinfo.htst == '1' && (timerHour >= 1 || timerMin >= 50)) {
        return true;
    }

    return false;
};



/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_odds1x2_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58134854_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_odds1x2_vue__ = __webpack_require__(323);
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_odds1x2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58134854_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_odds1x2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_mixins_allBet__ = __webpack_require__(90);






/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__vue_mixins_allBet__["a" /* default */]],
    props: {
        oddsTitle: {
            type: Boolean,
            default: false
        },
        event: null,
        bmk: null,
        plytyp: null,
        bettyp: null,
        type: null
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['arr_selectedTemplate', 'sportTableLang', 'int_marketToggle', 'editionStand'])),
    data: function data() {
        return {
            lang: window.lang,
            sumOdds: 0
        };
    },

    methods: {
        checkLock: function checkLock(od, team) {

            if (od[team]) {
                return false;
            }
            return true;
        }
    }
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        loading: false
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['skinTheme'])),
    data: function data() {
        return {};
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(6);









/* harmony default export */ __webpack_exports__["a"] = ({
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(["arr_selectedTemplate", "isGameBannerSelected", "gameBannerSportId", "sportList", "isOtr", "market", "currSlideIndex"])),
    props: {
        position: null
    },
    data: function data() {
        return {
            showGameBanner: false,
            gameBannerImage: window._gameBannerImage,
            cookies_lang: window._cookie,
            langList: window._lang,
            intervalId: null
        };
    },

    methods: {
        selectGameBanner: function selectGameBanner() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var vue, container, container2, market;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt("return");

                            case 25:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getGameBannerCount: function getGameBannerCount(market, count) {
            if (this.market.inPlayMarket.key == market) {
                this.inPlyCount = count;
            } else if (this.market.tdyMarket.key == market) {
                this.tdyCount = count;
            } else if (this.market.earlyMarket.key == market) {
                this.earlyCount = count;
            }
        },
        showNext: function showNext() {
            var total = $('.slide').length;
            var currSlideIndex = (this.currSlideIndex + 1) % total;
            this.$store.commit('CURR_SLIDE_INDEX', currSlideIndex);
            this.showSlide(currSlideIndex);
        },
        showPrev: function showPrev() {
            var total = $('.slide').length;
            var currSlideIndex = (this.currSlideIndex - 1 + total) % total;
            this.$store.commit('CURR_SLIDE_INDEX', currSlideIndex);
            this.showSlide(currSlideIndex);
        },
        showSlide: function showSlide(index) {
            var slides = document.querySelectorAll('.slide');
            slides.forEach(function (slide, i) {
                slide.classList.toggle('active', i === index);
            });
        }
    },
    beforeMount: function beforeMount() {
        if (window._gameBanner) {
            if (window._imageBanner) {
                if (['t'].indexOf(this.position) !== -1) {
                    this.showGameBanner = true;
                }
            } else {
                this.showGameBanner = true;
                this.$store.commit('GAME_BANNER_ID', window._gameBanner);
                this.$store.commit('GAME_BANNER_SPORT_ID', this.$store.getters.sportList[0].sprtId);
            }
        }
    },
    mounted: function mounted() {
        this.intervalId = setInterval(this.showNext, 10000);
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.intervalId);
    },
    destroyed: function destroyed() {}
});

/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_components_loadingScreen__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_mixins_favourite__ = __webpack_require__(91);












/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__vue_mixins_favourite__["a" /* default */]],
    props: {},
    components: {
        loadingScreen: __WEBPACK_IMPORTED_MODULE_4__vue_components_loadingScreen__["a" /* default */]
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['int_marketToggle', 'arr_allBetEvent', 'sportAllBetLang', 'sportTableLang', 'sportBettypeList', 'arr_selectedTemplate', 'isMobile', 'arr_selectedBetTab', 'loadingScreen', 'isCollapse', 'showMoreEvent', 'scAllBetTab', 'bkAllBetTab', 'osAllBetTab', 'arr_eventList', 'arr_selectedEvent', 'refreshAllBet', 'tvIconFlag', 'bettingFormToggle', 'bettingSelection', 'bettingMessage', 'showHelp', 'isShowBottomRefresh', 'timeZone', 'arr_lang'])),
    data: function data() {
        return {
            cookies_lang: window._cookie,
            content: '',
            timerCount: 60,
            timerIdCount: null,
            selectedGrp: [],
            isRB: false,
            showNotice: false,
            closeTvWindow: true,
            tvlink: null
        };
    },

    methods: {
        checkStart: function checkStart(end) {
            var startTime = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a().utcOffset("-04:00").format("YYYY-MM-DD HH:mm:ss");
            var endTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(end);
            var difference = endTime.diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(startTime), 'minutes');
            if (difference > 0) {
                return difference;
            }
            return 10000;
        },
        matchDateCheck: function matchDateCheck(date) {
            return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(date).utcOffset(this.$store.getters.timeZone.list[this.$store.getters.timeZone.default][1]).format("YYYY-MM-DD HH:mm:ss");
        },
        startTv: function startTv(allBet) {
            var _this = this;

            if (this.$store.getters.account.previewFlag) {}

            this.$ajax({
                url: _baseUrl + '/livetv',
                type: 'post',
                data: {
                    chlid: allBet.ch,
                    eventid: allBet.eveid,
                    league: allBet.lgecapt,
                    tacap: allBet.tacapt,
                    tbcap: allBet.tbcapt
                }
            }).then(function (response) {
                if (response != 'error') {
                    _this.tvlink = response;
                    _this.closeTvWindow = false;
                } else {
                    alert(_this.arr_lang.LivetvLang['LIVETV.Stream_Error']);
                }
            });
        },
        videoClose: function videoClose() {
            this.closeTvWindow = !this.closeTvWindow;
        },
        getTime: function getTime(dt) {
            return new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(dt).format("HH:mm");
        },
        getDate: function getDate(dt) {
            if (this.cookies_lang == 'zh_TW' || this.cookies_lang == 'zh_CN') {
                return new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(dt).format("MM / DD");
            }
            return new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(dt).format("DD / MM");
        },
        startTimer: function startTimer() {
            var _this2 = this;

            if (this.timerIdCount == null) {
                this.timerIdCount = setInterval(function () {
                    if (_this2.timerCount - 1 < 0) {
                        _this2.forAllBetTitle();
                    } else {
                        _this2.timerCount -= 1;
                    }
                }, 1000);
            }
        },
        clearTimer: function clearTimer() {
            if (this.timerIdCount != null) {
                clearInterval(this.timerIdCount);
                this.timerIdCount = null;
            }
        },
        forAllBetTitle: function forAllBetTitle() {
            var d = $('#myDiv');
            if (d.length) {
                if ($('#myDiv')[0].scrollWidth > $('#myDiv')[0].clientWidth) {
                    $('#myDiv')[0].innerHTML = '<marquee>' + $('#myDiv')[0].innerHTML + '</marquee>';
                    this.startTimer();
                }
            }
        },
        changeBetTab: function changeBetTab(tab) {
            this.$store.commit('SELECTEDBETTYPE', tab);
        },
        showHideAllOdds: function showHideAllOdds() {
            if (this.isCollapse) {
                this.$store.commit('IS_COLLAPSE', false);
                $('.odd').css('display', 'none');
                $('.row.items-center').addClass('bottom-style');
            } else {
                this.$store.commit('IS_COLLAPSE', true);
                $('.odd').css('display', 'block');
                $('.row.items-center').removeClass('bottom-style');
            }
        },
        goBack: function goBack() {
            this.$store.commit('MARKET_BUTTON_TOGGLE', false);
            if (this.$store.getters.arr_selectedTemplate.templateId == 6) {
                this.sportTemplate_AllBet(this.arr_selectedTemplate.sportId);
                this.$store.commit('IS_RESULT_SCHEDULE', true);
            } else {
                window.history.go(-1);
            }
        },
        showMoreMatch: function showMoreMatch() {
            if (this.$store.getters.showMoreEvent) {
                this.$store.commit('SHOWMOREEVENT', false);
                $('body').removeClass('q-body--prevent-scroll');
            } else {
                this.$store.commit('SHOWMOREEVENT', true);
                $('body').addClass('q-body--prevent-scroll');
            }
        },
        sportBackground: function sportBackground(sportid, mod) {
            var display = '';
            if (mod == 1) {
                display = 'display: block;';
            }
            if (sportid == 'N1') {
                return 'background: url(assets/images/score/football.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N2') {
                return 'background: url(assets/images/score/basketball.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N13') {
                return 'background: url(assets/images/score/american_football.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N3') {
                return 'background: url(assets/images/score/tennis.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N21') {
                return 'background: url(assets/images/score/volleyball.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N12') {
                return 'background: url(assets/images/score/badminton.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N24') {
                return 'background: url(assets/images/score/ping_pong.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N23') {
                return 'background: url(assets/images/score/baseball.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N15') {
                return 'background: url(assets/images/score/snooker_pool.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N7') {
                return 'background: url(assets/images/score/baseball.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N14') {
                return 'background: url(assets/images/score/ice_hockey.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N19') {
                return 'background: url(assets/images/score/handball.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            } else if (sportid == 'N20') {
                return 'background: url(assets/images/score/DOTA.jpg) center center / 100% no-repeat content-box content-box; ' + display;
            }
        },
        checkBetGroup: function checkBetGroup(grp) {
            var availableGroup = '';
            var con = true;

            if (this.arr_selectedTemplate.sportId == 'N1') {
                availableGroup = this.scAllBetTab[grp];
                if (grp == 4) {
                    if (this.arr_allBetEvent != null && !_.isUndefined(this.arr_allBetEvent.od)) {
                        if (!_.isUndefined(this.arr_allBetEvent.od[2])) {
                            _.forEach(this.arr_allBetEvent.od[2], function (pval, btype) {
                                if (_.indexOf(availableGroup, btype) !== -1) {
                                    con = false;
                                    return false;
                                }
                            });
                        }

                        if (!_.isUndefined(this.arr_allBetEvent.od[19])) {
                            _.forEach(this.arr_allBetEvent.od[19], function (pval, btype) {
                                if (_.indexOf(availableGroup, btype) !== -1) {
                                    con = false;
                                    return false;
                                }
                            });
                        }
                    }
                } else if (grp == 5) {
                    if (this.arr_allBetEvent && this.arr_allBetEvent.sp) {
                        con = false;
                    }
                    if (con && this.arr_allBetEvent && !_.isUndefined(this.arr_allBetEvent.od)) {
                        _.forEach(this.arr_allBetEvent.od, function (pval, plytype) {
                            _.forEach(pval, function (val, btype) {
                                if (_.indexOf(availableGroup, btype) !== -1) {
                                    con = false;
                                    return false;
                                }
                            });
                        });
                    }
                } else {
                    if (this.arr_allBetEvent != null && !_.isUndefined(this.arr_allBetEvent.od)) {
                        _.forEach(this.arr_allBetEvent.od, function (pval, plytype) {
                            _.forEach(pval, function (val, btype) {
                                if (_.indexOf(availableGroup, btype) !== -1) {
                                    con = false;
                                    return false;
                                }
                            });
                        });
                    }
                }
            } else if (this.arr_selectedTemplate.sportId == 'G1') {
                availableGroup = this.bkAllBetTab[grp];
                if (this.arr_allBetEvent != null && !_.isUndefined(this.arr_allBetEvent.od)) {
                    _.forEach(this.arr_allBetEvent.od, function (pval, plytype) {
                        _.forEach(pval, function (val, btype) {
                            if (_.indexOf(availableGroup, btype) !== -1) {
                                con = false;
                                return false;
                            }
                        });
                    });
                }
            } else {
                if (grp == 9) {
                    availableGroup = this.osAllBetTab[grp];
                    if (this.arr_allBetEvent != null && !_.isUndefined(this.arr_allBetEvent.od)) {
                        _.forEach(this.arr_allBetEvent.od, function (pval, plytype) {
                            if (_.indexOf(availableGroup, plytype) !== -1) {
                                con = false;
                                return false;
                            }
                        });
                    }
                } else {
                    availableGroup = this.osAllBetTab[grp];
                    if (this.arr_allBetEvent && !_.isUndefined(this.arr_allBetEvent.od)) {
                        _.forEach(this.arr_allBetEvent.od, function (pval, plytype) {
                            _.forEach(pval, function (val, btype) {
                                if (_.indexOf(availableGroup, btype) !== -1) {
                                    con = false;
                                    return false;
                                }
                            });
                        });
                    }
                }
            }
            if (con == false) {
                if (!(_.indexOf(this.selectedGrp, grp) !== -1)) {
                    this.selectedGrp.push(grp);
                    this.$store.commit('SELECTEDBETTYPE', this.selectedGrp[0]);
                }
            }
        },
        updateSelectedGrp: function updateSelectedGrp(grp) {
            this.selectedGrp = grp;
        },
        reloadAllBetTable: function reloadAllBetTable() {
            this.$store.commit('REFRESHALLBET', true);
            __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('reloadAllBet');
        },
        updateBetGroup: function updateBetGroup() {
            this.checkBetGroup(8);
            this.checkBetGroup(1);
            this.checkBetGroup(2);
            this.checkBetGroup(3);
            this.checkBetGroup(4);
            this.checkBetGroup(5);
            this.checkBetGroup(6);
            this.checkBetGroup(7);
            this.checkBetGroup(9);
            this.checkBetGroup(10);
        },
        sportTemplate_AllBet: function sportTemplate_AllBet(sportId) {
            var vue = this;

            this.$store.commit('SELECTED_TEMPLATE', {
                sportId: sportId,
                marketKey: vue.int_marketToggle,
                subTemplateId: vue.$store.getters.arr_selectedTemplate.subTemplateId
            });

            this.$store.commit('SELECTED_SPORT', sportId);
            var bettypeid = sportId.split('');
            if (bettypeid.length >= 3) {
                bettypeid = bettypeid[1] + "" + bettypeid[2];
            } else {
                bettypeid = bettypeid[1];
            }
            __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('enableLoading', true);
            this.changeSubTemplate(vue.$store.getters.arr_selectedTemplate.subTemplateId, sportId);
            this.$store.commit('SELECTED_MARKET', this.int_marketToggle);
        },
        changeSubTemplate: function changeSubTemplate(subTemplateId) {
            var sportId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


            if (this.account.previewFlag && subTemplateId == '3') {
                alert(lang.info7);
                return false;
            }

            if (this.account.previewFlag && subTemplateId == '3') {
                alert(lang.info7);
                return false;
            }

            if ((this.$store.getters.int_marketToggle == '1' || this.$store.getters.int_marketToggle == '2') && subTemplateId == 2 || this.$store.getters.int_marketToggle == '2' && subTemplateId == 1) {
                this.$store.commit('SELECTED_PAYLAY_DATE', 99);
                if (this.$store.getters.int_marketToggle == '1' && subTemplateId == 2) {
                    this.$store.commit('SELECTED_PAYLAY_DATE', 0);
                }
                this.selectedDate = this.int_selectedParlayDate;
            }

            if (account.previewFlag == undefined || account.previewFlag && this.$store.getters.int_marketToggle != '1') {
                var btemplateId = 2;
            } else if (account.previewFlag && this.$store.getters.int_marketToggle == '1') {
                var btemplateId = 3;
                this.$store.commit('SEL_MATCH', true);
            }

            this.$store.dispatch('changeTemplate', {
                templateId: btemplateId,
                marketKey: this.$store.getters.int_marketToggle,
                plytype: 1,
                bettypeid: this.arr_selectedTemplate.bettypeid,
                sportId: sportId != null ? sportId : this.arr_selectedTemplate.sportId,
                subTemplateId: subTemplateId
            });
            if (subTemplateId == '3') {
                this.$store.dispatch('getOutrightLeague', {
                    token: token.arr_2
                });
            } else {
                if (this.$store.getters.int_marketToggle == '3') {
                    this.$store.dispatch('getLiveSportOdds', {
                        enableLoading: true,
                        token: token.arr_2
                    });
                } else {
                    if (this.$store.getters.isSpecial) {
                        this.$store.dispatch('getSpecialEventOdds', {
                            enableLoading: true,
                            token: token.arr_2
                        });
                    } else {
                        if (this.isOtr) {
                            this.$store.dispatch('getOutrightLeague', { token: token.arr_1 });
                        } else {
                            __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$emit('resetTimer');
                            if (this.$store.getters.arr_selectedTemplate.marketKey == 1) {
                                this.$store.dispatch('getTodayRBSportOdds', {
                                    loading: 0,
                                    token: token.arr_2,
                                    isGameBanner: 0
                                });
                            } else {
                                this.$store.dispatch('getSportOdds', {
                                    enableLoading: true,
                                    token: token.arr_2,
                                    isGameBanner: 0
                                });
                            }
                        }
                    }
                }
            }
        }
    },
    beforeMount: function beforeMount() {
        var _this3 = this;

        __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$on('startTvDefault', function (event) {
            _this3.startTv(event);
        }.bind(this));
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_5__vue_events_event_bus__["a" /* default */].$off('startTvDefault');
    },
    mounted: function mounted() {
        this.updateBetGroup();
        var Vue = this;
    },
    updated: function updated() {
        this.forAllBetTitle();
        this.updateBetGroup();
    },
    created: function created() {},
    destroyed: function destroyed() {
        this.clearTimer();
    }
});

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_favourite__ = __webpack_require__(91);







/* harmony default export */ __webpack_exports__["a"] = ({
   mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_favourite__["a" /* default */]],
   computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['arr_allBetEvent', 'arr_lang', 'selectedSport', 'favouriteTeams', 'skinTheme', 'isMobile', 'loadingScreen']), {
      splitLineups: function splitLineups() {
         return this.arr_allBetEvent && this.arr_allBetEvent.lineup ? this.splitTwoColumns(this.arr_allBetEvent.lineup.homeLineup, this.arr_allBetEvent.lineup.awayLineup) : [];
      },
      splitBackups: function splitBackups() {
         return this.arr_allBetEvent && this.arr_allBetEvent.lineup ? this.splitTwoColumns(this.arr_allBetEvent.lineup.homeBackup, this.arr_allBetEvent.lineup.awayBackup) : [];
      }
   }),
   watch: {
      'arr_allBetEvent.anime': function arr_allBetEventAnime(newVal) {
         if (this.animelink == null) {
            this.animelink = newVal;
         }
      }
   },
   data: function data() {
      return {
         heightPX: window.innerHeight,
         token: window.token,
         cloneEventAllBet: null,
         mainMarketList: null,
         allBetRefreshTimer: 90,
         allBetTimerId: null,
         matchDate: '',
         matchDateInterval: null,
         days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
         months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
         orientation: window.outerWidth < window.outerHeight || window.orientation != undefined && window.orientation === 0 || window.matchMedia("(orientation: portrait)").matches ? 0 : 90,
         tvlink: null,
         animelink: null,
         chatroom: true,
         contentFlag: {
            video: true,
            livetext: true,
            chat: true,
            analysis: true,
            lineup: true,
            odds: true
         },
         bmkToggle: false,
         selectedBmk: '8',
         oddsSwitchToggle: {
            'pre': false,
            'live': false
         },
         oddsBettyp: '5',
         selectedTab: '2'
      };
   },

   methods: {
      reloadAllBetTable: function reloadAllBetTable() {
         var _this = this;

         var token_val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

         if (token_val == '') {
            token_val = token.arr_5;
         }
         this.cloneEventAllBet = _.cloneDeep(this.$store.getters.arr_allBetEvent);
         this.clearAllBetTimer();
         this.$store.dispatch('getSportAllBet', {
            token: token_val,
            inAllBet: true,
            event: this.$store.getters.arr_allBetEvent,
            callback: function (res) {
               _this.allBetRefreshTimer = _this.$store.getters.selectedMarket == _this.$store.getters.market.inPlayMarket.key ? 30 : 90;
               _this.startAllBetTimer();
               _this.mainMarketList = _.cloneDeep(_this.$store.getters.arr_allBetEvent);

               _this.$store.commit('REFRESHALLBET', false);
            }.bind(this)
         });
      },
      clearAllBetTimer: function clearAllBetTimer() {
         clearInterval(this.allBetTimerId);
         this.allBetTimerId = null;
      },
      startAllBetTimer: function startAllBetTimer() {
         var _this2 = this;

         if (this.allBetTimerId == null) {
            this.allBetTimerId = setInterval(function () {
               if (_this2.allBetRefreshTimer - 1 < 0) {
                  _this2.reloadAllBetTable(token.arr_1);
               } else {
                  _this2.allBetRefreshTimer -= 1;
               }
            }, 1000);
         }
      },
      updateMatchDate: function updateMatchDate() {
         var now = new Date();

         var selectedTimezone = this.$store.getters.selected_timezone;
         var utc = now.getTime() + now.getTimezoneOffset() * 60000;
         var tzDate = new Date(utc + selectedTimezone * 3600000);
         var formatted = this.days[tzDate.getDay()] + ' ' + this.months[tzDate.getMonth()] + ' ' + String(tzDate.getDate()).padStart(2, '0') + ' ' + tzDate.getFullYear() + ' ' + String(tzDate.getHours()).padStart(2, '0') + ':' + String(tzDate.getMinutes()).padStart(2, '0') + ':' + String(tzDate.getSeconds()).padStart(2, '0');

         this.matchDate = formatted;
      },
      changeVideo: function changeVideo(type, allBet) {
         this.displayContent('overview');
         if (type == 'live') {
            this.selectedTab = '1';
         } else if (type == 'anime') {
            this.selectedTab = '2';
         }
      },
      startTv: function startTv(allBet) {
         var _this3 = this;

         if (allBet && allBet.rb == 1) {
            this.$ajax({
               url: _baseUrl + '/livetv',
               type: 'post',
               data: {
                  chlid: allBet.chid ? allBet.chid : allBet.ch,
                  eventid: allBet.eveid,
                  sptid: allBet.sprtid ? allBet.sprtid : allBet.sptid,
                  league: allBet.lgecapt,
                  tacap: allBet.tacapt,
                  tbcap: allBet.tbcapt
               }
            }).then(function (response) {
               if (response != 'error') {
                  _this3.tvlink = response;
                  _this3.changeVideo('live', allBet);
               } else {
                  _this3.tvlink = null;
                  _this3.changeVideo('anime', allBet);
               }
            });
         }
      },
      closeVideo: function closeVideo() {
         $('.title-events-mobile-video').removeClass('active');
      },
      toggleChatroom: function toggleChatroom() {
         this.chatroom = !this.chatroom;
      },
      getAnalysisStyle: function getAnalysisStyle(position, t) {
         var defaultStyle = {
            backgroundColor: 'transparent',
            color: 'var(--live-box-score-text)'
         };

         var styles = {
            left: { backgroundColor: '#4360ec', color: '#fff' },
            right: { backgroundColor: '#ffdd00', color: '#000' }
         };

         if (position === 'left' && t === 'a' || position === 'right' && t === 'b') {
            return styles[position];
         }

         return defaultStyle;
      },
      splitTwoColumns: function splitTwoColumns(home, away) {
         var homeArr = Array.isArray(home) ? home : [];
         var awayArr = Array.isArray(away) ? away : [];

         var homeMid = Math.ceil(homeArr.length / 2);
         var awayMid = Math.ceil(awayArr.length / 2);

         var maxLen = Math.max(homeMid, awayMid);
         var result = [];

         for (var i = 0; i < maxLen; i++) {
            result.push({
               homeLeft: homeArr[i] || null,
               homeRight: homeArr[i + homeMid] || null,
               awayLeft: awayArr[i] || null,
               awayRight: awayArr[i + awayMid] || null
            });
         }

         return result;
      },
      getLiveTextScore: function getLiveTextScore(rb_timer_status, rb_score) {
         if (rb_timer_status) {
            return rb_timer_status + (rb_score && rb_score[rb_timer_status] ? ' ' + rb_score[rb_timer_status] : '');
         }
         return '';
      },
      displayContent: function displayContent(type) {
         if (!$('.tabs-btn#tab-' + type).hasClass('current')) {
            $('.tabs-btn').removeClass('current');
            $('.tabs-btn#tab-' + type).addClass('current');
         }

         var defaultFlags = {
            video: false,
            livetext: false,
            chat: false,
            analysis: false,
            lineup: false,
            odds: false
         };

         if (type === 'overview') {
            for (var key in defaultFlags) {
               defaultFlags[key] = true;
            }
         } else {
            defaultFlags[type] = true;
         }

         this.contentFlag = defaultFlags;
      },
      checkFavTeams: function checkFavTeams(team) {
         if (this.arr_allBetEvent && this.arr_allBetEvent[team]) {
            if (this.favouriteTeams && this.favouriteTeams[this.selectedSport] && this.favouriteTeams[this.selectedSport].indexOf(this.arr_allBetEvent[team]) >= 0) {
               return true;
            }
         }
         return false;
      },
      getDate: function getDate(event) {
         if (event != null) {
            return event.evedt;
         }
      },
      checkTitle: function checkTitle(title, mod) {
         if (title && title.length > 20) {
            if (mod && mod == 'lge') {
               return 'text-ellipsis';
            } else if (mod && mod == 'team') {
               return 'text-ellipsis-team';
            }
         }
         return '';
      },
      toggleBmkDropdown: function toggleBmkDropdown() {
         var _this4 = this;

         if ($('.odds-data-dropdown').length > 0 && $('.content-top').children('.odds-data-dropdown').length <= 0) {
            $('.content-top').append($('.odds-data-dropdown'));
         }
         this.bmkToggle = !this.bmkToggle;
         if (this.bmkToggle) {
            $('.odds-data-dropdown').addClass('open');
            this.$nextTick(function () {
               return _this4.updateDropdownPosition();
            });
         } else {
            $('.odds-data-dropdown').removeClass('open');
         }
      },
      selectBmk: function selectBmk(bmk) {
         this.bmkToggle = false;
         $('.odds-data-dropdown').removeClass('open');
         this.selectedBmk = bmk;
      },
      updateDropdownPosition: function updateDropdownPosition() {
         var selector = this.$refs.oddsselector;
         var dropdown = this.$refs.oddsdropdown;
         if (!selector || !dropdown) return;

         var rect = selector.getBoundingClientRect();

         if (window.innerWidth >= 1366) {
            dropdown.style.top = '520px';
            dropdown.style.left = rect.left + 'px';
         } else if (window.innerWidth >= 481 && window.innerWidth < 1366) {
            dropdown.style.top = '48px';
            dropdown.style.left = '23px';
         } else {
            this.bmkToggle = false;
            $('.odds-data-dropdown').removeClass('open');
         }
      },
      handleResize: function handleResize() {
         this.orientation = window.outerWidth < window.outerHeight || window.orientation != undefined && window.orientation === 0 || window.matchMedia("(orientation: portrait)").matches ? 0 : 90;
         if (this.bmkToggle) {
            this.updateDropdownPosition();
         }
      },
      getOdd: function getOdd(event, bettyp, type, team) {
         var plytyp = event.rb == 1 ? '3' : '2';
         if (event.od && event.od[this.selectedBmk] && event.od[this.selectedBmk][bettyp] && event.od[this.selectedBmk][bettyp][type] && event.od[this.selectedBmk][bettyp][type][team]) {
            return event.od[this.selectedBmk][bettyp][type][team];
         }
         return '-';
      },
      getHan: function getHan(event, bettyp, type, team) {
         var plytyp = event.rb == 1 ? '3' : '2';
         if (event.od && event.od[this.selectedBmk] && event.od[this.selectedBmk][bettyp] && event.od[this.selectedBmk][bettyp][type] && event.od[this.selectedBmk][bettyp][type]['han']) {
            var ret = event.od[this.selectedBmk][bettyp][type]['han'].toString();
            if (parseFloat(ret) != 0) {
               if (ret.substring(0, 1) != '-') {
                  if (team == 'odA') {
                     ret = '+' + ret;
                  } else {
                     ret = '-' + ret;
                  }
               } else {
                  if (team == 'odA') {
                     ret = '-' + ret.slice(1);
                  } else {
                     ret = '+' + ret.slice(1);
                  }
               }
            }
            return ret;
         }
         return '';
      },
      oddsSwitch: function oddsSwitch(swt) {
         this.oddsSwitchToggle[swt] = !this.oddsSwitchToggle[swt];
      },
      selectOddsBettyp: function selectOddsBettyp(bty) {
         this.selectedBmk = '8';
         this.oddsBettyp = bty;
      }
   },
   beforeMount: function beforeMount() {
      var _this5 = this;

      $(".scroll").scrollTop(0);
      this.$store.commit('LOADINGSCREEN', true);
      this.allBetRefreshTimer = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 90;
      this.mainMarketList = _.cloneDeep(this.$store.getters.arr_allBetEvent);
      this.startAllBetTimer();

      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$off('startTvDefault');
      __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$on('startTvDefault', function (event) {
         _this5.startTv(event);
      }.bind(this));
   },
   mounted: function mounted() {
      this.updateMatchDate();
      this.matchDateInterval = setInterval(this.updateMatchDate, 1000);
      window.addEventListener('resize', this.handleResize, { passive: true });
   },
   beforeDestroy: function beforeDestroy() {
      clearInterval(this.matchDateInterval);
      window.removeEventListener('resize', this.handleResize, { passive: true });
   },
   destroyed: function destroyed() {
      this.clearAllBetTimer();
   }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_apps_home_home_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_store___ = __webpack_require__(338);






history.pushState(null, null, location.href);

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#landing',
  template: '<Home></Home>',
  store: __WEBPACK_IMPORTED_MODULE_2__vue_store___["a" /* default */],
  beforeMount: function beforeMount() {
    this.$store.commit('ACCOUNT', window.account);
    this.$store.commit('SPORTBETTYPELIST', window.sportBettypeList);
    this.$store.commit('SPORTLIST', _.uniqBy(window.sportBettypeList, 'sprtId'));
    var sport_id = 0;
    if (window.sprtid != '') {
      var index = this.$store.getters.sportList.findIndex(function (item) {
        return item.sprtId === 'N' + window.sprtid;
      });
      if (index !== -1) {
        sport_id = index;
        if (window.selectedMrkt != '') {
          this.$store.commit('SELECTED_MARKET', window.selectedMrkt);
          this.$store.commit('MARKETTOGGLE', window.selectedMrkt);
        }
      }
    }
    this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[sport_id]['sprtId']);
  },
  mounted: function mounted() {
    var VUE = this;
    if (window.navigator.userAgent.indexOf('Safari') < 0 && window.navigator.userAgent.indexOf('Chrome') != -1) {
      window.onpopstate = function () {
        VUE.$store.dispatch('redirectReturn');
      };
    }
  },

  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0__vue_apps_home_home_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4e4226_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__(337);
function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f4e4226_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 240:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportHeader_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662f1423_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportHeader_vue__ = __webpack_require__(330);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sportHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_662f1423_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sportHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 29:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ajax_http_interceptor__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__ = __webpack_require__(73);


__webpack_require__(84).polyfill();





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].mixin({
	data: function data() {
		return {
			_: _
		};
	}
});


/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
	components: { Core: __WEBPACK_IMPORTED_MODULE_3__vue_apps_core_core_vue__["a" /* default */] }
}));

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accountMenu_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4932161a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accountMenu_vue__ = __webpack_require__(293);
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_accountMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4932161a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_accountMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-set-menu effect",class:{'show': _vm.isShowMenu==true},staticStyle:{"display":"none","right":"-3.77rem"},on:{"click":function($event){return _vm.hideMenuAll($event)}}},[_c('div',{staticClass:"menu-inner",staticStyle:{"width":"70vw"},attrs:{"id":"menu-inner"}},[_c('div',{staticClass:"close-wrap"},[_c('div',{staticClass:"img",on:{"click":function($event){return _vm.hideMenu()}}})]),_vm._v(" "),_c('div',{staticClass:"set-item"},[_c('div',{staticClass:"icon set-icon-1"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.lang.home['HOME.SORT']))]),_vm._v(" "),_c('div',{staticClass:"option",on:{"click":function($event){return _vm.optionTrigger('sort')}}},[_c('div',{staticClass:"op-item active"},[_vm._v(_vm._s(_vm.sortHot==2 ? _vm.lang.home['HOME.BY_HOT'] : _vm.lang.home['HOME.BY_TIME']))]),_vm._v(" "),_c('div',{staticClass:"op-icon"}),_vm._v(" "),_c('div',{staticClass:"op-item"},[_vm._v(_vm._s(_vm.sortHot==2 ? _vm.lang.home['HOME.BY_TIME'] : _vm.lang.home['HOME.BY_HOT']))])])]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"set-item no-border"},[_c('div',{staticClass:"icon set-icon-5"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.lang.home['HOME.SWITCH']))]),_vm._v(" "),_c('div',{staticClass:"option option3",on:{"click":function($event){return _vm.showLanguage()}}},[_c('i',{staticClass:"lang-icon yb_mr4",class:{'lang-zh':_vm.cookies_lang=='zh_CN', 'lang-tw':_vm.cookies_lang=='zh_TW', 'lang-en':_vm.cookies_lang=='en_US', 'lang-th':_vm.cookies_lang=='th_TH', 'lang-vn':_vm.cookies_lang=='vn_VN', 'lang-id':_vm.cookies_lang=='id_ID', 'lang-es':_vm.cookies_lang=='es_MX', 'lang-pt':_vm.cookies_lang=='pt_PT', 'lang-fa':_vm.cookies_lang=='fa_IR', 'lang-ja':_vm.cookies_lang=='ja_JP', 'lang-ko':_vm.cookies_lang=='ko_KR'}}),_vm._v(" "),_c('div',{staticClass:"op-icon op-icon2"}),_vm._v(" "),(_vm.cookies_lang=='zh_TW')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"zh-TW"}},[_vm._v(_vm._s(_vm.langSelect[3].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='en_US')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"en-US"}},[_vm._v(_vm._s(_vm.langSelect[1].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='zh_CN')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"zh_CN"}},[_vm._v(_vm._s(_vm.langSelect[2].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='th_TH')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"th-TH"}},[_vm._v(_vm._s(_vm.langSelect[5].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='vn_VN')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"vn-VN"}},[_vm._v(_vm._s(_vm.langSelect[6].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='id_ID')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"id-ID"}},[_vm._v(_vm._s(_vm.langSelect[7].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='es_MX')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"es-MX"}},[_vm._v(_vm._s(_vm.langSelect[8].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='pt_PT')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"pt-PT"}},[_vm._v(_vm._s(_vm.langSelect[9].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='fa_IR')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"fa-IR"}},[_vm._v(_vm._s(_vm.langSelect[10].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='ja_JP')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"ja-JP"}},[_vm._v(_vm._s(_vm.langSelect[4].caption))]):_vm._e(),_vm._v(" "),(_vm.cookies_lang=='ko_KR')?_c('div',{staticClass:"op-item active lgSelect",staticStyle:{"font-size":"0.14rem"},attrs:{"id":"ko-Kr"}},[_vm._v(_vm._s(_vm.langSelect[11].caption))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"lang-wrap"},[_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='en_US'},on:{"click":function($event){return _vm.changeLanguage(1)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-en"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[1].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='zh_CN'},on:{"click":function($event){return _vm.changeLanguage(2)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-zh"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[2].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='zh_TW'},on:{"click":function($event){return _vm.changeLanguage(3)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-tw"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[3].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='th_TH'},on:{"click":function($event){return _vm.changeLanguage(5)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-th"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[5].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='vn_VN'},on:{"click":function($event){return _vm.changeLanguage(6)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-vi"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[6].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='id_ID'},on:{"click":function($event){return _vm.changeLanguage(7)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-id"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[7].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='es_MX'},on:{"click":function($event){return _vm.changeLanguage(8)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-es"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[8].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='pt_PT'},on:{"click":function($event){return _vm.changeLanguage(9)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-pt"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[9].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='fa_IR'},on:{"click":function($event){return _vm.changeLanguage(10)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-fa"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[10].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='ja_JP'},on:{"click":function($event){return _vm.changeLanguage(4)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-ja"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[4].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"lang-item",class:{'active':_vm.cookies_lang=='ko_KR'},on:{"click":function($event){return _vm.changeLanguage(11)}}},[_c('i',{staticClass:"lang-icon yb_mr4 lang-ko"}),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.langSelect[11].caption))]),_vm._v(" "),_c('div',{staticClass:"icon"})])]),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"set-item"},[_c('div',{staticClass:"icon set-icon-7"}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.lang.home['HOME.SKIN']))]),_vm._v(" "),_c('div',{staticClass:"skin-wrap",attrs:{"id":"toggleTheme"}},[_c('div',{staticClass:"skin-icon skin-icon1",on:{"click":function($event){return _vm.changeSkin(1)}}}),_vm._v(" "),_c('div',{staticClass:"skin-icon skin-icon2",on:{"click":function($event){return _vm.changeSkin(2)}}})])]),_vm._v(" "),(_vm.timeZone.format>0)?_c('div',{staticClass:"set-item no-border"},[_c('div',{staticClass:"name",staticStyle:{"margin-left":"2em"}},[_vm._v(_vm._s(_vm.lang.home['HOME.TIMEZONE']))]),_vm._v(" "),(_vm.timeZone.format==1)?_c('div',{staticClass:"option option3",on:{"click":function($event){return _vm.showTimeZone()}}},[_c('div',{staticClass:"op-icon op-icon2"}),_vm._v(" "),_vm._l((_vm.timeZone.list),function(dt,index){return [(_vm.selectedTimeZone==index)?_c('div',{staticClass:"op-item active",staticStyle:{"font-size":"0.14rem"},attrs:{"id":'tZ-'+index}},[_vm._v(_vm._s(index))]):_vm._e()]})],2):_vm._e(),_vm._v(" "),(_vm.timeZone.format==2)?_c('div',{staticClass:"option option3"},[_c('div',[_vm._v(_vm._s(_vm.timeZone.default))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.timeZone.format==1)?_c('div',{staticClass:"timeZone-wrap"},[_vm._l((_vm.timeZone.list),function(dt,index){return [_c('div',{staticClass:"odds-item",class:{'active':_vm.selectedTimeZone==index},on:{"click":function($event){return _vm.changeTimeZone(index)}}},[_c('div',{staticClass:"col"},[_vm._v(_vm._s(index))]),_vm._v(" "),_c('div',{staticClass:"icon"})])]})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-toast",staticStyle:{"display":"none"},attrs:{"id":"successChip_msg"}},[_vm._v(_vm._s(_vm.lang.info7))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 294:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('div',{staticClass:"sub-menu-date-w",class:{'zaopan': _vm.int_marketToggle == 2 && !_vm.isOtr}},[_c('div',{staticClass:"sport-m-container effect shadow-down",class:{'zaopan': _vm.int_marketToggle == 2 && !_vm.isOtr}},[_c('div',{staticClass:"s-menu-container flex"},[_vm._l((_vm.titleSport),function(sport,key){return [(_vm.checkSportCount(sport.id) && ['N1','N2'].includes(sport.id))?_c('div',{staticClass:"sport-menu-item flex justify-center",class:{'current':_vm.arr_selectedTemplate.sportId == sport.id},on:{"click":function($event){return _vm.changeSport(sport.id)}}},[_c('div',{staticClass:"inner-w flex justify-between items-center"},[_c('div',{staticClass:"sport-w-icon"},[_c('span',{staticClass:"sport-icon-wrap",class:[{'focus-d':_vm.arr_selectedTemplate.sportId!=sport.id, 'focus-a':_vm.arr_selectedTemplate.sportId==sport.id ||_vm.arr_selectedTemplate.sportId=='G98'}, sport.icon]})]),_vm._v(" "),_c('div',{staticClass:"s-w-i-title"},[_vm._v(_vm._s(_vm.arr_lang.configLang[sport.titleLang]))])])]):_vm._e()]}),_vm._v(" "),_vm._l((_vm.popularLeagues),function(lge,key){return _c('div',{staticClass:"sport-menu-item flex justify-center current",on:{"click":function($event){return _vm.filterLeague(lge.lgeid)}}},[_c('div',{staticClass:"inner-w flex justify-between items-center"},[_vm._m(0,true),_vm._v(" "),_c('div',{staticClass:"s-w-i-title"},[_vm._v(_vm._s(lge.name))])])])})],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sport-w-icon"},[_c('img',{staticClass:"side-img",attrs:{"src":"assets/images/england_logo.svg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrap"},[_c('div',{staticClass:"menu-item logo left",attrs:{"alt":""},on:{"click":function($event){return _vm.refresh()}}}),_vm._v(" "),_c('div',{staticClass:"menu-item settings-wrap right"},[_c('div',{staticClass:"settings-toggle"},[_c('a',{staticClass:"settings-icon",class:{ active: _vm.isSettingsOpen },on:{"click":function($event){$event.preventDefault();return _vm.toggleSettingsMenu.apply(null, arguments)}}}),_vm._v(" "),_c('div',{staticClass:"settings-menu",class:{ show: _vm.isSettingsOpen }},[_c('a',{staticClass:"settings-item",attrs:{"id":"light-mode"},on:{"click":function($event){$event.preventDefault();return _vm.changeSkin(1)}}},[_vm._v(_vm._s(_vm.lang.home['HOME.LIGHT_MODE']))]),_vm._v(" "),_c('a',{staticClass:"settings-item",attrs:{"id":"dark-mode"},on:{"click":function($event){$event.preventDefault();return _vm.changeSkin(2)}}},[_vm._v(_vm._s(_vm.lang.home['HOME.DARK_MODE']))])])])]),_vm._v(" "),_c('div',{staticClass:"menu-item lang-wrap right"},[_c('div',{staticClass:"lang-toggle"},[_c('a',{staticClass:"lang-icon",class:{ active: _vm.isLangOpen },on:{"click":function($event){$event.preventDefault();return _vm.toggleLangMenu.apply(null, arguments)}}}),_vm._v(" "),_c('div',{staticClass:"lang-menu",class:{ show: _vm.isLangOpen }},[_c('a',{staticClass:"lang-item lang-cn",on:{"click":function($event){$event.preventDefault();return _vm.changeLanguage(2)}}},[_c('span',{staticClass:"flag-icon"}),_vm._v(" "),_c('span',{staticClass:"lang-label"},[_vm._v(_vm._s(_vm.langSelect[2].caption))])]),_vm._v(" "),_c('a',{staticClass:"lang-item lang-tw",on:{"click":function($event){$event.preventDefault();return _vm.changeLanguage(3)}}},[_c('span',{staticClass:"flag-icon"}),_vm._v(" "),_c('span',{staticClass:"lang-label"},[_vm._v(_vm._s(_vm.langSelect[3].caption))])]),_vm._v(" "),_c('a',{staticClass:"lang-item lang-en",on:{"click":function($event){$event.preventDefault();return _vm.changeLanguage(1)}}},[_c('span',{staticClass:"flag-icon"}),_vm._v(" "),_c('span',{staticClass:"lang-label notranslate"},[_vm._v(_vm._s(_vm.langSelect[1].caption))])]),_vm._v(" "),_c('a',{staticClass:"lang-item lang-th",on:{"click":function($event){$event.preventDefault();return _vm.changeLanguage(5)}}},[_c('span',{staticClass:"flag-icon"}),_vm._v(" "),_c('span',{staticClass:"lang-label"},[_vm._v(_vm._s(_vm.langSelect[5].caption))])])])])]),_vm._v(" "),_c('div',{staticClass:"menu-item search-box"},[_c('span',{staticClass:"search-icon"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],attrs:{"type":"text","placeholder":_vm.lang.home['HOME.SEARCH'],"id":"searchInput"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"menu-item nav-sport"},[_c('ul',{staticClass:"clearfix"},[_vm._l((_vm.titleSport),function(sport,key){return [(['N1','N2'].includes(sport.id))?_c('li',{on:{"click":function($event){return _vm.changeSport(sport.id)}}},[_c('a',{class:{'current':_vm.selectedSport == sport.id && !_vm.selectedPopular}},[_c('span',{staticClass:"nav-icon",class:'icon-'+sport.id}),_vm._v(" "),_c('span',{staticClass:"nav-title"},[_vm._v(_vm._s(_vm.arr_lang.configLang[sport.titleLang]))])])]):_vm._e()]}),_vm._v(" "),_vm._l((_vm.popularLeagues),function(lge,key){return [_c('li',{on:{"click":function($event){return _vm.filterLeague(lge)}}},[_c('a',{class:{'current':_vm.playtype == '2' && _vm.selected_league == lge.lgeid}},[_c('span',{staticClass:"nav-icon icon-lge"}),_vm._v(" "),_c('span',{staticClass:"nav-title",style:((_vm.cookies_lang == 'zh_CN' || _vm.cookies_lang == 'zh_TW')? 'max-width: 90px;':'max-width: 86px;'),attrs:{"title":_vm.getNameByLang(lge)}},[_vm._v(_vm._s(_vm.getNameByLang(lge)))])])])]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentSport_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aff0b9a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contentSport_vue__ = __webpack_require__(325);
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contentSport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aff0b9a8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contentSport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 298:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"list-scroll-to-top",attrs:{"data-v-7211449b":"","data-v-c9bcc182":"","src":_vm.skinTheme==2?'assets/images/score/scroll_top_02.svg':'assets/images/score/scroll_top_01.svg'},on:{"click":function($event){return _vm.backToTop()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-more-container",attrs:{"data-v-c9bcc182":""}},[_c('div',{staticStyle:{"color":"rgb(170, 174, 184)","font-size":"0.12rem"},attrs:{"data-v-c9bcc182":""}},[_vm._v("\n      "+_vm._s(_vm.sportTableLang['SPORT_TABLE.END'])+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refreshScreen_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04552912_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refreshScreen_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(303)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04552912"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_refreshScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04552912_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_refreshScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 303:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{style:({ height: _vm.heightPX+'px !important'}),attrs:{"id":"refresh"}},[_c('div',{staticClass:"spinner"})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleSoccerTable_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371e022a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleSoccerTable_vue__ = __webpack_require__(324);
function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-371e022a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simpleSoccerTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_371e022a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simpleSoccerTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_common_rb_timer__ = __webpack_require__(191);







switch (comp_lang) {
  case 'zh_CN':
    __webpack_require__(308);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('zh-cn');
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('zh-cn', {
      longDateFormat: {
        MM: 'xx'
      }
    });
    break;
  case 'zh_TW':
    __webpack_require__(309);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('zh-tw');
    break;
  case 'th_TH':
    __webpack_require__(310);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('th');
    break;
  case 'es_MX':
    __webpack_require__(311);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('es');
    break;
  case 'pt_PT':
    __webpack_require__(312);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt');
    break;
  case 'fa_IR':
    __webpack_require__(313);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('fa');
    break;
  case 'ja_JP':
    __webpack_require__(314);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('ja');
    break;
  case 'ko_KR':
    __webpack_require__(315);
    __WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('ko');
    break;
  default:}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', function (value, format) {
  var paramDate = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(value);
  return paramDate.format(format);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('rb-timer', function (event, format) {
  var timer = '';

  if (event.sptid == '1') {
    var timerSec = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').seconds();
    var timerMin = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').minutes();
    var timerHour = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').hours();

    if (timerSec.toString().length == 1) {
      timerSec = '0' + timerSec;
    }

    timer = timerMin;
    if (event.rbinfo.htst == '2') {
      if (event.extraflag) {
        timer = timerMin >= 15 ? timerMin - 15 : timerMin;
      } else {
        timer = timerHour * 60 - 45 + timerMin;
      }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__js_common_rb_timer__["a" /* validateSpecialRBTimer */])(event, timerHour, timerMin)) {
      timer = timerHour * 60 - 45 + timerMin;
    }

    if (timer.toString().length == 1) {
      timer = '0' + timer;
    }

    if (format == 'mm:ss') {
      timer += ':' + timerSec;
    } else if (format == 'mm') {
      timer = timer;
    } else {
      timer += ':' + timerSec;
    }
  } else if (event.sptid == '2') {
    var timerMin = event.rbinfo.evetm;
    if (timerMin != null && timerMin.toString().length >= 1) {
      timerMin = timerMin.toString().length == 1 ? '0' + timerMin : timerMin;
      timer = timerMin;
      if (format == 'mm:ss') {
        timer += ':00';
      } else if (format == 'mm') {
        timer = timer;
      } else {
        timer += ':00';
      }
    }
  }
  return timer;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('checkTimer', function (event, format) {
  var timer = '';

  if (event.sptid == '1') {
    var timerSec = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').seconds();
    var timerMin = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').minutes();
    var timerHour = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').hours();

    if (timerSec.toString().length == 1) {
      timerSec = '0' + timerSec;
    }

    timer = timerMin;
    if (event.rbinfo.htst == '2') {
      if (event.extraflag) {
        timer = timerMin >= 15 ? timerMin - 15 : timerMin;
      } else {
        timer = timerHour * 60 - 45 + timerMin;
      }
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__js_common_rb_timer__["a" /* validateSpecialRBTimer */])(event, timerHour, timerMin)) {
      timer = timerHour * 60 - 45 + timerMin;
    }

    if (timer.toString().length == 1) {
      timer = '0' + timer;
    }

    if (timer < 0) {
      timer = '';
    } else {
      if (format == 'mm:ss') {
        timer += ':' + timerSec;
      } else if (format == 'mm') {
        timer = timer;
      } else {
        timer += ':' + timerSec;
      }
    }
  } else if (event.sptid == '2') {
    var timerMin = event.rbinfo.evetm;
    if (timerMin != null && timerMin.toString().length >= 1) {
      timerMin = timerMin.toString().length == 1 ? '0' + timerMin : timerMin;
      timer = timerMin;

      if (timer < 0) {
        timer = '';
      } else {
        if (format == 'mm:ss') {
          timer += ':00';
        } else if (format == 'mm') {
          timer = timer;
        } else {
          timer += ':00';
        }
      }
    }
  }

  return timer;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('isPersian', function (stringLanguage) {
  var PersianOrASCII = /[آ-ی]|([a-zA-Z])/;
  var m = "";
  if ((m = stringLanguage.match(PersianOrASCII)) !== null) {
    if (m[1]) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
});

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_filters_vue_filter_number__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__ = __webpack_require__(90);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('odd1x2', {
  mixins: [__WEBPACK_IMPORTED_MODULE_3__vue_mixins_allBet__["a" /* default */]],
  name: 'odd1x2',
  template: '\n      <span class="ratio" :style="{float:cssAttr[\'style1\']}">\n        <font :class="{ngve: isNegative, diff: isDiff}">\n          <template v-if="event.od">\n            <template v-if="event.od && event.od && event.od[team]">\n                {{ parseFloat(event.od[team]).toFixed(2) }}\n            </template>\n            <template v-else>\n              <span class="odd-oe" :class="{ ht: plyType != \'1\'}"></span>\n            </template>\n          </template>\n          <template v-else>\n              <span class="odd-oe" :class="{ ht: plyType != \'1\'}"></span>\n            </template>\n        </font>\n        <span class="change-icon" v-if="isDiff" :class="{\'icon-red\': isDiff && isUp, \'icon-green\': isDiff && !isUp}"></span>\n      </span>\n  ',
  props: {
    event: null,
    bmk: null,
    plyType: null,
    betType: null,
    type: null,
    team: null,
    uid: null,
    isAllBet: null,
    styleAttr: null
  },
  watch: {
    'event': {
      handler: function handler(val, oldVal) {
        if (this.isDefinedOdds(val)) {
          this.classNegative(val.od[this.team]);

          if (oldVal && !this.refreshOdd) {
            this.refreshOdd = false;
            if (this.isDefinedOdds(oldVal)) {
              this.diffOddsUpDown(val.od[this.team], oldVal.od[this.team]);
              this.diffOdds(val.od[this.team], oldVal.od[this.team]);
            }
            this.checkOdds();
          } else if (this.refreshOdd) {
            this.refreshOdd = false;
            this.isDiff = false;
          } else if (!oldVal) {
            this.refreshOdd = true;
          }
        }
      },

      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      isNegative: false,
      isDiff: false,
      matchId: null,
      refreshOdd: false,
      isUp: false
    };
  },

  methods: {
    cssAttr: function cssAttr() {
      if (this.styleAttr) {
        return this.styleAttr;
      }
      return 'inherit';
    },
    classNegative: function classNegative(val, oldVal) {
      this.isNegative = parseFloat(val) < 0 ? true : false;
    },
    diffOdds: function diffOdds(val, oldVal) {
      this.isDiff = parseFloat(val) != parseFloat(oldVal) ? true : false;
    },
    diffOddsUpDown: function diffOddsUpDown(val, oldVal) {
      this.isUp = parseFloat(val) > parseFloat(oldVal) ? true : false;
    },
    isDefinedOdds: function isDefinedOdds(val) {
      var isDefinedOdds = false;

      var od = val.od;
      var bmk = this.bmk;
      var plytyp = this.plytyp;
      var bettyp = this.bettyp;
      var type = this.type;
      var team = this.team;
      if (od[team]) {
        isDefinedOdds = true;
      }
      return isDefinedOdds;
    },
    checkOdds: function checkOdds() {
      if (this.isAllBet) {
        $('.odds.' + this.uid).removeClass('red_text');
        $('.odds.' + this.uid).removeClass('green_text');
        if (this.isDiff) {
          if (this.isUp) {
            $('.odds.' + this.uid).addClass('red_text');
          } else {
            $('.odds.' + this.uid).addClass('green_text');
          }
        }
      } else {
        $('.odd-value.' + this.uid).removeClass('red');
        $('.odd-value.' + this.uid).removeClass('green');
        $('.odd-column-item.' + this.uid).removeClass('mred');
        $('.odd-column-item.' + this.uid).removeClass('mgreen');
        if (this.isDiff) {
          if (this.isUp) {
            $('.odd-value.' + this.uid).addClass('red');
            $('.odd-column-item.' + this.uid).addClass('mred');
          } else {
            $('.odd-value.' + this.uid).addClass('green');
            $('.odd-column-item.' + this.uid).addClass('mgreen');
          }
        }
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$on(['diffOdd'], function (params) {
      if (typeof _this.event.all == 'undefined') {
        if (_this.isDefinedOdds(_this.event) && _this.isDefinedOdds(params)) {
          _this.diffOdds(params.od[_this.plyType][_this.betType]['odds' + _this.team], _this.event.od[_this.plyType][_this.betType]['odds' + _this.team]);
          _this.$forceUpdate();
        }
      }
    }.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$off('diffOdd');
  }
});

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('number', function (value, decimalParam) {
  var accounting = __webpack_require__(125);
  var decimal = typeof decimalParam !== 'undefined' ? decimalParam : 2;

  if (window.account.showDecimals == false) {}
  var factor = Math.pow(10, decimal);
  var tempNumber = value * factor;
  var roundedTempNumber = 0;

  tempNumber = -tempNumber;
  roundedTempNumber = Math.round(tempNumber) * -1;

  value = roundedTempNumber / factor;
  return accounting.formatNumber(value, decimal, ',');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('odd', function (value, decimalParam) {
  return parseFloat(value).toFixed(2);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('roundUpNumber', function (value, isRoundUp) {
  if (value == '-') {
    return value;
  }

  var accounting = __webpack_require__(125);
  var decimal = 0;

  isRoundUp = typeof isRoundUp === 'undefined' ? true : isRoundUp;

  value = isRoundUp ? Math.ceil(parseFloat(value)) : Math.floor(parseFloat(value));

  return accounting.formatNumber(value, decimal, ',');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('ccl', function (value, decimalParam) {
  var accounting = __webpack_require__(125);
  if (value) {
    var decimal = typeof decimalParam !== 'undefined' ? decimalParam : 2;
    if (window.account.showDecimals) {
      if (typeof value === "string") {
        value = parseFloat(value.split(',').join(''));
      }
    } else {
      if (typeof value == "string") {
        value = Math.floor(parseFloat(value.split(',').join('')));
      } else if (typeof value === "number") {
        value = Math.floor(value);
      }
    }
    decimal = value == 0 ? 0 : decimal;
    if (value == '-') {
      return value;
    }
  }
  return accounting.formatNumber(Math.floor((value * 100).toFixed(2)) / 100, decimal, ',');
});

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return MARKETTOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return LOADINGSCREEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return REQUEST_ALLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return SUBLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FULL_LOAD; });
/* unused harmony export CHANGE_SKIN_THEME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return SHOW_FLOATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return SIM_DISP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return SPORTCOUNTMARKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return IS_OTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return IS_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SELECTEDBETTYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return REFRESHSCREEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return IS_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SHOWMOREEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FILTER_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COOKIE_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return SEARCH_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return HIST_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CURRENT_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return SELECTED_ODD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACC_CHIP_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return PASSCODE; });
/* unused harmony export TIME_ZONE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNT_FAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return S_ODD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return SPORT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ALLSPORTCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return SELECTED_MARKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return SPORTBETTYPELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return LEAGUELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return SELECTED_LEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return SELECTED_SORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return SORTEDEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return PARLAYDATELIST; });
/* unused harmony export OUTRIGHT_LEAGUELIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return SELECTED_PAYLAY_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return SELECTED_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return LIVELEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return LIVE_EVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return SPECIAL_EVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return SELECTED_LEAGUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ARR_LEAGUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return SHOW_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SEL_MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return PARLAY_TDYEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return PARLAY_EARLYEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return IS_PARLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return IS_SPECIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return IS_VIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return IS_PLACE_BET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return IS_PROCESS_BET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return IS_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return TOTALPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return SELECTED_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GAMEBANNER_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return SPORT_ALL_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return IS_CORRECTSCORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SELECTED_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return STATE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return PARLAY_SPORT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return SPORT_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FAVOURITEEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return SELECTED_BETTYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return SORTEDMATCHEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return SORTEDFAVRBEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return SPORT_SHOW_FAV_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FAVOURITEALLBETEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EARLYCOUNT_BYDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return LOADGAMEHEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return SORTEDFAVOTREVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SELECT_ALL_LEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SETTLE_UNSETTLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return TODAYRBLEAGUELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return TODAYRBEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return SORTEDTODAYRBEVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return HIDE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return LABEL_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SETFAVOURITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FILTERLEAGUELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return SORTEDLEAGUELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return SELECTED_CHAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COOKIE_LEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return SELECTED_LEAGUELIST; });
/* unused harmony export FILTER_LEAGUE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SELECTEDLEAGUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return TOTALLEAGUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return SELECTED_SPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return SPORTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return REFRESH_SPORTTABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return OTREVENTLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHANGE_ODDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return SWIPE_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return VIRTUAL_DATA_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return IS_COLLAPSE_MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return SHOW_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return SHOW_NOSCROLLEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return IS_HIDE_LEAGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return SHOW_LEG_CAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return LEG_CAPT_DATA_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DEFAULT_SPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return OTRHIDELGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return OTRHIDETITLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FAVOURITELGEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return OTRHIDEFAVLGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return OTRHIDEFAVTITLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return IS_RESULT_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FILTER_SELECT_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return HOT_MATCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALLBETEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CSODDSEVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return REFRESHALLBET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return SELECTED_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ARR_BREADCUMB; });
/* unused harmony export BETTINGFORM_TOGGLE */
/* unused harmony export BETTING_SELECTION */
/* unused harmony export LIVE_EVENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ALLOW_LANDSACPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GAME_BANNER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GAME_BANNER_SPORT_ID; });
/* unused harmony export SKIN_THEME */
/* unused harmony export SORT_HOT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return ODDSFORMATDEC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BETSLIPANY; });
/* unused harmony export EDITIONSTAND */
/* unused harmony export PREVIOUS_EDITION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SHOW_BTMODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return SHOW_FILTER; });
/* unused harmony export BETTER_ODDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FILTERTYPE; });
/* unused harmony export RESULT_SPORT */
/* unused harmony export RESULT_DATE */
/* unused harmony export PROMO_JOINED_FLAG */
/* unused harmony export PROMO_FLAG */
/* unused harmony export PROMO_DETAILS */
/* unused harmony export PROMO_SHOW_JOIN_SUCCESS */
/* unused harmony export PROMO_BET_STATUS */
/* unused harmony export PROMO_BET_INDEX */
/* unused harmony export PROMO_BET_WITHOUT_JOIN */
/* unused harmony export STATEMENT_SHOW_PROMOTIONDETAIL */
/* unused harmony export PROMO_WAGER_DETAIL */

var MARKETTOGGLE = 'MARKETTOGGLE';
var LOADINGSCREEN = 'LOADINGSCREEN';
var REQUEST_ALLOW = 'REQUEST_ALLOW';
var SUBLOAD = 'SUBLOAD';
var FULL_LOAD = 'FULL_LOAD';
var CHANGE_SKIN_THEME = 'CHANGE_SKIN_THEME';
var SHOW_FLOATING = 'SHOW_FLOATING';
var SIM_DISP = 'SIM_DISP';
var SPORTCOUNTMARKET = 'SPORTCOUNTMARKET';
var IS_OTR = 'IS_OTR';
var IS_RESULT = 'IS_RESULT';
var SELECTEDBETTYPE = 'SELECTEDBETTYPE';
var REFRESHSCREEN = 'REFRESHSCREEN';
var IS_COLLAPSE = 'IS_COLLAPSE';
var SHOWMOREEVENT = 'SHOWMOREEVENT';
var FILTER_EVENT = 'FILTER_EVENT';
var COOKIE_HISTORY = 'COOKIE_HISTORY';
var SEARCH_LOADING = 'SEARCH_LOADING';
var HIST_LIST = 'HIST_LIST';
var CURRENT_TAB = 'CURRENT_TAB';

var ACCOUNT = 'ACCOUNT';
var SELECTED_ODD = 'SELECTED_ODD';
var ACC_CHIP_SETTING = 'ACC_CHIP_SETTING';
var PASSCODE = 'PASSCODE';
var TIME_ZONE = 'TIME_ZONE';
var ACCOUNT_FAV = 'ACCOUNT_FAV';

var S_ODD = 'S_ODD';
var SPORT_LIST = 'SPORT_LIST';
var ALLSPORTCOUNT = 'ALLSPORTCOUNT';
var SELECTED_MARKET = 'SELECTED_MARKET';
var SPORTBETTYPELIST = 'SPORTBETTYPELIST';
var LEAGUELIST = 'LEAGUELIST';
var SELECTED_LEAGUE = 'SELECTED_LEAGUE';
var EVENTLIST = 'EVENTLIST';
var SELECTED_SORT = 'SELECTED_SORT';
var SORTEDEVENTLIST = 'SORTEDEVENTLIST';
var PARLAYDATELIST = 'PARLAYDATELIST';
var OUTRIGHT_LEAGUELIST = 'OUTRIGHT_LEAGUELIST';
var SELECTED_PAYLAY_DATE = 'SELECTED_PAYLAY_DATE';
var SELECTED_EVENT = 'SELECTED_EVENT';
var LIVELEAGUE = 'LIVELEAGUE';
var LIVE_EVENTLIST = 'LIVE_EVENTLIST';
var SPECIAL_EVENTLIST = 'SPECIAL_EVENTLIST';
var SELECTED_LEAGUES = 'SELECTED_LEAGUES';
var ARR_LEAGUES = 'ARR_LEAGUES';
var SHOW_CALENDAR = 'SHOW_CALENDAR';
var SEL_MATCH = 'SEL_MATCH';
var PARLAY_TDYEVENTLIST = 'PARLAY_TDYEVENTLIST';
var PARLAY_EARLYEVENTLIST = 'PARLAY_EARLYEVENTLIST';
var IS_PARLAY = 'IS_PARLAY';
var IS_SPECIAL = 'IS_SPECIAL';
var IS_VIP = 'IS_VIP';
var IS_PLACE_BET = 'IS_PLACE_BET';
var IS_PROCESS_BET = 'IS_PROCESS_BET';
var IS_MOBILE = 'IS_MOBILE';
var TOTALPAGE = 'TOTALPAGE';
var SELECTED_PAGE = 'SELECTED_PAGE';
var GAMEBANNER_SELECTED = 'GAMEBANNER_SELECTED';
var SPORT_ALL_EVENTS = 'SPORT_ALL_EVENTS';
var IS_CORRECTSCORE = 'IS_CORRECTSCORE';
var SELECTED_STATE = 'SELECTED_STATE';
var STATE_LIST = 'STATE_LIST';
var PARLAY_SPORT_LIST = 'PARLAY_SPORT_LIST';
var SPORT_SELECTED = 'SPORT_SELECTED';
var FAVOURITEEVENT = 'FAVOURITEEVENT';
var SELECTED_BETTYPE = 'SELECTED_BETTYPE';
var SORTEDMATCHEVENTLIST = 'SORTEDMATCHEVENTLIST';
var SORTEDFAVRBEVENTLIST = 'SORTEDFAVRBEVENTLIST';
var SPORT_SHOW_FAV_EVENTS = 'SPORT_SHOW_FAV_EVENTS';
var FAVOURITEALLBETEVENT = 'FAVOURITEALLBETEVENT';
var EARLYCOUNT_BYDATE = 'EARLYCOUNT_BYDATE';
var LOADGAMEHEADER = 'LOADGAMEHEADER';
var SORTEDFAVOTREVENTLIST = 'SORTEDFAVOTREVENTLIST';
var SELECT_ALL_LEAGUE = 'SELECT_ALL_LEAGUE';
var SETTLE_UNSETTLED = 'SETTLE_UNSETTLED';
var TODAYRBLEAGUELIST = 'TODAYRBLEAGUELIST';
var TODAYRBEVENTLIST = 'TODAYRBEVENTLIST';
var SORTEDTODAYRBEVENTLIST = 'SORTEDTODAYRBEVENTLIST';
var HIDE_STATUS = 'HIDE_STATUS';
var LABEL_STATUS = 'LABEL_STATUS';
var SETFAVOURITE = 'SETFAVOURITE';
var FILTERLEAGUELIST = 'FILTERLEAGUELIST';
var SORTEDLEAGUELIST = 'SORTEDLEAGUELIST';
var SELECTED_CHAR = 'SELECTED_CHAR';
var COOKIE_LEAGUE = 'COOKIE_LEAGUE';
var SELECTED_LEAGUELIST = 'SELECTED_LEAGUELIST';
var FILTER_LEAGUE = 'FILTER_LEAGUE';
var SELECTEDLEAGUES = 'SELECTEDLEAGUES';
var TOTALLEAGUES = 'TOTALLEAGUES';
var SELECTED_SPORT = 'SELECTED_SPORT';
var SPORTLIST = 'SPORTLIST';
var REFRESH_SPORTTABLE = 'REFRESH_SPORTTABLE';
var OTREVENTLIST = 'OTREVENTLIST';
var CHANGE_ODDS = 'CHANGE_ODDS';
var SWIPE_MODE = 'SWIPE_MODE';
var VIRTUAL_DATA_LIST = 'VIRTUAL_DATA_LIST';
var IS_COLLAPSE_MATCH = 'IS_COLLAPSE_MATCH';
var SHOW_END = 'SHOW_END';
var SHOW_NOSCROLLEND = 'SHOW_NOSCROLLEND';
var IS_HIDE_LEAGUE = 'IS_HIDE_LEAGUE';
var SHOW_LEG_CAP = 'SHOW_LEG_CAP';
var LEG_CAPT_DATA_LIST = 'LEG_CAPT_DATA_LIST';
var DEFAULT_SPORT = 'DEFAULT_SPORT';
var OTRHIDELGE_LIST = 'OTRHIDELGE_LIST';
var OTRHIDETITLE_LIST = 'OTRHIDETITLE_LIST';
var FAVOURITELGEVENT = 'FAVOURITELGEVENT';
var OTRHIDEFAVLGE_LIST = 'OTRHIDEFAVLGE_LIST';
var OTRHIDEFAVTITLE_LIST = 'OTRHIDEFAVTITLE_LIST';
var IS_RESULT_SCHEDULE = 'IS_RESULT_SCHEDULE';
var FILTER_SELECT_ALL = 'FILTER_SELECT_ALL';
var HOT_MATCH_LIST = 'HOT_MATCH_LIST';

var ALLBETEVENT = 'ALLBETEVENT';
var CSODDSEVENT = 'CSODDSEVENT';
var REFRESHALLBET = 'REFRESHALLBET';

var SELECTED_TEMPLATE = 'SELECTED_TEMPLATE';
var ARR_BREADCUMB = 'ARR_BREADCUMB';

var BETTINGFORM_TOGGLE = 'BETTINGFORM_TOGGLE';
var BETTING_SELECTION = 'BETTING_SELECTION';

var LIVE_EVENT = 'LIVE_EVENT';
var ALLOW_LANDSACPE = 'ALLOW_LANDSACPE';

var GAME_BANNER_ID = 'GAME_BANNER_ID';
var GAME_BANNER_SPORT_ID = 'GAME_BANNER_SPORT_ID';

var SKIN_THEME = 'SKIN_THEME';
var SORT_HOT = 'SORT_HOT';
var ODDSFORMATDEC = 'ODDSFORMATDEC';
var BETSLIPANY = 'BETSLIPANY';
var EDITIONSTAND = 'EDITIONSTAND';
var PREVIOUS_EDITION = 'PREVIOUS_EDITION';
var SHOW_BTMODAL = 'SHOW_BTMODAL';
var SHOW_FILTER = 'SHOW_FILTER';
var BETTER_ODDS = 'BETTER_ODDS';
var FILTERTYPE = 'FILTERTYPE';

var RESULT_SPORT = 'RESULT_SPORT';
var RESULT_DATE = 'RESULT_DATE';

var PROMO_JOINED_FLAG = 'PROMO_JOINED_FLAG';
var PROMO_FLAG = 'PROMO_FLAG';
var PROMO_DETAILS = 'PROMO_DETAILS';
var PROMO_SHOW_JOIN_SUCCESS = 'PROMO_SHOW_JOIN_SUCCESS';
var PROMO_BET_STATUS = 'PROMO_BET_STATUS';
var PROMO_BET_INDEX = 'PROMO_BET_INDEX';
var PROMO_BET_WITHOUT_JOIN = 'PROMO_BET_WITHOUT_JOIN';
var STATEMENT_SHOW_PROMOTIONDETAIL = 'STATEMENT_SHOW_PROMOTIONDETAIL';
var PROMO_WAGER_DETAIL = 'PROMO_WAGER_DETAIL';

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"odds-row"},[_c('span',{staticClass:"odds-box",class:[_vm.getOdd1x2UniqueId_1(_vm.event,'odA')]},[(_vm.checkLock(_vm.event.od,'odA'))?[_c('img',{staticClass:"icon-lock standard",attrs:{"src":"assets/images/score/match-icon-lock.svg"}})]:[(_vm.oddsTitle)?_c('span',{staticClass:"odds-number"},[_vm._v("1")]):_vm._e(),_vm._v(" "),_c('odd1x2',{attrs:{"event":_vm.event,"bmk":_vm.bmk,"plyType":_vm.plytyp,"betType":_vm.bettyp,"type":_vm.type,"team":'odA',"uid":_vm.getOdd1x2UniqueId_1(_vm.event,'odA'),"isAllBet":false}})]],2),_vm._v(" "),(_vm.event.sptid == 1)?_c('span',{staticClass:"odds-box",class:[_vm.getOdd1x2UniqueId_1(_vm.event,'odX')]},[(_vm.checkLock(_vm.event.od,'odX'))?[_c('img',{staticClass:"icon-lock standard",attrs:{"src":"assets/images/score/match-icon-lock.svg"}})]:[(_vm.oddsTitle)?_c('span',{staticClass:"odds-number"},[_vm._v("x")]):_vm._e(),_vm._v(" "),_c('odd1x2',{attrs:{"event":_vm.event,"bmk":_vm.bmk,"plyType":_vm.plytyp,"betType":_vm.bettyp,"type":_vm.type,"team":'odX',"uid":_vm.getOdd1x2UniqueId_1(_vm.event,'odX'),"isAllBet":false}})]],2):_vm._e(),_vm._v(" "),_c('span',{staticClass:"odds-box",class:[_vm.getOdd1x2UniqueId_1(_vm.event,'odB')]},[(_vm.checkLock(_vm.event.od,'odB'))?[_c('img',{staticClass:"icon-lock standard",attrs:{"src":"assets/images/score/match-icon-lock.svg"}})]:[(_vm.oddsTitle)?_c('span',{staticClass:"odds-number"},[_vm._v("2")]):_vm._e(),_vm._v(" "),_c('odd1x2',{attrs:{"event":_vm.event,"bmk":_vm.bmk,"plyType":_vm.plytyp,"betType":_vm.bettyp,"type":_vm.type,"team":'odB',"uid":_vm.getOdd1x2UniqueId_1(_vm.event,'odB'),"isAllBet":false}})]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.sortedEvents && (_vm.sortedEvents.length > 0 || Object.keys(_vm.sortedEvents).length > 0)) || (_vm.leagueList && (_vm.leagueList.length > 0 || Object.keys(_vm.leagueList).length > 0)))?_c('div',{class:{ 'odds-hidden': !_vm.isOddsSwitch },attrs:{"id":"simpleSoccerTable"}},[(_vm.items.length)?_c('DynamicScroller',{staticClass:"scroller",attrs:{"items":_vm.items,"page-mode":"","min-item-size":142,"buffer":500},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
var active = ref.active;
return [_c('DynamicScrollerItem',{attrs:{"item":item,"active":active,"size-dependencies":[item.message],"data-index":index}},[(!_vm.isLoading && !item.isResult && ((!_vm.checkLeague(item.obj, item.sptid) && !item.subdis) || item.subdis))?_c('div',{staticClass:"s-w-item user",class:!_vm.hideLegHeader[item.key] ? 'llgggAll llggg'+item.obj:'',attrs:{"data-v-5bf51e32":"","index":index}},[_c('div',{staticClass:"s-w-i-inner",attrs:{"data-v-5bf51e32":""}},[_c('div',{staticClass:"data_mid",attrs:{"data-v-379cdb5e":"","data-v-5bf51e32":""}},[(!_vm.loadingScreen)?_c('div',{staticClass:"match-container",class:{'first is_league_tail':item.key==0, 'is_division_league':item.subdis},attrs:{"data-v-065fe993":"","data-v-379cdb5e":"","data-v-5bf51e32":""}},[_c('div',{staticClass:"match-inner-container",attrs:{"data-v-065fe993":"","id":'match-inner-container'+item.eveid}},[(item.subdis)?_c('div',{staticClass:"league-header",class:{'collapsed':_vm.checkLeague(item.obj,item.sptid)},attrs:{"id":'llge'+item.obj},on:{"click":function($event){return _vm.showHide(item.obj,item.sptid)}}},[_c('div',{staticClass:"league-title-row"},[((_vm.account.showCtrLogo && item.ctrlogo) || (_vm.account.showLogo && item.lglogo))?_c('div',{staticClass:"league-icon"},[_c('img',{attrs:{"src":_vm.account.showCtrLogo && item.ctrlogo ? item.ctrlogo : item.lglogo}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"league-name",attrs:{"title":item.lgecapt}},[_vm._v(_vm._s(item.lgecapt))])]),_vm._v(" "),_c('div',{staticClass:"league-subtext-row full-row"},[_c('div',{staticClass:"sub-left",style:(item.sptid == 2? 'width: 215px !important;':'')},[_c('span',{staticClass:"match-time"},[_vm._v(_vm._s(_vm.getDate(item.dt))+" "+_vm._s(_vm.getTime(item.dt)))]),_vm._v(" "),_c('span',{staticClass:"match-minute"})]),_vm._v(" "),_c('div',{staticClass:"sub-center"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_SCO']))]),_vm._v(" "),_c('div',{staticClass:"sub-right"},[_c('div',{staticClass:"odds-title-row",class:{'bk': item.sptid == 2}},[_c('span',[_vm._v("1")]),_vm._v(" "),(item.sptid == 1)?[_c('span',[_vm._v("x")])]:_vm._e(),_vm._v(" "),_c('span',[_vm._v("2")])],2)])]),_vm._v(" "),_c('svg',{staticClass:"league-arrow",attrs:{"viewBox":"0 0 24 24","fill":"none","stroke-width":"2"}},[_c('polyline',{attrs:{"points":"6 9 12 15 18 9","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e(),_vm._v(" "),(!_vm.checkLeague(item.obj,item.sptid))?_c('div',{staticClass:"league-content",class:'llge'+item.obj},[_c('div',{staticClass:"match-row",class:{ 'first': item.subdis },on:{"click":function($event){return _vm.getAllBet(item)}}},[_c('div',{staticClass:"match-main-info"},[_c('div',{staticClass:"favorite-toggle",class:{ 'active': item.isFavourite },on:{"click":function($event){$event.stopPropagation();return _vm.favourite(item)}}}),_vm._v(" "),_c('div',{staticClass:"team-info left"},[_c('div',{staticClass:"team-avatar"},[(_vm.account.showLogo && item.talogo !='')?_c('div',{staticClass:"team-icon"},[_c('img',{attrs:{"src":item.talogo}})]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"team-name",attrs:{"title":item.tacapt}},[_vm._v(_vm._s(item.tacapt))])]),_vm._v(" "),_c('div',{staticClass:"match-score-box",style:(item.sptid == 2? 'width: 60px !important;':'')},[(item.rb && item.rb==='0')?[_vm._v("VS")]:[(item.score && item.score.FT)?[_vm._v(_vm._s(item.score.FT))]:(item.score && item.score.HT)?[_vm._v(_vm._s(item.score.HT))]:[_vm._v("0 - 0")]]],2),_vm._v(" "),_c('div',{staticClass:"team-info right"},[_c('span',{staticClass:"team-name",staticStyle:{"text-align":"right"},attrs:{"title":item.tbcapt}},[_vm._v(_vm._s(item.tbcapt))]),_vm._v(" "),_c('div',{staticClass:"team-avatar"},[(_vm.account.showLogo && item.tblogo !='')?_c('div',{staticClass:"team-icon"},[_c('img',{attrs:{"src":item.tblogo}})]):_vm._e()])]),_vm._v(" "),(item.rb != -1 && item.ch != undefined && item.ch != 0)?_c('div',{staticClass:"video-icon",class:{ 'disable': item.rb != 1 },attrs:{"title":"live"},on:{"click":function($event){$event.stopPropagation();return _vm.getAllBet(item,1)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"odds-title-row"},[_c('span',[_vm._v("1")]),_vm._v(" "),(item.sptid == 1)?[_c('span',[_vm._v("x")])]:_vm._e(),_vm._v(" "),_c('span',[_vm._v("2")])],2),_vm._v(" "),_c('odds1x2',{attrs:{"event":item,"bmk":'8',"plytyp":(item.rb == 1? '3':'2'),"bettyp":'5',"type":'2'}})],1)]):_vm._e()])]):_vm._e()])])]):_vm._e()])]}}],null,false,1356129147)}):_vm._e()],1):_c('div',{staticClass:"no-data data-get-empty1",attrs:{"data-v-549f1e7b":"","data-v-379cdb5e":""}},[(_vm.skinTheme==2)?[_c('div',{staticClass:"empty-favorite-bg",staticStyle:{"background-image":"url('assets/images/score/noMatch2.png')"},attrs:{"data-v-549f1e7b":""}})]:[_c('div',{staticClass:"empty-favorite-bg",staticStyle:{"background-image":"url('assets/images/score/noMatch.svg')"},attrs:{"data-v-549f1e7b":""}})],_vm._v(" "),(!(_vm.gameBanner && _vm.isGameBannerSelected))?_c('p',{staticStyle:{"color":"rgb(165, 169, 179)"},attrs:{"data-v-549f1e7b":""}},[_vm._v(_vm._s(_vm.arr_lang.sportTable['SPORT_TABLE.EMPTY']))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-list-container",class:{'jinri':_vm.int_marketToggle==1 && !_vm.isOtr, 'guanjun':_vm.isOtr},attrs:{"data-v-61a108b8":""}},[_c('div',{staticClass:"schedule-tabs",attrs:{"id":"scheduleTabs"}},[_c('div',{staticClass:"schedule-tab",class:{ 'active':_vm.matchSchdTab==1 },attrs:{"data-tab":"all"},on:{"click":function($event){return _vm.changeMarket(1)}}},[_vm._v(_vm._s(_vm.arr_lang.result['RESULT.ALL']))]),_vm._v(" "),_c('div',{staticClass:"schedule-tab",class:{ 'active':_vm.matchSchdTab==2 },attrs:{"data-tab":"live"},on:{"click":function($event){return _vm.changeMarket(2)}}},[_vm._v(_vm._s(_vm.arr_lang.result['RESULT.RUNNING']))]),_vm._v(" "),_c('div',{staticClass:"schedule-tab",class:{ 'active':_vm.matchSchdTab==3 },attrs:{"data-tab":"ended"},on:{"click":function($event){return _vm.changeMarket(3)}}},[_vm._v(_vm._s(_vm.arr_lang.result['RESULT.FINISH']))]),_vm._v(" "),_c('div',{staticClass:"schedule-tab",class:{ 'active':_vm.matchSchdTab==4 },attrs:{"data-tab":"upcoming"},on:{"click":function($event){return _vm.changeMarket(4)}}},[_vm._v(_vm._s(_vm.arr_lang.sportTable['SPORT_TABLE.NOT_STARTED']))])]),_vm._v(" "),_c('refreshScreen',{attrs:{"loading":_vm.refreshScreen,"edition":_vm.editionStand,"stemplate":_vm.arr_selectedTemplate}}),_vm._v(" "),_c('simpleSoccerTable',{attrs:{"is-odds-switch":_vm.isOddsSwitch}}),_vm._v(" "),_c('backToTop')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading",class:{'theme01-root-loading':_vm.skinTheme==1,'theme02-root-loading':_vm.skinTheme==2},attrs:{"id":"loading-root-ele"}},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"la-line-scale",attrs:{"id":"loading-root-main"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gameBanner_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31328770_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gameBanner_vue__ = __webpack_require__(329);
function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gameBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31328770_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gameBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 328:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showGameBanner)?_c('div',{staticClass:"slider-box"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"prev notranslate",on:{"click":function($event){return _vm.showPrev()}}},[_vm._v("❮")]),_vm._v(" "),_c('button',{staticClass:"next notranslate",on:{"click":function($event){return _vm.showNext()}}},[_vm._v("❯")])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slides"},[_c('img',{staticClass:"slide active",attrs:{"src":"assets/images/banner/slider01.png","alt":"slider01"}}),_vm._v(" "),_c('img',{staticClass:"slide",attrs:{"src":"assets/images/banner/slider02.png","alt":"slider02"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-body",attrs:{"id":"home-match-body"}},[_c('div',{staticClass:"side-panel-icon",class:{ 'spin': _vm.selected_panel == 'hot', 'open': _vm.selected_panel != '' },attrs:{"id":"hot-panel-icon"},on:{"click":function($event){return _vm.panelClick('hot')}}},[_c('span',{staticClass:"icon-symbol"},[_vm._v("⚽")])]),_vm._v(" "),_c('div',{staticClass:"side-panel-icon earth-panel-icon",class:{ 'spin': _vm.selected_panel == 'earth', 'open': _vm.selected_panel != '' },attrs:{"id":"earth-panel-icon"},on:{"click":function($event){return _vm.panelClick('earth')}}},[_c('span',{staticClass:"icon-symbol"},[_vm._v("🌐")])]),_vm._v(" "),_c('div',{staticClass:"side-panel-overlay",class:{ 'open': _vm.selected_panel != '' },attrs:{"id":"side-panel-overlay"},on:{"click":function($event){return _vm.panelClick()}}}),_vm._v(" "),_c('div',{staticClass:"side-box-container left"},[_c('div',{staticClass:"side-box hot-box",class:{ collapsed: _vm.collapsedBoxes.includes(0)&&_vm.innerWidth>1132, 'open': _vm.selected_panel == 'hot' },attrs:{"id":"hot-panel-wrapper"}},[_c('div',{staticClass:"form-header",on:{"click":function($event){return _vm.toggleCollapse(0)}}},[_c('div',{staticClass:"form-title-text"},[_vm._v(_vm._s(_vm.arr_lang.home['HOME.HOT_MATCH']))]),_vm._v(" "),_c('button',{staticClass:"form-toggle-btn"},[_c('svg',{staticClass:"toggle-arrow",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M6 9l6 6 6-6","stroke-width":"2","fill":"none"}})])]),_vm._v(" "),_c('div',{staticClass:"panel-close",attrs:{"id":"panel-close"},on:{"click":function($event){return _vm.panelClick()}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 0 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"}})])])]),_vm._v(" "),_c('div',{staticClass:"form-body"},[_vm._l((_vm.hotMatchList['events']),function(value){return [_c('div',{staticClass:"form-item",class:_vm.checkHotLeg(value, _vm.selected_league),on:{"click":function($event){return _vm.filterLeague(value, true)}}},[((_vm.account.showCtrLogo && value.ctrlogo) || (_vm.account.showLogo && value.lglogo))?_c('div',{staticClass:"form-item-icon"},[_c('img',{attrs:{"src":_vm.account.showCtrLogo && value.ctrlogo ? value.ctrlogo : value.lglogo}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-item-text",attrs:{"title":value.league}},[_c('a',{class:_vm.checkHotLeg(value, _vm.selected_league)},[_vm._v(_vm._s(value.league))])])])]})],2)]),_vm._v(" "),_c('div',{staticClass:"side-box schedule-box"},[_c('div',{staticClass:"form-header"},[_c('div',{staticClass:"form-title-text"},[_vm._v(_vm._s(_vm.arr_lang.home['HOME.SCHEDULE']))])]),_vm._v(" "),_c('div',{staticClass:"form-body schedule-body"},[_c('div',{staticClass:"form-item schedule-box-tabs"},[_c('button',{class:{ active: _vm.scheduleTab === 'completed' },attrs:{"id":"tab-completed"},on:{"click":function($event){return _vm.toggleScheduleTab('completed')}}},[_vm._v(_vm._s(_vm.arr_lang.home['HOME.COMPLETED_SCHEDULE']))]),_vm._v(" "),_c('button',{class:{ active: _vm.scheduleTab === 'upcoming' },attrs:{"id":"tab-upcoming"},on:{"click":function($event){return _vm.toggleScheduleTab('upcoming')}}},[_vm._v(_vm._s(_vm.arr_lang.home['HOME.NEXT_SCHEDULE']))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scheduleTab === 'completed'),expression:"scheduleTab === 'completed'"}],attrs:{"id":"content-completed"}},_vm._l((_vm.completedDateList),function(date,key){return _c('div',{key:key,staticClass:"form-item",class:_vm.selected_date == date ? 'current' : '',on:{"click":function($event){return _vm.changeDate(_vm.schedule,date)}}},[_c('div',{staticClass:"form-item-text"},[_c('a',{staticClass:"notranslate",class:_vm.selected_date == date ? 'current' : ''},[_vm._v(_vm._s(_vm._f("date")(date,'YYYY-MM-DD')))])])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scheduleTab === 'upcoming'),expression:"scheduleTab === 'upcoming'"}],attrs:{"id":"content-upcoming"}},_vm._l((_vm.arr_earlyParlayDateList),function(date,key){return (key!=0)?_c('div',{key:key,staticClass:"form-item",class:_vm.selected_date == date ? 'current' : '',on:{"click":function($event){return _vm.changeDate(_vm.schedule,date)}}},[_c('div',{staticClass:"form-item-text"},[_c('a',{staticClass:"notranslate",class:_vm.selected_date == date ? 'current' : ''},[_vm._v(_vm._s(_vm._f("date")(date,'YYYY-MM-DD')))])])]):_vm._e()}),0)])])]),_vm._v(" "),_c('div',{staticClass:"match-body-content"},[_c('gameBanner',{attrs:{"position":'t'}}),_vm._v(" "),_c('div',{staticClass:"filter-box"},[_c('div',{staticClass:"event-title"},[_vm._v("\n                "+_vm._s(_vm.sportTableLang['SPORT_TABLE.'+_vm.selectedSport+'_MATCHES']? _vm.sportTableLang['SPORT_TABLE.'+_vm.selectedSport+'_MATCHES']:(_vm.selectedSport+' '+_vm.sportTableLang['SPORT_TABLE.SUBHEADER_MATCHES1']))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"event-controls"},[_c('div',{staticClass:"timezone-selector",class:{ 'open': _vm.isTimeZoneOpen },attrs:{"id":"timezoneToggle"},on:{"click":_vm.toggleTimezone}},[_c('div',{staticClass:"timezone-left"},[_c('div',{staticClass:"timezone-icon"}),_vm._v(" "),_c('span',{staticClass:"selected-timezone notranslate"},[_vm._v(_vm._s(_vm.getSelectedTz))])]),_vm._v(" "),_c('svg',{staticClass:"arrow",attrs:{"viewBox":"0 0 24 24","fill":"none","stroke-width":"2"}},[_c('polyline',{attrs:{"points":"6 9 12 15 18 9","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}})]),_vm._v(" "),_c('div',{staticClass:"timezone-dropdown"},_vm._l((_vm.timezonelist),function(val,key){return _c('div',{key:key,staticClass:"option notranslate",on:{"click":function($event){return _vm.changeTimezone(val)}}},[_vm._v(_vm._s(key))])}),0)]),_vm._v(" "),_c('div',{staticClass:"date-selector"},[_c('div',{staticClass:"date-icon"}),_vm._v(" "),_c('input',{attrs:{"type":"date","id":"customDateInput"},domProps:{"value":_vm.selected_date},on:{"change":_vm.handleDateChange}})]),_vm._v(" "),_c('div',{staticClass:"odds-switch-wrapper"},[_c('span',{staticClass:"odds-label"},[_vm._v(_vm._s(_vm.arr_lang.oddsConversionLang['ODDS_CONVERSION.ODDS']))]),_vm._v(" "),_c('div',{staticClass:"odds-toggle",class:{ 'active': _vm.showOdds },attrs:{"id":"oddsSwitch"},on:{"click":_vm.oddsSwitch}},[_c('div',{staticClass:"circle"})])])])]),_vm._v(" "),_c('contentSport',{attrs:{"is-odds-switch":_vm.showOdds}})],1),_vm._v(" "),_c('div',{staticClass:"side-box-container right"},[_c('div',{staticClass:"live-hot-box"},[_c('div',[_c('div',{staticClass:"live-title"},[_vm._v(_vm._s(_vm.arr_lang.home['HOME.HOT_LIVE_MATCH']))]),_vm._v(" "),_c('div',{staticClass:"live-subtitle",attrs:{"title":_vm.firstEvent && _vm.firstEvent.lgecapt ? _vm.firstEvent.lgecapt : ''},domProps:{"innerHTML":_vm._s(_vm.firstEvent && _vm.firstEvent.lgecapt ? _vm.firstEvent.lgecapt : '-')}})]),_vm._v(" "),_c('div',{staticClass:"live-teams"},[_c('div',{staticClass:"live-team"},[_c('div',{staticClass:"team-icon-circle"},[_c('div',{staticClass:"team-icon"},[(_vm.firstEvent && _vm.firstEvent.talogo)?_c('img',{attrs:{"src":_vm.firstEvent.talogo}}):(_vm.skinTheme==1)?_c('img',{attrs:{"src":"assets/images/team_icon/team_icon_default01.png"}}):_c('img',{attrs:{"src":"assets/images/team_icon/team_icon_default02.png"}})])]),_vm._v(" "),_c('div',{staticClass:"team-name",attrs:{"title":_vm.firstEvent && _vm.firstEvent.tacapt ? _vm.firstEvent.tacapt : ''},domProps:{"innerHTML":_vm._s(_vm.firstEvent && _vm.firstEvent.tacapt ? _vm.firstEvent.tacapt : '-')}})]),_vm._v(" "),_c('div',{staticClass:"live-score",style:(_vm.firstEvent && _vm.firstEvent.sptid == 2? 'font-size: 27px !important;':'')},[(_vm.firstEvent && _vm.firstEvent.score && _vm.firstEvent.score.FT)?[_vm._v(_vm._s(_vm.firstEvent.score.FT))]:(_vm.firstEvent && _vm.firstEvent.score && _vm.firstEvent.score.HT)?[_vm._v(_vm._s(_vm.firstEvent.score.HT))]:[_vm._v("0 - 0")]],2),_vm._v(" "),_c('div',{staticClass:"live-team"},[_c('div',{staticClass:"team-icon-circle"},[_c('div',{staticClass:"team-icon"},[(_vm.firstEvent && _vm.firstEvent.tblogo)?_c('img',{attrs:{"src":_vm.firstEvent.tblogo}}):(_vm.skinTheme==1)?_c('img',{attrs:{"src":"assets/images/team_icon/team_icon_default01.png"}}):_c('img',{attrs:{"src":"assets/images/team_icon/team_icon_default02.png"}})])]),_vm._v(" "),_c('div',{staticClass:"team-name",attrs:{"title":_vm.firstEvent && _vm.firstEvent.tbcapt ? _vm.firstEvent.tbcapt : ''},domProps:{"innerHTML":_vm._s(_vm.firstEvent && _vm.firstEvent.tbcapt ? _vm.firstEvent.tbcapt : '-')}})])]),_vm._v(" "),(_vm.firstEvent && Object.keys(_vm.firstEvent).length)?[_c('odds1x2',{attrs:{"event":_vm.firstEvent,"bmk":'8',"plytyp":(_vm.firstEvent.rb == 1? '3':'2'),"bettyp":'5',"type":'2'}})]:[_c('div',{staticClass:"odds-row"},[_vm._m(0),_vm._v(" "),(_vm.arr_selectedTemplate.sportId == 'N1')?_c('div',{staticClass:"odds-box"},[_c('span',{staticClass:"odds-number"},[_vm._v("x")]),_vm._v(" "),_c('span',{staticClass:"odds-value"},[_vm._v("-")])]):_vm._e(),_vm._v(" "),_vm._m(1)])],_vm._v(" "),_c('div',{staticClass:"live-buttons"},[_c('div',{staticClass:"btn btn-red",on:{"click":function($event){return _vm.getAllBet(_vm.firstEvent,1)}}}),_vm._v(" "),_c('div',{staticClass:"btn btn-blue",on:{"click":function($event){return _vm.getAllBet(_vm.firstEvent,0)}}},[_c('span',[_vm._v(_vm._s(_vm.arr_lang.home['HOME.MATCH_DETAILS']))])]),_vm._v(" "),_c('div',{staticClass:"btn btn-grey",class:{ 'active': _vm.firstEvent && _vm.firstEvent.isFavourite? _vm.firstEvent.isFavourite:false },attrs:{"id":"star-btn"},on:{"click":function($event){$event.stopPropagation();return _vm.favourite(_vm.firstEvent)}}})])],2),_vm._v(" "),_c('div',{staticClass:"side-box country-box",class:{ collapsed: _vm.collapsedBoxes.includes(1), 'open': _vm.selected_panel == 'earth' },attrs:{"id":"earth-panel-wrapper"}},[_c('div',{staticClass:"form-header",on:{"click":function($event){return _vm.toggleCollapse(1)}}},[_c('div',{staticClass:"form-title-text"},[_vm._v(_vm._s(_vm.arr_lang.home['HOME.COUNTRY_MATCH']))]),_vm._v(" "),_c('button',{staticClass:"form-toggle-btn"},[_c('svg',{staticClass:"toggle-arrow",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M6 9l6 6 6-6","stroke-width":"2","fill":"none"}})])]),_vm._v(" "),_c('div',{staticClass:"panel-close",attrs:{"id":"panel-close"},on:{"click":function($event){return _vm.panelClick()}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 0 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"}})])])]),_vm._v(" "),_c('div',{staticClass:"form-body"},_vm._l((_vm.countryMatches),function(cty,key){return _c('div',{staticClass:"form-item",class:_vm.selected_country == cty.cid ? 'current' : '',on:{"click":function($event){return _vm.selectCountry(cty.cid)}}},[_c('div',{staticClass:"form-item-icon",class:'nation-icon-'+cty.icon}),_vm._v(" "),_c('div',{staticClass:"form-item-text",attrs:{"title":_vm.cookies_lang == 'zh_CN'? cty.name_2 : (_vm.cookies_lang == 'zh_TW'? cty.name_3 : cty.name_1)}},[_c('a',{class:_vm.selected_country == cty.cid ? 'current' : ''},[_vm._v(_vm._s(_vm.cookies_lang == 'zh_CN'? cty.name_2 : (_vm.cookies_lang == 'zh_TW'? cty.name_3 : cty.name_1)))])])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"odds-box"},[_c('span',{staticClass:"odds-number"},[_vm._v("1")]),_vm._v(" "),_c('span',{staticClass:"odds-value"},[_vm._v("-")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"odds-box"},[_c('span',{staticClass:"odds-number"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"odds-value"},[_vm._v("-")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetHeader_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9561d10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetHeader_vue__ = __webpack_require__(333);
function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBetHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9561d10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBetHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 332:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.arr_allBetEvent)?_c('div',{attrs:{"id":"allBetHeader"}},[_c('loadingScreen',{attrs:{"loading":_vm.loadingScreen}}),_vm._v(" "),_c('div',{staticClass:"q-page-container -page-container- wrapper-scroller",attrs:{"data-v-7718c41e":""}},[_c('div',{attrs:{"data-v-58c1d432":"","data-v-7718c41e":""}},[_c('div',{staticClass:"details-fat scroll relative-position details-bet",class:{'show-video':!_vm.closeTvWindow},staticStyle:{"height":"100vh"},attrs:{"data-v-58c1d432":""}},[_c('div',{staticClass:"header-fix",attrs:{"data-v-58c1d432":""}},[_c('div',{staticClass:"relative-position scroll_video_h",attrs:{"data-v-58c1d432":""}},[(!_vm.closeTvWindow && _vm.tvlink && _vm.tvlink!='error')?_c('div',{staticClass:"player",attrs:{"data-v-7508f7a8":"","data-v-58c1d432":""}},[_c('div',{staticClass:"change-header",attrs:{"data-v-6b63be36":"","data-v-58c1d432":""}},[_c('div',{staticClass:"bg-wrap",style:(_vm.sportBackground(_vm.arr_selectedTemplate.sportId, 0)),attrs:{"data-v-6b63be36":""}}),_vm._v(" "),_c('div',{staticClass:"h-row row mx-15",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"col-1 go-back-container",staticStyle:{"display":"block !important","padding-top":"5px"},attrs:{"data-v-6b63be36":""},on:{"click":function($event){return _vm.videoClose()}}},[_c('div',{staticClass:"go-back",attrs:{"data-v-6b63be36":""}})]),_vm._v(" "),_c('div',{staticClass:"col-2 text-left ellipsis base-header-font",class:_vm.checkPersian(_vm.arr_allBetEvent.tacapt),attrs:{"data-v-6b63be36":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tacapt)}}),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo && (_vm.arr_allBetEvent.sptid==1 || _vm.arr_allBetEvent.sptid==2))?[_c('div',{staticClass:"col-6 row",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"col-2 text-center header-font",attrs:{"data-v-6b63be36":""}},[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.scoa)+" ")]),_vm._v(" "),_c('div',{staticClass:"col text-center base-header-font",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"match_stage",attrs:{"data-v-33858d13":"","data-v-6b63be36":""}},[_c('span',{attrs:{"data-v-33858d13":""}},[_c('span',{staticClass:"dialogStage_1",attrs:{"data-v-c8b324f0":"","data-v-33858d13":""}},[_c('span',{attrs:{"data-v-c8b324f0":""}},[(_vm.arr_allBetEvent.sptid==1)?[(_vm.arr_allBetEvent.rbinfo.htst == '0')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT']))]:(_vm.validateRBTimer(_vm.arr_allBetEvent) == '1')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT1']))]:(_vm.validateRBTimer(_vm.arr_allBetEvent) == '2')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT2']))]:_vm._e()]:[(_vm.arr_allBetEvent.rbinfo.htst == '1')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q1']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '2')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q2']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '3')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q3']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '4')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q4']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '5')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '6')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT_SHOR']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '7')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '8')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OT']))]:_vm._e()],_vm._v(" "),_c('span',{attrs:{"data-v-c8b324f0":""}},[_c('span',{attrs:{"data-v-c8b324f0":""}},[_vm._v("  "+_vm._s(_vm._f("rb-timer")(_vm.arr_allBetEvent)))])])],2)])])])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center header-font",attrs:{"data-v-6b63be36":""}},[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.scob)+" ")])])]:[_c('div',{staticClass:"col-6 row",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"col-2 text-center header-font",staticStyle:{"display":"none"},attrs:{"data-v-6b63be36":""}},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"col text-center base-header-font",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"match_stage",attrs:{"data-v-33858d13":"","data-v-6b63be36":""}},[_c('span',{attrs:{"data-v-33858d13":""}},[_vm._v("\n                                                    "+_vm._s(_vm.getDate(_vm.matchDateCheck(_vm.arr_allBetEvent.dt)))+"\n                                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center header-font",staticStyle:{"display":"none"},attrs:{"data-v-6b63be36":""}},[_vm._v("0")])])],_vm._v(" "),_c('div',{staticClass:"col-2 text-right ellipsis base-header-font",class:_vm.checkPersian(_vm.arr_allBetEvent.tbcapt),attrs:{"data-v-6b63be36":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tbcapt)}})],2)]),_vm._v(" "),_c('div',{staticClass:"top-space",attrs:{"data-v-7508f7a8":""}},[_c('div',{staticClass:"iframe-wrap DJ-score-information stickyed",staticStyle:{"width":"100%","height":"2.11rem"},attrs:{"data-v-7508f7a8":""}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"data-v-7508f7a8":"","id":"bdIframe","allow":"autoplay","frameborder":"0","scrolling":"no","src":_vm.tvlink}}),_vm._v(" "),_c('div',{staticClass:"bg",staticStyle:{"display":"none"},attrs:{"data-v-7508f7a8":""}}),_vm._v(" "),_c('div',{staticClass:"football-events yb_ml10 fullscreen",attrs:{"data-v-6fc7563b":"","data-v-7508f7a8":""}},[_c('div',{staticClass:"img-wrap yb_mb10 yb_ml4",attrs:{"data-v-6fc7563b":""}}),_vm._v(" "),_c('div',{staticClass:"info-wrap yb_px4 yb_py4 relative-position",attrs:{"data-v-6fc7563b":""}},[_c('p',{staticClass:"row justify-between yb",attrs:{"data-v-6fc7563b":""}},[_c('span',{staticClass:"ellipsis yb_mr8",staticStyle:{"flex":"1 1 0%"},attrs:{"data-v-6fc7563b":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tacapt)}}),_c('span',{staticClass:"text-right",staticStyle:{"width":"0.36rem"},attrs:{"data-v-6fc7563b":""}})])])]),_vm._v(" "),_c('div',{staticClass:"title",staticStyle:{"display":"none"},attrs:{"data-v-7508f7a8":""}},[_c('div',{staticClass:"row justify-between full-height mx-15",attrs:{"data-v-7508f7a8":""}},[_c('div',{staticClass:"col-1 go-back-btn-wrap",attrs:{"data-v-7508f7a8":""},on:{"click":function($event){return _vm.videoClose()}}},[_c('div',{staticClass:"video_back",attrs:{"data-v-7508f7a8":""}})]),_vm._v(" "),_c('div',{staticClass:"col-10 row",staticStyle:{"max-width":"2.43rem"},attrs:{"data-v-7508f7a8":""}},[_c('div',{staticClass:"col title-text-style",class:_vm.checkPersian(_vm.arr_allBetEvent.tacapt),attrs:{"data-v-7508f7a8":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tacapt)}}),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo && (_vm.arr_allBetEvent.sptid==1 || _vm.arr_allBetEvent.sptid==2))?[_c('div',{staticClass:"col title-text-style",staticStyle:{"visibility":"visible"},attrs:{"data-v-7508f7a8":""}},[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.scoa)+" - "+_vm._s(_vm.arr_allBetEvent.rbinfo.scob))])]:[_c('div',{staticClass:"col title-text-style",staticStyle:{"visibility":"visible"},attrs:{"data-v-7508f7a8":""}},[_vm._v(_vm._s(_vm.getTime(_vm.matchDateCheck(_vm.arr_allBetEvent.dt))))])],_vm._v(" "),_c('div',{staticClass:"col title-text-style",class:_vm.checkPersian(_vm.arr_allBetEvent.tbcapt),attrs:{"data-v-7508f7a8":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tbcapt)}})],2),_vm._v(" "),_c('div',{staticClass:"col-1",attrs:{"data-v-7508f7a8":""}})])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),(_vm.closeTvWindow)?_c('div',{staticClass:"details-header",style:(_vm.sportBackground(_vm.arr_selectedTemplate.sportId, 1)),attrs:{"data-v-722424a7":"","data-v-58c1d432":""}},[_c('div',{staticClass:"common-header",attrs:{"data-v-6173da5c":"","data-v-722424a7":""}},[_c('div',{staticClass:"row justify-between full-height mx-15",attrs:{"data-v-6173da5c":""}},[_c('div',{staticClass:"go-back-btn-wrap a1",attrs:{"data-v-6173da5c":""},on:{"click":_vm.goBack}},[_c('div',{staticClass:"go-back",attrs:{"data-v-6173da5c":""}})]),_vm._v(" "),_c('div',{staticClass:"ellipsis title-style details-c",attrs:{"data-v-6173da5c":""},on:{"click":function($event){return _vm.showMoreMatch()}}},[_c('div',{staticClass:"marquee-wrap",attrs:{"data-v-9403808a":"","data-v-6173da5c":""}},[_c('div',{staticClass:"scroll_wrap",staticStyle:{"animation":"7.6875s linear 0s infinite normal none running titleScroll"},attrs:{"data-v-9403808a":""}},[_c('p',{staticClass:"marquee",class:_vm.checkPersian(_vm.arr_allBetEvent.lgecapt),staticStyle:{"margin-right":"16px"},attrs:{"data-v-9403808a":"","id":"myDiv"},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.lgecapt)}})]),_vm._v(" "),_c('p',{staticClass:"full_content",class:_vm.checkPersian(_vm.arr_allBetEvent.lgecapt),attrs:{"data-v-9403808a":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.lgecapt)}})]),_vm._v("\n                                     \n                                    "),_c('span',{staticClass:"triangle-down",attrs:{"data-v-6173da5c":""}})]),_vm._v(" "),_c('div',{staticClass:"row common-header-right",attrs:{"data-v-6173da5c":""}},[_c('div',{staticClass:"det-ref refreshing-common",class:{'refreshing':_vm.refreshAllBet},attrs:{"data-v-6173da5c":""},on:{"click":_vm.reloadAllBetTable}})])])]),_vm._v(" "),_c('div',{staticClass:"relative-position header-top",attrs:{"data-v-49969bd3":"","data-v-722424a7":""}},[_c('div',{staticClass:"row mx-30 top-style",attrs:{"data-v-49969bd3":""}},[_c('div',{staticClass:"col-3 logo-double",attrs:{"data-v-49969bd3":""}},[(_vm.account.showCtrLogo && _vm.arr_allBetEvent.sptid == 1 || _vm.arr_allBetEvent.sptid == 2)?_c('div',{staticClass:"team-img",attrs:{"data-v-507efc54":"","data-v-49969bd3":""}},[_c('img',{staticClass:"img-style",attrs:{"data-v-507efc54":"","alt":"","data-team":"J","data-csid":"1","src":_vm.arr_allBetEvent.tblogo}})]):_vm._e()]),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo && (_vm.arr_allBetEvent.sptid==1 || _vm.arr_allBetEvent.sptid==2))?[_c('div',{staticClass:"col-6",attrs:{"data-v-49969bd3":""}},[_c('div',{staticClass:"team-text",attrs:{"data-v-0b6b47eb":"","data-v-49969bd3":""}},[(_vm.arr_allBetEvent.ha=='N')?_c('span',{staticClass:"style_icon",attrs:{"data-v-0b6b47eb":""}},[_c('img',{attrs:{"data-v-0b6b47eb":"","src":"assets/images/score/zhonglichang.svg","alt":""}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"base-header-font",attrs:{"data-v-0b6b47eb":""}},[_c('div',{staticClass:"match_stage",attrs:{"data-v-553ff1f6":"","data-v-0b6b47eb":""}},[_c('span',{attrs:{"data-v-553ff1f6":""}},[_c('span',{attrs:{"data-v-553ff1f6":""}},[_c('span',{staticClass:"stage_child_1",attrs:{"data-v-8edd72a2":"","data-v-553ff1f6":""}},[_c('span',{attrs:{"data-v-8edd72a2":""}},[(_vm.arr_allBetEvent.sptid==1)?[(_vm.arr_allBetEvent.rbinfo.htst == '0')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT']))]:(_vm.validateRBTimer(_vm.arr_allBetEvent) == '1')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT1']))]:(_vm.validateRBTimer(_vm.arr_allBetEvent) == '2')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT2']))]:_vm._e(),_vm._v(" "),_c('span',{attrs:{"data-v-8edd72a2":""}},[_vm._v(" "+_vm._s(_vm._f("rb-timer")(_vm.arr_allBetEvent)))])]:[(_vm.arr_allBetEvent.rbinfo.htst == '1')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q1']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '2')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q2']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '3')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q3']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '4')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q4']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '5')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '6')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT_SHOR']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '7')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '8')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OT']))]:_vm._e(),_vm._v(" "),_c('span',{attrs:{"data-v-8edd72a2":""}},[_vm._v(" "+_vm._s(_vm._f("rb-timer")(_vm.arr_allBetEvent)))])]],2)])])])])])])])]:[_c('div',{staticClass:"col-6",attrs:{"data-v-49969bd3":""}},[_c('div',{staticClass:"team-text",attrs:{"data-v-0b6b47eb":"","data-v-49969bd3":""}},[(_vm.arr_allBetEvent.ha=='N')?_c('span',{staticClass:"style_icon",attrs:{"data-v-0b6b47eb":""}},[_c('img',{attrs:{"data-v-0b6b47eb":"","src":"assets/images/score/zhonglichang.svg","alt":""}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"base-header-font",attrs:{"data-v-0b6b47eb":""}},[_c('div',{staticClass:"match_stage",attrs:{"data-v-553ff1f6":"","data-v-0b6b47eb":""}},[_c('span',{attrs:{"data-v-553ff1f6":""}},[_c('span',{attrs:{"data-v-553ff1f6":""}},[(_vm.checkStart(_vm.arr_allBetEvent.dt)<60)?_c('span',{attrs:{"data-v-553ff1f6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.sportTableLang['SPORT_TABLE.START_IN'].replace('{minute}',_vm.checkStart(_vm.arr_allBetEvent.dt)))+"\n                                                        ")]):_c('span',{attrs:{"data-v-553ff1f6":""}},[_vm._v(" "+_vm._s(_vm.getDate(_vm.matchDateCheck(_vm.arr_allBetEvent.dt))))])])])])])])])],_vm._v(" "),_c('div',{staticClass:"col-3 logo-double",attrs:{"data-v-49969bd3":""}},[(_vm.account.showCtrLogo && _vm.arr_allBetEvent.sptid == 1 || _vm.arr_allBetEvent.sptid == 2)?_c('div',{staticClass:"team-img",attrs:{"data-v-507efc54":"","data-v-49969bd3":""}},[_c('img',{staticClass:"img-style",attrs:{"data-v-507efc54":"","alt":"","data-team":"B","data-csid":"1","src":_vm.arr_allBetEvent.talogo}})]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"score-style",attrs:{"data-v-49969bd3":""}},[(_vm.arr_allBetEvent.rb==0)?[(_vm.checkStart(_vm.arr_allBetEvent.dt)<60)?_c('span',{attrs:{"data-v-49969bd3":""}}):_c('span',{attrs:{"data-v-49969bd3":""}},[_c('span',{attrs:{"data-v-49969bd3":""}},[_vm._v(_vm._s(_vm.getTime(_vm.matchDateCheck(_vm.arr_allBetEvent.dt))))])])]:[(_vm.arr_allBetEvent.rbinfo && (_vm.arr_allBetEvent.sptid==1 || _vm.arr_allBetEvent.sptid==2))?[_c('span',{staticClass:"score1",attrs:{"data-v-49969bd3":""}},[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.scoa)+" - "+_vm._s(_vm.arr_allBetEvent.rbinfo.scob))])]:[(_vm.checkStart(_vm.arr_allBetEvent.dt)<60)?_c('span',{staticClass:"score1",attrs:{"data-v-49969bd3":""}}):_c('span',{staticClass:"score1",attrs:{"data-v-49969bd3":""}},[_vm._v(_vm._s(_vm.getTime(_vm.matchDateCheck(_vm.arr_allBetEvent.dt))))])],_vm._v(" "),_c('div',{staticClass:"match_between_score score-ball din-regular",attrs:{"data-v-1ad51395":"","data-v-49969bd3":""}})]],2),_vm._v(" "),_c('div',{staticClass:"mx-4 row team-name",attrs:{"data-v-49969bd3":""}},[_c('div',{staticClass:"row name-wrap mhn",attrs:{"data-v-49969bd3":""}},[_c('div',{staticClass:"mhn-name ellipsis-2-lines",class:_vm.checkPersian(_vm.arr_allBetEvent.tacapt),attrs:{"data-v-49969bd3":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tacapt)}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"row name-wrap",attrs:{"data-v-49969bd3":""}},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"man-name ellipsis-2-lines",class:_vm.checkPersian(_vm.arr_allBetEvent.tbcapt),attrs:{"data-v-49969bd3":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tbcapt)}})])])]),_vm._v(" "),_c('div',{staticClass:"header-bottom margin_left_bottom",attrs:{"data-v-3581e3c7":"","data-v-722424a7":""}},[_c('div',{staticClass:"team-match-icon",attrs:{"data-v-50fa4088":"","data-v-3581e3c7":""}},[_c('div',{staticClass:"icon-wrap",attrs:{"data-v-50fa4088":""}},[(_vm.arr_allBetEvent.rbinfo && _vm.arr_allBetEvent.ch != 0 && _vm.tvIconFlag)?_c('div',{staticClass:"match-icon fl",attrs:{"data-v-e2136514":"","data-v-50fa4088":""},on:{"click":function($event){return _vm.startTv(_vm.arr_allBetEvent)}}},[_c('div',{staticClass:"row mx-8 items-center",attrs:{"data-v-e2136514":""}},[_c('img',{staticClass:"icon-style",attrs:{"data-v-e2136514":"","src":"assets/images/score/shipin.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"col text-left",attrs:{"data-v-e2136514":""}},[_c('span',{staticClass:"tx-style",attrs:{"data-v-e2136514":""}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.VIDEO']))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"match-icon match-icon-single",attrs:{"data-v-50fa4088":""},on:{"click":function($event){return _vm.favouriteAllBet(_vm.arr_allBetEvent, _vm.isRB)}}},[_c('div',{staticClass:"collect-icon",class:_vm.arr_allBetEvent.isFavourite?'active':'',attrs:{"data-v-50fa4088":""}}),_vm._v(" "),_c('div',{staticClass:"text",attrs:{"data-v-50fa4088":""}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.FAVOURITES']))])])])]),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo && _vm.arr_allBetEvent.sptid==1)?[_c('span',{attrs:{"data-v-3581e3c7":""}},[_c('div',{staticClass:"match_score",attrs:{"data-v-126a0a7d":"","data-v-3581e3c7":""}},[_c('div',{staticClass:"score_child_1 row mx-12 font-style",attrs:{"data-v-8c6648dc":"","data-v-126a0a7d":""}},[(_vm.arr_allBetEvent.rbinfo.htscoa!='')?_c('div',{attrs:{"data-v-8c6648dc":""}},[_c('div',{attrs:{"data-v-8c6648dc":""}},[_c('span',{attrs:{"data-v-8c6648dc":""}},[_vm._v("  ")]),_vm._v(" "),_c('span',{attrs:{"data-v-8c6648dc":""}},[_vm._v(" "+_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_H']))]),_vm._v(" "),_c('span',{attrs:{"data-v-8c6648dc":""}},[_vm._v(" : \n                                                        "),(_vm.arr_allBetEvent.rbinfo.htscoa!=''&&_vm.arr_allBetEvent.rbinfo.htscob!='')?[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.htscoa)+" - "+_vm._s(_vm.arr_allBetEvent.rbinfo.htscob))]:[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.scoa)+" - "+_vm._s(_vm.arr_allBetEvent.rbinfo.scob))]],2)])]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"data-v-8c6648dc":""}},[_c('span',{attrs:{"data-v-8c6648dc":""}},[_vm._v("  ")]),_vm._v(" "),_c('span',{attrs:{"data-v-8c6648dc":""}},[_c('span',{attrs:{"data-v-8c6648dc":""}},[_vm._v("  ")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('span',{attrs:{"data-v-8c6648dc":""}},[_vm._v("  ")]),_vm._v(" "),_c('span',{attrs:{"data-v-8c6648dc":""}},[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.rca)+"-"+_vm._s(_vm.arr_allBetEvent.rbinfo.rcb))])])])])])])]:_vm._e()],2)]):_vm._e()])]),_vm._v(" "),_c('div',{ref:"miniHeader",staticClass:"mini-header-container",staticStyle:{"visibility":"hidden"},attrs:{"data-v-58c1d432":""}},[_c('div',{staticClass:"change-header",attrs:{"data-v-6b63be36":"","data-v-58c1d432":""}},[_c('div',{staticClass:"bg-wrap",style:(_vm.sportBackground(_vm.arr_selectedTemplate.sportId, 0)),attrs:{"data-v-6b63be36":""}}),_vm._v(" "),_c('div',{staticClass:"h-row row mx-15",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"col-1 go-back-container",attrs:{"data-v-6b63be36":""},on:{"click":_vm.goBack}},[_c('div',{staticClass:"go-back",attrs:{"data-v-6b63be36":""}})]),_vm._v(" "),_c('div',{staticClass:"col-2 text-left ellipsis base-header-font",class:_vm.checkPersian(_vm.arr_allBetEvent.tacapt),attrs:{"data-v-6b63be36":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tacapt)}}),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo && (_vm.arr_allBetEvent.sptid==1 || _vm.arr_allBetEvent.sptid==2))?[_c('div',{staticClass:"col-6 row",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"col-2 text-center header-font",attrs:{"data-v-6b63be36":""}},[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.scoa)+" ")]),_vm._v(" "),_c('div',{staticClass:"col text-center base-header-font",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"match_stage",attrs:{"data-v-33858d13":"","data-v-6b63be36":""}},[_c('span',{attrs:{"data-v-33858d13":""}},[_c('span',{staticClass:"dialogStage_1",attrs:{"data-v-c8b324f0":"","data-v-33858d13":""}},[_c('span',{attrs:{"data-v-c8b324f0":""}},[(_vm.arr_allBetEvent.sptid==1)?[(_vm.arr_allBetEvent.rbinfo.htst == '0')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT']))]:(_vm.validateRBTimer(_vm.arr_allBetEvent) == '1')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT1']))]:(_vm.validateRBTimer(_vm.arr_allBetEvent) == '2')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT2']))]:_vm._e()]:[(_vm.arr_allBetEvent.rbinfo.htst == '1')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q1']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '2')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q2']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '3')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q3']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '4')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_Q4']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '5')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_1HT']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '6')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_HT_SHOR']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '7')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_2HT']))]:_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.rbinfo.htst == '8')?[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.LBL_OT']))]:_vm._e()],_vm._v(" "),_c('span',{attrs:{"data-v-c8b324f0":""}},[_c('span',{attrs:{"data-v-c8b324f0":""}},[_vm._v("  "+_vm._s(_vm._f("rb-timer")(_vm.arr_allBetEvent)))])])],2)])])])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center header-font",attrs:{"data-v-6b63be36":""}},[_vm._v(_vm._s(_vm.arr_allBetEvent.rbinfo.scob)+" ")])])]:[_c('div',{staticClass:"col-6 row",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"col-2 text-center header-font",staticStyle:{"display":"none"},attrs:{"data-v-6b63be36":""}},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"col text-center base-header-font",attrs:{"data-v-6b63be36":""}},[_c('div',{staticClass:"match_stage",attrs:{"data-v-33858d13":"","data-v-6b63be36":""}},[(_vm.checkStart(_vm.arr_allBetEvent.dt)<60)?_c('span',{attrs:{"data-v-681648d4":""}},[_vm._v("\n                                                "+_vm._s(_vm.sportTableLang['SPORT_TABLE.START_IN'].replace('{minute}',_vm.checkStart(_vm.arr_allBetEvent.dt)))+"\n                                        ")]):_c('span',{attrs:{"data-v-33858d13":""}},[_vm._v("\n                                            "+_vm._s(_vm.getDate(_vm.matchDateCheck(_vm.arr_allBetEvent.dt)))+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-2 text-center header-font",staticStyle:{"display":"none"},attrs:{"data-v-6b63be36":""}},[_vm._v("0")])])],_vm._v(" "),_c('div',{staticClass:"col-2 text-right ellipsis base-header-font",class:_vm.checkPersian(_vm.arr_allBetEvent.tbcapt),attrs:{"data-v-6b63be36":""},domProps:{"innerHTML":_vm._s(_vm.arr_allBetEvent.tbcapt)}})],2)])]),_vm._v(" "),_c('div',{staticClass:"play-wrapper bet-wrapper-hide",staticStyle:{"display":"none"},attrs:{"data-v-58c1d432":"","id":"tbl"}},[_c('div',{staticClass:"details-tab-wrap",attrs:{"data-v-58c1d432":""}},[_c('div',{staticClass:"q-tabs row no-wrap items-center bg-tabs q-tabs--not-scrollable q-tabs--horizontal q-tabs__arrows--inside col-shrink self-stretch",attrs:{"data-v-58c1d432":"","role":"tablist"}},[_c('div',{staticClass:"q-tabs__content row no-wrap items-center self-stretch hide-scrollbar relative-position q-tabs__content--align-justify tab-bet-wrapper scroll"},[_c('div',{staticClass:"q-tab relative-position self-stretch flex flex-center text-center no-outline q-tab--active text-active-tab bg-active-tab q-focusable q-hoverable cursor-pointer",attrs:{"data-v-58c1d432":"","tabindex":"0","role":"tab","aria-selected":"true"}},[_c('div',{staticClass:"q-focus-helper",attrs:{"tabindex":"-1"}}),_vm._v(" "),_c('div',{staticClass:"q-tab__content self-stretch flex-center relative-position q-anchor--skip non-selectable row no-wrap q-tab__content--inline"},[_c('div',{staticClass:"q-tab__label"},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.BET']))])])]),_vm._v(" "),_c('div',{staticClass:"q-tab__indicator absolute-top"})])]),_vm._v(" "),_c('div',{staticClass:"details-tab",attrs:{"data-v-064a5016":"","data-v-58c1d432":""}},[_c('div',{staticClass:"fat-btn",attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.showHideAllOdds()}}},[_c('div',{staticClass:"tab-btn",class:{'collapsed':_vm.isCollapse},attrs:{"data-v-064a5016":""}})]),_vm._v(" "),_c('span',{staticClass:"menu-third",attrs:{"data-v-064a5016":""}}),_vm._v(" "),_c('div',{staticClass:"menu-s",attrs:{"data-v-064a5016":""}},[_c('div',{staticClass:"menu-s",attrs:{"data-v-064a5016":""}},[(_vm.selectedGrp.includes(7))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 7},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(7)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.ALL']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(8))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 8},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(8)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.HOT']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(1))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 1},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(1)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.HDP'])+_vm._s(_vm.sportAllBetLang['ALL_BET.AND'])+_vm._s(_vm.sportAllBetLang['ALL_BET.OU']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(2))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 2},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(2)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.GOALS']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(3))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 3},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(3)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.CS']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(4))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 4},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(4)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.HALF']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(5))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 5},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(5)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.SPECIALS']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(6))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 6},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(6)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.OTHER']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(9))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 9},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(9)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.INNINGS']))])]:_vm._e(),_vm._v(" "),(_vm.selectedGrp.includes(10))?[_c('div',{staticClass:"menu-item",class:{'t_color':_vm.arr_selectedBetTab == 10},attrs:{"data-v-064a5016":""},on:{"click":function($event){return _vm.changeBetTab(10)}}},[_vm._v(_vm._s(_vm.sportAllBetLang['ALL_BET.TEAMS']))])]:_vm._e()],2)])])]),_vm._v(" "),_c('allBet',{attrs:{"selectedBetTab":_vm.arr_selectedBetTab}})],1),_vm._v(" "),(_vm.isShowBottomRefresh)?_c('div',{staticClass:"details-ref",attrs:{"data-v-58c1d432":""},on:{"click":_vm.reloadAllBetTable}},[_c('div',{class:{'refreshing':_vm.refreshAllBet},attrs:{"data-v-58c1d432":""}})]):_vm._e(),_vm._v(" "),(_vm.showNotice)?_c('div',{staticClass:"info-rules fullscreen",attrs:{"data-v-2ba1a780":"","data-v-58c1d432":""}},[_c('div',{staticClass:"content-box",attrs:{"data-v-2ba1a780":""}},[_c('header',{attrs:{"data-v-2ba1a780":""}},[_vm._v("赛事直播说明")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('footer',{attrs:{"data-v-2ba1a780":""},on:{"click":function($event){_vm.showNotice=false;}}},[_vm._v("我知道了")])])]):_vm._e()])])])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen-btn",staticStyle:{"display":"none"},attrs:{"data-v-7508f7a8":""}},[_c('img',{attrs:{"data-v-7508f7a8":"","src":"assets/images/score/full_screen.svg"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description-popup",staticStyle:{"display":"none"},attrs:{"data-v-7508f7a8":""}},[_c('div',{staticClass:"img-wrap",attrs:{"data-v-7508f7a8":""}},[_c('img',{attrs:{"data-v-7508f7a8":"","src":"assets/images/score/video_b.svg"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"red-gif",attrs:{"data-v-49969bd3":""}},[_c('div',{staticClass:"inner left",attrs:{"data-v-49969bd3":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"red-gif",attrs:{"data-v-49969bd3":""}},[_c('div',{staticClass:"inner right",attrs:{"data-v-49969bd3":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-v-8c6648dc":""}},[_c('div',{staticClass:"q-img overflow-hidden",staticStyle:{"width":"0.12rem","margin-top":"-3px"},attrs:{"data-v-8c6648dc":"","role":"img"}},[_c('div',{staticStyle:{"padding-bottom":"100%"}}),_vm._v(" "),_c('div',{staticClass:"q-img__image absolute-full",staticStyle:{"background-size":"cover","background-position":"50% 50%","background-image":"url('assets/images/score/details_red_card.svg')"}}),_vm._v(" "),_c('div',{staticClass:"q-img__content absolute-full"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-v-2ba1a780":""}},[_c('div',{staticClass:"rules-wet"},[_vm._v("1")]),_vm._v("\n                          此版面显示的所有直播内容"),_c('span',{staticClass:"font-wet"},[_vm._v("仅供参考，")]),_vm._v("会员亦可使用此内容为指南。我们将尽最大的努力确保显示的内容是正确的，如有错误，本公司将不承担任何责任。\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-v-2ba1a780":""}},[_c('div',{staticClass:"rules-wet"},[_vm._v("2")]),_vm._v("\n                          对于滚球比分，例如滚球让球，将"),_c('span',{staticClass:"font-wet"},[_vm._v("以投注时在投注单中显示的正确比分为准")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet2_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7a5d88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet2_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var normalizeComponent = __webpack_require__(10)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b7a5d88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allBet2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b7a5d88_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allBet2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"match-body",staticStyle:{"flex-direction":"column"},attrs:{"id":"allbet"}},[_c('div',{staticClass:"clearfix",attrs:{"id":"title-events-wrap"}},[_c('div',{staticClass:"clearfix",attrs:{"id":"title-events"}},[_c('div',{staticClass:"match-block"},[_c('div',{staticClass:"match-header"},[_c('div',{staticClass:"star-icon",class:{ 'active': _vm.arr_allBetEvent && _vm.arr_allBetEvent.isFavourite? _vm.arr_allBetEvent.isFavourite:false },on:{"click":function($event){$event.stopPropagation();return _vm.favouriteAllBet(_vm.arr_allBetEvent)}}}),_vm._v(" "),(!_vm.loadingScreen)?_c('div',{staticClass:"match-title",attrs:{"title":_vm.arr_allBetEvent && _vm.arr_allBetEvent.lgecapt? _vm.arr_allBetEvent.lgecapt:'-'}},[_vm._v(_vm._s(_vm.arr_allBetEvent && _vm.arr_allBetEvent.lgecapt? _vm.arr_allBetEvent.lgecapt:'-'))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"match-date"},[_vm._v(_vm._s(_vm.getDate(_vm.arr_allBetEvent)))]),_vm._v(" "),_c('div',{staticClass:"match-content"},[_c('div',{staticClass:"side-star star-icon",class:{ 'active': _vm.checkFavTeams('taid') },on:{"click":function($event){$event.stopPropagation();return _vm.favouriteTeam(_vm.arr_allBetEvent,'a')}}}),_vm._v(" "),_c('div',{staticClass:"team"},[_c('div',{staticClass:"team-icon"},[(_vm.arr_allBetEvent && _vm.arr_allBetEvent.talogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.talogo}}):_vm._e()]),_vm._v(" "),(!_vm.loadingScreen)?_c('div',{staticClass:"team-name"},[_vm._v(_vm._s(_vm.arr_allBetEvent && _vm.arr_allBetEvent.tacapt? _vm.arr_allBetEvent.tacapt:'-'))]):_vm._e()]),_vm._v(" "),(_vm.arr_allBetEvent && _vm.arr_allBetEvent.rb == 0)?_c('div',{staticClass:"score"},[_vm._v("VS")]):(_vm.arr_allBetEvent && _vm.arr_allBetEvent.score && _vm.arr_allBetEvent.score.FT)?_c('div',{staticClass:"score"},[_vm._v(_vm._s(_vm.arr_allBetEvent.score.FT))]):(_vm.arr_allBetEvent && _vm.arr_allBetEvent.score && _vm.arr_allBetEvent.score.HT)?_c('div',{staticClass:"score"},[_vm._v(_vm._s(_vm.arr_allBetEvent.score.HT))]):_c('div',{staticClass:"score"},[_vm._v("0-0")]),_vm._v(" "),_c('div',{staticClass:"team"},[_c('div',{staticClass:"team-icon"},[(_vm.arr_allBetEvent && _vm.arr_allBetEvent.tblogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.tblogo}}):_vm._e()]),_vm._v(" "),(!_vm.loadingScreen)?_c('div',{staticClass:"team-name"},[_vm._v(_vm._s(_vm.arr_allBetEvent && _vm.arr_allBetEvent.tbcapt? _vm.arr_allBetEvent.tbcapt:'-'))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"side-star star-icon",class:{ 'active': _vm.checkFavTeams('tbid') },on:{"click":function($event){$event.stopPropagation();return _vm.favouriteTeam(_vm.arr_allBetEvent,'b')}}})])])])]),_vm._v(" "),_c('div',{staticClass:"title-events-mobile-wrap"},[_c('div',{staticClass:"title-events-mobile-content"},[_c('div',{staticClass:"title-events-mobile-header"},[_c('div',{staticClass:"title-events-mobile-icon star",class:{ 'active': _vm.arr_allBetEvent && _vm.arr_allBetEvent.isFavourite? _vm.arr_allBetEvent.isFavourite:false },on:{"click":function($event){$event.stopPropagation();return _vm.favouriteAllBet(_vm.arr_allBetEvent)}}}),_vm._v(" "),(!_vm.loadingScreen)?_c('div',{staticClass:"title-events-mobile-title",attrs:{"title":_vm.arr_allBetEvent && _vm.arr_allBetEvent.lgecapt? _vm.arr_allBetEvent.lgecapt:'-'}},[_vm._v(_vm._s(_vm.arr_allBetEvent && _vm.arr_allBetEvent.lgecapt? _vm.arr_allBetEvent.lgecapt:'-'))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title-events-mobile-date"},[_vm._v(_vm._s(_vm.getDate(_vm.arr_allBetEvent)))])]),_vm._v(" "),_c('div',{staticClass:"title-events-mobile-teams"},[_c('div',{staticClass:"title-events-mobile-icon star",class:{ 'active': _vm.checkFavTeams('taid') },on:{"click":function($event){$event.stopPropagation();return _vm.favouriteTeam(_vm.arr_allBetEvent,'a')}}}),_vm._v(" "),_c('div',{staticClass:"title-events-mobile-team"},[_c('div',{staticClass:"team-logo team1"},[(_vm.arr_allBetEvent && _vm.arr_allBetEvent.talogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.talogo}}):_vm._e()]),_vm._v(" "),(!_vm.loadingScreen)?_c('div',{staticClass:"team-name"},[_vm._v(_vm._s(_vm.arr_allBetEvent && _vm.arr_allBetEvent.tacapt? _vm.arr_allBetEvent.tacapt:'-'))]):_vm._e()]),_vm._v(" "),(_vm.arr_allBetEvent && _vm.arr_allBetEvent.rb == 0)?_c('div',{staticClass:"title-events-mobile-score"},[_vm._v("VS")]):(_vm.arr_allBetEvent && _vm.arr_allBetEvent.score && _vm.arr_allBetEvent.score.FT)?_c('div',{staticClass:"title-events-mobile-score"},[_vm._v(_vm._s(_vm.arr_allBetEvent.score.FT))]):(_vm.arr_allBetEvent && _vm.arr_allBetEvent.score && _vm.arr_allBetEvent.score.HT)?_c('div',{staticClass:"title-events-mobile-score"},[_vm._v(_vm._s(_vm.arr_allBetEvent.score.HT))]):_c('div',{staticClass:"title-events-mobile-score"},[_vm._v("0-0")]),_vm._v(" "),_c('div',{staticClass:"title-events-mobile-team"},[_c('div',{staticClass:"team-logo team2"},[(_vm.arr_allBetEvent && _vm.arr_allBetEvent.tblogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.tblogo}}):_vm._e()]),_vm._v(" "),(!_vm.loadingScreen)?_c('div',{staticClass:"team-name"},[_vm._v(_vm._s(_vm.arr_allBetEvent && _vm.arr_allBetEvent.tbcapt? _vm.arr_allBetEvent.tbcapt:'-'))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"title-events-mobile-icon star",class:{ 'active': _vm.checkFavTeams('tbid') },on:{"click":function($event){$event.stopPropagation();return _vm.favouriteTeam(_vm.arr_allBetEvent,'b')}}})]),_vm._v(" "),_c('div',{staticClass:"title-events-mobile-toggle"},[_c('div',{staticClass:"toggle-btn"},[(_vm.arr_allBetEvent && _vm.arr_allBetEvent.rb != -1 && _vm.arr_allBetEvent.chid != 0)?_c('div',{staticClass:"icon-mobile-left",class:{ 'active':_vm.selectedTab == '1', 'non-rb': (_vm.arr_allBetEvent && _vm.arr_allBetEvent.rb != 1) },on:{"click":function($event){return _vm.startTv(_vm.arr_allBetEvent)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icon-mobile-right",class:_vm.selectedTab == '2'?'active':'',on:{"click":function($event){return _vm.changeVideo('anime', _vm.arr_allBetEvent)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tabs-wrap"},[_c('div',{staticClass:"tabs-nav"},[_c('button',{staticClass:"tabs-btn current",attrs:{"id":"tab-overview"},on:{"click":function($event){return _vm.displayContent('overview')}}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.OVERVIEW']))]),_vm._v(" "),(_vm.arr_allBetEvent && _vm.arr_allBetEvent.od && (_vm.arr_allBetEvent.od.length > 0 || Object.keys(_vm.arr_allBetEvent.od).length > 0))?_c('button',{staticClass:"tabs-btn",attrs:{"id":"tab-odds"},on:{"click":function($event){return _vm.displayContent('odds')}}},[_vm._v(_vm._s(_vm.arr_lang.oddsConversionLang['ODDS_CONVERSION.ODDS']))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"tabs-btn mob-only",attrs:{"id":"tab-chat"},on:{"click":function($event){return _vm.displayContent('chat')}}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.LIVE_CHAT']))]),_vm._v(" "),(_vm.arr_allBetEvent && _vm.arr_allBetEvent.lineup && Object.keys(_vm.arr_allBetEvent.lineup).length > 0)?_c('button',{staticClass:"tabs-btn mob-only",attrs:{"id":"tab-lineup"},on:{"click":function($event){return _vm.displayContent('lineup')}}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.LINE_UP']))]):_vm._e()])]),_vm._v(" "),(_vm.arr_allBetEvent)?_c('div',{staticClass:"tabs-content-wrap"},[_c('div',{staticClass:"tabs-content current",attrs:{"id":"overview"}},[(_vm.arr_allBetEvent.od && (_vm.arr_allBetEvent.od.length > 0 || Object.keys(_vm.arr_allBetEvent.od).length > 0))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.odds),expression:"contentFlag.odds"}],staticClass:"content-top"},[_c('div',{staticClass:"table-wrapper"},[_c('div',{staticClass:"responsive-wrapper"},[_c('div',{staticClass:"odds-data-table"},[_c('div',{staticClass:"odds-data-row odds-data-header"},[_c('div',{staticClass:"odds-data-col odds-data-col1",class:{'open': _vm.bmkToggle}},[_c('div',{ref:"oddsselector",staticClass:"odds-data-type-selector",on:{"click":function($event){return _vm.toggleBmkDropdown()}}},[_c('div',{staticClass:"logo",class:'bmk-'+_vm.selectedBmk}),_vm._v(" "),_c('svg',{staticClass:"dropdown-icon",attrs:{"viewBox":"0 0 24 24","width":"20","height":"20"}},[_c('path',{attrs:{"d":"M6 9l6 6 6-6","stroke":"#FFF","stroke-width":"2","fill":"none","stroke-linecap":"round"}})])]),_vm._v(" "),_c('div',{ref:"oddsdropdown",staticClass:"odds-data-dropdown"},[_c('button',{staticClass:"dropdown-item bmk-8",on:{"click":function($event){return _vm.selectBmk('8')}}}),_vm._v(" "),(_vm.arr_allBetEvent.od && _vm.arr_allBetEvent.od['22'])?_c('button',{staticClass:"dropdown-item bmk-22",on:{"click":function($event){return _vm.selectBmk('22')}}}):_vm._e(),_vm._v(" "),(_vm.arr_allBetEvent.od && _vm.arr_allBetEvent.od['3'])?_c('button',{staticClass:"dropdown-item bmk-3",on:{"click":function($event){return _vm.selectBmk('3')}}}):_vm._e()])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col3"},[_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.AH']))])]),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col4"},[_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.SCORE']))]),_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.OVER']))]),_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.UNDER']))])])]),_vm._v(" "),_c('div',{staticClass:"odds-data-row odds-data-body bg-blue"},[_c('div',{staticClass:"odds-data-col odds-data-col1"},[_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.OPEN_ODDS']))])]),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col2"},[_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '5', '1', 'odA')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '5', '1', 'odX')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '5', '1', 'odB')))])]),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col3"},[_c('span',[_c('em',[_vm._v(_vm._s(_vm.getHan(_vm.arr_allBetEvent, '1', '1', 'odA')))]),_vm._v(" "+_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '1', '1', 'odA')))]),_vm._v(" "),_c('span',[_c('em',[_vm._v(_vm._s(_vm.getHan(_vm.arr_allBetEvent, '1', '1', 'odB')))]),_vm._v(" "+_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '1', '1', 'odB')))])]),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col4"},[_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '3', '1', 'han')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '3', '1', 'odA')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '3', '1', 'odB')))])])]),_vm._v(" "),_c('div',{staticClass:"odds-data-row odds-data-body bg-yellow last-row"},[_c('div',{staticClass:"odds-data-col odds-data-col1"},[_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.PREMATCH_ODDS']))])]),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col2"},[_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '5', '2', 'odA')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '5', '2', 'odX')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '5', '2', 'odB')))])]),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col3"},[_c('span',[_c('em',[_vm._v(_vm._s(_vm.getHan(_vm.arr_allBetEvent, '1', '2', 'odA')))]),_vm._v(" "+_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '1', '2', 'odA')))]),_vm._v(" "),_c('span',[_c('em',[_vm._v(_vm._s(_vm.getHan(_vm.arr_allBetEvent, '1', '2', 'odB')))]),_vm._v(" "+_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '1', '2', 'odB')))])]),_vm._v(" "),_c('div',{staticClass:"odds-data-col odds-data-col4"},[_c('span',{staticClass:"highlight"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '3', '2', 'han')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '3', '2', 'odA')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, '3', '2', 'odB')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"odds-info-wrapper"},[_c('div',{staticClass:"odds-overview-header"},[_c('span',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.arr_lang.oddsConversionLang['ODDS_CONVERSION.ODDS']))])]),_vm._v(" "),_c('div',{staticClass:"odds-info-tabs"},[_c('button',{staticClass:"tab-btn",class:{'active': _vm.oddsBettyp == '5'},on:{"click":function($event){return _vm.selectOddsBettyp('5')}}},[_vm._v("1x2")]),_vm._v(" "),_c('button',{staticClass:"tab-btn",class:{'active': _vm.oddsBettyp == '1'},on:{"click":function($event){return _vm.selectOddsBettyp('1')}}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.AH_short']))]),_vm._v(" "),_c('button',{staticClass:"tab-btn",class:{'active': _vm.oddsBettyp == '3'},on:{"click":function($event){return _vm.selectOddsBettyp('3')}}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.SCORE']))])]),_vm._v(" "),_c('div',{staticClass:"odds-info-switch"},[_c('div',{staticClass:"switch-btn",class:{'active': _vm.oddsSwitchToggle['pre']},attrs:{"data-switch":"pre"},on:{"click":function($event){return _vm.oddsSwitch('pre')}}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.PREMATCH_ODDS']))])]),_vm._v(" "),_c('div',{staticClass:"odds-info-table-wrap"},[_c('table',{staticClass:"odds-info-table"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),(_vm.oddsBettyp == '5')?_c('th',{attrs:{"colspan":"3"}},[_vm._v("1x2")]):(_vm.oddsBettyp == '1')?_c('th',{attrs:{"colspan":"3"}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.AH']))]):(_vm.oddsBettyp == '3')?_c('th',{attrs:{"colspan":"3"}},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.SCORE']))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"brand-row"},[_c('td',{attrs:{"rowspan":"3"}},[_vm._v("bet365")]),_vm._v(" "),_c('td',{staticClass:"odds-cell"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, _vm.oddsBettyp, '1', (_vm.oddsBettyp=='5'?'odA':'han'))))]),_vm._v(" "),_c('td',{staticClass:"odds-cell"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, _vm.oddsBettyp, '1', (_vm.oddsBettyp=='5'?'odX':'odA'))))]),_vm._v(" "),_c('td',{staticClass:"odds-cell"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, _vm.oddsBettyp, '1', 'odB')))])]),_vm._v(" "),_c('tr',{staticClass:"pre-row",class:{'hidden': !_vm.oddsSwitchToggle['pre']}},[_c('td',{staticClass:"odds-cell"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, _vm.oddsBettyp, '2', (_vm.oddsBettyp=='5'?'odA':'han'))))]),_vm._v(" "),_c('td',{staticClass:"odds-cell"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, _vm.oddsBettyp, '2', (_vm.oddsBettyp=='5'?'odX':'odA'))))]),_vm._v(" "),_c('td',{staticClass:"odds-cell"},[_vm._v(_vm._s(_vm.getOdd(_vm.arr_allBetEvent, _vm.oddsBettyp, '2', 'odB')))])])])])]),_vm._v(" "),_c('div',{staticClass:"odds-info-annotation-row"},[_c('div',{staticClass:"annotation-item icon-blue"},[_c('div',{staticClass:"annotation-icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.OPEN_ODDS']))])]),_vm._v(" "),_c('div',{staticClass:"annotation-item icon-yellow"},[_c('div',{staticClass:"annotation-icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.PREMATCH_ODDS']))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content-middle"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.video || _vm.contentFlag.livetext),expression:"contentFlag.video || contentFlag.livetext"}],staticClass:"container-inner container-inner-left"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.video),expression:"contentFlag.video"}],staticClass:"videos-wrap"},[_c('div',{staticClass:"content-header"},[_c('div',{staticClass:"content-title"},[_c('span',{staticClass:"videos-title-text",class:_vm.checkTitle(_vm.arr_allBetEvent.lgecapt,'lge')},[_vm._v(_vm._s(_vm.arr_allBetEvent.lgecapt))]),_vm._v(" "),_c('span',{staticClass:"videos-title-divider"},[_vm._v("|")]),_vm._v(" "),_c('span',{staticClass:"videos-title-date",attrs:{"id":"videos-date"}},[_vm._v(_vm._s(_vm.getDate(_vm.arr_allBetEvent)))])]),_vm._v(" "),_c('div',{staticClass:"videos-tabs-wrap"},[_c('div',{staticClass:"videos-tabs"},[(_vm.arr_allBetEvent.rb != -1 && _vm.arr_allBetEvent.chid != 0)?_c('button',{staticClass:"videos-tab-btn videos-tab-live",class:_vm.selectedTab == '1'?'active':'',on:{"click":function($event){return _vm.startTv(_vm.arr_allBetEvent)}}},[_c('div',{staticClass:"videos-tab-icon live"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"videos-tab-btn videos-tab-anime",class:_vm.selectedTab == '2'?'active':'',on:{"click":function($event){return _vm.changeVideo('anime', _vm.arr_allBetEvent)}}},[_c('div',{staticClass:"videos-tab-icon anime"})])])])]),_vm._v(" "),_c('div',{staticClass:"videos-content"},[(_vm.selectedTab == '1')?_c('div',{staticClass:"videos-screen live",class:_vm.selectedTab == '1'?'active':''},[(_vm.tvlink)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"bdIframe","allow":"autoplay","frameborder":"0","scrolling":"no","src":_vm.tvlink}}):_c('div',{staticStyle:{"width":"fit-content","margin":"auto","color":"var(--live-box-score-text)"}},[_vm._v("NO LIVE")])]):(_vm.selectedTab == '2')?_c('div',{staticClass:"videos-screen anime",class:_vm.selectedTab == '2'?'active':''},[(_vm.animelink)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.animelink,"frameborder":"0"}}):_c('div',{staticStyle:{"width":"fit-content","margin":"auto","color":"var(--live-box-score-text)"}},[_vm._v("NO ANIME")])]):_vm._e()])]),_vm._v(" "),(_vm.arr_allBetEvent.livetext && (_vm.arr_allBetEvent.livetext.length > 0 || Object.keys(_vm.arr_allBetEvent.livetext).length > 0))?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.livetext),expression:"contentFlag.livetext"}],staticClass:"live-text-wrap"},[_c('div',{staticClass:"content-header"},[_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.LIVE_TEXT']))])]),_vm._v(" "),_c('div',{staticClass:"live-text-team-row"},[_c('div',{staticClass:"live-text-team-left"},[_c('div',{staticClass:"team-icon live-text-team-icon team-a"},[(_vm.arr_allBetEvent.talogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.talogo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"live-text-team-name",class:_vm.checkTitle(_vm.arr_allBetEvent.tacapt, 'team')},[_vm._v(_vm._s(_vm.arr_allBetEvent.tacapt))])]),_vm._v(" "),_c('div',{staticClass:"analysis-padding"}),_vm._v(" "),_c('div',{staticClass:"live-text-team-right"},[_c('div',{staticClass:"live-text-team-name",class:_vm.checkTitle(_vm.arr_allBetEvent.tbcapt, 'team')},[_vm._v(_vm._s(_vm.arr_allBetEvent.tbcapt))]),_vm._v(" "),_c('div',{staticClass:"team-icon live-text-team-icon team-b"},[(_vm.arr_allBetEvent.tblogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.tblogo}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"live-text-content"},[_c('div',{staticClass:"live-text-row"},[_c('div',{staticClass:"live-text-score"},[_vm._v(_vm._s(_vm.getLiveTextScore(_vm.arr_allBetEvent.rb_timer_status, _vm.arr_allBetEvent.score)))])]),_vm._v(" "),_c('div',{staticClass:"live-text-message-list",attrs:{"id":"liveTextMessages"}},_vm._l((_vm.arr_allBetEvent.livetext),function(value,index){return ((value.happenTime && (value.actCap1 || value.act1)) || (value.happenTime && value.direction == 3))?_c('div',{staticClass:"live-text-msg-block"},[_c('div',{staticClass:"live-text-time-circle"},[_vm._v(_vm._s(value.direction == 3? value.act1: value.happenTime))]),_vm._v(" "),(value.direction == 1)?[_c('div',{staticClass:"live-text-msg live-text-msg-left"},[(value.actCap1)?[_vm._v(_vm._s(value.actCap1)+"\n                                 "),(value.actCap3 || value.act3)?[(value.act2)?[_vm._v(_vm._s(value.act2))]:_vm._e(),_vm._v(" "),(value.actCap2)?[_vm._v(_vm._s(value.actCap2))]:_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),(value.actCap1 && value.act1)?[_vm._v(" | ")]:_vm._e(),_vm._v(" "),(value.act1)?[_c('span',{staticClass:"strong"},[_vm._v(_vm._s(value.act1))])]:_vm._e(),_vm._v(" "),(value.actCap3 || value.act3)?[(value.actCap3 || value.act3)?[_c('br')]:_vm._e(),_vm._v(" "),(value.actCap3)?[_vm._v(_vm._s(value.actCap3))]:_vm._e(),_vm._v(" "),(value.actCap3 && value.act3)?[_vm._v(" | ")]:_vm._e(),_vm._v(" "),(value.act3)?[_c('span',{staticClass:"strong"},[_vm._v(_vm._s(value.act3))])]:_vm._e()]:[(value.actCap2 || value.act2)?[_c('br')]:_vm._e(),_vm._v(" "),(value.actCap2)?[_vm._v(_vm._s(value.actCap2))]:_vm._e(),_vm._v(" "),(value.actCap2 && value.act2)?[_vm._v(" | ")]:_vm._e(),_vm._v(" "),(value.act2)?[_c('span',{staticClass:"strong"},[_vm._v(_vm._s(value.act2))])]:_vm._e()]],2)]:(value.direction == 2)?[_c('div',{staticClass:"live-text-msg live-text-msg-right"},[(value.act1)?[_c('span',{staticClass:"strong"},[_vm._v(_vm._s(value.act1))])]:_vm._e(),_vm._v(" "),(value.actCap1 && value.act1)?[_vm._v(" | ")]:_vm._e(),_vm._v(" "),(value.actCap1)?[_vm._v(_vm._s(value.actCap1)+"\n                                 "),(value.actCap3 || value.act3)?[(value.act2)?[_vm._v(_vm._s(value.act2))]:_vm._e(),_vm._v(" "),(value.actCap2)?[_vm._v(_vm._s(value.actCap2))]:_vm._e()]:_vm._e()]:_vm._e(),_vm._v(" "),(value.actCap3 || value.act3)?[(value.actCap3 || value.act3)?[_c('br')]:_vm._e(),_vm._v(" "),(value.act3)?[_c('span',{staticClass:"strong"},[_vm._v(_vm._s(value.act3))])]:_vm._e(),_vm._v(" "),(value.actCap3 && value.act3)?[_vm._v(" | ")]:_vm._e(),_vm._v(" "),(value.actCap3)?[_vm._v(_vm._s(value.actCap3))]:_vm._e()]:[(value.actCap2 || value.act2)?[_c('br')]:_vm._e(),_vm._v(" "),(value.act2)?[_c('span',{staticClass:"strong"},[_vm._v(_vm._s(value.act2))])]:_vm._e(),_vm._v(" "),(value.actCap2 && value.act2)?[_vm._v(" | ")]:_vm._e(),_vm._v(" "),(value.actCap2)?[_vm._v(_vm._s(value.actCap2))]:_vm._e()]],2)]:_vm._e()],2):_vm._e()}),0)])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.chat || _vm.contentFlag.analysis),expression:"contentFlag.chat || contentFlag.analysis"}],staticClass:"container-inner container-inner-right"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.chat),expression:"contentFlag.chat"}],staticClass:"chat-room-wrap"},[_c('div',{staticClass:"content-header"},[_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.LIVE_CHAT']))]),_vm._v(" "),_c('button',{staticClass:"chat-room-toggle-btn",attrs:{"id":"chatToggleBtn","aria-label":"Toggle Chat"},on:{"click":_vm.toggleChatroom}},[_c('svg',{staticClass:"chat-room-toggle-icon",class:{ 'collapsed': !_vm.chatroom },attrs:{"viewBox":"0 0 24 24","width":"20","height":"20"}},[_c('path',{attrs:{"d":"M6 9l6 6 6-6","stroke":"#FFF","stroke-width":"2","fill":"none","stroke-linecap":"round"}})])])]),_vm._v(" "),_c('div',{staticClass:"chat-room-body",class:{ 'hidden': !_vm.chatroom },attrs:{"id":"chatRoomBody"}},[_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"chat-room-footer"},[_c('input',{staticClass:"chat-room-input",attrs:{"type":"text","placeholder":_vm.arr_lang.sportAllBet['ALL_BET.WRITE_SOMETHING']}}),_vm._v(" "),_c('button',{staticClass:"chat-room-send-btn",attrs:{"aria-label":"Send Message"}})])]),_vm._v(" "),(_vm.arr_allBetEvent.anlysis && _vm.arr_allBetEvent.anlysis.length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.analysis),expression:"contentFlag.analysis"}],staticClass:"data-analysis-wrap"},[_c('div',{staticClass:"content-header"},[_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.ANALYSIS']))])]),_vm._v(" "),_c('div',{staticClass:"data-analysis-team-row"},[_c('div',{staticClass:"data-analysis-team"},[_c('div',{staticClass:"team-icon data-analysis-team-icon team-a"},[(_vm.arr_allBetEvent.talogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.talogo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"data-analysis-team-name",class:_vm.checkTitle(_vm.arr_allBetEvent.tacapt,'team')},[_vm._v(_vm._s(_vm.arr_allBetEvent.tacapt))])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"data-analysis-team"},[_c('div',{staticClass:"data-analysis-team-name",class:_vm.checkTitle(_vm.arr_allBetEvent.tbcapt,'team')},[_vm._v(_vm._s(_vm.arr_allBetEvent.tbcapt))]),_vm._v(" "),_c('div',{staticClass:"team-icon data-analysis-team-icon team-b"},[(_vm.arr_allBetEvent.tblogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.tblogo}}):_vm._e()])])]),_vm._v(" "),_vm._l((_vm.arr_allBetEvent.anlysis),function(value,index){return _c('div',{key:index,staticClass:"data-analysis-content-row"},[_c('div',{staticClass:"data-analysis-num data-analysis-num-left"},[_c('span',{style:(_vm.getAnalysisStyle('left', value[Object.keys(value)[0]].t))},[_vm._v(_vm._s(value[Object.keys(value)[0]].a))])]),_vm._v(" "),_c('div',{staticClass:"data-analysis-label"},[_vm._v(_vm._s(value[Object.keys(value)[0]].cap))]),_vm._v(" "),_c('div',{staticClass:"data-analysis-num data-analysis-num-right"},[_c('span',{style:(_vm.getAnalysisStyle('right', value[Object.keys(value)[0]].t))},[_vm._v(_vm._s(value[Object.keys(value)[0]].b))])])])})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"content-bottom"},[(_vm.arr_allBetEvent.lineup && Object.keys(_vm.arr_allBetEvent.lineup).length > 0)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.contentFlag.lineup),expression:"contentFlag.lineup"}],staticClass:"jersey-wrap"},[_c('div',{staticClass:"content-header"},[_c('div',{staticClass:"content-title"},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.LINE_UP']))])]),_vm._v(" "),_c('div',{staticClass:"jersey-team-row"},[_c('div',{staticClass:"jersey-team-col jersey-team-left"},[_c('div',{staticClass:"team-icon jersey-team-icon team-a"},[(_vm.arr_allBetEvent.talogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.talogo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"jersey-team-name"},[_vm._v(_vm._s(_vm.arr_allBetEvent.tacapt))])]),_vm._v(" "),_c('div',{staticClass:"jersey-team-col jersey-team-right"},[_c('div',{staticClass:"team-icon jersey-team-icon team-b"},[(_vm.arr_allBetEvent.tblogo)?_c('img',{attrs:{"src":_vm.arr_allBetEvent.tblogo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"jersey-team-name"},[_vm._v(_vm._s(_vm.arr_allBetEvent.tbcapt))])])]),_vm._v(" "),_c('div',{staticClass:"jersey-section-title"},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.START_LINE_UP']))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-list"},_vm._l((_vm.splitLineups),function(row,index){return _c('div',{key:'lineup-'+index,staticClass:"jersey-player-row"},[_c('div',{staticClass:"jersey-player-group jersey-left"},[(row.homeLeft)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-left"},[_vm._v(_vm._s(row.homeLeft.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.homeLeft.name))])]):_vm._e(),_vm._v(" "),(row.homeRight)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-left"},[_vm._v(_vm._s(row.homeRight.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.homeRight.name))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"jersey-player-group jersey-right"},[(row.awayLeft)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-right"},[_vm._v(_vm._s(row.awayLeft.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.awayLeft.name))])]):_vm._e(),_vm._v(" "),(row.awayRight)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-right"},[_vm._v(_vm._s(row.awayRight.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.awayRight.name))])]):_vm._e()])])}),0),_vm._v(" "),_c('div',{staticClass:"jersey-section-title substitute"},[_vm._v(_vm._s(_vm.arr_lang.sportAllBet['ALL_BET.SUB_LINE_UP']))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-list"},_vm._l((_vm.splitBackups),function(row,index){return _c('div',{key:'backup-'+index,staticClass:"jersey-player-row"},[_c('div',{staticClass:"jersey-player-group jersey-left"},[(row.homeLeft)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-left"},[_vm._v(_vm._s(row.homeLeft.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.homeLeft.name))])]):_vm._e(),_vm._v(" "),(row.homeRight)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-left"},[_vm._v(_vm._s(row.homeRight.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.homeRight.name))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"jersey-player-group jersey-right"},[(row.awayLeft)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-right"},[_vm._v(_vm._s(row.awayLeft.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.awayLeft.name))])]):_vm._e(),_vm._v(" "),(row.awayRight)?_c('div',{staticClass:"jersey-player-item"},[_c('div',{staticClass:"jersey-player-icon icon-right"},[_vm._v(_vm._s(row.awayRight.number))]),_vm._v(" "),_c('div',{staticClass:"jersey-player-name"},[_vm._v(_vm._s(row.awayRight.name))])]):_vm._e()])])}),0)]):_vm._e()])])]):_c('div',{staticClass:"tabs-content-wrap"},[_c('div',{staticClass:"no-data data-get-empty1",attrs:{"data-v-549f1e7b":""}},[(_vm.skinTheme==2)?[_c('div',{staticClass:"empty-favorite-bg",staticStyle:{"background-image":"url('assets/images/mob/noMatch2.png')"},attrs:{"data-v-549f1e7b":""}})]:[_c('div',{staticClass:"empty-favorite-bg",staticStyle:{"background-image":"url('assets/images/mob/noMatch.svg')"},attrs:{"data-v-549f1e7b":""}})],_vm._v(" "),_c('p',{staticStyle:{"color":"rgb(165, 169, 179)"},attrs:{"data-v-549f1e7b":""}},[_vm._v(_vm._s(_vm.arr_lang.sportTable['SPORT_TABLE.EMPTY']))])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"odds-data-col odds-data-col2"},[_c('span',[_vm._v("1")]),_c('span',[_vm._v("X")]),_c('span',[_vm._v("2")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-room-message"},[_c('div',{staticClass:"chat-room-meta"},[_c('span',{staticClass:"chat-room-user"},[_vm._v("Alice")]),_vm._v(" "),_c('span',{staticClass:"chat-room-time"},[_vm._v("09:39 AM")])]),_vm._v(" "),_c('div',{staticClass:"chat-room-text"},[_vm._v("Hi there! 😊 How's it going?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-room-message"},[_c('div',{staticClass:"chat-room-meta"},[_c('span',{staticClass:"chat-room-user"},[_vm._v("Bob_88")]),_vm._v(" "),_c('span',{staticClass:"chat-room-time"},[_vm._v("09:39 AM")])]),_vm._v(" "),_c('div',{staticClass:"chat-room-text"},[_vm._v("Doing great! Just got off work 🏃‍♂️")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-analysis-team"},[_c('div',{staticClass:"analysis-padding"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-layout q-layout--containerized"},[([1,2,3,5,6,19,21,22].includes(parseInt(_vm.selectedTemplate.templateId)))?[_c('div',{staticClass:"menu match-main-menu menu-inner-wrap",staticStyle:{"z-index":"501","max-width":"unset !important"},attrs:{"id":"sport_menu"}},[_c('marketHeader'),_vm._v(" "),_c('gameHeader')],1),_vm._v(" "),(_vm.selectedTemplate.templateId == '6')?[(_vm.loadingScreen)?_c('div',{staticClass:"loading",class:{'theme01-root-loading':_vm._theme==1,'theme02-root-loading':_vm._theme==2},staticStyle:{"z-index":"500 !important"},attrs:{"id":"loading-root-ele"}},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('allBet2')]:[_c('sportHeader')]]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix",attrs:{"id":"page-footer"}},[_vm._v("\n          Copyright © 2025 BeFun Score. "+_vm._s(_vm.arr_lang.home['HOME.ALL_RIGHT_RESERVED'])+"\n    ")])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"la-line-scale",attrs:{"id":"loading-root-main"}},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_home__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_sport__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_account__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_breadcumb__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_sport_odds__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_all_bet__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_help__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_betting_form__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_result__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_sport_league__ = __webpack_require__(569);



__webpack_require__(84).polyfill();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);













/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  modules: [__WEBPACK_IMPORTED_MODULE_5__modules_account__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modules_sport__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modules_sport_odds__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modules_home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modules_breadcumb__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modules_all_bet__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modules_help__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__modules_betting_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__modules_result__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__modules_sport_league__["a" /* default */]]
}));

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(32);


/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_core_core__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(32);


var _mutations;





var state = {
  int_marketToggle: 1,
  loadingScreen: null,
  requestAllow: true,
  isMobile: false,
  minSize: 1024,
  subLoading: null,
  fullLoading: null,
  oddsFormatDec: 1,
  betSlipAny: 1,
  showFloating: false,
  simDisp: 1,
  refreshScreen: null,
  isCollapse: true,
  showMoreEvent: false,
  scAllBetTab: {
    '1': ['1', '2', '8', '9', '46', '47', '48', '49'],
    '2': ['3', '5', '10', '18', '46', '47', '48', '49', '19', '20'],
    '3': ['7', '16'],
    '4': ['1', '2', '3', '4', '5', '7', '8', '9', '10', '11', '14', '15', '16', '17', '18', '20', '22', '23', '24', '25', '26', '32', '33', '46', '47', '48', '49', '51'],
    '5': ['59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73'],
    '6': ['34', '35'],
    '7': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '52'],
    '8': ['1', '2', '4', '5', '6', '7', '8', '9', '11']
  },
  bkAllBetTab: {
    '7': ['1', '2', '3', '8', '9', '10', '12', '13', '50', '51', '53', '54', '55', '56'],
    '8': ['1', '2', '4', '5', '6', '7', '8', '9', '11', '12', '13'],
    '5': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'],
    '6': ['50', '51', '53', '54', '55', '56']
  },
  osAllBetTab: {
    '7': ['1', '2', '3', '4', '11', '8', '9', '10', '12', '13'],
    '8': ['1', '2', '4', '5', '6', '7', '8', '9', '11', '12', '13'],
    '9': ['13', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
    '10': ['80', '81', '82', '83'] },
  isShowBtModal: false,
  isShowFilter: false,
  filter_type: 1,
  loadGameHeader: true,
  titleSport: window.titleSport,
  settle_unsettled: 1,
  selectedSport: null,
  filterEventArr: null,
  mulpSetting: window.mulpSetting,
  currentTab: 1,
  previousTab: 1,
  currSlideIndex: 0,
  matchSchdTab: 4,
  actHistory: {
    selDate: null,
    theme: 2,
    selCtr: null
  },
  TVfullscreen: '0'
};

var getters = {
  int_marketToggle: function int_marketToggle(state) {
    return state.int_marketToggle;
  },
  loadingScreen: function loadingScreen(state) {
    return state.loadingScreen;
  },
  requestAllow: function requestAllow(state) {
    return state.requestAllow;
  },
  isMobile: function isMobile(state) {
    return state.isMobile;
  },
  minSize: function minSize(state) {
    return state.minSize;
  },
  subLoading: function subLoading(state) {
    return state.subLoading;
  },
  fullLoading: function fullLoading(state) {
    return state.fullLoading;
  },
  oddsFormatDec: function oddsFormatDec(state) {
    return state.oddsFormatDec;
  },
  betSlipAny: function betSlipAny(state) {
    return state.betSlipAny;
  },
  showFloating: function showFloating(state) {
    return state.showFloating;
  },
  simDisp: function simDisp(state) {
    return state.simDisp;
  },
  refreshScreen: function refreshScreen(state) {
    return state.refreshScreen;
  },
  isCollapse: function isCollapse(state) {
    return state.isCollapse;
  },
  showMoreEvent: function showMoreEvent(state) {
    return state.showMoreEvent;
  },
  scAllBetTab: function scAllBetTab(state) {
    return state.scAllBetTab;
  },
  bkAllBetTab: function bkAllBetTab(state) {
    return state.bkAllBetTab;
  },
  osAllBetTab: function osAllBetTab(state) {
    return state.osAllBetTab;
  },
  isShowBtModal: function isShowBtModal(state) {
    return state.isShowBtModal;
  },
  isShowFilter: function isShowFilter(state) {
    return state.isShowFilter;
  },
  filter_type: function filter_type(state) {
    return state.filter_type;
  },
  loadGameHeader: function loadGameHeader(state) {
    return state.loadGameHeader;
  },
  titleSport: function titleSport(state) {
    return state.titleSport;
  },
  settle_unsettled: function settle_unsettled(state) {
    return state.settle_unsettled;
  },
  selectedSport: function selectedSport(state) {
    return state.selectedSport;
  },
  filterEventArr: function filterEventArr(state) {
    return state.filterEventArr;
  },
  mulpSetting: function mulpSetting(state) {
    return state.mulpSetting;
  },
  currentTab: function currentTab(state) {
    return state.currentTab;
  },
  previousTab: function previousTab(state) {
    return state.previousTab;
  },
  currSlideIndex: function currSlideIndex(state) {
    return state.currSlideIndex;
  },
  matchSchdTab: function matchSchdTab(state) {
    return state.matchSchdTab;
  },
  actHistory: function actHistory(state) {
    return state.actHistory;
  },
  TVfullscreen: function TVfullscreen(state) {
    return state.TVfullscreen;
  }
};

var actions = {
  getFilterEventList: function getFilterEventList(context, payload) {
    var _this = this;

    var url = '/filter-event';
    if (this.getters.account.previewFlag == true) {
      url = '/filter-event-preview';
    }
    __WEBPACK_IMPORTED_MODULE_1__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        sorting: 1,
        sportid: payload.sportid
      }
    }).done(function (res) {
      _this.commit('FILTER_EVENT', res.allEvent);
      if (res.earlyParlayDateList) {
        _this.commit('PARLAYDATELIST', res.earlyParlayDateList);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["Z" /* MARKETTOGGLE */], function (state, payload) {
  state.int_marketToggle = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_0" /* ODDSFORMATDEC */], function (state, payload) {
  state.oddsFormatDec = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* BETSLIPANY */], function (state, payload) {
  state.betSlipAny = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["Y" /* LOADINGSCREEN */], function (state, payload) {
  state.loadingScreen = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_14" /* REQUEST_ALLOW */], function (state, payload) {
  state.requestAllow = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["J" /* IS_MOBILE */], function (state, payload) {
  state.isMobile = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_60" /* SUBLOAD */], function (state, payload) {
  state.subLoading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["y" /* FULL_LOAD */], function (state, payload) {
  state.fullLoading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_41" /* SHOW_FLOATING */], function (state, payload) {
  state.showFloating = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_44" /* SIM_DISP */], function (state, payload) {
  state.simDisp = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_12" /* REFRESHSCREEN */], function (state, payload) {
  state.refreshScreen = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["F" /* IS_COLLAPSE */], function (state, payload) {
  state.isCollapse = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_36" /* SHOWMOREEVENT */], function (state, payload) {
  state.showMoreEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_37" /* SHOW_BTMODAL */], function (state, payload) {
  state.isShowBtModal = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_40" /* SHOW_FILTER */], function (state) {
  state.isShowFilter = state.isShowFilter === false ? true : false;

  if (state.isShowFilter) {

    var lge;

    if (this.getters.sortedEvents.length > 0) {
      this.commit('LEAGUE_FILTER', []);
      lge = _.groupBy(this.getters.sortedEvents, 'lgeid');
      var ret = [];
      var ttlret = [];
      _.forEach(lge, function (lgeinfo, lgeid) {
        ret = { 'id': lgeid * 1, 'c': lgeinfo.length, 'f': lgeinfo[0].lgecapt.charAt(0), 'lgecapt': lgeinfo[0].lgecapt };

        ttlret.push(ret);
      });
      this.commit('LEAGUE_FILTER', ttlret);
      this.commit('TODAYRBLEAGUELIST', ttlret);
    }

    this.commit('LEAGUELIST', []);
    if (this.getters.arr_selectedTemplate.int_marketToggle == '1') {
      this.dispatch('getTodayRBLaugueList', {
        enableLoading: true,
        token: token.arr_2,
        isGameBanner: 0
      });
    } else {
      this.dispatch('getLaugueList', {
        enableLoading: true,
        token: token.arr_2,
        isGameBanner: 0
      });
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["v" /* FILTERTYPE */], function (state, payload) {
  state.filter_type = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["X" /* LOADGAMEHEADER */], function (state, payload) {
  state.loadGameHeader = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_35" /* SETTLE_UNSETTLED */], function (state, payload) {
  state.settle_unsettled = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_29" /* SELECTED_SPORT */], function (state, payload) {
  state.selectedSport = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["w" /* FILTER_EVENT */], function (state, payload) {
  state.filterEventArr = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["n" /* CURRENT_TAB */], function (state, payload) {
  if (state.currentTab != 4) {
    this.commit('PREVIOUS_TAB', state.currentTab);
  }
  state.currentTab = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'PREVIOUS_TAB', function PREVIOUS_TAB(state, payload) {
  state.previousTab = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'CURR_SLIDE_INDEX', function CURR_SLIDE_INDEX(state, payload) {
  state.currSlideIndex = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'MATCH_SCHEDULE_TAB', function MATCH_SCHEDULE_TAB(state, payload) {
  state.matchSchdTab = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'ACT_HISTORY', function ACT_HISTORY(state, payload) {
  state.actHistory = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'TV_FULL_SCREEN', function TV_FULL_SCREEN(state, payload) {
  state.TVfullscreen = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_core_core__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookie__);





var _mutations;







var state = {
  market: {
    inPlayMarket: {
      key: '3',
      lang: window.lang.home['HOME.WELCOME_IN_PLAY'],
      betLang: window.lang.home['HOME.BET_IN_PLAY']
    },
    tdyMarket: {
      key: '1',
      lang: window.lang.home['HOME.WELCOME_TODAYS_MARKET'],

      betLang: window.lang.home['HOME.BET_TODAYS_MARKET']
    },
    earlyMarket: {
      key: '2',
      lang: window.lang.home['HOME.WELCOME_EARLY_MARKET'],

      betLang: window.lang.home['HOME.BET_EARLY_MARKET']
    },
    scheduleMarket: {
      key: '7',
      lang: window.lang.home['HOME.BUTTON_SCHEDULE']
    }
  },
  sortTypes: {
    time: {
      key: '2',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_TIME'
    },
    competition: {
      key: '1',
      lang: 'SPORT_TABLE.SUBHEADER_SORTBY_COMPETITION'
    }
  },
  sportBettypeList: null,
  arr_sportList: {},
  arr_sportAll: {},
  int_selectedMarket: null,
  arr_leagueList: [],
  arr_selectedLeague: null,
  sportTableLang: window._lang.sportTableLang,
  arr_earlyParlayDateList: null,
  int_selectedParlayDate: 99,
  arr_selectedEvent: null,
  oddTypesList: window.odds,
  allSportLang: window._lang.allSportLang,
  allBettypeLang: window._lang.allBettypeLang,
  allPlaytypeLang: window._lang.allPlaytypeLang,
  arr_selectedLeagues: [],
  arr_leagues: [],
  showCalendarBox: false,
  selectedMatches: false,
  isParlay: false,
  isSpecial: false,
  isVip: false,
  isPlaceBet: false,
  isProcessBet: false,
  totalPage: 1,
  selectedPage: 1,
  s_odd: false,
  selectedMarket: '1',
  isGameBannerSelected: false,
  isCorrectScore: false,
  parlaySportList: {},
  sportSelected: false,
  arr_sportCountMarket: {},
  isOtr: false,
  isResult: false,
  arr_earlyEventCountByDate: {},
  todayRBLeagueList: {},
  arr_filterLeagueList: {},
  arr_sortedLeagueList: {},
  selectedChar: null,
  arr_selectedLeagueList: [],
  selectedLeagues: 0,
  totalLeagues: 0,
  sportList: [],
  reloadSportTable: false,
  changeOdds: [],
  swipe: 1,
  isCollapseMatch: [],
  showEnd: false,
  allowLanscape: false,
  showNoScrollEnd: false,
  isHideLeague: [],
  defaultSport: 'N1',
  gameBannerId: null,
  gameBannerSportId: null,
  schedule_sprt: 'N1',
  isresult_schedule: false,
  filter_select_all: true,
  market_button_toggle: false,
  subMenuStatus: {},
  sc_cs_hide: {},
  selected_date: null,
  selected_timezone: '7',
  selected_league: null,
  selected_country: null
};

var getters = {
  market: function market(state) {
    return state.market;
  },
  arr_sportList: function arr_sportList(state) {
    return state.arr_sportList;
  },
  arr_sportAll: function arr_sportAll(state) {
    return state.arr_sportAll;
  },
  int_selectedMarket: function int_selectedMarket(state) {
    return state.int_selectedMarket;
  },
  sportBettypeList: function sportBettypeList(state) {
    return state.sportBettypeList;
  },
  arr_leagueList: function arr_leagueList(state) {
    return state.arr_leagueList;
  },
  arr_selectedLeague: function arr_selectedLeague(state) {
    return state.arr_selectedLeague;
  },
  sortTypes: function sortTypes(state) {
    return state.sortTypes;
  },
  sportTableLang: function sportTableLang(state) {
    return state.sportTableLang;
  },
  arr_earlyParlayDateList: function arr_earlyParlayDateList(state) {
    return state.arr_earlyParlayDateList;
  },
  int_selectedParlayDate: function int_selectedParlayDate(state) {
    return state.int_selectedParlayDate;
  },
  arr_selectedEvent: function arr_selectedEvent(state) {
    return state.arr_selectedEvent;
  },
  allSportLang: function allSportLang(state) {
    return state.allSportLang;
  },
  allBettypeLang: function allBettypeLang(state) {
    return state.allBettypeLang;
  },
  allPlaytypeLang: function allPlaytypeLang(state) {
    return state.allPlaytypeLang;
  },
  oddTypesList: function oddTypesList(state) {
    return state.oddTypesList;
  },
  arr_selectedLeagues: function arr_selectedLeagues(state) {
    return state.arr_selectedLeagues;
  },
  arr_leagues: function arr_leagues(state) {
    return state.arr_leagues;
  },
  showCalendarBox: function showCalendarBox(state) {
    return state.showCalendarBox;
  },
  selectedMatches: function selectedMatches(state) {
    return state.selectedMatches;
  },
  isParlay: function isParlay(state) {
    return state.isParlay;
  },
  isSpecial: function isSpecial(state) {
    return state.isSpecial;
  },
  isVip: function isVip(state) {
    return state.isVip;
  },
  isPlaceBet: function isPlaceBet(state) {
    return state.isPlaceBet;
  },
  isProcessBet: function isProcessBet(state) {
    return state.isProcessBet;
  },
  totalPage: function totalPage(state) {
    return state.totalPage;
  },
  selectedPage: function selectedPage(state) {
    return state.selectedPage;
  },
  s_odd: function s_odd(state) {
    return state.s_odd;
  },
  selectedMarket: function selectedMarket(state) {
    return state.selectedMarket;
  },
  isGameBannerSelected: function isGameBannerSelected(state) {
    return state.isGameBannerSelected;
  },
  isCorrectScore: function isCorrectScore(state) {
    return state.isCorrectScore;
  },
  parlaySportList: function parlaySportList(state) {
    return state.parlaySportList;
  },
  sportSelected: function sportSelected(state) {
    return state.sportSelected;
  },
  arr_sportCountMarket: function arr_sportCountMarket(state) {
    return state.arr_sportCountMarket;
  },
  isOtr: function isOtr(state) {
    return state.isOtr;
  },
  isResult: function isResult(state) {
    return state.isResult;
  },
  arr_earlyEventCountByDate: function arr_earlyEventCountByDate(state) {
    return state.arr_earlyEventCountByDate;
  },
  todayRBLeagueList: function todayRBLeagueList(state) {
    return state.todayRBLeagueList;
  },
  arr_filterLeagueList: function arr_filterLeagueList(state) {
    return state.arr_filterLeagueList;
  },
  arr_sortedLeagueList: function arr_sortedLeagueList(state) {
    return state.arr_sortedLeagueList;
  },
  selectedChar: function selectedChar(state) {
    return state.selectedChar;
  },
  arr_selectedLeagueList: function arr_selectedLeagueList(state) {
    return state.arr_selectedLeagueList;
  },
  selectedLeagues: function selectedLeagues(state) {
    return state.selectedLeagues;
  },
  totalLeagues: function totalLeagues(state) {
    return state.totalLeagues;
  },
  sportList: function sportList(state) {
    return state.sportList;
  },
  reloadSportTable: function reloadSportTable(state) {
    return state.reloadSportTable;
  },
  changeOdds: function changeOdds(state) {
    return state.changeOdds;
  },
  swipe: function swipe(state) {
    return state.swipe;
  },
  isCollapseMatch: function isCollapseMatch(state) {
    return state.isCollapseMatch;
  },
  showEnd: function showEnd(state) {
    return state.showEnd;
  },
  allowLanscape: function allowLanscape(state) {
    return state.allowLanscape;
  },
  showNoScrollEnd: function showNoScrollEnd(state) {
    return state.showNoScrollEnd;
  },
  isHideLeague: function isHideLeague(state) {
    return state.isHideLeague;
  },
  defaultSport: function defaultSport(state) {
    return state.defaultSport;
  },
  gameBannerId: function gameBannerId(state) {
    return state.gameBannerId;
  },
  gameBannerSportId: function gameBannerSportId(state) {
    return state.gameBannerSportId;
  },
  schedule_sprt: function schedule_sprt(state) {
    return state.schedule_sprt;
  },
  isresult_schedule: function isresult_schedule(state) {
    return state.isresult_schedule;
  },
  filter_select_all: function filter_select_all(state) {
    return state.filter_select_all;
  },
  market_button_toggle: function market_button_toggle(state) {
    return state.market_button_toggle;
  },
  subMenuStatus: function subMenuStatus(state) {
    return state.subMenuStatus;
  },
  sc_cs_hide: function sc_cs_hide(state) {
    return state.sc_cs_hide;
  },
  selected_date: function selected_date(state) {
    return state.selected_date;
  },
  selected_timezone: function selected_timezone(state) {
    return state.selected_timezone;
  },
  selected_league: function selected_league(state) {
    return state.selected_league;
  },
  selected_country: function selected_country(state) {
    return state.selected_country;
  }
};

var actions = {
  getSportCCL: function getSportCCL(context, payload) {
    var _this = this;

    payload = payload ? payload : {};

    var url = window._baseUrl + '/sport-ccl';

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: url,
      data: {
        token: payload.token,
        enableLoading: false
      }
    }).done(function (res) {
      var updateCurrCL = _this.getters.account;
      updateCurrCL.currCL = res.cleft;
      _this.commit('ACCOUNT', updateCurrCL);
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          com_code: window.compcode,
          acc: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(updateCurrCL)
        }
      }).done(function (res) {});
      $('.balance-wrap').find('.refesh').removeClass('rotate');
      $('.row').find('.refesh').removeClass('refesh2');
      if (res.authtoken) {
        window.authtoken = res.authtoken;
        $.ajaxSetup({
          headers: { 'Authorization': 'Bearer ' + res.authtoken }
        });
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getEventList: function getEventList(context, payload) {
    var _this2 = this;

    var gameMenuId = 0;
    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = '/sport-event-list-preview';
    } else {
      url = '/sport-event-list';
    }

    if (payload.isGameBanner || this.getters.isSpecial) {
      gameMenuId = 1;
    } else if (this.getters.isVip && !this.getters.isSpecial) {
      gameMenuId = 99;
    } else if (this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId;
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        schedule: payload.market,
        spread: this.getters.account.spread,
        gameMenuId: gameMenuId,
        enableLoading: false,
        token: payload.token,
        mode: 1
      }
    }).done(function (res) {
      if (res.totalMatch != null) {
        _this2.commit('SPORT_LIST', res.totalMatch);
      } else {
        _this2.commit('SPORT_LIST', []);
      }

      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getEventOutright: function getEventOutright(context, payload) {
    var _this3 = this;

    var gameMenuId = 0;
    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = '/sport-event-outright-preview';
    } else {
      url = '/sport-event-outright';
    }

    if (payload.isGameBanner || this.getters.isSpecial) {
      gameMenuId = 1;
    } else if (this.getters.isVip && !this.getters.isSpecial) {
      gameMenuId = 99;
    } else if (this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId;
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: {
        schedule: payload.market,
        spread: this.getters.account.spread,
        gameMenuId: gameMenuId,
        enableLoading: false,
        token: payload.token,
        mode: 2
      }
    }).done(function (res) {
      if (res.totalMatch != null) {
        _this3.commit('SPORT_LIST', res.totalMatch);

        var current1stSport = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(res.totalMatch)[0];
        var getSport = _.filter(_this3.getters.titleSport, function (x) {
          return _.indexOf(x.sid, current1stSport) !== -1;
        });

        _this3.commit('SELECTED_TEMPLATE', {
          sportId: getSport[0].id
        });
      } else {
        _this3.commit('SPORT_LIST', []);
      }
      if (payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getLaugueList: function getLaugueList(context, payload) {
    var _this4 = this;

    var vue = this;
    var date = this.getters.int_selectedParlayDate;
    if (this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == '3') {
      date = '0';
    }
    var plytypgrp = '1';
    if (this.getters.arr_selectedTemplate.subTemplateId == '2') {
      date = this.getters.int_selectedParlayDate;
      plytypgrp = '5';
    }
    var gameMenuId = 0;
    if (this.getters.arr_selectedTemplate.gameMenuId) {
      gameMenuId = this.getters.arr_selectedTemplate.gameMenuId;
    }
    if (payload.isGameBanner || this.getters.isSpecial) {
      gameMenuId = 1;
    } else if (this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId;
    }

    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = _baseUrl + '/sport-league-list-preview';
    } else {
      url = _baseUrl + '/sport-league-list';
    }

    __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);
    this.commit('SUBLOAD', true);

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: url,
      data: {
        sprtid: this.getters.isGameBannerSelected ? this.getters.gameBannerSportId : this.getters.arr_selectedTemplate.sportId,
        schedule: this.getters.arr_selectedTemplate.marketKey,
        date: date,
        plytypgrp: plytypgrp,
        langId: window._langid,
        sort: this.getters.selectedSort,
        spread: this.getters.account.spread,
        gameMenuId: gameMenuId,
        enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
        token: payload.token
      }
    }).done(function (res) {
      var stateArr = [];
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(res.leagues).length > 0) {
        $.each(res.leagues, function (key, val) {
          if (!(_.indexOf(stateArr, val.state) !== -1)) {
            stateArr.push(val.state);
          }
        });

        _this4.commit('STATE_LIST', stateArr);
        _this4.commit('LEAGUELIST', res.leagues);
        _this4.commit('SUBLOAD', false);
        if (res.earlyParlayDateList) {
          _this4.commit('PARLAYDATELIST', res.earlyParlayDateList);
        }
        _this4.commit('FILTERLEAGUELIST', []);

        if (_this4.getters.isShowFilter) {
          var newLeague = '';

          var newRes = _(res.leagues).groupBy(function (o) {
            return o.id;
          }).map(function (g) {
            var _ref;

            return (_ref = _).mergeWith.apply(_ref, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(g).concat([function (o, s, k) {
              return k === 'c' ? o + s : o;
            }]));
          }).value();

          if (_this4.getters.int_marketToggle == '1') {
            if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.getters.todayRBLeagueList).length > 0) {

              _.forEach(newRes, function (val, key) {
                vue.getters.todayRBLeagueList.push(val);
              });

              newLeague = _(vue.getters.todayRBLeagueList).groupBy(function (o) {
                return o.id;
              }).map(function (g) {
                var _ref2;

                return (_ref2 = _).mergeWith.apply(_ref2, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(g).concat([function (o, s, k) {
                  return k === 'c' ? o + s : o;
                }]));
              }).value();

              newLeague = _.sortBy(newLeague, function (obj) {
                return obj.f;
              });
            } else {
              newLeague = _.sortBy(newRes, function (obj) {
                return obj.f;
              });
            }
          } else {
            newLeague = _.sortBy(newRes, function (obj) {
              return obj.f;
            });
          }
          _this4.commit('SORTEDLEAGUELIST', newLeague);

          var filterLeagues = _(newLeague).groupBy(function (o) {
            return o.f.toUpperCase();
          }).map(function (leg, cap) {
            return { cap: cap, leg: leg };
          }).value();

          _this4.commit('SELECTED_CHAR', filterLeagues[0].cap);
          _this4.commit('FILTERLEAGUELIST', filterLeagues);
        }

        if (!_this4.getters.isShowFilter) {
          if (_this4.getters.arr_selectedTemplate.marketKey == 3) {
            _this4.dispatch('getLiveSportOdds', {
              loading: 1,
              token: token.arr_2,
              state: _this4.getters.selectedState ? _this4.getters.selectedState : ''
            });
          } else {
            _this4.dispatch('getSportOdds', {
              loading: 1,
              token: token.arr_2,
              state: _this4.getters.selectedState ? _this4.getters.selectedState : ''
            });
          }
        }
        if (payload && payload.callback) {
          return payload.callback(res);
        }
      } else {
        if (_this4.getters.isShowFilter) {
          var _newLeague = '';

          if (_this4.getters.int_marketToggle == '1') {
            if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this4.getters.todayRBLeagueList).length > 0) {
              _newLeague = _.sortBy(vue.getters.todayRBLeagueList, function (obj) {
                return obj.f;
              });

              _this4.commit('SORTEDLEAGUELIST', _newLeague);

              var filterLeagues = _(_newLeague).groupBy(function (o) {
                return o.f.toUpperCase();
              }).map(function (leg, cap) {
                return { cap: cap, leg: leg };
              }).value();

              _this4.commit('SELECTED_CHAR', filterLeagues[0].cap);
              _this4.commit('FILTERLEAGUELIST', filterLeagues);
            }
          }
        }
        _this4.commit('REFRESHSCREEN', false);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getTodayRBLaugueList: function getTodayRBLaugueList(context, payload) {
    var _this5 = this;

    var vue = this;
    var date = this.getters.int_selectedParlayDate;

    if (this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == '3') {
      date = '0';
    }
    var plytypgrp = '1';
    if (this.getters.arr_selectedTemplate.subTemplateId == '2') {
      date = this.getters.int_selectedParlayDate;
      plytypgrp = '5';
    }
    var gameMenuId = 0;
    if (this.getters.arr_selectedTemplate.gameMenuId) {
      gameMenuId = this.getters.arr_selectedTemplate.gameMenuId;
    }
    if (payload.isGameBanner || this.getters.isSpecial) {
      gameMenuId = 1;
    } else if (this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId;
    }

    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = _baseUrl + '/sport-league-list-preview';
    } else {
      url = _baseUrl + '/sport-league-list';
    }

    __WEBPACK_IMPORTED_MODULE_6__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);
    this.commit('SUBLOAD', true);

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: url,
      data: {
        sprtid: this.getters.isGameBannerSelected ? this.getters.gameBannerSportId : this.getters.arr_selectedTemplate.sportId,
        schedule: 4,
        date: date,
        plytypgrp: plytypgrp,
        langId: window._langid,
        sort: this.getters.selectedSort,
        spread: this.getters.account.spread,
        gameMenuId: gameMenuId,
        enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
        token: payload.token
      }
    }).done(function (res) {
      var stateArr = [];
      _this5.commit('TODAYRBEVENTLIST', []);
      _this5.commit('TODAYRBLEAGUELIST', {});
      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(res.leagues).length > 0) {
        _this5.commit('TODAYRBLEAGUELIST', res.leagues);
        _this5.commit('SUBLOAD', false);

        if (!_this5.getters.isShowFilter) {
          _this5.dispatch('getTodayRBSportOdds', {
            loading: 1,
            token: token.arr_2,
            state: _this5.getters.selectedState ? _this5.getters.selectedState : ''
          });
        }
        if (payload && payload.callback) {
          return payload.callback(res);
        }
        var newLeague = '';
        if (res.leagues.length > 0) {
          newLeague = _.sortBy(res.leagues, function (obj) {
            return obj.f;
          });

          _this5.commit('SORTEDLEAGUELIST', newLeague);

          var filterLeagues = _(newLeague).groupBy(function (o) {
            return o.f.toUpperCase();
          }).map(function (leg, cap) {
            return { cap: cap, leg: leg };
          }).value();

          _this5.commit('SELECTED_CHAR', filterLeagues[0].cap);
          _this5.commit('FILTERLEAGUELIST', filterLeagues);
        }
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  selectLeague: function selectLeague(context, callback) {
    if (callback.leagueid) {
      var lgecapt = '';
      if (this.getters.arr_selectedTemplate.subTemplateId == 3) {
        lgecapt = callback.capt;
      } else {
        lgecapt = callback.lgecapt;
      }
      this.commit('SELECTED_LEAGUE', {
        leagueid: callback.leagueid,
        lgecapt: lgecapt,
        c: callback.c
      });
    }
  },
  getSportEventList: function getSportEventList(context, payload) {
    var _this6 = this;

    payload = payload ? payload : {};

    var ajaxData = {
      schedule: payload.market ? payload.market : state.selectedMarket,
      spread: this.getters.account.spread,
      gameMenuId: 0
    };

    if (payload.isGameBanner || this.getters.isSpecial) {
      ajaxData.gameMenuId = 1;
    } else if (this.getters.isGameBannerSelected) {
      ajaxData.gameMenuId = this.getters.gameBannerId;
    }

    ajaxData.token = payload.token;

    var url = '';

    if (this.getters.account.previewFlag == true) {
      url = '/sport-event-list-preview';
    } else {
      url = '/sport-event-list';
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData
    }).done(function (res) {
      if (!ajaxData.gameMenuId) {
        if (state.selectedMarket == state.market.inPlayMarket.key || payload.market == state.market.inPlayMarket.key) {
          _this6.commit('SPORT_INPLAY_EVENTS', res.totalMatch);
        } else {
          _this6.commit('SPORT_ALL_EVENTS', res.totalMatch);
        }
      }
      if (payload) {
        if (payload.callback) return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getSportCount: function getSportCount(context, payload) {
    var _this7 = this;

    var url = '';

    if (this.getters.account.previewFlag == true) {
      url = '/sport-count-preview';
    } else {
      url = '/sport-count';
    }
    var ajaxData = {
      enableLoading: false
    };
    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData
    }).done(function (res) {
      _this7.commit('ALLSPORTCOUNT', res.allCount);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getSportCountByMarket: function getSportCountByMarket(context, payload) {
    var _this8 = this;

    var url = '';
    var ajaxData = {
      enableLoading: false
    };
    if (this.getters.account.previewFlag == true) {
      url = '/sport-count-market-preview';
    } else {
      url = '/sport-count-market';
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData
    }).done(function (res) {
      _this8.commit('SPORTCOUNTMARKET', res.countMarket);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getEarlyEventCountByDate: function getEarlyEventCountByDate(context, payload) {
    var _this9 = this;

    var url = '';
    var ajaxData = {
      enableLoading: false
    };
    if (this.getters.account.previewFlag == true) {
      url = '/event-count-bydate-preview';
    } else {
      url = '/event-count-bydate';
    }

    __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
      method: 'get',
      url: window._baseUrl + url,
      data: ajaxData
    }).done(function (res) {
      _this9.commit('EARLYCOUNT_BYDATE', res.countByDate);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_56" /* SPORT_LIST */], function (state, payload) {
  state.arr_sportList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* ALLSPORTCOUNT */], function (state, payload) {
  state.arr_sportAll = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_52" /* SPORTBETTYPELIST */], function (state, payload) {
  state.sportBettypeList = _.keyBy(payload, 'sprtId');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_24" /* SELECTED_MARKET */], function (state, payload) {
  state.int_selectedMarket = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["T" /* LEAGUELIST */], function (state, payload) {
  state.arr_leagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["u" /* FILTERLEAGUELIST */], function (state, payload) {
  state.arr_filterLeagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_48" /* SORTEDLEAGUELIST */], function (state, payload) {
  state.arr_sortedLeagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_21" /* SELECTED_LEAGUE */], function (state, payload) {
  state.arr_selectedLeague = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_6" /* PARLAYDATELIST */], function (state, payload) {
  state.arr_earlyParlayDateList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_27" /* SELECTED_PAYLAY_DATE */], function (state, payload) {
  state.int_selectedParlayDate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_20" /* SELECTED_EVENT */], function (state, payload) {
  state.arr_selectedEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_23" /* SELECTED_LEAGUES */], function (state, payload) {
  state.arr_selectedLeagues = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* ARR_LEAGUES */], function (state, payload) {
  state.arr_leagues = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_38" /* SHOW_CALENDAR */], function (state, payload) {
  state.showCalendarBox = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_33" /* SEL_MATCH */], function (state, payload) {
  state.selectedMatches = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["L" /* IS_PARLAY */], function (state, payload) {
  state.isParlay = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["Q" /* IS_SPECIAL */], function (state, payload) {
  state.isSpecial = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["R" /* IS_VIP */], function (state, payload) {
  state.isVip = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["M" /* IS_PLACE_BET */], function (state, payload) {
  state.isPlaceBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["N" /* IS_PROCESS_BET */], function (state, payload) {
  state.isProcessBet = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_66" /* TOTALPAGE */], function (state, payload) {
  state.totalPage = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_26" /* SELECTED_PAGE */], function (state, payload) {
  state.selectedPage = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["z" /* GAMEBANNER_SELECTED */], function (state, payload) {
  state.isGameBannerSelected = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_55" /* SPORT_ALL_EVENTS */], function (state, payload) {
  state.sportAllEvents = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_62" /* S_ODD */], function (state, payload) {
  state.s_odd = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["H" /* IS_CORRECTSCORE */], function (state, payload) {
  state.isCorrectScore = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_8" /* PARLAY_SPORT_LIST */], function (state, payload) {
  state.parlaySportList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_57" /* SPORT_SELECTED */], function (state, payload) {
  state.sportSelected = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_53" /* SPORTCOUNTMARKET */], function (state, payload) {
  state.arr_sportCountMarket = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["K" /* IS_OTR */], function (state, payload) {
  state.isOtr = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["O" /* IS_RESULT */], function (state, payload) {
  state.isResult = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["p" /* EARLYCOUNT_BYDATE */], function (state, payload) {
  state.arr_earlyEventCountByDate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_64" /* TODAYRBLEAGUELIST */], function (state, payload) {
  state.todayRBLeagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_19" /* SELECTED_CHAR */], function (state, payload) {
  state.selectedChar = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_22" /* SELECTED_LEAGUELIST */], function (state, payload) {
  state.arr_selectedLeagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_17" /* SELECTEDLEAGUES */], function (state, payload) {
  state.selectedLeagues = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_65" /* TOTALLEAGUES */], function (state, payload) {
  state.totalLeagues = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_54" /* SPORTLIST */], function (state, payload) {
  state.sportList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_13" /* REFRESH_SPORTTABLE */], function (state, payload) {
  state.reloadSportTable = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* CHANGE_ODDS */], function (state, payload) {
  state.changeOdds = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_61" /* SWIPE_MODE */], function (state, payload) {
  state.swipe = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* IS_COLLAPSE_MATCH */], function (state, payload) {
  if (payload == '-1') {
    if (!window.hideLeagues) {
      state.isCollapseMatch = [];
    }
  }
  if (_.isUndefined(state.isCollapseMatch[payload.sport])) {
    state.isCollapseMatch[payload.sport] = [];
  }
  if (!_.isUndefined(payload.sport) && !_.isUndefined(payload.lid)) {
    if (payload.lid == '-1') {
      state.isCollapseMatch[payload.sport] = [];
    } else if (_.indexOf(state.isCollapseMatch[payload.sport], payload.lid) < 0) {
      state.isCollapseMatch[payload.sport].push(payload.lid);
    } else {
      state.isCollapseMatch[payload.sport].splice(_.indexOf(state.isCollapseMatch[payload.sport], payload.lid), 1);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_39" /* SHOW_END */], function (state, payload) {
  state.showEnd = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* ALLOW_LANDSACPE */], function (state, payload) {
  state.allowLanscape = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["_43" /* SHOW_NOSCROLLEND */], function (state, payload) {
  state.showNoScrollEnd = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["I" /* IS_HIDE_LEAGUE */], function (state, payload) {
  if (payload == false) {
    if (!window.hideLeagues) {
      state.isHideLeague = [];
    }
  } else if (!_.isUndefined(payload.sport) && !_.isUndefined(payload.status)) {
    state.isHideLeague[payload.sport] = payload.status;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* DEFAULT_SPORT */], function (state, payload) {
  state.defaultSport = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["A" /* GAME_BANNER_ID */], function (state, payload) {
  state.gameBannerId = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["B" /* GAME_BANNER_SPORT_ID */], function (state, payload) {
  state.gameBannerSportId = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["P" /* IS_RESULT_SCHEDULE */], function (state, payload) {
  state.isresult_schedule = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["x" /* FILTER_SELECT_ALL */], function (state, payload) {
  state.filter_select_all = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SC_CS_HIDE', function SC_CS_HIDE(state, payload) {
  state.sc_cs_hide = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SCHEDULE_SPORT', function SCHEDULE_SPORT(state, payload) {
  state.schedule_sprt = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'MARKET_BUTTON_TOGGLE', function MARKET_BUTTON_TOGGLE(state, payload) {
  state.market_button_toggle = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SUBMENU_STATUS', function SET_SUBMENU_STATUS(state, payload) {
  state.subMenuStatus = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SELECTEDDATE', function SELECTEDDATE(state, payload) {
  state.selected_date = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SELECTEDTIMEZONE', function SELECTEDTIMEZONE(state, payload) {
  state.selected_timezone = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SELECTEDLEAGUE', function SELECTEDLEAGUE(state, payload) {
  state.selected_league = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SELECTEDCOUNTRY', function SELECTEDCOUNTRY(state, payload) {
  state.selected_country = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_core_core__ = __webpack_require__(29);




var _mutations;





var state = {
  account: null,
  tvIconFlag: window.tvIconFlag,
  privateMessageCount: 0,
  chipSetting: {
    chipAmountOption: {
      min: 50,
      med: 150,
      big: 250,
      big2: 500,
      big3: 1000,
      max: 0
    }
  },
  passcode: {
    noShowAgainModel: false,
    noShowAgainList: [],
    showReminder: true
  },
  userdetail: {
    usrn: '-1'
  },
  timeZone: window._timeZone,
  editionStand: window._editionStand,
  previous_edition: window._editionStand == 3 ? 1 : window._editionStand,
  sortHot: window._sortHot,
  skinTheme: window._skinTheme,
  betterOdds: window._betterOdds,
  filterLeague: window._filterLeague,
  _theme: window.theme,
  accSetting: window.accSetting,
  accTimeZone: window._accTimeZone,
  comp_token: window.comp_token,
  accBetSetting: window.accBetSetting,
  _sortHot: window.sortHot,
  _betterOdds: window.betterOdds,
  _editionStand: window.edition,
  _filterLeague: window.filterLeague,
  showOdds: window.showOdds == 0 ? false : true
};

var getters = {
  account: function account(state) {
    return state.account;
  },
  timeZone: function timeZone(state) {
    return state.timeZone;
  },
  editionStand: function editionStand(state) {
    return state.editionStand;
  },
  previous_edition: function previous_edition(state) {
    return state.previous_edition;
  },
  sortHot: function sortHot(state) {
    return state.sortHot;
  },
  tvIconFlag: function tvIconFlag(state) {
    return state.tvIconFlag;
  },
  privateMessageCount: function privateMessageCount(state) {
    return state.privateMessageCount;
  },
  chipSetting: function chipSetting(state) {
    return state.chipSetting;
  },
  passcode: function passcode(state) {
    return state.passcode;
  },
  skinTheme: function skinTheme(state) {
    return state.skinTheme;
  },
  betterOdds: function betterOdds(state) {
    return state.betterOdds;
  },
  filterLeague: function filterLeague(state) {
    return state.filterLeague;
  },
  _theme: function _theme(state) {
    return state._theme;
  },
  accSetting: function accSetting(state) {
    return state.accSetting;
  },
  accTimeZone: function accTimeZone(state) {
    return state.accTimeZone;
  },
  comp_token: function comp_token(state) {
    return state.comp_token;
  },
  _sortHot: function _sortHot(state) {
    return state._sortHot;
  },
  _betterOdds: function _betterOdds(state) {
    return state._betterOdds;
  },
  _editionStand: function _editionStand(state) {
    return state._editionStand;
  },
  _filterLeague: function _filterLeague(sttae) {
    return state._filterLeague;
  },
  showOdds: function showOdds(sttae) {
    return state.showOdds;
  },
  accBetSetting: function accBetSetting(state) {
    return state.accBetSetting;
  },
  chipAmountOption: function chipAmountOption(state, getters) {
    if (getters.account.previewFlag == true) {
      return state.chipSetting.chipAmountOption;
    }

    if (state.accBetSetting == null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.accBetSetting).length == 0) {
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        data: {
          com_code: window.compcode,
          acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.chipSetting.chipAmountOption),
          acc_code: getters.account.acccode,
          enableLoading: false
        }
      }).done(function (res) {});
      return state.chipSetting.chipAmountOption;
    } else {
      return state.accBetSetting;
    }
  },
  userdetail: function userdetail(state, getters) {
    if (!__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get('UID')) {
      __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set('UID', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userdetail));
      return state.userdetail;
    } else {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get('UID'));
    }
  },
  noShowAgainList: function noShowAgainList(state, getters) {
    if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_xrmd')) {
      state.passcode.noShowAgainList = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_xrmd'));
      return state.passcode.noShowAgainList;
    }
    return state.passcode.noShowAgainList;
  }
};

var actions = {
  getAnn: function getAnn(context, payload) {
    var _this = this;

    var params = payload.params;
    var token_val = params.token;
    if (params.token == '' || params.token == undefined) {
      var token_val = token.arr_7;
    }
    params.token = token_val;
    this.commit('FULL_LOAD', true);
    __WEBPACK_IMPORTED_MODULE_5__js_core_core__["default"].$ajax({
      url: window._baseUrl + '/annhistory/getAnn',
      type: 'get',
      data: params
    }).done(function (response) {
      if (params.selAnn == '3' || params.selAnn == '2') {
        state.privateMessageCount = response.c;
      }
      _this.commit('FULL_LOAD', false);
      if (payload.callback) {
        return payload.callback(response);
      }
    });
  },
  logoutAccount: function logoutAccount(context, payload) {
    __WEBPACK_IMPORTED_MODULE_5__js_core_core__["default"].$ajax({
      method: 'post',
      url: _baseUrl + '/login',
      data: {
        action: 'logout',
        enableLoading: false,
        token: token.arr_10
      }
    }).done(function (res) {
      console.log(res);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["a" /* ACCOUNT */], function (state, payload) {
  payload.selectedMarket = null;
  state.account = payload;

  if (this.getters.accSetting && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.getters.accSetting).length > 0) {
    var accCookie = this.getters.accSetting;
    state.account.oddsType = accCookie.oddsType;
    if (typeof accCookie.showReminder !== 'undefined') {
      state.account.showReminder = accCookie.showReminder;
      state.passcode.showReminder = accCookie.showReminder;
    }
  }

  if (!state.accSetting || !state.comp_token || state.account.oddsType != state.accSetting.oddsType || btoa(account.acccode) != state.comp_token) {
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        com_code: window.compcode,
        acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.account),
        tkn: btoa(state.account.acccode)
      }
    }).done(function (res) {});
  }

  var userdetail = {
    usrn: ''
  };

  if (!__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get('UID')) {
    userdetail.usrn = this.getters.account.usrn;
    if (!window.pch) {
      userdetail.usrn = '-1';
    }
    state.userdetail = userdetail;
    __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set('UID', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userdetail));
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_25" /* SELECTED_ODD */], function (state, payload) {
  var accCookie = state.accSetting;
  accCookie.oddsType = payload;
  state.account = accCookie;

  $.ajax({
    method: 'post',
    url: _baseUrl + '/callCookies',
    async: false,
    data: {
      com_code: window.compcode,
      acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.account)
    }
  }).done(function (res) {});
  if (this.getters.arr_selectedTemplate.templateId == 3) {
    this.dispatch('getSportOdds', { token: token.arr_4 });
  } else if (this.getters.arr_selectedTemplate.templateId == 6) {
    var event = this.getters.arr_selectedEvent;
    this.dispatch('getSportAllBet', {
      event: event,
      token: token.arr_4
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["c" /* ACC_CHIP_SETTING */], function (state, payload) {
  var chipAmountOption = {
    min: 0,
    med: 0,
    big: 0
  };

  if (payload && payload.isBetting) {
    if (state.accBetSetting == null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.accBetSetting).length == 0) {
      $.ajax({
        method: 'post',
        url: _baseUrl + '/callCookies',
        async: false,
        data: {
          com_code: window.compcode,
          acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.chipSetting.chipAmountOption),
          acc_code: this.getters.account.acccode
        }
      }).done(function (res) {});
      chipAmountOption = state.chipSetting.chipAmountOption;
    } else {
      chipAmountOption = state.accBetSetting;
    }
    chipAmountOption.max = payload.minMax.max;
    state.chipSetting.minMax = payload.minMax;
  } else {
    chipAmountOption = {
      min: payload.min,
      med: payload.med,
      big: payload.big
    };
  }

  state.chipSetting.chipAmountOption = chipAmountOption;

  $.ajax({
    method: 'post',
    url: _baseUrl + '/callCookies',
    data: {
      com_code: window.compcode,
      acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.chipSetting.chipAmountOption),
      acc_code: this.getters.account.acccode
    }
  }).done(function (res) {});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_ACC_CHIP_SETTING', function SET_ACC_CHIP_SETTING(state, payload) {
  if (state.accBetSetting == null || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state.accBetSetting).length == 0) {
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        com_code: window.compcode,
        acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.chipSetting.chipAmountOption),
        acc_code: state.account.acccode,
        callback: 1
      }
    }).done(function (res) {
      state.accBetSetting = JSON.parse(res);
    });
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_10" /* PASSCODE */], function (state, payload) {
  state.passcode = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SHOW_PASSCODE_REMINDER', function SHOW_PASSCODE_REMINDER(state, payload) {
  state.passcode.showReminder = payload;

  if (state.accSetting) {
    state.account.showReminder = payload;

    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        com_code: window.compcode,
        acc: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.account)
      }
    }).done(function (res) {});
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'CLOSE_REMINDER', function CLOSE_REMINDER(state, payload) {
  state.passcode.noShowAgainModel = payload.noShow;
  if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_xrmd')) {
    state.passcode.noShowAgainList = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(window.compcode + '_xrmd'));
  }
  var accIndex = state.passcode.noShowAgainList.indexOf(payload.accCode);
  if (accIndex !== -1) {
    if (payload.noShow) {
      state.passcode.noShowAgainList.push(payload.accCode);
    } else {
      state.passcode.noShowAgainList.splice(accIndex, 1);
    }
  } else {
    if (payload.noShow) {
      state.passcode.noShowAgainList.push(payload.accCode);
    }
  }
  __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set(window.compcode + '_xrmd', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.passcode.noShowAgainList));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'NO_SHOW_AGAIN_LIST', function NO_SHOW_AGAIN_LIST(state, payload) {
  state.passcode.noShowAgainList = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_UID', function SET_UID(state, payload) {
  var userdetail = {
    usrn: ''
  };

  userdetail.usrn = this.getters.account.usrn;
  if (window.pch && window.pch != '') {
    userdetail.nsid = window.pch;
  }
  state.userdetail = userdetail;
  __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set('UID', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userdetail));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'REMOVE_UID', function REMOVE_UID(state, payload) {
  if (__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get('UID') && JSON.parse(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get('UID')).usrn !== this.getters.account.usrn) {
    var userdetail = {
      usrn: '-1'
    };
    __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.set('UID', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(userdetail));
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'TIME_ZONE', function TIME_ZONE(state, payload) {
  state.timeZone.default = payload;

  if (!state.accTimeZone || state.accTimeZone && state.accTimeZone != stringify(stkset)) {
    var stkset = {
      default: payload,
      timeS: state.timeZone.list[payload][0],
      timeA: state.timeZone.list[payload][1],
      format: state.timeZone.format
    };
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        action: 'timeZone',
        timeZoneSet: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(stkset),
        acc_code: state.account.acccode
      }
    }).done(function (res) {});
    state.accTimeZone = stringify(stkset);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SORT_HOT', function SORT_HOT(state, payload) {
  state.sortHot = payload;

  if (!state._sortHot || state._sortHot && state._sortHot != state.sortHot) {
    $.ajax({
      method: "post",
      url: _baseUrl + "/callCookies",
      async: false,
      data: {
        action: "sortHot",
        sortHotSet: state.sortHot,
        acc_code: state.account.acccode
      }
    }).done(function (res) {});
  }
  if (state.sortHot != this.getters.selectedSort) {
    this.commit('SELECTED_SORT', payload);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SKIN_THEME', function SKIN_THEME(state, payload) {
  state._theme = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'EDITIONSTAND', function EDITIONSTAND(state, payload) {
  state.editionStand = payload;

  if (!state._editionStand || state._editionStand && state._editionStand != state.editionStand) {
    $.ajax({
      method: "post",
      url: _baseUrl + "/callCookies",
      async: false,
      data: {
        action: "edition",
        editionStandSet: state.editionStand,
        acc_code: state.account.acccode
      }
    }).done(function (res) {});
    state._editionStand = state.editionStand;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'BETTER_ODDS', function BETTER_ODDS(state, payload) {
  state.betterOdds = payload;

  if (!state._betterOdds || state._betterOdds && state._betterOdds != state.betterOdds) {
    $.ajax({
      method: "post",
      url: _baseUrl + "/callCookies",
      async: false,
      data: {
        action: "betterOdds",
        betterOddsSet: state.betterOdds,
        acc_code: state.account.acccode
      }
    }).done(function (res) {});
    state._betterOdds = state.betterOdds;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'FILTER_LEAGUE', function FILTER_LEAGUE(state, payload) {
  state.filterLeague = payload;

  if (!state._filterLeague || state._filterLeague && state._filterLeague != state.filterLeague) {
    $.ajax({
      method: "post",
      url: _baseUrl + "/callCookies",
      async: false,
      data: {
        action: "filterLeague",
        filterLeagueSet: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.filterLeague),
        acc_code: state.account.acccode
      }
    }).done(function (res) {});
    state._filterLeague = state.filterLeague;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'PREVIOUS_EDITION', function PREVIOUS_EDITION(state, payload) {
  state.previous_edition = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SHOW_ODDS_TOGGLE', function SHOW_ODDS_TOGGLE(state, payload) {
  state.showOdds = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["b" /* ACCOUNT_FAV */], function (state, payload) {
  if (!__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(state.account.acccode + '_accfavlg_event') || __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(state.account.acccode + '_accfavlg_event') && __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a.get(state.account.acccode + '_accfavlg_event') != __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload.favdt)) {
    $.ajax({
      method: 'post',
      url: _baseUrl + '/callCookies',
      async: false,
      data: {
        action: payload.isFavLeague == '1' ? 'favLeagueEvent' : 'favEvent',
        fav: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(payload.favdt),
        acc_code: this.getters.account.acccode
      }
    }).done(function (res) {});
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_core_core__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__ = __webpack_require__(6);


var _mutations;






var state = {
  arr_selectedTemplate: {},
  arr_breadcumb: []
};

var getters = {
  arr_selectedTemplate: function arr_selectedTemplate(state) {
    return state.arr_selectedTemplate;
  },
  arr_breadcumb: function arr_breadcumb(state) {
    return state.arr_breadcumb;
  }
};

var actions = {
  changeTemplate: function changeTemplate(context, payload) {
    payload.int_marketToggle = this.getters.int_marketToggle;
    this.commit('ARR_BREADCUMB', payload);
    var params = {
      templateId: payload.templateId,
      bettypeid: payload.bettypeid,
      sportId: payload.sportId,
      marketKey: payload.marketKey,
      plytype: payload.plytype,
      int_marketToggle: this.getters.int_marketToggle,
      subTemplateId: payload.subTemplateId,
      date: payload.date
    };
    if (payload.eveid) {
      params.eveid = payload.eveid;
    }

    this.commit('SELECTED_TEMPLATE', params);
    this.commit('SELECTED_MARKET', payload.marketKey);
    this.commit('SHOW_LEDGER', false);
  },
  redirectReturn: function redirectReturn(context, payload) {
    this.commit('ARR_BREADCUMB', {
      return: true
    });
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_31" /* SELECTED_TEMPLATE */], function (state, payload) {
  state.arr_selectedTemplate = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* ARR_BREADCUMB */], function (state, payload) {
  if (payload.return) {
    state.arr_breadcumb.splice(-1, 1);
    if (state.arr_breadcumb.length == 0) {
      if (this.getters.account.previewFlag == true) {
        location.href = "preview?authtoken=" + window.authtoken;
      } else {
        location.href = "home?authtoken=" + window.authtoken;
      }

      return;
    }
    if (state.arr_breadcumb[state.arr_breadcumb.length - 1]['templateId'] == '18') {
      location.href = "home?authtoken=" + window.authtoken;
      return;
    }
    if (state.arr_breadcumb.length == 0) {
      state.arr_selectedTemplate = {
        templateId: 1
      };
      this.dispatch('getEventList', {
        market: 3
      });
      this.commit('MARKETTOGGLE', '3');
    } else {
      state.arr_selectedTemplate = state.arr_breadcumb[state.arr_breadcumb.length - 1];
      if (state.arr_breadcumb[state.arr_breadcumb.length - 1].int_marketToggle) {
        this.commit('MARKETTOGGLE', state.arr_breadcumb[state.arr_breadcumb.length - 1].int_marketToggle);
      }
      this.commit('MARKET_BUTTON_TOGGLE', false);
      this.commit('IS_RESULT_SCHEDULE', false);

      if (state.arr_selectedTemplate.templateId == '2') {
        var date = state.arr_selectedTemplate.int_marketToggle == "1" || state.arr_selectedTemplate.int_marketToggle == "3" ? 0 : 99;
        this.commit('SELECTED_PAYLAY_DATE', date);
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshLeague');
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshSportHeaderSelection');
      } else if (state.arr_selectedTemplate.templateId == '3') {
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshSportTable');
      } else if (state.arr_selectedTemplate.templateId == '4') {
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshEvents');
      } else if (state.arr_selectedTemplate.templateId == '5') {
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshSportOutrightTable');
      } else if (state.arr_selectedTemplate.templateId == '6') {
        __WEBPACK_IMPORTED_MODULE_3__vue_events_event_bus__["a" /* default */].$emit('refreshAllBet');
      }
    }
  } else {
    history.pushState(null, null, location.href);
    state.arr_breadcumb.push(payload);
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_core_core__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__ = __webpack_require__(6);






var _mutations;






var state = {
  arr_eventList: [],
  selectedSort: 2,
  sortedEvents: null,
  arr_liveLeague: [],
  arr_liveEventList: [],
  arr_parlayTdyEventList: [],
  arr_parlayEarlyEventList: [],
  arr_specialEventLeague: [],
  selectedState: null,
  stateList: [],
  favouriteEvents: {},
  favouriteLgeEvents: {},
  selectedBettype: null,
  sortedFavRbEventList: [],
  sortedMatchEventList: [],
  showFavEvents: false,
  favrbeventList: [],
  favotreventList: [],
  sortedFavOtrEventList: [],
  arr_todayRBEventList: [],
  sortedTodayRBEvents: null,
  hideLegHeader: [],
  lableHeader: [],
  arr_otrEventList: [],
  virtualDataList: [],
  showLegCapt: [],
  legCaptDataList: [],
  otrHideLegList: {},
  otrHideTitleList: [],
  otrHideFavLegList: {},
  otrHideFavTitleList: [],
  filter_leagueList: [],
  hotMatchList: [],
  schedule: 1,
  playtype: 1,
  favouriteTeams: {}
};

var getters = {
  arr_eventList: function arr_eventList(state) {
    return state.arr_eventList;
  },
  selectedSort: function selectedSort(state) {
    return state.selectedSort;
  },
  sortedEvents: function sortedEvents(state) {
    return state.sortedEvents;
  },
  arr_liveLeague: function arr_liveLeague(state) {
    return state.arr_liveLeague;
  },
  arr_liveEventList: function arr_liveEventList(state) {
    return state.arr_liveEventList;
  },
  arr_parlayTdyEventList: function arr_parlayTdyEventList(state) {
    return state.arr_parlayTdyEventList;
  },
  arr_parlayEarlyEventList: function arr_parlayEarlyEventList(state) {
    return state.arr_parlayEarlyEventList;
  },
  arr_specialEventLeague: function arr_specialEventLeague(state) {
    return state.arr_specialEventLeague;
  },
  selectedState: function selectedState(state) {
    return state.selectedState;
  },
  stateList: function stateList(state) {
    return state.stateList;
  },
  favouriteEvents: function favouriteEvents(state) {
    return state.favouriteEvents;
  },
  favouriteLgeEvents: function favouriteLgeEvents(state) {
    return state.favouriteLgeEvents;
  },
  selectedBettype: function selectedBettype(state) {
    return state.selectedBettype;
  },
  sortedFavRbEventList: function sortedFavRbEventList(state) {
    return state.sortedFavRbEventList;
  },
  sortedMatchEventList: function sortedMatchEventList(state) {
    return state.sortedMatchEventList;
  },
  showFavEvents: function showFavEvents(state) {
    return state.showFavEvents;
  },
  favrbeventList: function favrbeventList(state) {
    return state.favrbeventList;
  },
  favotreventList: function favotreventList(state) {
    return state.favotreventList;
  },
  sortedFavOtrEventList: function sortedFavOtrEventList(state) {
    return state.sortedFavOtrEventList;
  },
  arr_todayRBEventList: function arr_todayRBEventList(state) {
    return state.arr_todayRBEventList;
  },
  sortedTodayRBEvents: function sortedTodayRBEvents(state) {
    return state.sortedTodayRBEvents;
  },
  hideLegHeader: function hideLegHeader(state) {
    return state.hideLegHeader;
  },
  lableHeader: function lableHeader(state) {
    return state.lableHeader;
  },
  arr_otrEventList: function arr_otrEventList(state) {
    return state.arr_otrEventList;
  },
  virtualDataList: function virtualDataList(state) {
    return state.virtualDataList;
  },
  showLegCapt: function showLegCapt(state) {
    return state.showLegCapt;
  },
  legCaptDataList: function legCaptDataList(state) {
    return state.legCaptDataList;
  },
  otrHideLegList: function otrHideLegList(state) {
    return state.otrHideLegList;
  },
  otrHideTitleList: function otrHideTitleList(state) {
    return state.otrHideTitleList;
  },
  otrHideFavLegList: function otrHideFavLegList(state) {
    return state.otrHideFavLegList;
  },
  otrHideFavTitleList: function otrHideFavTitleList(state) {
    return state.otrHideFavTitleList;
  },
  filter_leagueList: function filter_leagueList(state) {
    return state.filter_leagueList;
  },
  schedule: function schedule(state) {
    return state.schedule;
  },
  playtype: function playtype(state) {
    return state.playtype;
  },
  favouriteTeams: function favouriteTeams(state) {
    return state.favouriteTeams;
  },
  hotMatchList: function hotMatchList(state) {
    return state.hotMatchList;
  }
};

var actions = {
  getSportOdds: function getSportOdds(context, payload) {
    var _this = this;

    var bool_loading = false;
    if (payload && payload.loading == '1') {
      bool_loading = true;
    }
    var httpMethod = 'get';

    var data = {
      sprtid: this.getters.selectedSport,
      schedule: this.getters.schedule,
      lang: window._langid,

      sdate: this.getters.selected_date,
      timezone: this.getters.selected_timezone,
      plytypgrp: this.getters.playtype,
      enableLoading: bool_loading,
      token: payload.token
    };

    if (data.plytypgrp == 2 && this.getters.selected_league) {
      data.league = this.getters.selected_league;
    }
    if (data.plytypgrp == 3 && this.getters.selected_country) {
      data.country = this.getters.selected_country;
    }

    var url = window._baseUrl + '/sport-odds-preview';


    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {

      var events = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.events);

      if (!_this.getters.s_odd && _this.getters.arr_selectedLeague && _this.getters.arr_selectedLeague.leagueid && res.events && res.events.length > 0) {
        var c = _this.getters.arr_selectedLeague.c;
        _this.dispatch('selectLeague', {
          leagueid: res.events[0][0].lgeid,
          lgecapt: res.events[0][0].lgecapt,
          c: c
        });
      }
      _this.commit('TODAYRBEVENTLIST', []);
      _this.commit('EVENTLIST', events);
      if (_this.getters.arr_selectedTemplate.subTemplateId == '4') {
        _this.commit('CSODDSEVENT', events);
      }
      _this.commit('TOTALPAGE', res.ttlPg);
      if (_this.getters.selectedPage > res.ttlPg) {
        _this.commit('SELECTED_PAGE', res.ttlPg);
      }
      if (res.earlyParlayDateList) {
        _this.commit('PARLAYDATELIST', earlyParlayDateList);
      }
      _this.commit('LOADINGSCREEN', false);

      _this.dispatch('sortEvents');
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });

    if (this.getters.playtype == 1) {
      this.dispatch('getHotMatch', {
        data: data
      });
    }
  },
  getHotMatch: function getHotMatch(context, payload) {
    var _this2 = this;

    var httpMethod = 'get';
    var url = window._baseUrl + '/hot-matches-preview';


    payload['data']['action'] = 'gethotMatch';
    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: payload['data']
    }).done(function (res) {
      _this2.commit('HOT_MATCH_LIST', res);
    });
  },
  getTodayRBSportOdds: function getTodayRBSportOdds(context, payload) {
    var _this3 = this;

    var bool_loading = true;
    if (payload && payload.loading == '1') {
      bool_loading = false;
    }

    var bettype = this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;

    var schedule = 4;
    var date = '0';
    var httpMethod = 'post';

    if (payload && payload.livetv) {
      bettype = payload.sportId ? payload.sportId : "";
      plytype = payload.playType ? payload.playType : "";
      schedule = payload.schedule ? payload.schedule : "";
      date = payload.sDate;
    }

    if (this.getters.arr_selectedTemplate.subTemplateId == '2') {
      date = this.getters.int_selectedParlayDate;
      plytype = '5';
    }

    var gameMenuId = 0;
    if (this.getters.arr_selectedTemplate.gameMenuId) {
      gameMenuId = this.getters.arr_selectedTemplate.gameMenuId;
    }
    if (payload.isGameBanner || this.getters.isSpecial) {
      gameMenuId = 1;
    } else if (this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId;
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      page: 0,
      sorttyp: this.getters.selectedSort,
      date: date,
      sdate: this.getters.selected_date,
      timezone: this.getters.selected_timezone,
      plytypgrp: plytype,
      gameMenuId: gameMenuId,
      enableLoading: bool_loading,
      token: payload.token
    };

    if (!this.getters.showFavEvents) {
      var lgList = [];
      if (this.getters.todayRBLeagueList && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.getters.todayRBLeagueList).length > 0) {
        __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(this.getters.todayRBLeagueList, function (d, k) {
          lgList.push(d.id);
        });
      }

      data.leagues = lgList;
    }

    if (this.getters.isShowFilter) {
      if (this.getters.arr_selectedLeagueList) {
        data.leagues = this.getters.arr_selectedLeagueList;
      }
    }

    if (this.getters.selectedSort) {
      data.sorttyp = this.getters.selectedSort;
    }

    var url = '';
    if (this.getters.cookieLeague) {
      var cookieLeague = this.getters.cookieLeague;
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(cookieLeague).length > 0) {
        url = window._baseUrl + '/sport-odds-leagues';
        var selectedMarket = this.getters.selectedMarket;
        var selectedSport = this.getters.arr_selectedTemplate.sportId;

        if (this.getters.isGameBannerSelected) {
          selectedBettype += 'gmBanner';
        }
        if (!this.getters.selectAllLeague) {
          if (cookieLeague[selectedMarket]) {
            if (cookieLeague[selectedMarket][selectedSport] && cookieLeague[selectedMarket][selectedSport].length > 0) {
              data.leagues = cookieLeague[selectedMarket][selectedSport];
            } else {
              if (this.getters.account.previewFlag == true) {
                url = window._baseUrl + '/sport-odds-leagues-preview';
                if (this.getters.s_odd) {
                  url = window._baseUrl + '/sport-odds-preview';
                }
              } else {
                url = window._baseUrl + '/sport-odds-leagues';
                if (this.getters.s_odd) {
                  url = window._baseUrl + '/sport-odds';
                }
              }
            }
          } else {
            if (this.getters.account.previewFlag == true) {
              url = window._baseUrl + '/sport-odds-leagues-preview';
              if (this.getters.s_odd) {
                url = window._baseUrl + '/sport-odds-preview';
              }
            } else {
              url = window._baseUrl + '/sport-odds-leagues';
              if (this.getters.s_odd) {
                url = window._baseUrl + '/sport-odds';
              }
            }
          }
        } else {
          if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-odds-leagues-preview';
            if (this.getters.s_odd) {
              url = window._baseUrl + '/sport-odds-preview';
            }
          } else {
            url = window._baseUrl + '/sport-odds-leagues';
            if (this.getters.s_odd) {
              url = window._baseUrl + '/sport-odds';
            }
          }
        }
      }
      if (this.getters.filter_select_all) {
        if (this.getters.account.previewFlag == true) {
          url = window._baseUrl + '/sport-odds-preview';
        } else {
          url = window._baseUrl + '/sport-odds';
        }
      }
    } else {
      if (this.getters.account.previewFlag == true) {
        url = window._baseUrl + '/sport-odds-leagues-preview';
        if (this.getters.s_odd) {
          url = window._baseUrl + '/sport-odds-preview';
        }
      } else {
        url = window._baseUrl + '/sport-odds-leagues';
        if (this.getters.s_odd) {
          url = window._baseUrl + '/sport-odds';
        }
        if (this.getters.filter_select_all) {
          if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-odds-preview';
          } else {
            url = window._baseUrl + '/sport-odds';
          }
        }
      }
    }
    var schdl = data.schedule;

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      data.gameMenuId = 0;
      delete data.leagues;
      delete data.schedule;
    }

    if (payload.showfavorite != undefined) {
      this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite);
    } else {}

    if (this.getters.showFavEvents) {
      httpMethod = 'post';

      if (this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId] && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]).length > 0) {
        data.events = this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId];
      } else {
        data.events = '0';
      }
      if (this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId] && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]).length > 0) {
        data.lgevents = this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId];
      } else {
        data.lgevents = '0';
      }

      url = window._baseUrl + '/sport-odds-favevents';

      if (data.token == undefined) {
        data.token = window.token.arr_7;
      }
      data.showFav = '1';
      data.schedule = schdl;
    }

    if (plytype == '5' && this.getters.account.oddsType != 'am') {
      data.odd = this.getters.oddTypesList.EU.key;
    }

    if (payload.sDate != null) {
      data.date = payload.sDate;
    } else {
      data.date = schedule == this.getters.market.earlyMarket.key ? this.getters.int_selectedParlayDate : '0';
      if (plytype == '5') {
        data.date = this.getters.int_selectedParlayDate;
      }
    }

    data.plytypgrp = plytype;
    if (plytype == '7' || plytype == '8' || plytype == '9' || plytype == '10') {
      data.plytypgrp = '1';
    }

    if (data.plytypgrp == '2' && this.getters.int_fullHalfTime == '2') {
      data.plytypgrp = '6';
    } else if (data.plytypgrp == '3' && this.getters.int_fullHalfTime == '2') {
      data.plytypgrp = '7';
    }

    if (this.getters.editionStand == '0') {
      if (this.getters.simDisp == '4') {
        data.plytypgrp = '4';
      } else if (this.getters.simDisp == '6') {
        data.plytypgrp = '12';
      }
    }

    data.gameMenuId = 0;
    if (this.getters.isGameBannerSelected) {
      data.sprtid = this.getters.gameBannerSportId;
      data.gameMenuId = this.getters.gameBannerId;
    }

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      delete data.schedule;
    }

    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.events);
      var events_rb = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.events_rb);
      var rbevents = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.rbevents);
      var earlyParlayDateList = res.earlyParlayDateList;

      if (!_this3.getters.s_odd && _this3.getters.arr_selectedLeague && _this3.getters.arr_selectedLeague.leagueid && res.events && res.events.length > 0) {
        var c = _this3.getters.arr_selectedLeague.c;
        _this3.dispatch('selectLeague', {
          leagueid: res.events[0][0].lgeid,
          lgecapt: res.events[0][0].lgecapt,
          c: c
        });
      }
      if (_this3.getters.showFavEvents) {
        _this3.commit('EVENTLIST', events);
        _this3.commit('TODAYRBEVENTLIST', rbevents);
      } else {
        _this3.commit('EVENTLIST', events);
        _this3.commit('TODAYRBEVENTLIST', events_rb);
      }
      if (_this3.getters.arr_selectedTemplate.subTemplateId == '4') {
        _this3.commit('CSODDSEVENT', events);
      }
      _this3.commit('TOTALPAGE', res.ttlPg);
      if (_this3.getters.selectedPage > res.ttlPg) {
        _this3.commit('SELECTED_PAGE', res.ttlPg);
      }
      if (res.earlyParlayDateList) {
        _this3.commit('PARLAYDATELIST', earlyParlayDateList);
      }
      _this3.commit('LOADINGSCREEN', false);

      if (res.data && res.plyTyp) {
        _this3.commit('LEAGUE_LIST', res.data);
        _this3.commit('PLY_TYPE', res.plyTyp);
      }

      _this3.dispatch('sortEvents');

      if (payload && payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getMarketTodayOdd: function getMarketTodayOdd(context, payload) {
    var vue = this;
    var havMatch = false;
    this.dispatch('getTodayRBLaugueList', {
      enableLoading: true,
      token: payload.token,
      isGameBanner: 0,
      callback: function callback(res) {
        vue.dispatch('getTodayRBSportOdds', {
          loading: 1,
          token: token.arr_2,
          state: vue.getters.selectedState ? vue.getters.selectedState : '',
          callback: function callback(res) {
            if (res && res.events.length > 0) {
              havMatch = true;
            }
          }
        }).then(function () {
          havMatch = true;
        });
      }
    }).then(function () {
      havMatch = true;
    });

    this.dispatch('getLaugueList', {
      enableLoading: true,
      token: payload.token,
      isGameBanner: 0,
      callback: function callback(res) {
        vue.dispatch('getSportOdds', {
          loading: 1,
          token: token.arr_2,
          state: vue.getters.selectedState ? vue.getters.selectedState : '',
          callback: function callback(res) {
            if (res && res.events.length > 0) {
              havMatch = true;
            }
          }
        }).then(function () {
          havMatch = true;
        });
      }
    }).then(function () {
      havMatch = true;
    });

    if (havMatch) {
      this.dispatch('sortEvents');
    }
  },
  getSpecialEventOdds: function getSpecialEventOdds(context, payload) {
    var _this4 = this;

    var leagueIds = [];
    var httpMethod = 'post';

    var bool_loading = true;
    if (payload && payload.loading == '1') {
      bool_loading = false;
    }

    var bettype = this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if (payload && payload.livetv) {
      bettype = payload.sportId ? payload.sportId : "";
      plytype = payload.playType ? payload.playType : "";
      schedule = payload.schedule ? payload.schedule : "";
      date = payload.sDate;
    } else {
      if (this.getters.int_selectedParlayDate && schedule == '2') {
        date = this.getters.int_selectedParlayDate;
      }
    }

    if (this.getters.arr_selectedTemplate.subTemplateId == '2') {
      date = this.getters.int_selectedParlayDate;
      plytype = '5';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: 1,
      date: date,
      plytypgrp: plytype,
      enableLoading: bool_loading,
      token: payload.token
    };

    var url = window._baseUrl + '/sport-odds-leagues';
    if (this.getters.s_odd) {
      url = window._baseUrl + '/sport-odds';
    }

    if (url == window._baseUrl + '/sport-odds') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      data.gameMenuId = 1;
      delete data.leagues;
      delete data.schedule;
    }

    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.events);

      _this4.commit('EVENTLIST', events);
      _this4.commit('TOTALPAGE', res.ttlPg);
      if (_this4.getters.selectedPage > res.ttlPg) {
        _this4.commit('SELECTED_PAGE', res.ttlPg);
      }

      _this4.dispatch('sortEvents');
      _this4.commit('FULL_LOAD', false);
      _this4.commit('SUBLOAD', false);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getVipEventOdds: function getVipEventOdds(context, payload) {
    var _this5 = this;

    var leagueIds = [];
    var httpMethod = 'post';

    var bool_loading = true;
    if (payload && payload.loading == '1') {
      bool_loading = false;
    }

    var bettype = this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if (payload && payload.livetv) {
      bettype = payload.sportId ? payload.sportId : "";
      plytype = payload.playType ? payload.playType : "";
      schedule = payload.schedule ? payload.schedule : "";
      date = payload.sDate;
    } else {
      if (this.getters.int_selectedParlayDate && schedule == '2') {
        date = this.getters.int_selectedParlayDate;
      }
    }

    if (this.getters.arr_selectedTemplate.subTemplateId == '2') {
      date = this.getters.int_selectedParlayDate;
      plytype = '5';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: 1,
      date: date,
      plytypgrp: plytype,
      enableLoading: bool_loading,
      token: payload.token
    };

    var url = window._baseUrl + '/sport-odds-leagues';
    if (this.getters.s_odd) {
      url = window._baseUrl + '/sport-odds';
    }

    if (url == window._baseUrl + '/sport-odds') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      data.gameMenuId = 99;
      delete data.leagues;
      delete data.schedule;
    }

    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.events);
      var earlyParlayDateList = res.earlyParlayDateList;

      _this5.commit('EVENTLIST', events);
      _this5.commit('TOTALPAGE', res.ttlPg);
      if (_this5.getters.selectedPage > res.ttlPg) {
        _this5.commit('SELECTED_PAGE', res.ttlPg);
      }
      if (res.earlyParlayDateList) {
        _this5.commit('PARLAYDATELIST', earlyParlayDateList);
      }
      _this5.dispatch('sortEvents');
      _this5.commit('FULL_LOAD', false);
      _this5.commit('SUBLOAD', false);
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  sortEvents: function sortEvents() {
    var _this6 = this;

    var vue = this;
    var sortedEvents = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(this.getters.arr_eventList);
    var sortedTodayRBEvents = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(this.getters.arr_todayRBEventList);
    var newRBEvents = [];
    var newSortedEvents = [];
    var keyword = $('#searchInput').val().trim().toLowerCase();

    if (this.getters.arr_selectedTemplate.sportId != 'G98' && (this.getters.int_marketToggle == 1 || this.getters.int_marketToggle == 2 && this.getters.isParlay)) {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(sortedTodayRBEvents, function (todayRbVal, todayRbKey) {
        __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(todayRbVal, function (val, key) {
          var objStr = vue.getters.currentTab + 'R';
          if (vue.getters.int_marketToggle == '3') {
            objStr = 'R';
          }
          val['obj'] = objStr + todayRbKey;
          if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(vue.getters.isHideLeague[val['sptid']])) {
            vue.getters.isHideLeague[val['sptid']] = false;
          }
          if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(vue.getters.isCollapseMatch[val['sptid']])) {
            vue.getters.isCollapseMatch[val['sptid']] = [];
          }
          if (vue.getters.isHideLeague[val['sptid']] == false && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj']) >= 0 && key != 0) {} else if (vue.getters.isHideLeague[val['sptid']] == true && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj']) < 0 && key != 0) {} else {
            newRBEvents.push(val);
          }
        });
      });
    }
    var load1st = 0;
    if (this.getters.arr_selectedTemplate.subTemplateId != '3') {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(sortedEvents, function (sVal, sKey) {
        __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(sVal, function (val, key) {
          var objStr = vue.getters.currentTab + 'T';
          if (vue.getters.int_marketToggle == '3') {
            objStr = 'R';
          }
          val['obj'] = objStr + sKey;
          val['lastid'] = 0;
          if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(vue.getters.isHideLeague[val['sptid']])) {
            vue.getters.isHideLeague[val['sptid']] = false;
          }
          if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(vue.getters.isCollapseMatch[val['sptid']])) {
            vue.getters.isCollapseMatch[val['sptid']] = [];
          }
          if (vue.getters.isHideLeague[val['sptid']] == false && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj']) >= 0 && key != 0) {} else if (vue.getters.isHideLeague[val['sptid']] == true && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj']) < 0 && key != 0) {} else {
            if (load1st == 0) {
              val['lastid'] = 1;
              load1st = 1;
            }
            if (!keyword || keyword && (val.lgecapt && val.lgecapt.trim().toLowerCase().indexOf(keyword) !== -1 || val.tacapt && val.tacapt.trim().toLowerCase().indexOf(keyword) !== -1 || val.tbcapt && val.tbcapt.trim().toLowerCase().indexOf(keyword) !== -1) || vue.getters.isHideLeague[val['sptid']] == false && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(vue.getters.isCollapseMatch[val['sptid']], val['obj']) >= 0 && key == 0) {
              newSortedEvents.push(val);
            }
          }
        });
      });
    }

    if (this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == 2 && this.getters.isParlay) {
      sortedEvents = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].concat(newRBEvents, newSortedEvents);
    } else if (this.getters.arr_selectedTemplate.subTemplateId != '3') {
      sortedEvents = newSortedEvents;
    }

    this.commit('SORTEDEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(sortedEvents));
    this.commit('SORTEDTODAYRBEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(newRBEvents));

    var lastId = '';
    var lastIdDt = '';
    __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(this.getters.sortedEvents, function (val, eventKey) {
      val.key = eventKey;
      if (lastId != val.lgeid || lastIdDt != val.dt) {
        lastId = val.lgeid;
        lastIdDt = val.dt;
        vue.getters.sortedEvents[eventKey]['subdis'] = true;
      } else {
        vue.getters.sortedEvents[eventKey]['subdis'] = false;
      }
    });

    if (this.getters.editionStand == 1) {
      if (this.getters.arr_selectedTemplate.sportId == 'G98') {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadAllComputed');
        }
      } else {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadComputed');
        }
      }
    } else if (this.getters.editionStand == 0) {
      if (this.getters.arr_selectedTemplate.sportId == 'G98') {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavSimpleComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadSimpleAllComputed');
        }
      } else {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavSimpleComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadSimpleComputed');
        }
      }
    } else if (this.getters.editionStand == 2) {
      if (this.getters.arr_selectedTemplate.sportId == 'G98') {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavExpandComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadExpandAllComputed');
        }
      } else {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavExpandComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadExpandComputed');
        }
      }
    } else if (this.getters.editionStand == 3) {
      if (this.getters.arr_selectedTemplate.sportId == 'G98') {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavExpandComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadSimpleSoccerComputed');
        }
      } else {
        if (this.getters.showFavEvents) {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadFavSSComputed');
        } else {
          __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('reloadSimpleSoccerComputed');
        }
      }
    }

    if (this.getters.showFavEvents) {
      var sortedFavRbEvents = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(sortedEvents);
      this.commit('SORTEDFAVRBEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(sortedFavRbEvents));
    }

    if (this.getters.favouriteEvents && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents).length > 0) {

      if (this.getters.arr_selectedTemplate.subTemplateId == '3') {
        this.dispatch('sortFavouriteOtrEvents', {
          orderedEvents: state.sortedFavOtrEventList,
          callback: function callback(res) {
            if (_this6.getters.showFavEvents) {
              var sortedFavOtrEvents = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].filter(res, function (o) {
                return __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(vue.getters.favouriteEvents[vue.getters.arr_selectedTemplate.sportId], o.eveid) !== -1;
              });
              _this6.commit('SORTEDFAVOTREVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(sortedFavOtrEvents));
            } else {
              _this6.commit('SORTEDFAVOTREVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
            }
          }
        });
      } else {
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedEvents,
          callback: function callback(res) {
            _this6.commit('SORTEDEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
          }
        });
      }

      if (state.sortedFavRbEventList) {
        this.dispatch('sortFavouriteEvents', {
          orderedEvents: state.sortedFavRbEventList,
          callback: function callback(res) {
            _this6.commit('SORTEDFAVRBEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
          }
        });
      }
    }
    this.commit('REFRESH_SPORTTABLE', false);
    this.commit('REFRESHSCREEN', false);
  },
  getLiveSportOdds: function getLiveSportOdds(context, payload) {
    var _this7 = this;

    var liveLeagueIds = [];


    var bool_loading = true;
    if (payload && payload.loading == '1') {
      bool_loading = false;
    }
    var isSportOdd = false;
    var bettype = this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if (payload && payload.livetv) {
      bettype = payload.sportId ? payload.sportId : "";
      plytype = payload.playType ? payload.playType : "";
      schedule = payload.schedule ? payload.schedule : "";
      date = payload.sDate;
    } else {
      if (this.getters.int_selectedParlayDate && (schedule == '2' || schedule == '1')) {
        date = this.getters.int_selectedParlayDate;
      }
    }

    if (this.getters.arr_selectedTemplate.subTemplateId == '2') {
      date = this.getters.int_selectedParlayDate;
      plytype = '5';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.arr_selectedTemplate.subTemplateId == '2' && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      page: 0,
      sorttyp: this.getters.selectedSort,
      date: date,
      sdate: this.getters.selected_date,
      timezone: this.getters.selected_timezone,
      plytypgrp: plytype,
      enableLoading: bool_loading,
      token: payload.token
    };

    if (!this.getters.showFavEvents) {
      if (this.getters.arr_selectedTemplate.leagueid) {
        data.leagues = [this.getters.arr_selectedTemplate.leagueid];
      } else {
        data.leagues = liveLeagueIds;
      }
    }

    var httpMethod = 'post';
    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-leagues-preview';
      if (this.getters.s_odd) {
        url = window._baseUrl + '/sport-odds-preview';
      }
    } else {
      url = window._baseUrl + '/sport-odds-leagues';
      if (this.getters.s_odd) {
        url = window._baseUrl + '/sport-odds';
      }
    }

    if (payload.showfavorite != undefined) {
      this.commit('SPORT_SHOW_FAV_EVENTS', payload.showfavorite);
    } else {}

    if (this.getters.showFavEvents) {
      if (this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId] && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId]).length > 0) {
        data.events = this.getters.favouriteEvents[this.getters.arr_selectedTemplate.sportId];
      } else {
        data.events = '0';
      }
      if (this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId] && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId]).length > 0) {
        data.lgevents = this.getters.favouriteLgeEvents[this.getters.arr_selectedTemplate.sportId];
      } else {
        data.lgevents = '0';
      }

      url = window._baseUrl + '/sport-odds-favevents';

      if (data.token == undefined) {
        data.token = window.token.arr_7;
      }
      data.showFav = '1';
    }

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      isSportOdd = true;
      httpMethod = 'get';
      data.gameMenuId = 0;
      delete data.leagues;
      delete data.schedule;
    }

    if (this.getters.isGameBannerSelected) {
      data.sprtid = this.getters.gameBannerSportId;
      data.gameMenuId = this.getters.gameBannerId;
    }

    if (this.getters.editionStand == '0') {
      if (this.getters.simDisp == '4') {
        data.plytypgrp = '4';
      } else if (this.getters.simDisp == '6') {
        data.plytypgrp = '12';
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(liveLeagueIds).length > 0 || isSportOdd && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(liveLeagueIds).length == 0 || this.getters.showFavEvents) {
      __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
        method: httpMethod,
        url: url,
        data: data
      }).done(function (res) {

        if (_this7.getters.showFavEvents) {
          var events = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.rbevents);
        } else {
          var events = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.events);
        }

        _this7.commit('EVENTLIST', events);
        if (_this7.getters.arr_selectedTemplate.subTemplateId == '4') {
          _this7.commit('CSODDSEVENT', events);
        }
        _this7.commit('TOTALPAGE', res.ttlPg);
        if (_this7.getters.selectedPage > res.ttlPg) {
          _this7.commit('SELECTED_PAGE', res.ttlPg);
        }

        _this7.dispatch('sortEvents');
        _this7.commit('FULL_LOAD', false);
      }.bind(this)).catch(function (errRes) {
        console.log(errRes);
      });
    } else {
      this.commit('FULL_LOAD', false);
    }
  },
  getLiveLeague: function getLiveLeague(context, payload) {
    var _this8 = this;

    var date = this.getters.int_selectedParlayDate;
    if (this.getters.int_marketToggle == '1' || this.getters.int_marketToggle == '3') {
      date = '0';
    }
    var plytypgrp = '1';
    if (this.getters.arr_selectedTemplate.subTemplateId == '2') {
      date = this.getters.int_selectedParlayDate;
      plytypgrp = '5';
    }

    var gameMenuId = 0;
    if (this.getters.isSpecial) {
      gameMenuId = 1;
    } else if (this.getters.isGameBannerSelected) {
      gameMenuId = this.getters.gameBannerId;
    }

    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = _baseUrl + '/sport-league-list-preview';
    } else {
      url = _baseUrl + '/sport-league-list';
    }
    __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);

    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: 'get',
      url: url,
      data: {
        sprtid: this.getters.isGameBannerSelected ? this.getters.gameBannerSportId : this.getters.arr_selectedTemplate.sportId,
        schedule: this.getters.arr_selectedTemplate.marketKey,
        date: date,
        plytypgrp: plytypgrp,
        langId: window._langid,
        sort: this.getters.selectedSort,
        spread: this.getters.account.spread,
        gameMenuId: gameMenuId,
        enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
        token: payload.token
      },
      async: false
    }).done(function (res) {

      var dat = res.leagues;

      if (payload.state && payload.state != '') {
        dat = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].filter(res.leagues, function (o) {
          if (o.state == payload.state) {
            return true;
          }
        });
      }

      __WEBPACK_IMPORTED_MODULE_8__vue_events_event_bus__["a" /* default */].$emit('enableLoading', false);
      _this8.commit('SUBLOAD', false);
      if (_this8.getters.int_marketToggle == '3') {
        _this8.commit('LIVELEAGUE', dat);
      } else {
        if (_this8.getters.int_marketToggle == '1' || _this8.getters.int_marketToggle == '2') {
          _this8.commit('LIVELEAGUE', dat);
        } else {
          _this8.commit('SPECIAL_EVENTLIST', dat);
        }
      }

      if (payload && payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getParlayOdds: function getParlayOdds(context, payload) {
    var _this9 = this;

    var liveLeagueIds = [];
    this.dispatch('getParlayTdyLeague', {
      enableLoading: true,
      token: token.arr_2,
      state: payload.state
    });

    __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(this.getters.arr_liveLeague, function (res, key) {
      liveLeagueIds.push(res.id);
    });

    var bool_loading = true;
    if (payload && payload.loading == '1') {
      bool_loading = false;
    }

    var bettype = this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if (payload && payload.livetv) {
      bettype = payload.sportId ? payload.sportId : "";
      plytype = payload.playType ? payload.playType : "";
      schedule = payload.schedule ? payload.schedule : "";
      date = payload.sDate;
    } else {
      if (this.getters.int_selectedParlayDate && (schedule == '2' || schedule == '1')) {
        date = this.getters.int_selectedParlayDate;
      }
    }

    if (this.getters.arr_selectedTemplate.subTemplateId == '2' || this.getters.isParlay) {
      date = this.getters.int_selectedParlayDate;
      plytype = '5';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.isParlay && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      page: 1,
      sorttyp: this.getters.selectedSort,
      date: date,
      plytypgrp: plytype,
      enableLoading: bool_loading,
      token: payload.token
    };

    if (this.getters.arr_selectedTemplate.leagueid) {
      data.leagues = [this.getters.arr_selectedTemplate.leagueid];
    } else {
      data.leagues = liveLeagueIds;
    }

    var httpMethod = 'post';
    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-leagues-preview';
      if (this.getters.s_odd) {
        url = window._baseUrl + '/sport-odds-preview';
      }
    } else {
      url = window._baseUrl + '/sport-odds-leagues';
      if (this.getters.s_odd) {
        url = window._baseUrl + '/sport-odds';
      }
    }

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      data.gameMenuId = 0;
      delete data.schedule;
    }

    if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(liveLeagueIds).length > 0) {
      __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
        method: httpMethod,
        url: url,
        data: data
      }).done(function (res) {
        var events = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res.events);

        _this9.commit('EVENTLIST', events);

        _this9.dispatch('sortEvents');
      }.bind(this)).catch(function (errRes) {
        console.log(errRes);
      });
    }
  },
  getParlayLeague: function getParlayLeague(context, payload) {
    this.dispatch('getParlayEarlyLeague', {
      enableLoading: true,
      token: payload.token,
      state: payload.state
    });
  },
  getParlayEarlyLeague: function getParlayEarlyLeague(context, payload) {
    var _this10 = this;

    var date = '99';
    var plytypgrp = '1';
    if (this.getters.arr_selectedTemplate.templateId == '21') {
      date = this.getters.int_selectedParlayDate;
      plytypgrp = '5';
    }

    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = _baseUrl + '/sport-league-list-preview';
    } else {
      url = _baseUrl + '/sport-league-list';
    }

    this.commit('FULL_LOAD', true);
    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: 'get',
      url: url,
      data: {
        sprtid: this.getters.arr_selectedTemplate.sportId,
        schedule: this.getters.int_marketToggle,
        date: date,
        plytypgrp: plytypgrp,
        langId: window._langid,
        sort: this.getters.selectedSort,
        spread: this.getters.account.spread,
        gameMenuId: this.getters.isGameBannerSelected ? this.getters.gameBannerId : 0,
        enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
        token: payload.token
      }
    }).done(function (res) {
      var dat = res.leagues;
      var stateArr = [];

      $.each(dat, function (key, val) {
        if (!(__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(stateArr, val.state) !== -1)) {
          stateArr.push(val.state);
        }
      });
      _this10.commit('STATE_LIST', stateArr);

      if (payload.state && payload.state != '') {
        dat = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].filter(res.leagues, function (o) {
          if (o.state == payload.state) {
            return true;
          }
        });
      }

      _this10.commit('LEAGUELIST', dat);
      if (res.earlyParlayDateList) {
        _this10.commit('PARLAYDATELIST', res.earlyParlayDateList);
      }
      _this10.commit('FULL_LOAD', false);

      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(res.leagues).length > 0) {
        _this10.dispatch('getSportOdds', {
          loading: 1,
          token: token.arr_2,
          state: _this10.getters.selectedState ? _this10.getters.selectedState : ''
        });
      } else {
        _this10.commit('REFRESHSCREEN', false);
      }
      if (payload && payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getParlayTdyLeague: function getParlayTdyLeague(context, payload) {
    var _this11 = this;

    var date = '0';

    var plytypgrp = '5';


    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = _baseUrl + '/sport-league-list-preview';
    } else {
      url = _baseUrl + '/sport-league-list';
    }

    __WEBPACK_IMPORTED_MODULE_6__js_core_core__["default"].$ajax({
      method: 'get',
      url: url,
      data: {
        sprtid: this.getters.arr_selectedTemplate.sportId,
        schedule: 1,
        date: date,
        plytypgrp: plytypgrp,
        langId: window._langid,
        sort: this.getters.selectedSort,
        spread: this.getters.account.spread,
        gameMenuId: 0,
        enableLoading: payload && payload.enableLoading ? payload.enableLoading : false,
        token: payload.token
      }
    }).done(function (res) {
      var dat = res.leagues;

      if (payload.state && payload.state != '') {
        dat = __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].filter(res.leagues, function (o) {
          if (o.state == payload.state) {
            return true;
          }
        });
      }

      _this11.commit('LIVELEAGUE', dat);
      if (res.earlyParlayDateList) {
        _this11.commit('PARLAYDATELIST', res.earlyParlayDateList);
      }
      if (payload && payload.callback) {
        return payload.callback(res);
      }
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  sortFavouriteEvents: function sortFavouriteEvents(orderedEvents, payload) {

    var vue = this;
    __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(payload.orderedEvents, function (event, key) {
      if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteEvents)) {
        if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteLgeEvents[vue.getters.selectedSport], event.lgeid) >= 0) {
          event.isFavourite = true;
        } else {
          if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteEvents[vue.getters.selectedSport], event.eveid) >= 0) {
            event.isFavourite = true;
          } else {
            event.isFavourite = false;
          }
        }
      }
    });
    payload.callback(payload.orderedEvents);
  },
  sortFavouriteOtrEvents: function sortFavouriteOtrEvents(orderedEvents, payload) {
    var vue = this;

    __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(payload.orderedEvents, function (event, key) {
      if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteEvents)) {
        if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteLgeEvents[vue.getters.arr_selectedTemplate.sportId], event.lgeid) >= 0) {
          event.isFavourite = true;
        } else {
          if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteEvents[vue.getters.arr_selectedTemplate.sportId], event.eveid) >= 0) {
            event.isFavourite = true;
          } else {
            event.isFavourite = false;
          }
        }
      }
    });
    payload.callback(payload.orderedEvents);
  },
  allBetFavouriteEvents: function allBetFavouriteEvents(orderedEvents, payload) {
    var vue = this;
    if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteEvents)) {
      if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteLgeEvents[vue.getters.selectedSport], payload.orderedEvents.lgeid) >= 0) {
        payload.orderedEvents.isFavourite = true;
      } else {
        if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteEvents[vue.getters.selectedSport], payload.orderedEvents.eveid) >= 0) {
          payload.orderedEvents.isFavourite = true;
        } else {
          payload.orderedEvents.isFavourite = false;
        }
      }
    }
    payload.callback(payload.orderedEvents);
  },
  sortFavouriteMatchEvents: function sortFavouriteMatchEvents(orderedEvents, payload) {
    var vue = this;
    if (payload.orderedEvents) {
      if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteEvents)) {
        if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteEvents[vue.getters.selectedSport], payload.orderedEvents.eveid) >= 0) {
          payload.orderedEvents.isFavourite = true;
        } else {
          payload.orderedEvents.isFavourite = false;
        }
      }
    }

    payload.callback(payload.orderedEvents);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["q" /* EVENTLIST */], function (state, payload) {
  state.arr_eventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_1" /* OTREVENTLIST */], function (state, payload) {
  state.arr_otrEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_28" /* SELECTED_SORT */], function (state, payload) {
  state.selectedSort = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_45" /* SORTEDEVENTLIST */], function (state, payload) {
  state.sortedEvents = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["V" /* LIVELEAGUE */], function (state, payload) {
  state.arr_liveLeague = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["W" /* LIVE_EVENTLIST */], function (state, payload) {
  state.arr_liveEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_9" /* PARLAY_TDYEVENTLIST */], function (state, payload) {
  state.arr_parlayTdyEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_7" /* PARLAY_EARLYEVENTLIST */], function (state, payload) {
  state.arr_parlayEarlyEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_51" /* SPECIAL_EVENTLIST */], function (state, payload) {
  state.arr_specialEventLeague = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_30" /* SELECTED_STATE */], function (state, payload) {
  state.selectedState = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_59" /* STATE_LIST */], function (state, payload) {
  state.stateList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["s" /* FAVOURITEEVENT */], function (state, payload) {
  var _this12 = this;

  if (payload.clear) {
    state.favouriteEvents = payload.clear ? {} : state.favouriteEvents;
    state.showFavEvents = false;
    __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(state.sortedEvents, function (events, eventsKey) {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(events, function (event, eventKey) {
        state.sortedEvents[eventsKey][eventKey].isFavourite = false;
      });
    });
    if (state.sortedMatchEventList) {
      if (state.sortedMatchEventList.eveid == payload.event.eveid) {
        state.sortedMatchEventList.isFavourite = false;
      }
    }
  } else {
    var _recursiveMethod = function _recursiveMethod(value, type, league) {
      var selectedMarket = VUE.getters.selectedMarket;
      var selectedSport = VUE.getters.arr_selectedTemplate.sportId;
      if (value == null && type == 'market') {
        value = {};
        return _recursiveMethod(value, 'sport', league);
      }
      if (value == null) {
        return _recursiveMethod(value, 'market', league);
      }
      if (value[selectedSport] == null) {
        value[selectedSport] = [];
        value[selectedSport].push(league);
        return value;
      }
      value[selectedSport].push(league);
      return value;
    };

    var VUE = this;

    var LgeCheck = false;
    if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteLgeEvents) && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.lgeid) >= 0) {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].pull(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.lgeid);
      var EveList = payload.isrb ? state.sortedFavRbEventList : state.sortedEvents;
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(EveList, function (events, eventsKey) {
        __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(events, function (event, eventKey) {
          if (event.eveid != payload.event.eveid && event.lgeid == payload.event.lgeid) {
            if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
              state.favouriteEvents = {};
              state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId] = [event.eveid];
            } else {
              var fav = _recursiveMethod(state.favouriteEvents, 'market', event.eveid);
            }
          } else if (event.eveid == payload.event.eveid && event.lgeid == payload.event.lgeid) {
            LgeCheck = true;
          }
        });
      });
      if (state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0) {
        delete state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId];
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
          state.favouriteLgeEvents = {};
        }
      }
    }
    if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteEvents) && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.eveid) >= 0) {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].pull(state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId], payload.event.eveid);
      if (state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0) {
        delete state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId];
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
          state.favouriteEvents = {};
        }
      }
    } else if (!LgeCheck) {
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length <= 0) {
        state.favouriteEvents = {};
        state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId] = [payload.event.eveid];
      } else {
        var fav = _recursiveMethod(state.favouriteEvents, 'market', payload.event.eveid);
      }
    }

    if (payload.isrb) {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(state.sortedFavRbEventList, function (events, eventsKey) {
        __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(events, function (event, eventKey) {
          if (event.eveid == payload.event.eveid) {
            if (!payload.event.isFavourite) {
              state.sortedFavRbEventList[eventsKey][eventKey].isFavourite = true;
            } else {
              state.sortedFavRbEventList[eventsKey][eventKey].isFavourite = !payload.event.isFavourite;
            }
          }
        });
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(state.sortedEvents, function (events, eventsKey) {
        __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(events, function (event, eventKey) {
          if (event.eveid == payload.event.eveid) {
            if (!payload.event.isFavourite) {
              state.sortedEvents[eventsKey][eventKey].isFavourite = true;
            } else {
              state.sortedEvents[eventsKey][eventKey].isFavourite = !payload.event.isFavourite;
            }
          }
        });
      });
    }

    if (state.sortedMatchEventList) {
      if (state.sortedMatchEventList.eveid == payload.event.eveid) {
        if (!payload.event.isFavourite) {
          state.sortedMatchEventList.isFavourite = true;
        } else {
          state.sortedMatchEventList.isFavourite = !payload.event.isFavourite;
        }
      }
    }
    if (VUE.getters.arr_selectedTemplate.subTemplateId == '3') {
      this.dispatch('sortFavouriteOtrEvents', {
        orderedEvents: state.sortedEvents,
        callback: function callback(res) {
          _this12.commit('SORTEDEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
        }
      });
    } else {
      this.dispatch('sortFavouriteEvents', {
        orderedEvents: state.sortedEvents,
        callback: function callback(res) {
          _this12.commit('SORTEDEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
        }
      });
    }
    this.dispatch('sortFavouriteMatchEvents', {
      orderedEvents: state.sortedMatchEventList,
      callback: function callback(res) {
        _this12.commit('SORTEDMATCHEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
      }
    });
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_18" /* SELECTED_BETTYPE */], function (state, payload) {
  state.selectedBettype = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_49" /* SORTEDMATCHEVENTLIST */], function (state, payload) {
  state.sortedMatchEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_47" /* SORTEDFAVRBEVENTLIST */], function (state, payload) {
  state.sortedFavRbEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_58" /* SPORT_SHOW_FAV_EVENTS */], function (state, payload) {
  state.showFavEvents = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["r" /* FAVOURITEALLBETEVENT */], function (state, payload) {
  var _this13 = this;

  var VUE = this;
  var eveid = payload.event.eveid;
  var sport = this.getters.selectedSport;

  if (!state.favouriteEvents[sport]) {
    state.favouriteEvents[sport] = [];
  }

  var index = state.favouriteEvents[sport].indexOf(eveid);

  if (index >= 0) {
    state.favouriteEvents[sport].splice(index, 1);
    if (state.favouriteEvents[sport].length === 0) {
      delete state.favouriteEvents[sport];
    }
  } else {
    state.favouriteEvents[sport].push(eveid);
  }

  if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length === 0) {
    state.favouriteEvents = {};
  }

  this.dispatch('allBetFavouriteEvents', {
    orderedEvents: VUE.getters.arr_allBetEvent,
    callback: function callback(res) {
      _this13.commit('ALLBETEVENT', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
    }
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_46" /* SORTEDFAVOTREVENTLIST */], function (state, payload) {
  state.sortedFavOtrEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_63" /* TODAYRBEVENTLIST */], function (state, payload) {
  state.arr_todayRBEventList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_50" /* SORTEDTODAYRBEVENTLIST */], function (state, payload) {
  state.sortedTodayRBEvents = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["C" /* HIDE_STATUS */], function (state, payload) {
  state.hideLegHeader = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["S" /* LABEL_STATUS */], function (state, payload) {
  state.lableHeader = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_34" /* SETFAVOURITE */], function (state, payload) {
  var _this14 = this;

  var eveid = payload.event.eveid;
  var sport = this.getters.selectedSport;

  if (!state.favouriteEvents[sport]) {
    state.favouriteEvents[sport] = [];
  }

  var index = state.favouriteEvents[sport].indexOf(eveid);

  if (index >= 0) {
    state.favouriteEvents[sport].splice(index, 1);
    if (state.favouriteEvents[sport].length === 0) {
      delete state.favouriteEvents[sport];
    }
  } else {
    state.favouriteEvents[sport].push(eveid);
  }

  if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteEvents).length === 0) {
    state.favouriteEvents = {};
  }

  this.dispatch('sortFavouriteEvents', {
    orderedEvents: state.sortedEvents,
    callback: function callback(res) {
      _this14.commit('SORTEDEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
    }
  });

  this.dispatch('sortFavouriteMatchEvents', {
    orderedEvents: state.sortedMatchEventList,
    callback: function callback(res) {
      _this14.commit('SORTEDMATCHEVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(res));
    }
  });
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_67" /* VIRTUAL_DATA_LIST */], function (state, payload) {
  state.virtualDataList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_42" /* SHOW_LEG_CAP */], function (state, payload) {
  state.showLegCapt = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["U" /* LEG_CAPT_DATA_LIST */], function (state, payload) {
  state.legCaptDataList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_4" /* OTRHIDELGE_LIST */], function (state, payload) {
  if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(payload.lid) && !__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(payload.key)) {
    if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.otrHideLegList[payload.lid])) {
      state.otrHideLegList[payload.lid] = [];
    }
    if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.otrHideLegList[payload.lid], payload.key) < 0) {
      state.otrHideLegList[payload.lid].push(payload.key);
    } else {}
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_5" /* OTRHIDETITLE_LIST */], function (state, payload) {
  state.otrHideTitleList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["t" /* FAVOURITELGEVENT */], function (state, payload) {
  var _this15 = this;

  if (payload.clear) {
    payload.clear ? {} : state.favouriteLgeEvents;
    state.showFavEvents = false;
  } else {
    var _recursiveMethod2 = function _recursiveMethod2(value, type, league) {
      var selectedMarket = VUE.getters.selectedMarket;
      var selectedSport = VUE.getters.arr_selectedTemplate.sportId;
      if (value == null && type == 'market') {
        value = {};
        return _recursiveMethod2(value, 'sport', league);
      }
      if (value == null) {
        return _recursiveMethod2(value, 'market', league);
      }
      if (value[selectedSport] == null) {
        value[selectedSport] = [];
        value[selectedSport].push(league);
        return value;
      }
      value[selectedSport].push(league);
      return value;
    };

    var VUE = this;


    if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteLgeEvents) && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.eventObj.eveid) >= 0) {
      state.favouriteLgeEvents = {};
      this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '0' });
    } else {

      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
        state.favouriteLgeEvents = {};
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '0' });
      }
    }

    if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.favouriteLgeEvents) && __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.lgeid) >= 0) {
      __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].pull(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], payload.lgeid);
      this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });
      if (state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0) {
        delete state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId];
        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
          state.favouriteLgeEvents = {};
        }
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });
      }
    } else {
      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
        state.favouriteLgeEvents = {};
        state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId] = [payload.lgeid];
        this.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '1' });
      } else {
        var fav = _recursiveMethod2(state.favouriteLgeEvents, 'market', payload.lgeid);
        this.commit('ACCOUNT_FAV', { favdt: fav, isFavLeague: '0' });
      }
    }

    __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(state.sortedFavOtrEventList, function (events, eventsKey) {
      if (state.sortedFavOtrEventList[eventsKey].lgeid == payload.lgeid) {
        if (state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId] && state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].indexOf(state.sortedFavOtrEventList[eventsKey].eveid) !== -1) {
          __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].pull(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], state.sortedFavOtrEventList[eventsKey].eveid);
          if (state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId].length <= 0) {
            delete state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId];
            if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteLgeEvents).length <= 0) {
              state.favouriteLgeEvents = {};
              _this15.commit('ACCOUNT_FAV', { favdt: state.favouriteLgeEvents, isFavLeague: '' });
            }
          }
        }
        if (payload.lgeChk) {
          state.sortedFavOtrEventList[eventsKey].isFavourite = false;
        } else {
          state.sortedFavOtrEventList[eventsKey].isFavourite = true;
        }
      }
    });

    var nwArr = [];
    __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].forEach(state.sortedFavOtrEventList, function (eve, eveKey) {
      if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.favouriteLgeEvents[VUE.getters.arr_selectedTemplate.sportId], eve.lgeid) !== -1) {
        nwArr.push(eve.eveid);
      }
    });
    state.favouriteEvents[VUE.getters.arr_selectedTemplate.sportId] = nwArr;
    this.commit('SORTEDFAVOTREVENTLIST', __WEBPACK_IMPORTED_MODULE_5_core_js__["_"].cloneDeep(state.sortedFavOtrEventList));
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_2" /* OTRHIDEFAVLGE_LIST */], function (state, payload) {
  if (!__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(payload.lid) && !__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(payload.key)) {
    if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].isUndefined(state.otrHideFavLegList[payload.lid])) {
      state.otrHideFavLegList[payload.lid] = [];
    }
    if (__WEBPACK_IMPORTED_MODULE_5_core_js__["_"].indexOf(state.otrHideFavLegList[payload.lid], payload.key) < 0) {
      state.otrHideFavLegList[payload.lid].push(payload.key);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["_3" /* OTRHIDEFAVTITLE_LIST */], function (state, payload) {
  state.otrHideFavTitleList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__mutation_types__["E" /* HOT_MATCH_LIST */], function (state, payload) {
  state.hotMatchList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'LEAGUE_FILTER', function LEAGUE_FILTER(state, payload) {
  state.filter_leagueList = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'SCHEDULE', function SCHEDULE(state, payload) {
  state.schedule = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'PLAYTYPE', function PLAYTYPE(state, payload) {
  state.playtype = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'FAVOURITE_TEAM', function FAVOURITE_TEAM(state, payload) {
  var teamId = payload.team === 'a' ? payload.event.taid : payload.event.tbid;
  var sport = payload.sport;

  var currentList = !state.favouriteTeams[sport] ? [] : state.favouriteTeams[sport];
  var index = currentList.indexOf(teamId);
  var newList = void 0;

  if (index >= 0) {
    newList = currentList.filter(function (id) {
      return id !== teamId;
    });
  } else {
    newList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(currentList), [teamId]);
  }

  if (newList.length > 0) {
    state.favouriteTeams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.favouriteTeams, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, sport, newList));
  } else {
    var _state$favouriteTeams = state.favouriteTeams,
        _2 = _state$favouriteTeams[sport],
        rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_state$favouriteTeams, [sport]);

    state.favouriteTeams = rest;
  }

  if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(state.favouriteTeams).length === 0) {
    state.favouriteTeams = {};
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_core_core__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);



var _mutations;






var state = {
  arr_allBetEvent: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
    lgecapt: '',
    tacapt: ''
  }, 'tacapt', ''),
  sportAllBetLang: window._lang.sportAllBet,
  arr_csOddsEvent: null,
  arr_selectedBetTab: 8,
  refreshAllBet: false,
  isShowBottomRefresh: false
};

var getters = {
  arr_allBetEvent: function arr_allBetEvent(state) {
    return state.arr_allBetEvent;
  },
  sportAllBetLang: function sportAllBetLang(state) {
    return state.sportAllBetLang;
  },
  arr_csOddsEvent: function arr_csOddsEvent(state) {
    return state.arr_csOddsEvent;
  },
  arr_selectedBetTab: function arr_selectedBetTab(state) {
    return state.arr_selectedBetTab;
  },
  refreshAllBet: function refreshAllBet(state) {
    return state.refreshAllBet;
  },
  isShowBottomRefresh: function isShowBottomRefresh(state) {
    return state.isShowBottomRefresh;
  }
};

var actions = {
  getSportAllBet: function getSportAllBet(context, payload) {
    var _this = this;

    var token_val = payload.token;

    if (payload.event) {

      var bool_loading = true;
      if (payload.loading == '1') {
        bool_loading = false;
      }

      var sptid = payload.event && payload.event.sptid ? payload.event.sptid : payload.event.sprtid;

      var sportid = payload && payload.sportId ? payload.sportId : 'N' + sptid;
      if (payload.sportId) {
        if (payload.sportId.indexOf('G') >= 0) {
          sportid = 'N' + payload.event.sptid;
        }
      }

      __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
        method: 'post',
        url: _baseUrl + '/sport-allbet',
        data: {
          sprtid: sportid,
          schedule: this.getters.schedule,

          lang: window._langid,

          evntid: payload.event.eveid,
          enableLoading: bool_loading,
          plytypgrp: this.getters.playtype,
          timezone: this.getters.selected_timezone,

          token: token_val
        }
      }).done(function (res) {
        if (res.allBet != "") {
          if (res.allBet.sp) {
            for (var eveid = 0; eveid < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res.allBet.sp).length; eveid++) {
              _.assign(res.allBet.sp[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res.allBet.sp)[eveid]], { 'sptid': res.allBet.sptid });
            }
          }

          _this.commit('ALLBETEVENT', res.allBet);
          _this.commit('FULL_LOAD', false);
          _this.commit('SELECTED_EVENT', payload.event);
          _this.dispatch('sortAllBetEvents');
          if (payload.startTv && payload.startTv == 1) {
            __WEBPACK_IMPORTED_MODULE_4__vue_events_event_bus__["a" /* default */].$emit('startTvDefault', res.allBet);
          }
          _this.commit('LOADINGSCREEN', false);
          if (payload.callback) {
            return payload.callback(res);
          }
        }
      }.bind(this)).catch(function (errRes) {
        console.log(errRes);
      });
    }
  },
  sortAllBetEvents: function sortAllBetEvents() {
    var _this2 = this;

    var sortedEvents = _.cloneDeep(this.getters.arr_allBetEvent);
    this.commit('ALLBETEVENT', _.cloneDeep(sortedEvents));

    if (this.getters.showFavEvents) {
      var sortedFavRbEvents = _.cloneDeep(this.getters.favrbeventList);
      this.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(sortedFavRbEvents));
    }
    if (this.getters.favouriteEvents || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.favouriteEvents).length > 0) {
      this.dispatch('allBetFavouriteEvents', {
        orderedEvents: sortedEvents,
        callback: function callback(res) {
          _this2.commit('ALLBETEVENT', _.cloneDeep(res));
        }
      });

      if (state.sortedFavRbEventList) {
        this.dispatch('allBetFavouriteEvents', {
          orderedEvents: state.sortedFavRbEventList,
          callback: function callback(res) {
            _this2.commit('SORTEDFAVRBEVENTLIST', _.cloneDeep(res));
          }
        });
      }
    }
    this.commit('LOADINGSCREEN', false);
  },
  getSportCorrectScore: function getSportCorrectScore(context, payload) {
    var _this3 = this;

    var bool_loading = true;
    if (payload && payload.loading == '1') {
      bool_loading = false;
    }

    var bettype = this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if (payload && payload.livetv) {
      bettype = payload.sportId ? payload.sportId : "";
      plytype = payload.playType ? payload.playType : "";
      schedule = payload.schedule ? payload.schedule : "";
      date = payload.sDate;
    } else {
      if (this.getters.int_selectedParlayDate && schedule == '2') {
        date = this.getters.int_selectedParlayDate;
      }
    }

    if (this.getters.arr_selectedTemplate.TemplateId == '21') {
      date = this.getters.int_selectedParlayDate;
      plytype = '5';
    }

    if (this.getters.arr_selectedTemplate.subTemplateId == '4') {
      plytype = '2';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.arr_selectedTemplate.subTemplateId == '4' && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: 1,
      date: date,
      plytypgrp: plytype,
      enableLoading: bool_loading,
      token: payload.token
    };

    if (this.getters.arr_selectedTemplate.leagueid) {
      data.leagues = [this.getters.arr_selectedTemplate.leagueid];
    } else {
      if (this.getters.int_marketToggle == '3' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_leagues).length == 0) {
        var liveLgList = [];
        _.forEach(this.getters.arr_liveLeague, function (res, key) {
          liveLgList.push(res.id);
        });

        data.leagues = liveLgList;
      } else {
        if (payload.state && payload.state != '') {
          var lgList = [];
          var arrLgList = this.getters.arr_leagueList;

          arrLgList = _.filter(this.getters.arr_leagueList, function (o) {
            if (o.state == payload.state) {
              return true;
            }
          });

          _.forEach(arrLgList, function (d, k) {
            lgList.push(d.id);
          });

          data.leagues = lgList;
        } else {
          if (this.getters.arr_selectedLeague && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_selectedLeague).length > 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_selectedLeagues).length == 0) {
            data.leagues = [this.getters.arr_selectedLeague.leagueid];
          } else {
            if (this.getters.arr_selectedLeagues && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_selectedLeagues).length > 0) {
              if (this.getters.arr_leagues && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_leagues).length > 0) {
                var lgList = [];
                _.forEach(this.getters.arr_leagues, function (d, k) {
                  lgList.push(d.leagueid);
                });

                data.leagues = lgList;
              }
            } else if (this.getters.arr_leagueList && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_leagueList).length > 0) {
              var lgList = [];
              var arrLgList = this.getters.arr_leagueList;

              if (payload.state != '') {

                arrLgList = _.filter(this.getters.arr_leagueList, function (o) {
                  if (o.state == payload.state) {
                    return true;
                  }
                });
              }

              _.forEach(arrLgList, function (d, k) {
                lgList.push(d.id);
              });

              data.leagues = lgList;
            }
          }
        }
      }
    }


    if (this.getters.selectedSort) {
      data.sorttyp = this.getters.selectedSort;
    }

    var httpMethod = 'post';
    var url = '';
    if (this.getters.account.previewFlag == true) {
      url = window._baseUrl + '/sport-odds-leagues-preview';
      if (this.getters.s_odd) {
        url = window._baseUrl + '/sport-odds-preview';
      }
    } else {
      url = window._baseUrl + '/sport-odds-leagues';
      if (this.getters.s_odd) {
        url = window._baseUrl + '/sport-odds';
      }
    }

    if (url == window._baseUrl + '/sport-odds' || url == window._baseUrl + '/sport-odds-preview') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      data.gameMenuId = 0;
      delete data.leagues;
      delete data.schedule;
    }

    __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = _.cloneDeep(res.events);


      if (_this3.getters.arr_selectedLeague && res.events && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res.events).length > 0) {
        var c = _this3.getters.arr_selectedLeague.c;
        _this3.dispatch('selectLeague', {
          leagueid: res.events[0][0].lgeid,
          lgecapt: res.events[0][0].lgecapt,
          c: c
        });
      }
      _this3.commit('CSODDSEVENT', events);
      _this3.commit('SUBLOAD', false);

      _this3.dispatch('sortEvents');
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  },
  getSpecialCorrectScore: function getSpecialCorrectScore(context, payload) {
    var _this4 = this;

    var bool_loading = true;
    if (payload && payload.loading == '1') {
      bool_loading = false;
    }

    var bettype = this.getters.arr_selectedTemplate.sportId;
    var plytype = this.getters.arr_selectedTemplate.plytype;
    var schedule = this.getters.int_marketToggle;
    var date = '0';

    if (payload && payload.livetv) {
      bettype = payload.sportId ? payload.sportId : "";
      plytype = payload.playType ? payload.playType : "";
      schedule = payload.schedule ? payload.schedule : "";
      date = payload.sDate;
    } else {
      if (this.getters.int_selectedParlayDate && schedule == '2') {
        date = this.getters.int_selectedParlayDate;
      }
    }

    if (this.getters.arr_selectedTemplate.TemplateId == '21') {
      date = this.getters.int_selectedParlayDate;
      plytype = '5';
    }

    if (this.getters.arr_selectedTemplate.subTemplateId == '4') {
      plytype = '2';
    }

    var data = {
      sprtid: bettype,
      schedule: schedule,
      lang: window._langid,
      spread: this.getters.account.spread,
      odd: this.getters.arr_selectedTemplate.subTemplateId == '4' && this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType,
      page: this.getters.selectedPage,
      sorttyp: 1,
      date: date,
      plytypgrp: plytype,
      enableLoading: bool_loading,
      token: payload.token
    };

    if (this.getters.arr_selectedTemplate.leagueid) {
      data.leagues = [this.getters.arr_selectedTemplate.leagueid];
    } else {
      if (this.getters.int_marketToggle == '3' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_leagues).length == 0) {
        var liveLgList = [];
        _.forEach(this.getters.arr_liveLeague, function (res, key) {
          liveLgList.push(res.id);
        });

        data.leagues = liveLgList;
      } else {
        if (this.getters.arr_selectedLeague && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_selectedLeague).length > 0) {
          data.leagues = [this.getters.arr_selectedLeague.leagueid];
        } else {
          if (this.getters.arr_selectedLeagues && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_selectedLeagues).length > 0) {
            if (this.getters.arr_leagues && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_leagues).length > 0) {
              var lgList = [];
              _.forEach(this.getters.arr_leagues, function (d, k) {
                lgList.push(d.leagueid);
              });

              data.leagues = lgList;
            }
          } else if (this.getters.arr_leagueList && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.getters.arr_leagueList).length > 0) {
            var lgList = [];
            _.forEach(this.getters.arr_leagueList, function (d, k) {
              lgList.push(d.id);
            });

            data.leagues = lgList;
          }
        }
      }
    }


    if (this.getters.selectedSort) {
      data.sorttyp = this.getters.selectedSort;
    }

    var httpMethod = 'post';
    var url = window._baseUrl + '/sport-odds-leagues';
    if (this.getters.s_odd) {
      url = window._baseUrl + '/sport-odds';
    }

    if (url == window._baseUrl + '/sport-odds') {
      url += '/' + data.schedule;
      httpMethod = 'get';
      data.gameMenuId = 1;
      delete data.leagues;
      delete data.schedule;
    }

    __WEBPACK_IMPORTED_MODULE_2__js_core_core__["default"].$ajax({
      method: httpMethod,
      url: url,
      data: data
    }).done(function (res) {
      var events = _.cloneDeep(res.events);


      if (_this4.getters.arr_selectedLeague && res.events && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(res.events).length > 0) {
        var c = _this4.getters.arr_selectedLeague.c;
        _this4.dispatch('selectLeague', {
          leagueid: res.events[0][0].lgeid,
          lgecapt: res.events[0][0].lgecapt,
          c: c
        });
      }
      _this4.commit('CSODDSEVENT', events);
      _this4.commit('SUBLOAD', false);

      _this4.dispatch('sortEvents');
    }.bind(this)).catch(function (errRes) {
      console.log(errRes);
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["d" /* ALLBETEVENT */], function (state, payload) {
  state.arr_allBetEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["m" /* CSODDSEVENT */], function (state, payload) {
  state.arr_csOddsEvent = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_16" /* SELECTEDBETTYPE */], function (state, payload) {
  state.arr_selectedBetTab = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutation_types__["_11" /* REFRESHALLBET */], function (state, payload) {
  state.refreshAllBet = payload;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, 'SHOW_BOTTOMREFRESH', function SHOW_BOTTOMREFRESH(state, payload) {
  state.isShowBottomRefresh = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cookie__);



var state = {
    helpLang: window._lang.helpLang,
    oddsConversionLang: window.lang.oddsConversionLang,
    int_page: 1,
    arr_lang: window.lang,
    arr_gameType: window.gameType,
    bool_isActive: true,
    randNum: window.randNum
};

var getters = {
    randNum: function randNum(state) {
        return state.randNum;
    },
    helpLang: function helpLang(state) {
        return state.helpLang;
    },
    oddsConversionLang: function oddsConversionLang(state) {
        return state.oddsConversionLang;
    },
    int_page: function int_page(state) {
        return state.int_page;
    },
    arr_lang: function arr_lang(state) {
        return state.arr_lang;
    },
    arr_gameType: function arr_gameType(state) {
        return state.arr_gameType;
    },
    bool_isActive: function bool_isActive(state) {
        return state.bool_isActive;
    }
};

var actions = {};

var mutations = {
    fn_change_page: function fn_change_page(state, payload) {
        state.int_page = payload;
    },
    fn_check_lang: function fn_check_lang(state) {
        if (__WEBPACK_IMPORTED_MODULE_1_vue_cookie___default.a.get('S0001_lang') == "en_US") {
            state.bool_isActive = false;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_core_core__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_common_common__ = __webpack_require__(190);











var state = {
    bettingFormToggle: false,
    bettingSelection: [],
    latestInfo: null,
    bettingMessage: null,
    mulpAllUpList: null,
    selectedAllUp: null,
    delayBetTimerId: null,
    allowRequestLatestInfo: true,
    betAmount: null,
    isMulpDayExceed: false,
    isBackgroundDelayBetting: false,
    currentBettingSelectionTemplate: false,
    delayBet: null,
    showDelAll: false,
    commonAmtSetting: false,
    commonAmt: null,
    possibleAmt: null,
    showHelp: false,
    tipsType: null,
    currentBetInfo: null,
    emptyBetAmt: false,
    isComboBet: false,
    combtAmt: [],
    combMaxInfo: false,
    selectedCombtBox: null,
    comboMax: window.comboMax,
    allowComboBet: window.allowComboBet,
    comboSuccessBetList: [],
    successBettingSelection: [],
    currentBetMarket: null,
    keepBettingSelection: [],
    comboErrBetList: [],
    errorBettingSelection: [],
    haveEmptyCombo: false,
    comboReachMaxBet: false,
    isShowChipMin: true,
    isShowChipMed: true,
    isShowChipBig: true,
    betMulpAmount: [],
    betMulpAmtFiltered: [],
    notSupportParlay: {
        show: false
    },
    prev_combobet: null,
    mulpMaxPayArr: []
};

var getters = {
    bettingFormToggle: function bettingFormToggle(state) {
        return state.bettingFormToggle;
    },
    bettingSelection: function bettingSelection(state) {
        if (localStorage.getItem('bts')) {
            var bts = JSON.parse(localStorage.getItem('bts'));
            if (bts.data != '' && bts.data.length > 0) {
                state.currentBettingSelectionTemplate = bts.selection;
                state.bettingSelection = bts.data;
            }
        }
        return state.bettingSelection;
    },
    latestInfo: function latestInfo(state) {
        return state.latestInfo;
    },
    bettingMessage: function bettingMessage(state) {
        return state.bettingMessage;
    },
    mulpAllUpList: function mulpAllUpList(state) {
        return state.mulpAllUpList;
    },
    selectedAllUp: function selectedAllUp(state) {
        return state.selectedAllUp;
    },
    betAmount: function betAmount(state) {
        return state.betAmount;
    },
    currentBettingSelectionTemplate: function currentBettingSelectionTemplate(state) {
        return state.currentBettingSelectionTemplate;
    },
    delayBet: function delayBet(state) {
        return state.delayBet;
    },
    showDelAll: function showDelAll(state) {
        return state.showDelAll;
    },
    commonAmtSetting: function commonAmtSetting(state) {
        return state.commonAmtSetting;
    },
    commonAmt: function commonAmt(state) {
        return state.commonAmt;
    },
    possibleAmt: function possibleAmt(state) {
        return state.possibleAmt;
    },
    showHelp: function showHelp(state) {
        return state.showHelp;
    },
    tipsType: function tipsType(state) {
        return state.tipsType;
    },
    currentBetInfo: function currentBetInfo(state) {
        return state.currentBetInfo;
    },
    emptyBetAmt: function emptyBetAmt(state) {
        return state.emptyBetAmt;
    },
    isComboBet: function isComboBet(state) {
        return state.isComboBet;
    },
    combtAmt: function combtAmt(state) {
        return state.combtAmt;
    },
    combMaxInfo: function combMaxInfo(state) {
        return state.combMaxInfo;
    },
    selectedCombtBox: function selectedCombtBox(state) {
        return state.selectedCombtBox;
    },
    comboMax: function comboMax(state) {
        return state.comboMax;
    },
    allowComboBet: function allowComboBet(state) {
        return state.allowComboBet;
    },
    comboSuccessBetList: function comboSuccessBetList(state) {
        return state.comboSuccessBetList;
    },
    successBettingSelection: function successBettingSelection(state) {
        return state.successBettingSelection;
    },
    currentBetMarket: function currentBetMarket(state) {
        return state.currentBetMarket;
    },
    keepBettingSelection: function keepBettingSelection(state) {
        return state.keepBettingSelection;
    },
    comboErrBetList: function comboErrBetList(state) {
        return state.comboErrBetList;
    },
    errorBettingSelection: function errorBettingSelection(state) {
        return state.errorBettingSelection;
    },
    haveEmptyCombo: function haveEmptyCombo(state) {
        return state.haveEmptyCombo;
    },
    comboReachMaxBet: function comboReachMaxBet(state) {
        return state.comboReachMaxBet;
    },
    isShowChipMin: function isShowChipMin(state) {
        return state.isShowChipMin;
    },
    isShowChipMed: function isShowChipMed(state) {
        return state.isShowChipMed;
    },
    isShowChipBig: function isShowChipBig(state) {
        return state.isShowChipBig;
    },
    betMulpAmount: function betMulpAmount(state) {
        return state.betMulpAmount;
    },
    betMulpAmtFiltered: function betMulpAmtFiltered(state) {
        return state.betMulpAmtFiltered;
    },
    notSupportParlay: function notSupportParlay(state) {
        return state.notSupportParlay;
    },
    prev_combobet: function prev_combobet(state) {
        return state.prev_combobet;
    },
    mulpMaxPayArr: function mulpMaxPayArr(state) {
        return state.mulpMaxPayArr;
    }
};

var actions = {
    finishBet: function finishBet(context, payload) {
        this.commit('BETTING_MESSAGE', null);
        this.commit('LATEST_INFO', null);
        this.commit('BETTING_SELECTION', []);
    },
    confirmBet: function confirmBet(context, payload) {
        if (this.getters.requestAllow == false) {
            return;
        }

        var STORE = this;
        var dual = '';
        var betData = {};

        var betSelect = STORE.getters.bettingSelection;
        var amt = _.cloneDeep(STORE.getters.combtAmt);

        if (STORE.getters.errorBettingSelection && STORE.getters.errorBettingSelection.length > 0) {
            STORE.commit('BETTING_SELECTION', []);
            betSelect = STORE.getters.errorBettingSelection;
        }

        _.forEach(this.getters.latestInfo.betting, function (value, key) {
            if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 0) {
                dual = 'a';
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 1) {
                dual = 'b';
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 2) {
                dual = 'c';
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 3) {
                dual = 'd';
            } else if (!_.isUndefined(betSelect[key]) && !_.isUndefined(betSelect[key]['subMatchKey']) && betSelect[key]['subMatchKey'] == 4) {
                dual = 'e';
            } else {
                return;
            }
            betData[key] = {};
            betData[key]['sprtid'] = value.sprtid;
            betData[key]['eveid'] = value['eveid'];
            betData[key]['plyType'] = value.plyType;
            betData[key]['taid'] = value['taid'];
            betData[key]['tbid'] = value['tbid'];
            betData[key]['tbetid'] = value.tbetid;
            betData[key]['betType'] = value.betType;
            betData[key]['dual'] = dual;
            betData[key]['tbet'] = value.tbet;
            betData[key]['rbscoa'] = value.rbscoa ? value.rbscoa : 0;
            betData[key]['rbscob'] = value.rbscob ? value.rbscob : 0;
            betData[key]['fav'] = value.fav ? value.fav : 0;
            betData[key]['odd'] = value.odd;
            betData[key]['hdp'] = value.hdp;
            betData[key]['rca'] = value.rca ? value.rca : 0;
            betData[key]['rcb'] = value.rcb ? value.rcb : 0;
            if (STORE.getters.isComboBet) {
                betData[key]['minMax'] = value.minMax;
            }

            if (STORE.getters.errorBettingSelection && STORE.getters.errorBettingSelection.length > 0) {
                STORE.commit('BETTING_SELECTION', {
                    'event': betSelect[key].event,
                    'bettype': betSelect[key].bettype,
                    'team': betSelect[key].team,
                    'playtype': betSelect[key].playtype,
                    'sportid': betSelect[key].sportid,
                    'subMatchKey': betSelect[key].subMatchKey,
                    'uniqueId': betSelect[key].uniqueId,
                    'marketToggle': betSelect[key].marketToggle
                });
                STORE.commit('COMBET_AMT', amt);
            }
        });
        this.commit('REQUEST_ALLOW', false);

        if (this.getters.delayBet > 0) {
            this.dispatch('ajaxInitBet', {
                payload: payload,
                data: betData
            });
        } else {
            if (this.getters.isComboBet) {
                this.dispatch('ajaxComboBet', {
                    payload: payload,
                    data: betData
                });
            } else if (this.getters.isParlay) {
                this.dispatch('ajaxMulpComboBet', {
                    payload: payload,
                    data: betData
                });
            } else {
                this.dispatch('ajaxConfirmBet', {
                    payload: payload,
                    data: betData
                });
            }
        }
    },
    ajaxInitBet: function ajaxInitBet(context, payload) {
        var _this = this;

        var STORE = this;
        __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
            method: 'post',
            url: window._baseUrl + '/sport-betting/init-bet',
            data: {
                enableLoading: false
            }
        }).done(function (res) {
            var delayTimer = parseInt(res.SYSTEM_DATA.DelayBet) * 1000;

            state.delayBetTimerId = setTimeout(function () {
                if (this.getters.isComboBet) {
                    this.dispatch('ajaxComboBet', {
                        payload: payload.payload,
                        data: payload.data,
                        isInitBet: true
                    });
                } else if (this.getters.isParlay) {
                    this.dispatch('ajaxMulpComboBet', {
                        payload: payload.payload,
                        data: payload.data,
                        isInitBet: true
                    });
                } else {
                    this.dispatch('ajaxConfirmBet', {
                        payload: payload.payload,
                        data: payload.data,
                        isInitBet: true
                    });
                }
            }.bind(_this), delayTimer);
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    ajaxConfirmBet: function ajaxConfirmBet(context, payload) {
        var _this2 = this;

        var STORE = this;
        var payloadData = payload;

        if (!state.isBackgroundDelayBetting) {
            this.commit('BETTING_MESSAGE', {
                isError: false
            });
        }

        var odTyp = this.getters.account.oddsType;
        var isMulp = 0;
        var allUp = '';
        if (this.getters.isParlay) {
            odTyp = odTyp != 'am' ? this.getters.oddTypesList.EU.key : odTyp;
            isMulp = 1;
            allUp = this.getters.selectedAllUp;
        }

        if (payload.payload.market && payload.payload.market != '') {
            this.commit('CURRENT_BET_MARKET', payload.payload.market);
        }

        if (this.getters.promotionFlag && !this.getters.promotionBetWithoutJoin && !isMulp && !this.getters.promotionBetStatus) {
            var promotionBetIndexArr = this.getters.promotionBetIndex;
        }

        __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
            data: {
                betting: payload.data,
                oddsType: odTyp,
                isMulp: isMulp,
                amount: payload.payload.betAmount != undefined ? payload.payload.betAmount : this.getters.combtAmt,
                betterOd: this.getters.account.autoAccBetterOdd,
                allUp: allUp,
                market: payload.payload.market && payload.payload.market != '' ? payload.payload.market : this.getters.int_marketToggle,
                enableLoading: false,
                promotionBetIndexArr: promotionBetIndexArr,
                token: token.arr_2
            },
            method: 'post',
            url: window._baseUrl + '/sport-betting/confirm-bet'
        }).done(function (res) {
            STORE.commit('REQUEST_ALLOW', true);
            STORE.commit('IS_PROCESS_BET', false);
            state.allowRequestLatestInfo = true;

            if (payloadData.isInitBet && state.delayBetTimerId) {
                state.delayBetTimerId = null;
            }
            if (state.isBackgroundDelayBetting) {
                state.isBackgroundDelayBetting = false;
                return;
            }
            if (res.SYSTEM_DATA.status == 'FAIL') {
                _this2.commit('BETTING_MESSAGE', {
                    isError: true,
                    data: res.SYSTEM_DATA
                });
                if (res.SYSTEM_DATA.code.indexOf('4022') >= 0) {
                    alert(res.SYSTEM_DATA.message + '(' + res.SYSTEM_DATA.code + ')');
                    _this2.dispatch('logoutAccount');
                }
                _this2.commit('LATEST_INFO', null);
                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('clearBetFormTimer', {
                    clearBetAmount: true
                });
            } else if (res.SYSTEM_DATA.WagerID) {
                _this2.commit('LATEST_INFO', null);
                _this2.commit('CURRENT_BETINFO', null);

                _this2.commit('BETTING_MESSAGE', {
                    isSuccess: true,
                    data: res.SYSTEM_DATA
                });
                _this2.dispatch('getSportCCL', {
                    token: token.arr_7,
                    enableLoading: false
                });

                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('clearBetFormTimer');
                if ((_this2.getters.arr_selectedTemplate.int_marketToggle == '3' || payload.payload.market == '3') && _this2.getters.arr_selectedTemplate.sportId == _this2.getters.sportBettypeList.N1.sprtId) {
                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('validatePendingWager', res);
                }

                if (_this2.getters.promotionFlag && !_this2.getters.promotionBetStatus) {
                    _this2.commit('PROMO_SHOW_JOIN_SUCCESS', res.SYSTEM_DATA.promotionBetStatus != undefined ? res.SYSTEM_DATA.promotionBetStatus : false);
                    _this2.commit('PROMO_BET_STATUS', res.SYSTEM_DATA.promotionBetStatus != undefined ? res.SYSTEM_DATA.promotionBetStatus : false);
                }
            } else {
                _this2.commit('BETTING_MESSAGE', {
                    isError: true,
                    data: res.SYSTEM_DATA.error
                });
                if (res.SYSTEM_DATA.error.code.indexOf('4002') >= 0) {
                    _this2.dispatch('getLatestInfo', {
                        token: token.arr_5
                    });
                } else {
                    _this2.commit('LATEST_INFO', res.SYSTEM_DATA);
                }

                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('refreshBetFormTimer');
            }
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    ajaxComboBet: function ajaxComboBet(context, payload) {
        var _this3 = this;

        var STORE = this;
        var payloadData = payload;

        if (!state.isBackgroundDelayBetting) {
            this.commit('BETTING_MESSAGE', {
                isError: false
            });
        }

        var odTyp = this.getters.account.oddsType;
        var isMulp = 0;
        var allUp = '';
        if (this.getters.isParlay) {
            odTyp = odTyp != 'am' ? this.getters.oddTypesList.EU.key : odTyp;
            isMulp = 1;
            allUp = this.getters.selectedAllUp;
        }

        if (payload.payload.market && payload.payload.market != '') {
            this.commit('CURRENT_BET_MARKET', payload.payload.market);
        }

        if (this.getters.promotionFlag && !this.getters.promotionBetWithoutJoin && !isMulp && !this.getters.promotionBetStatus) {
            var promotionBetIndexArr = this.getters.promotionBetIndex;
        }

        __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
            data: {
                betting: payload.data,
                oddsType: odTyp,
                isMulp: isMulp,
                amount: this.getters.combtAmt,
                betterOd: this.getters.account.autoAccBetterOdd,
                allUp: allUp,
                market: payload.payload.market && payload.payload.market != '' ? payload.payload.market : this.getters.int_marketToggle,
                enableLoading: false,
                token: token.arr_2,
                isCombo: this.getters.isComboBet ? 1 : 0,
                promotionBetIndexArr: promotionBetIndexArr
            },
            method: 'post',
            url: window._baseUrl + '/sport-betting/confirm-combo-bet'
        }).done(function (res) {
            var data = JSON.parse(res);
            var records = data.SYSTEM_DATA.betting;
            var successArr = [];
            var errorArr = [];
            var successBetArr = [];
            var errBetArr = [];
            var errCode = ['4003-N', '4010-N', 'N-4000-N'];

            STORE.commit('REQUEST_ALLOW', true);
            STORE.commit('IS_PROCESS_BET', false);
            state.allowRequestLatestInfo = true;

            if (payloadData.isInitBet && state.delayBetTimerId) {
                state.delayBetTimerId = null;
            }
            if (state.isBackgroundDelayBetting) {
                state.isBackgroundDelayBetting = false;
                return;
            }

            if (records && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(records).length > 0) {
                _.forEach(records, function (rec, rekey) {
                    if (rec.error && rec.error != '') {
                        if (!_.isUndefined(rec.error.code)) {
                            if (!(_.indexOf(errCode, rec.error.code) !== -1)) {
                                STORE.commit('BETTING_MESSAGE', {
                                    isError: true,
                                    data: records
                                });
                            }
                        } else {
                            STORE.commit('BETTING_MESSAGE', {
                                isError: true,
                                data: records
                            });
                        }
                        if (rec.error.code.indexOf('4002') >= 0) {
                            STORE.dispatch('getLatestInfo', {
                                token: token.arr_5
                            });
                        } else {
                            STORE.commit('LATEST_INFO', data.SYSTEM_DATA);
                        }

                        __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('refreshBetFormTimer');
                    }
                });
                var wgSuccess = _.findIndex(records, function (record) {
                    return record.WagerID !== undefined;
                });
                if (!STORE.getters.bettingMessage.isError || wgSuccess > -1) {
                    errorArr = _.pickBy(records, function (val, key) {
                        if (val.error && val.error != '') {
                            errBetArr.push(STORE.getters.bettingSelection[key]);
                        }

                        return val.error && val.error != '';
                    });

                    successArr = _.pickBy(records, function (val, key) {
                        if (val.WagerID) {
                            successBetArr.push(STORE.getters.bettingSelection[key]);
                        }
                        return val.WagerID;
                    });

                    if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errorArr).length > 0) {
                        var errAmt = STORE.getters.combtAmt.flatMap(function (x) {
                            return x = 0;
                        });
                        STORE.commit('COMBET_AMT', errAmt);
                    }

                    STORE.commit('BETTING_MESSAGE', {
                        data: records,
                        accCL: data.SYSTEM_DATA.accCcl,
                        isSuccess: true
                    });
                    _this3.commit('CURRENT_BETINFO', data.SYSTEM_DATA);

                    _this3.dispatch('getSportCCL', {
                        token: token.arr_7,
                        enableLoading: false
                    });

                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('clearBetFormTimer', {
                        clearBetAmount: true
                    });

                    if ((_this3.getters.arr_selectedTemplate.int_marketToggle == '3' || payload.payload.market == '3') && _this3.getters.arr_selectedTemplate.sportId == _this3.getters.sportBettypeList.N1.sprtId) {
                        __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('validateComboPendingWager', data);
                    }

                    if (_this3.getters.promotionFlag && !_this3.getters.promotionBetStatus) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(_this3.getters.promotionBetIndex), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var value = _step.value;

                                _this3.commit('PROMO_SHOW_JOIN_SUCCESS', data.SYSTEM_DATA.betting[value].promotionBetStatus != undefined ? data.SYSTEM_DATA.betting[value].promotionBetStatus : false);
                                _this3.commit('PROMO_BET_STATUS', data.SYSTEM_DATA.betting[value].promotionBetStatus != undefined ? data.SYSTEM_DATA.betting[value].promotionBetStatus : false);
                                if (data.SYSTEM_DATA.betting[value].promotionBetStatus != undefined && data.SYSTEM_DATA.betting[value].promotionBetStatus == true) {
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }

                    STORE.commit('COMB_SUCCESS_BET_LIST', successArr);
                    STORE.commit('SUCCESS_BETTING_SELECTION', successBetArr);

                    STORE.commit('COMB_ERR_BET_LIST', errorArr);
                    STORE.commit('ERR_BETTING_SELECTION', errBetArr);
                }
            }
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    ajaxMulpComboBet: function ajaxMulpComboBet(context, payload) {
        var _this4 = this;

        var STORE = this;
        var payloadData = payload;

        if (!state.isBackgroundDelayBetting) {
            this.commit('BETTING_MESSAGE', {
                isError: false
            });
        }

        var odTyp = this.getters.account.oddsType != 'am' ? this.getters.oddTypesList.EU.key : this.getters.account.oddsType;
        var mrkt = this.getters.int_marketToggle;
        if (payload.payload.market && payload.payload.market != '') {
            mrkt = payload.payload.market;
            this.commit('CURRENT_BET_MARKET', payload.payload.market);
        }

        var betAmt = payload.payload.betAmount != undefined ? payload.payload.betAmount : this.getters.betMulpAmtFiltered;
        var amountArr = [];
        var allUpArr = [];
        _.forEach(betAmt, function (arr, key) {
            amountArr[key] = arr.amount;
            allUpArr[key] = arr.allUpKey;
        });

        var dt = {
            betting: payload.data,
            oddsType: odTyp,
            isMulp: this.getters.isParlay ? 1 : 0,
            isCombo: 0,
            amount: amountArr,
            betterOd: this.getters.account.autoAccBetterOdd,
            allUp: allUpArr,
            market: mrkt,
            enableLoading: false,
            token: token.arr_2,
            minMax: this.getters.latestInfo.minMax
        };

        __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
            data: dt,
            method: 'post',
            url: window._baseUrl + '/sport-betting/confirm-mulp-combo-bet'
        }).done(function (res) {
            var ret = JSON.parse(res);
            var data = ret.SYSTEM_DATA.mulpRes;
            STORE.commit('REQUEST_ALLOW', true);
            STORE.commit('IS_PROCESS_BET', false);
            state.allowRequestLatestInfo = true;

            if (payloadData.isInitBet && state.delayBetTimerId) {
                state.delayBetTimerId = null;
            }
            if (state.isBackgroundDelayBetting) {
                state.isBackgroundDelayBetting = false;
                return;
            }

            var wgSuccess = _.findIndex(ret.SYSTEM_DATA.mulpRes, function (record) {
                return record.WagerID !== undefined;
            });
            var wgError = _.findIndex(ret.SYSTEM_DATA.mulpRes, function (record) {
                return record.error !== '';
            });

            _this4.dispatch('getSportCCL', {
                token: token.arr_7,
                enableLoading: false
            });
            __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('clearBetFormTimer', {
                clearBetAmount: true
            });

            if (wgSuccess > -1) {
                _this4.commit('BETTING_MESSAGE', {
                    isSuccess: true,
                    data: ret.SYSTEM_DATA
                });
                _this4.commit("BETMULP_AMOUNT", []);
                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('countTotalStakePayout', ret.SYSTEM_DATA);
                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('validateParlayPendingWager', ret);
            } else {
                STORE.dispatch('getLatestInfo', {
                    token: token.arr_5,
                    callback: function callback(res) {
                        var code = 'n/a';
                        var message = STORE.getters.arr_lang.betForm['BET_FORM.LBL_REJECT_BET'];

                        if (wgError > -1) {
                            var err = ret.SYSTEM_DATA.mulpRes[wgError].error;
                            message = _.isUndefined(err.message) ? message : err.message;
                            code = _.isUndefined(err.code) ? message : err.code;
                        }
                        STORE.commit('BETTING_MESSAGE', {
                            isError: true,
                            data: { code: code, message: message }
                        });
                    }
                });
            }
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    preBetForm: function preBetForm(context, payload) {
        if (parseInt(this.getters.account.currCL) <= 0) {
            this.commit('BETTING_MESSAGE', {
                isError: true,
                data: {
                    code: 'S-4015-A',
                    message: this.getters.arr_lang.betForm['BET_FORM.ERR_MSG_INSUFFICIENT_AMOUNT']

                }
            });
            this.commit('BETTINGFORM_TOGGLE', true);
            __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('resetBetFormTimer');
            return;
        }

        this.commit('REQUEST_ALLOW', true);
        this.commit('BETTING_MESSAGE', null);
        this.commit('LATEST_INFO', null);
        if (state.delayBetTimerId) {
            state.isBackgroundDelayBetting = true;
        }

        if (state.currentBettingSelectionTemplate && state.currentBettingSelectionTemplate != this.getters.arr_selectedTemplate.subTemplateId) {
            if (!this.getters.isComboBet && !this.getters.isParlay) {
                this.commit('BETTING_SELECTION', []);
            }
        }
        state.currentBettingSelectionTemplate = this.getters.arr_selectedTemplate.subTemplateId;
        var subMatchKey = payload.subMatchKey ? payload.subMatchKey : '0';
        if (this.getters.isParlay) {
            var vue = this;
            var removeArr = [];
            if (this.getters.bettingSelection && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.getters.bettingSelection).length > 0) {
                $.each(this.getters.bettingSelection, function (id, value) {
                    if (value.sportid != payload.event.sptid) {
                        removeArr.push(id);
                    }
                });
                removeArr = removeArr.sort().reverse();
                $.each(removeArr, function (id, value) {
                    vue.commit('BETTING_SELECTION', {
                        isRemove: true,
                        removeIndex: value
                    });
                });
            }

            if (this.getters.bettingSelection && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.getters.bettingSelection).length < this.getters.comboMax) {
                var eventDate = '';
                if (payload.event.dt) {
                    eventDate = new __WEBPACK_IMPORTED_MODULE_8_moment___default.a(payload.event.dt).locale('en').format("YYYY-MM-DD");
                }
                var filterDateIndex = _.indexOf(this.getters.arr_earlyParlayDateList, eventDate);
                var marketToggle = filterDateIndex === 0 ? 1 : 2;
                this.commit('BETTING_SELECTION', {
                    'event': payload.event,
                    'bettype': payload.bettype,
                    'team': payload.team,
                    'playtype': payload.playtype,
                    'sportid': payload.event.sptid,
                    'subMatchKey': subMatchKey,
                    'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                    'marketToggle': marketToggle
                });
                if (this.getters.bettingSelection.length > 0) {
                    this.dispatch('getLatestInfo', {
                        token: token.arr_2
                    });
                }
            } else {
                this.commit('COMB_MAX', true);
                setTimeout(function () {
                    this.commit('COMB_MAX', false);
                }.bind(this), 1000);
            }

            if (removeArr.length > 0 && this.getters.bettingSelection && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.getters.bettingSelection).length == 1) {
                this.commit('BETTINGFORM_TOGGLE', true);
            }
        } else if (this.getters.isComboBet) {
            if (this.getters.bettingSelection && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.getters.bettingSelection).length < this.getters.comboMax) {
                this.commit('BETTING_SELECTION', {
                    'event': payload.event,
                    'bettype': payload.bettype,
                    'team': payload.team,
                    'playtype': payload.playtype,
                    'sportid': payload.event.sptid,
                    'subMatchKey': subMatchKey,
                    'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                    'marketToggle': marketToggle
                });
                if (this.getters.bettingSelection.length > 0) {
                    this.dispatch('getLatestInfo', {
                        token: token.arr_2
                    });
                }
            } else {
                this.commit('COMB_MAX', true);
                setTimeout(function () {
                    this.commit('COMB_MAX', false);
                }.bind(this), 1000);
            }
        } else if (state.currentBettingSelectionTemplate == 3) {

            this.commit('BETTINGFORM_TOGGLE', true);
            this.commit('BETTING_SELECTION', {
                'event': payload.event,
                'eveid': payload.eveid,
                'bettype': payload.bettype,
                'team': payload.team,
                'playtype': payload.playtype,
                'sportid': payload.event[0]['sptid'],
                'subMatchKey': subMatchKey,
                'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                'marketToggle': payload.marketToggle
            });

            __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('resetBetFormTimer');
        } else {
            this.commit('BETTINGFORM_TOGGLE', true);
            this.commit('BETTING_SELECTION', {
                'event': payload.event,
                'bettype': payload.bettype,
                'team': payload.team,
                'playtype': payload.playtype,
                'sportid': payload.event.sptid,
                'subMatchKey': subMatchKey,
                'uniqueId': payload.uniqueId ? payload.uniqueId : '',
                'marketToggle': payload.marketToggle
            });

            __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('resetBetFormTimer');
        }
    },
    getLatestInfo: function getLatestInfo(context, payload) {
        var _this5 = this;

        var token_val = payload.token;
        if (state.allowRequestLatestInfo == false) {
            return;
        }
        if (this.getters.requestAllow == false) {
            return;
        }
        state.allowRequestLatestInfo = false;
        var betData = {};
        var dual = '';
        var team = '';
        var STORE = this;
        var selectedMarket = '';

        var betSelect = STORE.getters.bettingSelection;

        if (STORE.getters.keepBettingSelection && STORE.getters.keepBettingSelection.length > 0) {
            betSelect = STORE.getters.keepBettingSelection;
        }

        if (STORE.getters.errorBettingSelection && STORE.getters.errorBettingSelection.length > 0) {
            betSelect = STORE.getters.errorBettingSelection;
        }

        _.forEach(betSelect, function (value, key) {
            betData[key] = {};
            if (betSelect[key]['subMatchKey'] == 0) {
                dual = 'a';
            } else if (betSelect[key]['subMatchKey'] == 1) {
                dual = 'b';
            } else if (betSelect[key]['subMatchKey'] == 2) {
                dual = 'c';
            } else if (betSelect[key]['subMatchKey'] == 3) {
                dual = 'd';
            } else if (betSelect[key]['subMatchKey'] == 4) {
                dual = 'e';
            } else {
                return;
            }
            if (value.team == 'h') {
                team = 'a';
            } else if (value.team == 'a' && (value.bettype == '4' || value.bettype == '11' || value.bettype == '12' || value.bettype == '13' || value.bettype == '36' || value.bettype == '37' || value.bettype == '38' || value.bettype == '39' || value.bettype == '40' || value.bettype == '41' || value.bettype == '42' || value.bettype == '43' || value.bettype == '44' || value.bettype == '45' || value.bettype == '34' || value.bettype == '35' || value.bettype == '21' || value.bettype == '27' || value.bettype == '28' || value.bettype == '29' || value.bettype == '30' || value.bettype == '31' || value.bettype == '32' || value.bettype == '33' || value.bettype == '76' || value.bettype == '79')) {
                team = 'b';
            } else {
                team = value.team;
            }
            betData[key]['sprtid'] = STORE.getters.currentBettingSelectionTemplate == 3 ? value.sportid : value.event.sptid;
            betData[key]['eveid'] = STORE.getters.currentBettingSelectionTemplate == 3 ? value.eveid : value.event['eveid'];
            betData[key]['plyType'] = value.playtype;
            betData[key]['taid'] = value.event['taid'];
            betData[key]['tbid'] = value.event['tbid'];
            betData[key]['tbetid'] = STORE.getters.currentBettingSelectionTemplate == 3 ? team : value.event['t' + team + 'id'];
            betData[key]['betType'] = value.bettype;
            betData[key]['dual'] = STORE.getters.currentBettingSelectionTemplate == 3 ? 'a' : dual;
            betData[key]['tbet'] = team;
            if (value.rbstatus && value.rbstatus == 1) {
                selectedMarket = 3;
            }
        });

        var odTyp = this.getters.account.oddsType;
        var isMulp = 0;
        if (this.getters.isParlay) {
            odTyp = odTyp != 'am' ? this.getters.oddTypesList.EU.key : odTyp;
            isMulp = 1;
        }

        __WEBPACK_IMPORTED_MODULE_4__js_core_core__["default"].$ajax({
            data: {
                betting: betData,
                oddsType: odTyp,
                isMulp: isMulp,
                enableLoading: false,
                market: selectedMarket != '' ? selectedMarket : this.getters.int_marketToggle,
                token: token_val,
                isCombo: this.getters.isComboBet ? 1 : 0
            },
            method: 'post',
            url: window._baseUrl + '/sport-betting/latest-info'
        }).done(function (res) {
            var vue = _this5;
            if (typeof res.SYSTEM_DATA.DelayBet !== 'undefined') {
                state.delayBet = res.SYSTEM_DATA.DelayBet;
            }
            if (_this5.getters.requestAllow == false) {
                return;
            }
            state.allowRequestLatestInfo = true;

            if (_this5.getters.isParlay) {
                if (_this5.getters.arr_selectedTemplate.templateId != 21) {
                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', true);
                }
            } else if (res.SYSTEM_DATA.betting && _this5.getters.arr_selectedTemplate.templateId != 21) {
                if (_this5.getters.isComboBet) {
                    _.forEach(res.SYSTEM_DATA.betting, function (arr, key) {
                        var eid = _.findIndex(vue.getters.sortedEvents, function (e) {
                            return e.eveid == arr.eveid;
                        });
                        if (eid > -1) {
                            var event = vue.getters.sortedEvents[eid];
                            if (event.sptid == '1') {
                                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', true);
                                if (!window.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', false);
                                    return false;
                                }
                            } else {
                                if (event.sptid == '2' && event.lgeflag == '0' && !event.rbinfo && event.rbstatus != '1') {
                                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', true);
                                } else {
                                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', false);
                                    return false;
                                }
                            }
                        } else {
                            __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', false);
                        }
                    });
                } else {
                    var eventId = res.SYSTEM_DATA.betting[0].eveid;
                    var eid = _.findIndex(vue.getters.sortedEvents, function (e) {
                        return e.eveid == eventId;
                    });
                    if (eid > -1) {
                        var event = _this5.getters.sortedEvents[eid];
                        if (event.sptid == '1') {
                            __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', true);
                            if (!window.allowRbParlay && event.rbinfo && event.rbstatus == '1') {
                                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', false);
                            }
                        } else {
                            if (event.sptid == '2' && event.lgeflag == '0' && !event.rbinfo && event.rbstatus != '1') {
                                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', true);
                            } else {
                                __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', false);
                            }
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('setHasParlay', false);
                    }
                }
            }

            var firstOccurrencesEvent = {};
            var duplicateEventIndexes = [];
            var earlyEventIndexes = [];
            var rbEventExist = false;
            var hasEarly = false;
            var crossNotAllow = false;
            var allowRBCross = false;
            var earlyMoreThanOneDay = false;
            var removeArr = [];

            if (res.SYSTEM_DATA.status == 'FAIL') {
                if (!_this5.getters.bettingFormToggle && _this5.getters.isParlay) {
                    var parlay_unsupport_toggle = false;
                    if (_this5.getters.bettingSelection.length > 0) {
                        $.each(res.SYSTEM_DATA.betting, function (id, value) {
                            if (value.error != undefined && value.error != '') {
                                removeArr.push(id);
                                if (value.error.code.indexOf('4000-N1') > -1 || value.error.code.indexOf('4031') > -1) {
                                    parlay_unsupport_toggle = true;
                                }
                            }
                        });

                        if (removeArr.indexOf(res.SYSTEM_DATA.betting.length - 1) !== -1) {
                            _this5.commit('NOT_SUPPORT_PARLAY', {
                                show: true,
                                msg: parlay_unsupport_toggle ? _this5.getters.arr_lang.betForm['BET_FORM.PARLAY_UNSUPPORTED'] : _this5.getters.arr_lang.betForm['BET_FORM.INVALID']
                            });
                            setTimeout(function () {
                                vue.commit('NOT_SUPPORT_PARLAY', { reset: true });
                            }, 1500);
                        }

                        removeArr = removeArr.sort().reverse();
                        $.each(removeArr, function (id, value) {
                            vue.commit('BETTING_SELECTION', {
                                isRemove: true,
                                removeIndex: value
                            });
                        });

                        if (_this5.getters.isParlay && _this5.getters.currentTab != '4' && _this5.getters.bettingSelection.length == 0) {
                            _this5.commit('CURRENT_BETINFO', null);
                            _this5.commit('IS_PARLAY', false);
                        }
                    }
                } else {
                    _this5.commit('BETTING_MESSAGE', {
                        isError: true,
                        data: res.SYSTEM_DATA
                    });
                    _this5.commit('LATEST_INFO', null);
                    if (res.SYSTEM_DATA && res.SYSTEM_DATA.betting && res.SYSTEM_DATA.betting.length > 0) {
                        _this5.commit('CURRENT_BETINFO', res.SYSTEM_DATA);
                    }
                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('clearBetFormTimer');
                }
            } else {
                _this5.commit('BETTING_MESSAGE', null);

                if (_this5.getters.isParlay) {
                    var rbBetTypes = ['8', '9', '10', '11', '13', '16', '17', '18', '20', '27', '29', '31', '33', '35', '37', '39', '41', '43', '45', '47', '49', '51', '55', '56', '58', '61', '64', '66', '69', '71', '73', '75', '78', '79', '81', '83'];

                    if (res.SYSTEM_DATA.betting.length > 1) {
                        _.forEach(res.SYSTEM_DATA.betting, function (data, index) {
                            if (data.eveid) {
                                if (firstOccurrencesEvent[data.eveid] === undefined) {
                                    firstOccurrencesEvent[data.eveid] = index;
                                } else {
                                    if (!(duplicateEventIndexes.indexOf(firstOccurrencesEvent[data.eveid]) !== -1)) {
                                        duplicateEventIndexes.push(firstOccurrencesEvent[data.eveid]);
                                    }
                                    duplicateEventIndexes.push(index);
                                }

                                if (vue.getters.currentTab != '4') {
                                    var DateNow = new __WEBPACK_IMPORTED_MODULE_8_moment___default.a().utcOffset("-04:00").startOf('day').unix();
                                    var DateTomorrow = new __WEBPACK_IMPORTED_MODULE_8_moment___default.a().utcOffset("-04:00").add(1, 'days').startOf('day').unix();
                                    if (window.allowRbParlay) {
                                        if (rbBetTypes.indexOf(data.betType.toString()) !== -1) {
                                            rbEventExist = true;

                                            if (DateNow == data.event_date_timestamp && DateTomorrow == data.event_end_timestamp) {
                                                allowRBCross = true;
                                            }
                                            if (allowRBCross) {
                                                if (!earlyMoreThanOneDay) {
                                                    rbEventExist = false;
                                                } else {
                                                    rbEventExist = true;
                                                }
                                            }
                                        }

                                        if (DateNow < data.event_date_timestamp) {
                                            hasEarly = true;

                                            if ((data.event_date_timestamp - DateNow) / (60 * 60 * 24) > 1) {
                                                earlyMoreThanOneDay = true;
                                            }
                                            if (allowRBCross) {
                                                if (!earlyMoreThanOneDay) {
                                                    rbEventExist = false;
                                                } else {
                                                    rbEventExist = true;
                                                }
                                            }
                                            if (rbEventExist == true) {
                                                crossNotAllow = true;
                                            }
                                        } else if (rbEventExist == true && hasEarly == true) {
                                            crossNotAllow = true;
                                        }
                                    } else {
                                        if (rbBetTypes.indexOf(data.betType.toString()) !== -1) {
                                            removeArr.push(index);
                                        }
                                    }

                                    if (crossNotAllow) {
                                        if (!(earlyEventIndexes.indexOf(index) !== -1)) {
                                            earlyEventIndexes.push(index);
                                        }
                                    }
                                }
                            }
                        });
                    } else if (!window.allowRbParlay && res.SYSTEM_DATA.betting.length == 1) {
                        if (rbBetTypes.indexOf(res.SYSTEM_DATA.betting[0].betType.toString()) !== -1) {
                            duplicateEventIndexes.push(0);
                        }
                    }

                    if (removeArr && removeArr.length > 0) {
                        if (removeArr.indexOf(res.SYSTEM_DATA.betting.length - 1) !== -1) {
                            _this5.commit('NOT_SUPPORT_PARLAY', {
                                show: true,
                                msg: _this5.getters.arr_lang.betForm['BET_FORM.PARLAY_UNSUPPORTED']
                            });
                            setTimeout(function () {
                                vue.commit('NOT_SUPPORT_PARLAY', { reset: true });
                            }, 1500);
                        }

                        removeArr = removeArr.sort().reverse();
                        $.each(removeArr, function (id, value) {
                            vue.commit('BETTING_SELECTION', {
                                isRemove: true,
                                removeIndex: value
                            });
                        });
                    }

                    if (earlyEventIndexes && earlyEventIndexes.length > 0) {
                        earlyEventIndexes.forEach(function (value, id) {
                            if (!(duplicateEventIndexes.indexOf(value) !== -1)) {
                                duplicateEventIndexes.push(value);
                            }
                        });
                    }

                    if (duplicateEventIndexes.length > 0) {
                        duplicateEventIndexes.forEach(function (value, id) {
                            if (res.SYSTEM_DATA.betting[value].error == undefined || res.SYSTEM_DATA.betting[value].error == '') {
                                var msg = vue.getters.arr_lang.betForm['BET_FORM.MSG_NOT_SUPPORT_PARLAY'];
                                var err = { code: "N-4000", message: msg };
                                res.SYSTEM_DATA.betting[value].error = err;
                                res.SYSTEM_DATA.code = 'N-4000';
                                res.SYSTEM_DATA.message = msg;
                                var currBetInfo = vue.getters.currentBetInfo;
                                currBetInfo['betting'] = res.SYSTEM_DATA.betting;
                                vue.commit('CURRENT_BETINFO', currBetInfo);
                                vue.commit('BETTING_MESSAGE', {
                                    isError: true,
                                    data: res.SYSTEM_DATA
                                });
                            }
                        });
                    }
                }

                if (_this5.getters.bettingMessage && _this5.getters.bettingMessage.isError) {
                    _this5.commit('LATEST_INFO', null);
                    __WEBPACK_IMPORTED_MODULE_7__vue_events_event_bus__["a" /* default */].$emit('clearBetFormTimer');
                } else {
                    _this5.commit('LATEST_INFO', res.SYSTEM_DATA);
                    _this5.commit('CURRENT_BETINFO', res.SYSTEM_DATA);
                }

                if (res.SYSTEM_DATA.allUpList) {
                    _this5.commit('MULP_ALLUP_LIST', res.SYSTEM_DATA.allUpList);


                    var mulpMaxPayArrTemp = [];
                    _.forEach(res.SYSTEM_DATA.allUpList, function (value, i) {
                        var maxpay = 0;
                        if (res.SYSTEM_DATA.minMax && res.SYSTEM_DATA.minMax.max) {
                            if (res.SYSTEM_DATA.minMax.maxPay) {
                                var mulpParser = value.parser.split("#");
                                for (var index = 0; index < mulpParser.length; index++) {
                                    var ttlOdds = 1;
                                    var commaList = mulpParser[index].split(",");
                                    for (var comma = 0; comma < commaList.length; comma++) {
                                        var _betData = res.SYSTEM_DATA.betting[commaList[comma]];
                                        var betOdd = parseFloat(_betData.odd);
                                        if (vue.getters.account.oddsType == 'am') {
                                            if (betOdd < 0) {
                                                betOdd = Math.abs(100 / betOdd) + 1;
                                            } else {
                                                betOdd = betOdd / 100 + 1;
                                            }
                                            betOdd = betOdd.toFixed(3);
                                        }
                                        ttlOdds *= betOdd;
                                    }
                                    maxpay += res.SYSTEM_DATA.minMax.maxPay / ttlOdds;
                                }
                            }
                            if (res.SYSTEM_DATA.minMax.max > maxpay) {
                                mulpMaxPayArrTemp.push(res.SYSTEM_DATA.minMax.max.toFixed(0));
                            } else {
                                mulpMaxPayArrTemp.push(maxpay.toFixed(0));
                            }
                        }
                    });
                    _this5.commit("MULP_MAX_PAY_ARR", mulpMaxPayArrTemp);

                    if (_this5.getters.mulpAllUpList.length != _this5.getters.betMulpAmount.length) {
                        var data = [];
                        for (var i = 0; i < _this5.getters.mulpAllUpList.length; i++) {
                            data[i] = '';
                        }
                        _this5.commit("BETMULP_AMOUNT", data);
                    }
                }
            }

            if (payload.callback) {
                return payload.callback(res);
            }
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    getMulpLatestInfo: function getMulpLatestInfo(context, payload) {
        var _this6 = this;

        state.isMulpDayExceed = false;
        if (this.getters.arr_selectedTemplate.subTemplateId == 2) {
            var smallDate = null;
            var bigDate = null;
            _.forEach(this.getters.bettingSelection, function (value) {
                var onlyDate = new __WEBPACK_IMPORTED_MODULE_8_moment___default.a(value.event.dt).format('YYYY-MM-DD 00:00:00');
                var eventDate = new __WEBPACK_IMPORTED_MODULE_8_moment___default.a(onlyDate);
                if (smallDate == null && bigDate == null) {
                    smallDate = eventDate;
                    bigDate = eventDate;
                }

                if (smallDate.diff(eventDate, 'days') > 0) {
                    smallDate = eventDate;
                } else if (eventDate.diff(bigDate, 'days') > 0) {
                    bigDate = eventDate;
                }

                if (bigDate.diff(smallDate, 'days') >= 7) {
                    state.isMulpDayExceed = true;
                    _this6.jsError = {
                        error: true,
                        msg: _this6.arr_lang.betForm['BET_FORM.MSG_EXCEED_PARLAY_DATE']
                    };
                }
            }.bind(this));
        }

        return state.latestInfo;
    }
};

var mutations = {
    BETTINGFORM_TOGGLE: function BETTINGFORM_TOGGLE(state, payload) {
        state.bettingFormToggle = payload;
    },
    BETTING_SELECTION: function BETTING_SELECTION(state, payload) {

        var bts = {
            selection: state.currentBettingSelectionTemplate,
            tempId: this.getters.arr_selectedTemplate.templateId,
            isOtr: this.getters.isOtr,
            isParlay: this.getters.isParlay,
            isCombo: this.getters.isComboBet
        };

        if (payload.isRemove) {
            state.bettingSelection.splice(payload.removeIndex, 1);
            if (this.getters.currentBetInfo && this.getters.currentBetInfo.betting && this.getters.currentBetInfo.betting.length > 0) {
                this.getters.currentBetInfo.betting.splice(payload.removeIndex, 1);
            }
            bts.data = state.bettingSelection;
            localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
            Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);

            return;
        }
        if (payload.isOffCombo) {
            state.bettingSelection.splice(0, state.bettingSelection.length - 1);
            bts.data = state.bettingSelection;
            localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
            Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);

            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);

        if (payload.length == 0) {
            state.bettingSelection = payload;
            state.combtAmt[0] = 0;
            state.mulpAllUpList = null;
            state.selectedAllUp = null;
            bts.data = state.bettingSelection;
            localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
            Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);

            return;
        }
        if (!this.getters.isParlay && !this.getters.isComboBet) {
            var index = _.findIndex(this.getters.bettingSelection, { 'event': { 'eveid': payload.event.eveid } });
            if (index >= 0) {
                if (state.bettingSelection[index].team == payload.team) {
                    state.bettingSelection.splice(index, 1);
                    bts.data = state.bettingSelection;
                    localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
                    Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);
                    this.commit('BETTINGFORM_TOGGLE', false);
                    return;
                } else {
                    state.bettingSelection[0] = payload;
                }
            } else {
                state.bettingSelection[0] = payload;
            }
            bts.data = state.bettingSelection;
            localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
            Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);

            return;
        }

        if (state.bettingSelection.length > 0) {
            if (state.bettingSelection[0]['sportid'] != payload.sportid) {
                state.bettingSelection = [];
            }
        }

        if (this.getters.isComboBet) {
            var index = _.findIndex(this.getters.bettingSelection, { 'event': { 'eveid': payload.event.eveid }, 'playtype': payload.playtype, 'bettype': payload.bettype, 'subMatchKey': payload.subMatchKey });
            if (index >= 0) {
                if (state.bettingSelection[index].team == payload.team) {
                    state.bettingSelection.splice(index, 1);
                    state.combtAmt.splice(index, 1);
                    bts.data = state.bettingSelection;
                    localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
                    Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);
                    return;
                } else {
                    state.bettingSelection[index] = payload;
                }
            } else {
                payload = [payload];
                state.bettingSelection = state.bettingSelection.concat(payload);
                state.combtAmt = state.combtAmt.concat(0);
            }
        } else {
            var index = _.findIndex(this.getters.bettingSelection, { 'event': { 'eveid': payload.event.eveid } });
            if (index >= 0) {
                if (state.bettingSelection[index].team == payload.team) {
                    state.bettingSelection.splice(index, 1);
                    bts.data = state.bettingSelection;
                    localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
                    Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);
                    this.commit('BETTINGFORM_TOGGLE', false);

                    if (this.getters.isParlay && this.getters.currentTab != '4' && state.bettingSelection.length == 0) {
                        this.commit('IS_PARLAY', false);
                    }
                    return;
                } else {
                    state.bettingSelection[index] = payload;
                }
            } else {
                payload = [payload];
                state.bettingSelection = state.bettingSelection.concat(payload);
            }
        }

        bts.data = state.bettingSelection;
        localStorage.setItem("bts", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(bts));
        Object(__WEBPACK_IMPORTED_MODULE_9__js_common_common__["a" /* updateHightlightOdds */])(state.bettingSelection);
    },
    LATEST_INFO: function LATEST_INFO(state, payload) {
        if (payload) {
            if (_.isUndefined(payload.minMax) || payload.minMax == null) {
                payload.minMax = this.getters.latestInfo.minMax;
            }
            if (state.latestInfo && payload.betting) {
                var keyList = ['dual', 'fav', 'hdp', 'hdpCap', 'odd', 'rbscoa', 'rbscob'];

                var _loop = function _loop(index) {
                    var element = payload.betting[index];
                    keyList.forEach(function (value) {
                        var oldBettingIndex = _.findIndex(state.latestInfo.betting, {
                            eveid: payload.betting[index].eveid
                        });
                        if (oldBettingIndex < 0) return;

                        payload.betting[index][value + 'Chg'] = false;
                        if (value == 'odd' || value == 'hdp') {
                            if (parseFloat(state.latestInfo.betting[oldBettingIndex][value]) != parseFloat(payload.betting[index][value])) {
                                payload.betting[index][value + 'Chg'] = true;
                            }
                        } else {
                            if (state.latestInfo.betting[oldBettingIndex][value] !== payload.betting[index][value]) {
                                payload.betting[index][value + 'Chg'] = true;
                            }
                        }
                    });
                };

                for (var index = 0; index < payload.betting.length; index++) {
                    _loop(index);
                }
            }
        }
        state.latestInfo = payload;
    },
    BETTING_MESSAGE: function BETTING_MESSAGE(state, payload) {
        state.bettingMessage = payload;
    },
    MULP_ALLUP_LIST: function MULP_ALLUP_LIST(state, payload) {
        state.mulpAllUpList = payload;
    },
    SELECTED_ALLUP: function SELECTED_ALLUP(state, payload) {
        state.selectedAllUp = payload;
    },
    BETTING_DELAY_TIMERID: function BETTING_DELAY_TIMERID(state, payload) {
        if (state.delayBetTimerId) {
            this.commit('REQUEST_ALLOW', true);
            clearTimeout(state.delayBetTimerId);
        }
        state.delayBetTimerId = payload;
    },
    BETAMOUNT: function BETAMOUNT(state, payload) {
        state.betAmount = payload;
    },
    SHOWDELBTN: function SHOWDELBTN(state, payload) {
        state.showDelAll = payload;
    },
    COMMONAMT_SETTING: function COMMONAMT_SETTING(state, payload) {
        state.commonAmtSetting = payload;
    },
    COMMONAMT: function COMMONAMT(state, payload) {
        state.commonAmt = payload;
    },
    POSSIBLEAMT: function POSSIBLEAMT(state, payload) {
        state.possibleAmt = payload;
    },
    SHOWHELP: function SHOWHELP(state, payload) {
        state.showHelp = payload;
    },
    TIPS_TYPE: function TIPS_TYPE(state, payload) {
        state.tipsType = payload;
    },
    CURRENT_BETINFO: function CURRENT_BETINFO(state, payload) {
        state.currentBetInfo = payload;
    },
    BETTING_ALLUP: function BETTING_ALLUP(state, payload) {
        if (payload) {
            state.betting.selectedBetAllup = payload;
        }
    },
    EMPTY_BETAMT_STATUS: function EMPTY_BETAMT_STATUS(state, payload) {
        state.emptyBetAmt = payload;
    },
    IS_COMBOBET: function IS_COMBOBET(state, payload) {
        state.isComboBet = payload;
    },
    COMBET_AMT: function COMBET_AMT(state, payload) {
        state.combtAmt = payload;
    },
    COMB_MAX: function COMB_MAX(state, payload) {
        state.combMaxInfo = payload;
    },
    SELECTED_COMBOX: function SELECTED_COMBOX(state, payload) {
        state.selectedCombtBox = payload;
    },
    COMB_SUCCESS_BET_LIST: function COMB_SUCCESS_BET_LIST(state, payload) {
        state.comboSuccessBetList = payload;
    },
    SUCCESS_BETTING_SELECTION: function SUCCESS_BETTING_SELECTION(state, payload) {
        state.successBettingSelection = payload;
    },
    CURRENT_BET_MARKET: function CURRENT_BET_MARKET(state, payload) {
        state.currentBetMarket = payload;
    },
    KEEP_BETTING_SELECTION: function KEEP_BETTING_SELECTION(state, payload) {
        state.keepBettingSelection = payload;
    },
    COMB_ERR_BET_LIST: function COMB_ERR_BET_LIST(state, payload) {
        state.comboErrBetList = payload;
    },
    ERR_BETTING_SELECTION: function ERR_BETTING_SELECTION(state, payload) {
        state.errorBettingSelection = payload;
    },
    HAV_EMPTY_COMBO: function HAV_EMPTY_COMBO(state, payload) {
        state.haveEmptyCombo = payload;
    },
    COMBO_REACH_MAXBET: function COMBO_REACH_MAXBET(state, payload) {
        state.comboReachMaxBet = payload;
    },
    IS_SHOW_CHIPMIN: function IS_SHOW_CHIPMIN(state, payload) {
        state.isShowChipMin = payload;
    },
    IS_SHOW_CHIPMED: function IS_SHOW_CHIPMED(state, payload) {
        state.isShowChipMed = payload;
    },
    IS_SHOW_CHIPBIG: function IS_SHOW_CHIPBIG(state, payload) {
        state.isShowChipBig = payload;
    },
    BETMULP_AMOUNT: function BETMULP_AMOUNT(state, payload) {
        state.betMulpAmount = payload;
    },
    BETMULP_AMOUNT_FILTERED: function BETMULP_AMOUNT_FILTERED(state, payload) {
        state.betMulpAmtFiltered = payload;
    },
    NOT_SUPPORT_PARLAY: function NOT_SUPPORT_PARLAY(state, payload) {
        if (payload.reset) {
            state.notSupportParlay = { show: false };
        } else {
            state.notSupportParlay = payload;
        }
    },
    PREV_COMBOBET: function PREV_COMBOBET(state, payload) {
        state.prev_combobet = payload;
    },
    MULP_MAX_PAY_ARR: function MULP_MAX_PAY_ARR(state, payload) {
        state.mulpMaxPayArr = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_core_core__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);




var state = {
    dateList: {},
    leagueList: {},
    scoreList: {},
    plytyp: {},
    nowts: 0,
    resultDate: 0,
    resultSport: 'N1'
};

var getters = {
    dateList: function dateList(state) {
        return state.dateList;
    },
    leagueList: function leagueList(state) {
        return state.leagueList;
    },
    scoreList: function scoreList(state) {
        return state.scoreList;
    },
    plytyp: function plytyp(state) {
        return state.plytyp;
    },
    nowts: function nowts(state) {
        return state.nowts;
    },
    resultDate: function resultDate(state) {
        return state.resultDate;
    },
    resultSport: function resultSport(state) {
        return state.resultSport;
    }
};

var actions = {
    getDate: function getDate(context, payload) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1__js_core_core__["default"].$ajax({
            method: 'get',
            url: payload.url,
            data: { token: payload.token }
        }).done(function (res) {
            _this.commit('DATE_LIST', res.data);
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    getLeagueList: function getLeagueList(context, payload) {
        var _this2 = this;

        var data = {};
        data.date = payload.date;
        data.sportId = payload.sportId;
        data.langId = window._langid;
        data.token = payload.token;
        data.resultType = payload.resultType;
        __WEBPACK_IMPORTED_MODULE_1__js_core_core__["default"].$ajax({
            method: 'get',
            url: payload.url,
            data: data
        }).done(function (res) {
            _this2.commit('LEAGUE_LIST', res.leagueList);
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    },
    getScore: function getScore(context, payload) {
        var _this3 = this;

        var data = {};
        data.date = payload.date;
        data.sportId = payload.sportId;
        data.langId = window._langid;
        data.token = payload.token;
        data.resultType = payload.resultType;
        data.lgeid = payload.lgeid;
        data.enableLoading = false;
        __WEBPACK_IMPORTED_MODULE_1__js_core_core__["default"].$ajax({
            method: 'get',
            url: payload.url,
            data: data
        }).done(function (res) {
            _this3.commit('SCORE_LIST', res.data);
            _this3.commit('PLY_TYPE', res.plyTyp);
            _this3.commit('NOW_TS', res.now);
        }.bind(this)).catch(function (errRes) {
            console.log(errRes);
        });
    }
};

var mutations = {
    DATE_LIST: function DATE_LIST(state, payload) {
        state.dateList = payload;
    },
    LEAGUE_LIST: function LEAGUE_LIST(state, payload) {
        state.leagueList = payload;
    },
    SCORE_LIST: function SCORE_LIST(state, payload) {
        state.scoreList = payload;
    },
    PLY_TYPE: function PLY_TYPE(state, payload) {
        state.plytyp = payload;
    },
    NOW_TS: function NOW_TS(state, payload) {
        state.nowts = payload;
    },
    RESULT_SPORT: function RESULT_SPORT(state, payload) {
        state.resultSport = payload;
    },
    RESULT_DATE: function RESULT_DATE(state, payload) {
        state.resultDate = payload;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);



var _mutations;




var state = {
    cookieLeague: localStorage.getItem(window.compcode + '_league') != 'undefined' ? JSON.parse(localStorage.getItem(window.compcode + '_league')) : null,
    selectAllLeague: localStorage.getItem(window.compcode + '_league') != 'undefined' ? false : true,
    cookieHistory: localStorage.getItem(window.compcode + '_his') != 'undefined' ? JSON.parse(localStorage.getItem(window.compcode + '_his')) : null,
    searchHistory: [],
    searchLoading: false,
    historyList: []
};

var getters = {
    cookieLeague: function cookieLeague(state) {
        return state.cookieLeague;
    },
    selectAllLeague: function selectAllLeague(state) {
        return state.selectAllLeague;
    },
    cookieHistory: function cookieHistory(state) {
        return state.cookieHistory;
    },
    searchHistory: function searchHistory(state) {
        return state.searchHistory;
    },
    searchLoading: function searchLoading(state) {
        return state.searchLoading;
    },
    historyList: function historyList(state) {
        return state.historyList;
    }
};

var actions = {};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_32" /* SELECT_ALL_LEAGUE */], function (state, payload) {
    state.selectAllLeague = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["l" /* COOKIE_LEAGUE */], function (state, payload) {
    var selectedMarket = this.getters.selectedMarket;
    var selectedSport = this.getters.selectedSport;


    if (payload.remove) {
        if (this.getters.cookieLeague) {
            if (this.getters.cookieLeague[selectedMarket]) {
                if (this.getters.cookieLeague[selectedMarket][selectedSport]) {
                    state.cookieLeague[selectedMarket][selectedSport] = [];

                    localStorage.setItem(window.compcode + '_league', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cookieLeague));
                }
            }
        }

        return;
    }

    var VUE = this;
    function recursiveMethod(value, type, league) {
        var selectedMarket = VUE.getters.selectedMarket;
        var selectedSport = VUE.getters.selectedSport;

        if (value == null && type == 'market') {
            value[selectedMarket] = {};
            return recursiveMethod(value[selectedMarket], 'sport', league);
        }

        if (value == null && type == 'sport') {
            value[selectedMarket][selectedSport] = [];
            value[selectedMarket][selectedSport] = league;
            return value;
        } else {
            if (value == null) {
                return recursiveMethod(value, 'market', league);
            }
            if (value[selectedMarket] == null) {
                value[selectedMarket] = {};
                return recursiveMethod(value, 'sport', league);
            }
            if (value[selectedMarket][selectedSport] == null) {
                value[selectedMarket][selectedSport] = league;
                return value;
            }
            value[selectedMarket][selectedSport] = league;
            return value;
        }
    }
    if (this.getters.cookieLeague) {
        var cookie = '';
        cookie = recursiveMethod(this.getters.cookieLeague, 'market', payload.selectedLeague);
        state.cookieLeague = cookie;

        localStorage.setItem(window.compcode + '_league', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(cookie));
    } else {
        var selectedCookieLeague = {};
        selectedCookieLeague[selectedMarket] = {};
        selectedCookieLeague[selectedMarket][selectedSport] = payload.selectedLeague;
        state.cookieLeague = selectedCookieLeague;

        localStorage.setItem(window.compcode + '_league', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(selectedCookieLeague));
        return;
    }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["k" /* COOKIE_HISTORY */], function (state, payload) {
    var currentAcc = this.getters.account.acccode;

    if (payload.remove) {
        if (this.getters.cookieHistory) {
            state.cookieHistory = [];

            localStorage.setItem(window.compcode + '_his', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cookieHistory));
        }
        return;
    }

    if (payload.removeSelected) {
        if (this.getters.cookieHistory) {
            state.cookieHistory = _.pull(this.getters.cookieHistory, payload.searchVal);

            localStorage.setItem(window.compcode + '_his', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.cookieHistory));
        }
        return;
    }

    if (_.indexOf(state.cookieHistory, payload.searchVal) !== -1) {
        return;
    }

    var VUE = this;
    if (state.cookieHistory && state.cookieHistory && state.cookieHistory.length > 0) {
        state.searchHistory = _.reverse(state.cookieHistory);
    }
    if (state.searchHistory.length == 0 || state.searchHistory.length < 3) {
        if (payload.searchVal != '') {
            state.searchHistory.push(payload.searchVal);
        }
    } else {
        if (payload.searchVal != '') {
            state.searchHistory.shift();
            state.searchHistory.push(payload.searchVal);
        }
    }
    var selectedCookieLeague = {};
    selectedCookieLeague = _.reverse(state.searchHistory);
    state.cookieHistory = selectedCookieLeague;

    localStorage.setItem(window.compcode + '_his', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(selectedCookieLeague));

    return;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["_15" /* SEARCH_LOADING */], function (state, payload) {
    state.searchLoading = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["D" /* HIST_LIST */], function (state, payload) {
    state.historyList = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
});

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);




var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__ = __webpack_require__(6);




window.loading = false;

$.ajaxSetup({
  beforeSend: function beforeSend(xhr, settings) {
    var index = '';
    var token_val = '';
    var enableLoading = false;
    if (settings.data) {
      var data = settings.data.split('&');
      var data = data.indexOf("enableLoading=true");
      enableLoading = data >= 0 ? true : false;
      settings.data = settings.data.replace("&enableLoading=false", "");
      settings.data = settings.data.replace("&enableLoading=true", "");
      var url = settings.data;
    } else if (settings.type == 'GET') {
      var data = settings.url.indexOf("enableLoading=true");
      enableLoading = data >= 0 ? true : false;
      settings.url = settings.url.replace("&enableLoading=false", "");
      settings.url = settings.url.replace("&enableLoading=true", "");
      var url = settings.url;
    }
    settings.url = settings.url.replace("?enableLoading=false", "");
    settings.url = settings.url.replace("?enableLoading=true", "");
    if (url) {
      var valid = url.indexOf("&");
      if (valid >= 0) {
        var suburl = url.split('&');
        var delimiter = '&';
      } else {
        var suburl = url.split('?');
        var delimiter = '?';
      }

      suburl.forEach(function (value, i) {
        if (value.substring(0, 6) == 'token=') {
          index = i;
          token_val = value.split('=');
          if (settings.data) {
            settings.data = url.replace(delimiter + suburl[index], "");
          } else if (settings.type == 'GET') {
            settings.url = url.replace(delimiter + suburl[index], "");
          }
          xhr.setRequestHeader('TOKEN', decodeURIComponent(token_val[1]));
        }
      });
    }
    if (enableLoading) {
      __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('enableLoading', enableLoading);
    }
    if ($.inArray(settings.type, ['POST', 'PUT', 'DELETE', 'PATCH']) > -1) {
      if (!_.isUndefined(settings.data)) {
        var csrf = {
          'csrf_name': function () {
            return $('meta[name="csrf_name"]').attr('content');
          }(),
          'csrf_value': function () {
            return $('meta[name="csrf_value"]').attr('content');
          }()
        };
      }
      return true;
    }
  }
});

$(document).ajaxSuccess(function (event, xhr, options) {

  if (!_.isUndefined(xhr.responseJSON)) {
    if (xhr.responseJSON.redirect) {
      window.location.href = xhr.responseJSON.redirect;
    }
  }
});

$(document).ajaxComplete(function (event, xhr, options) {
  if (window.navigator.userAgent.indexOf('Safari') >= 0 && window.navigator.userAgent.indexOf('Chrome') == -1) {
    $('.gridContainer').height('90vh');
    $('.gridContainer').css('overflow-y', 'auto');
  }
  if (xhr.getResponseHeader('X-Auth') == '0') {
    window.location = 'login';
  }

  if (xhr.status === 0) {
    location.reload();
  }

  if (xhr.getResponseHeader('X-Csrf-Name') && xhr.getResponseHeader('X-Csrf-Value')) {
    var csrf = {
      'csrf_name': xhr.getResponseHeader('X-Csrf-Name'),
      'csrf_value': xhr.getResponseHeader('X-Csrf-Value')
    };

    $.each(csrf, function (k, v) {
      $('meta[name="' + k + '"]').attr('content', v);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$ajax = $.ajax;

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var normalizeComponent = __webpack_require__(10)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_filters_date__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_common_rb_timer__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(12);









/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['sportAllBetLang', 'account'])),
  data: function data() {
    return {
      teamA: 'oddsa',
      teamB: 'oddsb',
      teamHome: 'h',
      teamAway: 'a',
      teamDraw: 'd',
      ftPlyType: '1',
      firstHtPlyType: '2',
      secondHtPlyType: '19',
      setHandicapPlyType: '3',
      pointHdpPlyType: '4',
      iotPlyType: '5',
      gameHdpPlyType: '6',
      firstSetPlyType: '7',
      secondSetPlyType: '8',
      thirdSetPlyType: '9',
      fourthSetPlyType: '10',
      fifthSetPlyType: '11',
      sixthSetPlyType: '12',
      game1PlyType: '14',
      game2PlyType: '15',
      game3PlyType: '16',
      game4PlyType: '17',
      game5PlyType: '18',
      first5InningsPlyType: '13',
      first3InningsPlyType: '20',
      firstInningsPlyType: '21',
      secondInningsPlyType: '22',
      thirdInningsPlyType: '23',
      fourthInningsPlyType: '24',
      fifthInningsPlyType: '25',
      sixthInningsPlyType: '26',
      seventhInningsPlyType: '27',
      eighthInningsPlyType: '28',
      ninthInningsPlyType: '29',
      OTPlyType: '30',
      hdpBetType: '1',
      ouBetType: '2',
      oeBetType: '3',
      onex2BetType: '4',
      tgBetType: '5',
      htftBetType: '6',
      csBetType: '7',
      rhdpBetType: '8',
      rouBetType: '9',
      roeBetType: '10',
      ronex2BetType: '11',
      mlBetType: '12',
      rmlBetType: '13',
      otrBetType: '14',
      rcsBetType: '16',
      rhtftBetType: '17',
      rtgBetType: '18',
      dbchBetType: '19',
      rdbchBetType: '20',
      oddsToggle: true,
      rbettype: ['8', '9', '10', '11', '13', '16', '17', '18', '20', '27', '29', '31', '33', '35', '37', '39', '41', '43', '45', '47', '49', '51', '55', '56', '58', '61', '64', '66', '69', '71', '73', '75', '78', '79', '81', '83'],
      hdpbettype: ['1', '2', '8', '9'],
      normalHdpBettype: ['1', '8'],
      ouHdpBettype: ['2', '9', '46', '47', '48', '49', '80', '81', '82', '83'],
      sportWithML: [3, 7, 12, 13, 14, 15, 21],
      h1x2BetType: '21',
      wdBetType: '25',
      rh1x2BetType: '27',
      hmgBetType: '28',
      rhmgBetType: '29',
      hmg1x2BetType: '30',
      rhmg1x2BetType: '31',
      bttsBetType: '32',
      rbttsBetType: '33',
      cshBetType: '34',
      rcshBetType: '35',
      twtnBetType: '36',
      rtwtnBetType: '37',
      twfbBetType: '38',
      rtwfbBetType: '39',
      twehBetType: '40',
      rtwehBetType: '41',
      twbhBetType: '42',
      rtwbhBetType: '43',
      tsbhBetType: '44',
      rtsbhBetType: '45',
      htgBetType: '46',
      rhtgBetType: '47',
      atgBetType: '48',
      ratgBetType: '49',
      wmBetType: '50',
      rwmBetType: '51',
      flgBetType: '52',
      hldsBetType: '53',
      aldsBetType: '54',
      rhldsBetType: '55',
      raldsBetType: '56',
      nogBetType: '57',
      rnogBetType: '58',
      dualBetType: ['59', '73', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72'],
      dualHdpBetType: ['59', '73', '60', '61', '62', '63', '64', '68', '69'],
      ouoeBetType: '59',
      rouoeBetType: '73',
      oubttsBetType: '60',
      roubttsBetType: '61',
      ouftsBetType: '62',

      onex2ouBetType: '63',
      ronex2ouBetType: '64',
      onex2bttsBetType: '65',
      ronex2bttsBetType: '66',
      onex2ftsBetType: '67',

      dcouBetType: '68',
      rdcouBetType: '69',
      dcbttsBetType: '70',
      rdcbttsBetType: '71',
      dcftsBetType: '72',

      edgBetType: '74',
      exiBetType: '76',
      wmrBetType: '77',
      rwmrBetType: '78',
      rexiBetType: '79',
      htrBetType: '80',
      rhtrBetType: '81',
      atrBetType: '82',
      ratrBetType: '83'
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.checkInPly();
    __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$on('marketChange', function (params) {
      _this.checkInPly();
    }.bind(this));
  },

  methods: {
    checkPersian: function checkPersian(langsCap) {
      if (window._langid != '10') {
        return '';
      }
      if (!this.$options.filters.isPersian(langsCap)) {
        return 'directionltr';
      }

      return '';
    },
    getDecimalDisplay: function getDecimalDisplay(value) {
      if (this.$store.getters.account.oddsType == 'am') {
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    commasAmount: function commasAmount(amount) {
      amount += '';
      var x = amount.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    },
    checkInPly: function checkInPly() {
      if (this.$store.getters.int_marketToggle == this.$store.getters.market.inPlayMarket.key) {
        this.hdpBetType = _.cloneDeep(this.rhdpBetType);
        this.ouBetType = _.cloneDeep(this.rouBetType);
        this.oeBetType = _.cloneDeep(this.roeBetType);
        this.onex2BetType = _.cloneDeep(this.ronex2BetType);
        this.mlBetType = _.cloneDeep(this.rmlBetType);
        this.htgBetType = _.cloneDeep(this.rhtgBetType);
        this.atgBetType = _.cloneDeep(this.ratgBetType);
        this.bttsBetType = _.cloneDeep(this.rbttsBetType);
        this.wmBetType = _.cloneDeep(this.rwmBetType);
        this.twtnBetType = _.cloneDeep(this.rtwtnBetType);
        this.twfbBetType = _.cloneDeep(this.rtwfbBetType);
        this.twehBetType = _.cloneDeep(this.rtwehBetType);
        this.twbhBetType = _.cloneDeep(this.rtwbhBetType);
        this.tsbhBetType = _.cloneDeep(this.rtsbhBetType);
        this.cshBetType = _.cloneDeep(this.rcshBetType);
        this.h1x2BetType = _.cloneDeep(this.rh1x2BetType);
        this.hmgBetType = _.cloneDeep(this.rhmgBetType);
        this.hmg1x2BetType = _.cloneDeep(this.rhmg1x2BetType);
        this.hldsBetType = _.cloneDeep(this.rhldsBetType);
        this.aldsBetType = _.cloneDeep(this.raldsBetType);
        this.nogBetType = _.cloneDeep(this.rnogBetType);
        this.ouoeBetType = _.cloneDeep(this.rouoeBetType);
        this.oubttsBetType = _.cloneDeep(this.roubttsBetType);

        this.onex2ouBetType = _.cloneDeep(this.ronex2ouBetType);
        this.onex2bttsBetType = _.cloneDeep(this.ronex2bttsBetType);

        this.dcouBetType = _.cloneDeep(this.rdcouBetType);
        this.dcbttsBetType = _.cloneDeep(this.rdcbttsBetType);
        this.exiBetType = _.cloneDeep(this.rexiBetType);
        this.wmrBetType = _.cloneDeep(this.rwmrBetType);
        this.htrBetType = _.cloneDeep(this.rhtrBetType);
        this.atrBetType = _.cloneDeep(this.ratrBetType);
      } else {
        this.hdpBetType = '1';
        this.ouBetType = '2';
        this.oeBetType = '3';
        this.onex2BetType = '4';
        this.mlBetType = '12';
        this.htgBetType = '46';
        this.atgBetType = '48';
        this.bttsBetType = '32';
        this.wmBetType = '50';
        this.twtnBetType = '36';
        this.twfbBetType = '38';
        this.twehBetType = '40';
        this.twbhBetType = '42';
        this.tsbhBetType = '44';
        this.cshBetType = '34';
        this.h1x2BetType = '21';
        this.hmgBetType = '28';
        this.hmg1x2BetType = '30';
        this.hldsBetType = '53';
        this.aldsBetType = '54';
        this.nogBetType = '57';
        this.ouoeBetType = '59';
        this.oubttsBetType = '60';
        this.ouftsBetType = '62';
        this.onex2ouBetType = '63';
        this.onex2bttsBetType = '65';
        this.onex2ftsBetType = '67';
        this.dcouBetType = '68';
        this.dcbttsBetType = '70';
        this.dcftsBetType = '72';
        this.exiBetType = '76';
        this.wmrBetType = '77';
        this.htrBetType = '80';
        this.atrBetType = '82';
      }
    },
    checkOd: function checkOd(event, bettype, playtype, type) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(event.od).length == 0 || event.od[playtype][bettype] == undefined || event.od[playtype][bettype][type] <= 1) {
        return false;
      }
      return true;
    },
    checkMmOd: function checkMmOd(event, bettype, playtype, type) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(event.od).length == 0 || event.od[playtype][bettype] == undefined || event.od[playtype][bettype][__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(event.od[playtype][bettype])] == undefined || event.od[playtype][bettype][__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(event.od[playtype][bettype])][type] <= 1) {
        return false;
      }
      return true;
    },
    validateOddHdp: function validateOddHdp(args) {
      var ahou = [1, 8, 2, 9, 46, 47, 48, 49, 81, 80, 82, 83];
      var rahrou = [2, 9, 47, 49, 81, 80, 82, 83];
      var oeroe = [3, 10];
      var oddtype1 = ['my', 'in'];
      var oddtype2 = ['hk', 'in', 'eu'];

      if (args.odds == 0) {
        return false;
      }
      if (oddtype1.indexOf(args.oddstype) == -1) {
        if (ahou.indexOf(args.bettype) != -1) {
          if (args.oddstype == 'eu') {
            if (args.odds <= 1) {
              return false;
            }
          } else if (args.oddstype == 'hk') {
            if (args.odds <= 0) {
              return false;
            }
          }
          if (rahrou.indexOf(args.bettype, [2, 9, 46, 47, 48, 49, 81, 80, 82, 83]) != -1) {
            if (args.hdp) {
              if (Math.abs(args.hdp) == 0) {
                return false;
              }
            }
          }
        } else if (oeroe.indexOf(args.bettype) != -1) {
            if (oddtype2.indexOf(args.oddstype) != -1 && args.odds <= 1) {
              return false;
            }
          } else {
            if (args.odds <= 1 && args.oddstype != "am") {
              return false;
            }
          }
      }
      return true;
    },
    toggleDisplay: function toggleDisplay() {
      if (this.oddsToggle == true) {
        this.oddsToggle = false;
      } else {
        this.oddsToggle = true;
      }
    },
    validateRBTimer: function validateRBTimer(event) {

      if (event.rbinfo.tlsec == -1) {
        return false;
      }
      var timerMin = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').minutes();
      var timerHour = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(event.rbinfo.tlsec, 'seconds').hours();

      if (Object(__WEBPACK_IMPORTED_MODULE_5__js_common_rb_timer__["a" /* validateSpecialRBTimer */])(event, timerHour, timerMin)) {
        return '2';
      } else if (event.rbinfo.htst == '1') {
        return '1';
      } else if (event.rbinfo.htst == '2') {
        return '2';
      }

      return false;
    },
    specialLeagueCaption: function specialLeagueCaption(event, bettype) {
      var retCapt = '';

      if (event.spcapt) {
        retCapt = event.spcapt + ' - ';
      }


      return retCapt;
    },
    getOdd1x2UniqueId: function getOdd1x2UniqueId(event, playtype, bettype, team) {
      if (team == 'x') {
        team = 'd';
      }
      return event.eveid + playtype + bettype + team;
    },
    getOdd1x2UniqueId_1: function getOdd1x2UniqueId_1(event, team) {
      return event.eveid + team;
    },
    getOddUniqueId: function getOddUniqueId(event, playtype, bettype, team, dual) {
      return event.eveid + playtype + bettype + dual + team;
    },
    getOtrUniqueId: function getOtrUniqueId(event, playtype, bettype, team) {
      return event.eveid + playtype + bettype + team;
    },
    oddsTeamTitle: function oddsTeamTitle(team) {
      var retCapt = '';

      retCapt = team + ' - ';

      return retCapt;
    },
    checkEventPlyTypIndex: function checkEventPlyTypIndex(event, plytyp) {
      var firstindex = false;
      if (typeof event.od != 'undefined') {
        if (typeof event.od[plytyp] != 'undefined') {
          var index = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(event.od).indexOf(plytyp);
          if (index == 0) {
            firstindex = true;
          }
        }
      }
      return firstindex;
    },
    checkOddValidation: function checkOddValidation(value) {
      if (this.$store.getters.account.oddsType == 'am') {
        var pass_value = parseFloat(value);
        if (pass_value < 0) {
          pass_value = Math.abs(100 / pass_value);
        } else {
          pass_value = pass_value / 100;
        }
        pass_value = pass_value.toFixed(3);
        if (pass_value <= 0) {
          return false;
        }
      } else {
        if (parseFloat(value) <= 1) {
          return false;
        }
      }
      return true;
    },
    checkOdds: function checkOdds(val) {
      if (this.$store.getters.account.oddsType == 'am') {
        if (val < 0) {
          return parseFloat(Math.abs(100 / val)) + 1;
        } else {
          return parseFloat(Math.abs(val / 100)) + 1;
        }
      }
      return parseFloat(val);
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__vue_events_event_bus__["a" /* default */].$off('marketChange');
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    teamMouseOver: function teamMouseOver(event) {
      if (event) {
        var elem = $('.sportTable').find('#' + event.eveid);
        if (elem.length > 0) {
          elem.css("display", "block");
        }
      }
    },
    teamMouseLeave: function teamMouseLeave(event) {
      if (event) {
        var elem = $('.sportTable').find('#' + event.eveid);
        if (elem.length > 0) {
          elem.css("display", "");
        }
      }
    },
    favouritedEvent: function favouritedEvent(eveid, sportId, favEvent) {
      var lgeFav = false;
      if (favEvent != undefined && favEvent[sportId] != undefined) {
        if (favEvent[sportId].indexOf(eveid) !== -1) {
          lgeFav = true;
        }
      }
      return lgeFav;
    },
    favourite: function favourite(event) {
      var isrb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.$store.getters.int_marketToggle == '3' || this.$store.getters.int_marketToggle == '1' && event.rbstatus == 1) {
        isrb = true;
      }
      this.$store.commit('SETFAVOURITE', { event: event, isrb: isrb });
      this.$store.dispatch('sortEvents');
    },
    favouriteAllBet: function favouriteAllBet(event) {
      var isrb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.$store.getters.int_marketToggle == '3') {
        isrb = true;
      }
      this.$store.commit('FAVOURITEALLBETEVENT', { event: event, isrb: isrb });
    },
    favouriteTeam: function favouriteTeam(event, team) {
      this.$store.commit('FAVOURITE_TEAM', { event: event, team: team, sport: this.$store.getters.selectedSport });
    },
    favouritelgeve: function favouritelgeve(lgeid, wevent, isrb, eventObj) {
      wevent.preventDefault();
      wevent.stopPropagation();
      var lgChk = $(wevent.target).hasClass('favorited');
      this.$store.commit('FAVOURITELGEVENT', { lgeid: lgeid, lgeChk: lgChk, isrb: isrb, eventObj: eventObj });

      if (this.$store.getters.showFavEvents) {
        if (this.$store.getters.arr_selectedTemplate.subTemplateId == '3') {
          this.$store.dispatch('getOutrightLeague', {
            callback: function (res) {
              __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            }.bind(this)
          });
        } else {
          this.$store.dispatch('getSportOdds', {
            callback: function (res) {
              __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('refreshOdd', true);
            }.bind(this)
          });
        }
      }
    },
    lgFavorite: function lgFavorite(lgId, btPage, favouriteLgeEvents) {
      var lgeFav = false;
      if (favouriteLgeEvents != undefined && favouriteLgeEvents[btPage] != undefined) {
        if (favouriteLgeEvents[btPage].indexOf(lgId) !== -1) {
          lgeFav = true;
        }
      }
      return lgeFav;
    },
    lgAllBetFavorite: function lgAllBetFavorite(lgMatches) {
      var lgeFav = true;
      if (lgMatches.isFavourite == undefined || !lgMatches.isFavourite) {
        lgeFav = false;
      }
      return lgeFav;
    },
    showForecast: function showForecast(event, windowEvent) {
      this.$store.commit('SPORTFORECAST_TOGGLE', true);
      this.$store.commit('SPORTFORECAST_SELECTEDEVENT', event);
      this.$store.commit('SPORTFORECAST_WINDOWEVENT', windowEvent);
      __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('SHOW_FORECAST', event);

      if (this.$store.getters.betForm.length > 0 && !this.$store.getters.betting.success) {
        __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('FORECAST_GETWAITINGLIST', event);
      } else {
        __WEBPACK_IMPORTED_MODULE_1__vue_events_event_bus__["a" /* default */].$emit('FORECAST_GETWAITINGLIST', null);
      }
    }
  }
});

/***/ })

},[238]);


// WEBPACK FOOTER //
// js/home/home.6418d68501f386a34ad1.js